(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["account-address-input"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('address-input')) {
      customElements.define(
        'address-input',
        class AddressInput extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }

          /**
           * 更新填充状态 - 供外部调用
           * 当编辑地址时，需要重新检查并更新 is-filled 状态
           */
          updateFilledState() {
            var container = this.querySelector('.address_input_container');
            if (!container) return;

            var input = this.querySelector('input.address_input');
            var select = this.querySelector('select');

            // 检查 input 是否有值
            var hasInputValue = input && input.value && input.value.trim().length > 0;

            // 检查 select 是否有值（包括自定义下拉）
            var hasSelectValue = false;
            if (select) {
              hasSelectValue = select.value && select.value !== '---' && String(select.value).trim().length > 0;
            } else {
              // 如果没有原生 select，检查自定义下拉的显示文本
              var trigger = this.querySelector('.address-select-trigger');
              if (trigger) {
                var labelSpan = trigger.querySelector('.address-select-label');
                if (labelSpan && labelSpan.textContent && labelSpan.textContent.trim().length > 0) {
                  hasSelectValue = true;
                }
              }
            }

            // 更新 is-filled 状态
            if (hasInputValue || hasSelectValue) {
              container.classList.add('is-filled');
            } else {
              container.classList.remove('is-filled');
            }
          }

          init() {
            var self = this;

            // 确保初始化时所有下拉面板都是关闭的
            var allPanels = this.querySelectorAll('.address-dropdown-panel');
            allPanels.forEach(function (panel) {
              panel.style.display = 'none';
            });

            var container = this.querySelector('.address_input_container');
            var input = this.querySelector('input.address_input');
            var select = this.querySelector('select');

            var updateFilled = function () {
              var hasInputValue = input && input.value && input.value.trim().length > 0;
              var hasSelectValue =
                select && select.value && select.value !== '---' && String(select.value).trim().length > 0;
              if (hasInputValue || hasSelectValue) {
                container.classList.add('is-filled');
              } else {
                container.classList.remove('is-filled');
              }
            };

            // 初始状态
            updateFilled();

            if (input) {
              input.addEventListener('focus', function () {
                container.classList.add('is-focus');
              });
              input.addEventListener('blur', function () {
                container.classList.remove('is-focus');
                self.blurInput();
              });
              input.addEventListener('input', function () {
                updateFilled();
              });
            }

            // 如果有 select，初始化自定义下拉 + global-select 逻辑
            if (select) {
              var isCountry = select.classList.contains('country-selector');
              var isProvince = select.classList.contains('province-selector');

              // 初始化自定义 trigger 和 options
              if (isCountry) {
                this.initCountrySelect(select, container, updateFilled);
              } else if (isProvince) {
                this.initProvinceSelect(select, container, updateFilled);
              }

              // 原生 select 仍保留，供 Shopify 表单提交使用
              select.addEventListener('change', function () {
                updateFilled();
              });

              // 初始化 select 值
              updateFilled();
            }

            // 点击整体容器时，聚焦到输入框（如果存在）
            this.addEventListener('click', function () {
              self.focusInput();
            });

            // 点击外部收起下拉（局部）
            document.addEventListener('click', function (evt) {
              if (!self.contains(evt.target)) {
                self.closeDropdowns();
              }
            });
          }

          initCountrySelect(select, container, updateFilled) {
            var self = this;
            var optionsContainer = this.querySelector('[data-address-country-options]');
            var trigger = this.querySelector('.address-select-trigger-country');
            var panel = this.querySelector('.address-dropdown-panel-country');
            if (!optionsContainer || !trigger || !select) return;

            // 清空旧选项
            optionsContainer.innerHTML = '';

            var currentLabel = '';
            var currentValue = '';
            var dataCountry = select.getAttribute('data-country') || '';
            var foundMatch = false;
            var matchedProvincesAttr = '';

            // 先遍历生成所有国家选项
            for (var i = 0; i < select.options.length; i++) {
              var opt = select.options[i];
              var val = opt.value;
              var text = opt.textContent || opt.innerText || '';
              var provincesAttr = opt.getAttribute('data-provinces') || '';
              if (!val || val === '---') continue;

              var li = document.createElement('li');
              li.className = 'select-options-item';
              li.setAttribute('data-value', val);
              if (provincesAttr) {
                li.setAttribute('data-provinces', provincesAttr);
              }
              li.textContent = text;

              // 检查是否匹配 data-country
              if (dataCountry && val === dataCountry) {
                foundMatch = true;
                currentValue = val;
                currentLabel = text;
                matchedProvincesAttr = provincesAttr;
              }

              optionsContainer.appendChild(li);
            }

            // 检查是否存在 province-col 元素
            var provinceCol = document.querySelector('.province-col');
            if (!provinceCol) {
              console.log('获取不到');
            }

            // 如果找到匹配的国家，设置为选中状态
            if (foundMatch) {
              select.value = currentValue;
              // 触发 change 事件，确保其他监听器能够响应
              select.dispatchEvent(new Event('change', { bubbles: true }));
            } else {
              // 没有找到匹配的国家，清空选择
              select.value = '';
              currentValue = '';
              currentLabel = '';
            }

            // 初始化 trigger 显示文本
            var labelSpan = trigger.querySelector('.address-select-label');
            if (labelSpan) {
              labelSpan.textContent = currentLabel || '';
            }

            // 点击 trigger 展开/收起
            trigger.addEventListener('click', function (e) {
              e.stopPropagation();

              if (!panel) return;

              // 判断当前面板是否已经打开
              var isCurrentOpen = panel.style.display === 'block';

              // 关闭所有其他面板（不包括当前面板）
              var allPanels = document.querySelectorAll('.address-dropdown-panel');
              var allTriggers = document.querySelectorAll('.address-select-trigger');

              allPanels.forEach(function (p) {
                if (p !== panel) {
                  p.style.removeProperty('display');
                  p.style.display = 'none';
                }
              });

              allTriggers.forEach(function (t) {
                if (t !== trigger) {
                  t.classList.remove('open');
                }
              });

              // 切换当前面板
              if (isCurrentOpen) {
                panel.style.display = 'none';
                trigger.classList.remove('open');
              } else {
                panel.style.removeProperty('display');
                panel.style.display = 'block';
                trigger.classList.add('open');
              }
            });

            // 本地点击：同步 select 与 label，并收起
            optionsContainer.addEventListener('click', function (evt) {
              var item = evt.target.closest('.select-options-item');
              if (!item) return;
              var val = item.getAttribute('data-value');
              var text = item.textContent ? item.textContent.trim() : '';
              var provincesAttr = item.getAttribute('data-provinces') || '';

              // 更新国家 select 和 label
              select.value = val;
              select.dispatchEvent(new Event('change', { bubbles: true }));
              if (labelSpan) {
                labelSpan.textContent = text;
              }

              // 处理省份数据
              self.updateProvinceOptions(provincesAttr);

              updateFilled();
              self.closeDropdowns();
            });

            // 初始化时，使用匹配到的国家数据的省份信息
            if (currentValue && foundMatch) {
              if (matchedProvincesAttr) {
                self.updateProvinceOptions(matchedProvincesAttr);
              } else {
                // 没有省份数据，隐藏省份选择器
                self.updateProvinceOptions('');
              }
            } else if (!foundMatch) {
              // 没有匹配到国家，隐藏省份选择器
              self.updateProvinceOptions('');
            }

            // 更新浮动状态
            updateFilled();
          }

          /**
           * 更新省份选项
           * @param {string} provincesAttr - JSON 格式的省份数据字符串
           */
          updateProvinceOptions(provincesAttr) {
            // 查找同一个表单中的省份相关元素
            var form = this.closest('form');
            if (!form) return;

            var provinceSelect = form.querySelector('.province-selector');
            var provinceTrigger = form.querySelector('.address-select-trigger-province');
            var provincePanel = form.querySelector('.address-dropdown-panel-province');
            var provinceOptionsContainer = form.querySelector('[data-address-province-options]');
            var provinceContainer = provinceTrigger ? provinceTrigger.closest('.address_input_container') : null;

            if (!provinceSelect || !provinceTrigger || !provinceOptionsContainer) return;

            try {
              // 解析省份数据
              var provinces = provincesAttr ? JSON.parse(provincesAttr) : null;

              if (provinces && Array.isArray(provinces) && provinces.length > 0) {
                // 有省份数据：更新省份 select 和下拉列表，显示省份 trigger

                // 清空旧选项
                provinceSelect.innerHTML = '';
                provinceOptionsContainer.innerHTML = '';

                // 生成省份选项
                var provinceLabelSpan = provinceTrigger.querySelector('.address-select-label');

                // 获取原始省份值（如果存在）
                var originalProvince = provinceSelect.getAttribute('data-country_prov') || '';
                var selectedProvince = null;
                var firstProvince = null;

                // 先生成所有选项
                for (var i = 0; i < provinces.length; i++) {
                  var province = provinces[i];
                  var code = province[0];
                  var name = province[1];

                  // 添加到原生 select
                  var option = document.createElement('option');
                  option.value = code;
                  option.textContent = name;
                  provinceSelect.appendChild(option);

                  // 添加到自定义下拉列表
                  var li = document.createElement('li');
                  li.className = 'select-options-item';
                  li.setAttribute('data-value', code);
                  li.textContent = name;
                  provinceOptionsContainer.appendChild(li);

                  // 保存第一个省份作为默认值
                  if (i === 0) {
                    firstProvince = { code: code, name: name };
                  }

                  // 检查是否匹配原始省份值
                  if (originalProvince && code === originalProvince) {
                    selectedProvince = { code: code, name: name };
                  }
                }

                // 决定选中哪个省份：优先原始值，否则第一个
                var finalProvince = selectedProvince || firstProvince;
                if (finalProvince) {
                  provinceSelect.value = finalProvince.code;
                  if (provinceLabelSpan) {
                    provinceLabelSpan.textContent = finalProvince.name;
                  }
                }

                // 触发 change 事件
                provinceSelect.dispatchEvent(new Event('change', { bubbles: true }));

                // 显示省份 trigger 和容器
                if (provinceContainer) {
                  provinceContainer.style.display = '';
                }
                if (window.innerWidth <= 1200) {
                  var provinceCol = document.querySelector('.province-col');
                  if (provinceCol) {
                    provinceCol.style.display = '';
                  }
                }
                provinceTrigger.style.display = '';

                // 更新省份选择器的填充状态
                if (provinceContainer) {
                  provinceContainer.classList.add('is-filled');
                }
              } else {
                // 没有省份数据：隐藏省份 trigger 和容器，清空选项
                provinceSelect.innerHTML = '';
                provinceOptionsContainer.innerHTML = '';

                // 清空省份 select 的值
                provinceSelect.value = '';
                provinceSelect.dispatchEvent(new Event('change', { bubbles: true }));

                // 隐藏省份 trigger 和容器
                if (provinceContainer) {
                  provinceContainer.style.display = 'none';
                  provinceContainer.classList.remove('is-filled');
                  if (window.innerWidth <= 1200) {
                    var provinceCol = document.querySelector('.province-col');
                    if (provinceCol) {
                      provinceCol.style.display = 'none';
                    }
                  }
                }
                provinceTrigger.style.display = 'none';

                // 清空省份 trigger 的显示文本
                var provinceLabelSpan = provinceTrigger.querySelector('.address-select-label');
                if (provinceLabelSpan) {
                  provinceLabelSpan.textContent = '';
                }
              }
            } catch (e) {
              console.error('解析省份数据失败:', e);
              // 解析失败时隐藏省份选择器
              if (provinceContainer) {
                provinceContainer.style.display = 'none';
              }
              provinceTrigger.style.display = 'none';
            }
          }

          initProvinceSelect(select, container, updateFilled) {
            var self = this;
            var optionsContainer = this.querySelector('[data-address-province-options]');
            var trigger = this.querySelector('.address-select-trigger-province');
            var panel = this.querySelector('.address-dropdown-panel-province');
            if (!optionsContainer || !trigger || !select) return;

            // 清空旧选项
            optionsContainer.innerHTML = '';

            var currentValue = select.value;
            var currentLabel = '';

            for (var i = 0; i < select.options.length; i++) {
              var opt = select.options[i];
              var val = opt.value;
              var text = opt.textContent || opt.innerText || '';
              if (!val || val === '---') continue;

              var li = document.createElement('li');
              li.className = 'select-options-item';
              li.setAttribute('data-value', val);
              li.textContent = text;

              if (val === currentValue) {
                currentLabel = text;
              }

              optionsContainer.appendChild(li);
            }

            // 初始化 trigger 显示文本
            var labelSpan = trigger.querySelector('.address-select-label');
            if (labelSpan) {
              labelSpan.textContent = currentLabel || '';
            }

            // 点击 trigger 展开/收起
            trigger.addEventListener('click', function (e) {
              e.stopPropagation();

              if (!panel) return;

              // 判断当前面板是否已经打开
              var isCurrentOpen = panel.style.display === 'block';

              // 关闭所有其他面板（不包括当前面板）
              var allPanels = document.querySelectorAll('.address-dropdown-panel');
              var allTriggers = document.querySelectorAll('.address-select-trigger');

              allPanels.forEach(function (p) {
                if (p !== panel) {
                  p.style.removeProperty('display');
                  p.style.display = 'none';
                }
              });

              allTriggers.forEach(function (t) {
                if (t !== trigger) {
                  t.classList.remove('open');
                }
              });

              // 切换当前面板
              if (isCurrentOpen) {
                panel.style.display = 'none';
                trigger.classList.remove('open');
              } else {
                panel.style.removeProperty('display');
                panel.style.display = 'block';
                trigger.classList.add('open');
              }
            });

            // 本地点击：同步 select 与 label，并收起
            optionsContainer.addEventListener('click', function (evt) {
              var item = evt.target.closest('.select-options-item');
              if (!item) return;
              var val = item.getAttribute('data-value');
              var text = item.textContent ? item.textContent.trim() : '';

              // 更新省份 select 和 label
              select.value = val;
              select.dispatchEvent(new Event('change', { bubbles: true }));
              if (labelSpan) {
                labelSpan.textContent = text;
              }

              // 更新填充状态
              updateFilled();

              // 只关闭下拉面板，不隐藏省份选择器本身
              self.closeDropdowns();
            });

            // 更新浮动状态
            updateFilled();
          }

          closeDropdowns() {
            // 使用更通用的选择器，确保关闭所有下拉面板
            var panels = this.querySelectorAll('.address-dropdown-panel');
            panels.forEach(function (panel) {
              panel.style.display = 'none';
              // 强制设置，确保生效
              panel.style.setProperty('display', 'none', 'important');
            });
            // 移除所有 trigger 的 open 类
            var triggers = this.querySelectorAll('.address-select-trigger');
            triggers.forEach(function (trigger) {
              trigger.classList.remove('open');
            });
          }

          focusInput() {
            var input = this.querySelector('input.address_input');

            if (input) {
              input.focus();
            } else {
              // 如果没有 input，尝试聚焦到自定义下拉 trigger
              var trigger = this.querySelector('.address-select-trigger');
              if (trigger) {
                trigger.focus();
              }
            }
          }

          blurInput() {
            var input = this.querySelector('input.address_input');
            var container = this.querySelector('.address_input_container');
            var errorEl = this.querySelector('.error-message');
            if (!input) return;

            var value = input.value;
            var required = input.hasAttribute('required');

            if (!value && required) {
              container.classList.add('field-error');
              if (errorEl) {
                errorEl.classList.remove('hidden');
              }
            } else {
              container.classList.remove('field-error');
              if (errorEl) {
                errorEl.classList.add('hidden');
              }
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["account-address-popup"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('address-popup')) {
      customElements.define(
        'address-popup',
        class AddressPopup extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
            // 返回按钮点击事件 - 关闭弹窗
            var backBtn = this.querySelector('.account-address-popup-back-btn');
            if (backBtn) {
              backBtn.addEventListener('click', () => {
                this.closePopup();
              });
            }
          }

          /**
           * 关闭弹窗方法 - 与 address_cancel 按钮行为一致
           * 隐藏弹窗、重置表单、启用滚动、清空错误状态
           */
          closePopup() {
            const _this = this;
            // 查找最近的 .address-popup 父元素（弹窗容器）
            const popupContainer = this.closest('.address-popup');
            if (popupContainer) {
              // 隐藏弹窗
              popupContainer.style.zIndex = '-99';
              popupContainer.style.opacity = '0';

              // 重置表单
              const form = popupContainer.querySelector('form');
              if (form) {
                form.reset();

                // 重置自定义下拉的显示文本
                const countrySelect = form.querySelector('.country-selector');
                if (countrySelect) {
                  const dataCountry = countrySelect.getAttribute('data-country');
                  if (dataCountry && dataCountry !== '---' && dataCountry.trim() !== '') {
                    countrySelect.value = dataCountry;
                    countrySelect.dispatchEvent(new Event('change', { bubbles: true }));

                    // 重置国家下拉的显示文本
                    const countryTrigger = form.querySelector('.address-select-trigger-country');
                    if (countryTrigger) {
                      const countryLabelSpan = countryTrigger.querySelector('.address-select-label');
                      if (countryLabelSpan) {
                        // 从 select 的 options 中查找对应的文本
                        for (let i = 0; i < countrySelect.options.length; i++) {
                          if (countrySelect.options[i].value === dataCountry) {
                            countryLabelSpan.textContent = countrySelect.options[i].textContent || '';
                            break;
                          }
                        }
                      }
                    }
                  }
                }

                // 重置省份下拉的显示文本
                const provinceSelect = form.querySelector('.province-selector');
                const provinceTrigger = form.querySelector('.address-select-trigger-province');
                const provinceContainer = provinceTrigger ? provinceTrigger.closest('.address_input_container') : null;

                if (provinceSelect && provinceTrigger) {
                  const dataProvince = provinceSelect.getAttribute('data-country_prov');

                  // 如果有原始省份数据，需要恢复显示
                  if (dataProvince && dataProvince !== '---' && dataProvince.trim() !== '') {
                    // 检查原始国家是否有省份数据
                    const dataCountry = countrySelect ? countrySelect.getAttribute('data-country') : null;
                    if (dataCountry) {
                      // 从国家的 options 中查找对应的省份数据
                      const countryOptions = countrySelect.options;
                      let provincesAttr = null;
                      for (let j = 0; j < countryOptions.length; j++) {
                        if (countryOptions[j].value === dataCountry) {
                          provincesAttr = countryOptions[j].getAttribute('data-provinces');
                          break;
                        }
                      }

                      if (provincesAttr) {
                        try {
                          const provinces = JSON.parse(provincesAttr);
                          if (provinces && Array.isArray(provinces) && provinces.length > 0) {
                            // 原始国家有省份数据，恢复省份选择器
                            // 清空旧选项
                            provinceSelect.innerHTML = '';
                            const provinceOptionsContainer = form.querySelector('[data-address-province-options]');
                            if (provinceOptionsContainer) {
                              provinceOptionsContainer.innerHTML = '';
                            }

                            // 生成省份选项
                            const provinceLabelSpan = provinceTrigger.querySelector('.address-select-label');
                            let foundProvince = false;

                            for (let i = 0; i < provinces.length; i++) {
                              const province = provinces[i];
                              const code = province[0];
                              const name = province[1];

                              // 添加到原生 select
                              const option = document.createElement('option');
                              option.value = code;
                              option.textContent = name;
                              provinceSelect.appendChild(option);

                              // 添加到自定义下拉列表
                              if (provinceOptionsContainer) {
                                const li = document.createElement('li');
                                li.className = 'select-options-item';
                                li.setAttribute('data-value', code);
                                li.textContent = name;
                                provinceOptionsContainer.appendChild(li);
                              }

                              // 如果匹配原始省份值，设置为选中
                              if (code === dataProvince) {
                                provinceSelect.value = code;
                                if (provinceLabelSpan) {
                                  provinceLabelSpan.textContent = name;
                                }
                                foundProvince = true;
                              }
                            }

                            // 如果没有找到匹配的省份，选择第一个
                            if (!foundProvince && provinces.length > 0) {
                              const firstProvince = provinces[0];
                              provinceSelect.value = firstProvince[0];
                              if (provinceLabelSpan) {
                                provinceLabelSpan.textContent = firstProvince[1];
                              }
                            }

                            // 显示省份 trigger 和容器
                            if (provinceContainer) {
                              provinceContainer.style.display = '';
                            }
                            provinceTrigger.style.display = '';

                            // 触发 change 事件
                            provinceSelect.dispatchEvent(new Event('change', { bubbles: true }));
                          }
                        } catch (e) {
                          console.error('解析省份数据失败:', e);
                        }
                      }
                    }
                  }
                }
              }

              // 启用滚动
              if (window.litime && typeof window.litime.enableScroll === 'function') {
                window.litime.enableScroll();
              }

              // 清空所有必填字段的错误状态
              const requiredFields = popupContainer.querySelectorAll('[required]');
              requiredFields.forEach((field) => {
                const container = field.closest('.address_input_container');
                const errorEl = container ? container.parentElement.querySelector('.error-message') : null;
                const placeholder = container ? container.querySelector('.address_input_placeholder') : null;

                if (container) {
                  container.classList.remove('field-error');
                  container.classList.remove('is-focus');
                  container.classList.remove('is-filled');
                }
                if (errorEl) {
                  errorEl.classList.add('hidden');
                }
                if (placeholder) {
                  placeholder.style.color = '#666666';
                  placeholder.style.top = '';
                  placeholder.style.transform = '';
                  placeholder.style.fontSize = '';
                }
              });

              // 恢复保存按钮的 loading / 文案状态
              const submitBtn = popupContainer.querySelector('.addr-btn--primary');
              if (submitBtn) {
                const textEl = submitBtn.querySelector('.addr-loading-text-text');
                const iconEl = submitBtn.querySelector('.addr-loading-text-icon');
                if (textEl) textEl.classList.remove('hidden');
                if (iconEl) iconEl.classList.add('hidden');
              }

              // 重新初始化所有 address-input 组件，恢复到原始状态
              setTimeout(function () {
                const addressInputs = popupContainer.querySelectorAll('address-input');
                addressInputs.forEach(function (inputComponent) {
                  if (inputComponent && typeof inputComponent.updateFilledState === 'function') {
                    inputComponent.updateFilledState();
                  }
                });
              }, 50);
            }
          }

          init() {
            // 仅在本弹窗内处理必填校验的红色占位与边框（不依赖全局脚本）
            const forms = document.querySelectorAll('.addr-form form');
            forms.forEach((form) => {
              const submitBtn = form.querySelector('.addr-btn--primary');
              const cancelBtn = form.querySelector('.address_cancel');
              if (!submitBtn) return;

              const handleValidate = (e) => {
                let isValid = true;
                const requiredFields = form.querySelectorAll('[required]');
                requiredFields.forEach((field) => {
                  const container = field.closest('.address_input_container');
                  const errorEl = container ? container.parentElement.querySelector('.error-message') : null;
                  const value = field.value && field.value.trim();

                  if (!value) {
                    isValid = false;
                    if (container) container.classList.add('field-error');
                    if (errorEl) errorEl.classList.remove('hidden');
                  } else {
                    if (container) container.classList.remove('field-error');
                    if (errorEl) errorEl.classList.add('hidden');
                  }
                });

                if (!isValid) {
                  e.preventDefault();
                  e.stopPropagation();
                  return;
                }

                // 通过校验后：切换为 loading 态（文字隐藏，loading 显示）
                const loadingTextWrap = submitBtn.querySelector('.addr-loading-text');
                const textEl = submitBtn.querySelector('.addr-loading-text-text');
                const iconEl = submitBtn.querySelector('.addr-loading-text-icon');
                if (loadingTextWrap) {
                  if (textEl) textEl.classList.add('hidden');
                  if (iconEl) iconEl.classList.remove('hidden');
                }
              };

              submitBtn.addEventListener('click', handleValidate, { passive: false });

              // 点击取消时，关闭弹窗（与返回按钮行为一致）
              if (cancelBtn) {
                cancelBtn.addEventListener('click', () => {
                  this.closePopup();
                });
              }
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["account-coupons"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('account-coupons')) {
      class AccountCoupons extends HTMLElement {
        constructor() {
          super();
          this.currentRewardTab = 'available';
          this.rewardsData = { available: null, used: null, expired: null };
          this._onResize = this._onResize.bind(this);
          this.modal = null;
        }

        connectedCallback() {
          if (window.litime && window.litime.onVisibleOnce) {
            window.litime.onVisibleOnce(this, () => {
              // 在优惠券页本身标记已访问并隐藏入口提示
              localStorage.setItem('userDiscount', 'unshow');
              document.querySelectorAll('.coupons-show').forEach((item) => {
                item.classList.add('hidden');
              });
              this.modal = document.querySelector('coupon-detail-modal');
              const run = () => this.init().catch((e) => console.error('account-coupons init error:', e));
              if (window.litime && typeof window.litime.onVisibleOnce === 'function') {
                window.litime.onVisibleOnce(this, run);
              } else {
                run();
              }
            });
          }
        }

        disconnectedCallback() {
          window.removeEventListener('resize', this._onResize);
        }

        async init() {
          if (!window.customer) return;

          try {
            this.showRewardsLoading();
            const [available, used, expired] = await Promise.all([
              this.getMemberRewards({ page: 1, pageSize: 999, status: 0 }),
              this.getMemberRewards({ page: 1, pageSize: 999, status: 1 }),
              this.getMemberRewards({ page: 1, pageSize: 999, status: 2 }),
            ]);

            this.rewardsData = { available, used, expired };

            this.setupRewardTabs();
            this.hideRewardsLoading();

            if (available && available.records && available.records.length) {
              this.renderRewardsContent('available', available);
            } else {
              this.showRewardsEmpty('available');
            }

            window.addEventListener('resize', this._onResize);

            // 添加返回按钮事件监听
            this.querySelector('.account-coupons__nav .back-btn').addEventListener('click', () => {
              window.litime.eventBus.publish('account:switchTab', 'overview');
            });
          } catch (err) {
            console.error('getMemberRewards error:', err);
            this.showRewardsEmpty(this.currentRewardTab || 'available');
          }
        }

        _onResize() {
          const tab = this.currentRewardTab || 'available';
          if (this.rewardsData && this.rewardsData[tab]) {
            this.renderRewardsContent(tab, this.rewardsData[tab]);
          }
        }

        setupRewardTabs() {
          const tabs = this.querySelectorAll('[data-reward-tab]');
          tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
              const type = tab.getAttribute('data-reward-tab');
              this.switchRewardTab(type);
            });
          });
        }

        switchRewardTab(tabType) {
          if (this.currentRewardTab === tabType) return;
          this.currentRewardTab = tabType;

          const tabs = this.querySelectorAll('[data-reward-tab]');
          tabs.forEach((tab) => {
            if (tab.getAttribute('data-reward-tab') === tabType) tab.classList.add('active-tab');
            else tab.classList.remove('active-tab');
          });

          if (this.rewardsData && this.rewardsData[tabType]) {
            this.renderRewardsContent(tabType, this.rewardsData[tabType]);
          } else {
            this.showRewardsEmpty(tabType);
          }
        }

        showRewardsLoading() {
          const loading = this.querySelector('.account-coupons__rewards-loading');
          const empty = this.querySelector('.account-coupons__rewards-empty');
          const contentItems = this.querySelectorAll('[data-reward-tab-content]');
          if (loading) loading.classList.remove('account-coupons__hidden');
          if (empty) empty.classList.add('account-coupons__hidden');
          contentItems.forEach((el) => el.classList.add('account-coupons__hidden'));
        }

        hideRewardsLoading() {
          const loading = this.querySelector('.account-coupons__rewards-loading');
          if (loading) loading.classList.add('account-coupons__hidden');
        }

        async getMemberRewards(data) {
          const url = '/shopify/user/page/discount';
          try {
            if (window.litime && window.litime.http && typeof window.litime.http.get === 'function') {
              const res = await window.litime.http.get(url, { data });
              if (res.code === 200) return res.data;
              throw new Error(window.i18n && window.i18n.error_message_timeout);
            }
          } catch (e) {
            // fall through to fetch
          }
          const qs = new URLSearchParams();
          if (data) {
            Object.keys(data).forEach((k) => {
              const v = data[k];
              if (v !== undefined && v !== null) qs.append(k, v);
            });
          }
          const resp = await fetch(url + (qs.toString() ? `?${qs.toString()}` : ''), { credentials: 'include' });
          const json = await resp.json().catch(() => ({}));
          if (json && json.code === 200) return json.data;
          throw new Error(window.i18n && window.i18n.error_message_timeout);
        }

        renderRewardsContent(tab, data) {
          this.hideRewardsLoading();

          if (!data || !data.records || data.records.length === 0) {
            this.showRewardsEmpty(tab);
            return;
          }

          this.hideRewardsEmpty();

          const contentItems = this.querySelectorAll('[data-reward-tab-content]');
          contentItems.forEach((item) => {
            if (item.getAttribute('data-reward-tab-content') === tab) item.classList.remove('account-coupons__hidden');
            else item.classList.add('account-coupons__hidden');
          });

          const contentItem = this.querySelector(`[data-reward-tab-content="${tab}"]`);
          const rewardsListWrapper = contentItem.querySelector('.rewards-list_wrapper');

          rewardsListWrapper.innerHTML = '';

          data.records.forEach((item) => {
            const rewardItem = this.createRewardItem(item, tab);
            if (rewardItem) rewardsListWrapper.appendChild(rewardItem);
          });
        }

        createRewardItem(item, tab) {
          const template = this.querySelector('.reward-item-template .reward-item');
          if (!template) return null;
          const rewardItem = template.cloneNode(true);

          const img = rewardItem.querySelector('.member-redeem-img');
          const title = rewardItem.querySelector('.member-redeem-title');
          const codeContainer = rewardItem.querySelector('.member-redeem-code');
          const codeSpan = rewardItem.querySelector('.member-redeem-code span');
          const copyIcon = rewardItem.querySelector('.copy-icon');
          const date = rewardItem.querySelector('.member-redeem-date');

          if (item.icon) {
            img.src = item.icon;
            img.alt = item.rewardName || 'reward';
          }

          // Add click event to the image to open the rules modal
          img.addEventListener('click', () => {
            if (this.modal && typeof this.modal.open === 'function') {
              this.modal.open(item);
            }
          });

          if (tab === 'expired') img.style.filter = 'grayscale(1)';

          if (title) title.textContent = item.rewardName || '';
          if (codeSpan) codeSpan.textContent = item.discountCode || '';

          // 状态为 2（已过期）时，添加 status-expired 类，通过 CSS 控制颜色
          if (item.status === 2) {
            rewardItem.classList.add('status-expired');
          }

          // 复制按钮始终显示，所有状态都可以复制
          if (copyIcon && item.discountCode) {
            copyIcon.style.display = '';
            copyIcon.addEventListener('click', (e) => {
              e.stopPropagation();
              if (window.litime && window.litime.copyToClipboard) {
                window.litime.copyToClipboard(item.discountCode);
              } else if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(item.discountCode).catch(() => {});
              }
            });
          }

          if (date) {
            if (item.expiredAt) {
              const localTime = this.switchTimeZone(item.expiredAt);
              const tpl = (window.i18n && window.i18n.member_expires_on) || 'Expires on {date}';
              date.textContent = tpl.replace('{date}', localTime.toLocaleDateString());
            } else {
              date.textContent = (window.i18n && window.i18n.member_no_expiration_date) || 'No expiration date';
            }
          }
          return rewardItem;
        }

        showRewardsEmpty() {
          const empty = this.querySelector('.account-coupons__rewards-empty');
          const rewardsWrapper = this.querySelector('.account-coupons__rewards');
          const contentItems = this.querySelectorAll('[data-reward-tab-content]');
          contentItems.forEach((el) => el.classList.add('account-coupons__hidden'));
          if (empty) empty.classList.remove('account-coupons__hidden');
          // 当前 tab 无数据时，让容器高度占满可用空间，保证空状态垂直居中
          if (rewardsWrapper) rewardsWrapper.style.height = '100%';
        }

        hideRewardsEmpty() {
          const empty = this.querySelector('.account-coupons__rewards-empty');
          const rewardsWrapper = this.querySelector('.account-coupons__rewards');
          if (empty) empty.classList.add('account-coupons__hidden');
          // 有数据展示时，取消强制高度，还原为原本由内容决定的高度
          if (rewardsWrapper) rewardsWrapper.style.height = '';
        }

        switchTimeZone(cnTime) {
          const cnDate = new Date(cnTime);
          const userOffset = new Date().getTimezoneOffset();
          const userOffsetHours = -userOffset / 60;
          const diffHours = 8 - userOffsetHours;
          return new Date(cnDate.getTime() - diffHours * 60 * 60 * 1000);
        }
      }
      customElements.define('account-coupons', AccountCoupons);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["account-input-text"] && !Shopify.designMode) return;
  try {
    $(function () {
    // 在这里编写需要在文档加载完成后执行的代码
    if (!customElements.get('input-text')) {
      customElements.define(
        'input-text',
        class inputText extends HTMLElement {
          constructor() {
            super();
          }
          requiredText = '';
          formatText = '';
          rule = '';
          connectedCallback() {
            this.init();
            const $container = $(this.querySelector('.input_text_container'));
            this.requiredText = $container.data('tipEmpty');
            this.formatText = $container.data('tipFormat');
            var ruleType = $container.data('rule');
            switch (ruleType) {
              case 'email':
                this.rule = ltUtils.rule.email;
                break;
              case 'password':
                this.rule = ltUtils.rule.password; // 密码规则: 至少包含一个字母和一个数字
                break;
              case 'password_confirmation':
                this.rule = ltUtils.rule.password_confirmation;
                break;
              // 其他规则可以继续添加
              default:
                this.rule = null; // 默认情况，如果没有匹配规则，可以设置为 null 或空正则
            }
          }

          init() {
            const _this = this;
            const $placeholder_text = $(this.querySelector('.placeholder_text'));
            this.addEventListener('click', function () {
              _this.focusInput();
              this.querySelector('.input_text_container').setAttribute('data-focus', 'true');
            });
            const $input = $(this.querySelector('input'));
            $input.on('change', function () {});

            // 获取input的value
            const value = $input.val();

            $input.blur(this.blurInput.bind(this));
          }

          focusInput() {
            const input = this.querySelector('input');

            if (input) {
              input.focus();
            }
          }

          blurInput() {
            this.querySelector('.input_text_container').setAttribute('data-focus', 'false');
            const $input = $(this.querySelector('input'));
            const value = $input.val();
            // 判断元素是否为必填
            const required = $input.attr('required');
            // 获取父元素为 input_text_container
            const $inputContainer = $input.parents('.input_text_container');
            // 获取与$inputContainer同级的 error-message元素
            const $errorMessage = $inputContainer.siblings('.error-message');
            if (!value) {
              const $placeholder_text = $(this.querySelector('.placeholder_text'));
              if (required) {
                $inputContainer.attr('data-error', 'true');
                $errorMessage.text(this.requiredText);
              }
            } else {
              if (this.rule) {
                if (this.rule.test(value)) {
                  $inputContainer.attr('data-error', 'false');
                } else {
                  $inputContainer.attr('data-error', 'true');
                  $errorMessage.text(this.formatText);
                }
              } else {
                $inputContainer.attr('data-error', 'false');
              }
            }

            if (window.location.pathname.includes('/account/reset')) {
              let reset_customer = $('.reset_customer')[0];
              const passwordInput = reset_customer.querySelector('input[name="customer[password]"]');
              const passwordConfirmInput = reset_customer.querySelector(
                'input[name="customer[password_confirmation]"]'
              );
              const inputContainer = passwordConfirmInput.closest('.input_text_container'); // 获取最近的父容器
              if (passwordConfirmInput.value && passwordInput.value !== passwordConfirmInput.value) {
                if (passwordConfirmInput) {
                  let siblingErrorMessage = Array.from(inputContainer.parentNode.children).find(
                    (child) => child !== inputContainer && child.classList.contains('error-message')
                  );

                  siblingErrorMessage.innerHTML = window.i18n.password_confirmation_different;
                  inputContainer.setAttribute('data-error', 'true');
                  return false;
                }
              } else if (passwordInput.value == passwordConfirmInput.value) {
                inputContainer.setAttribute('data-error', 'false');
              }
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["account-order-detail"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('account-order-detail')) {
      customElements.define(
        'account-order-detail',
        class AccountOrderDetail extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.initBack();
            this.initCopy();
            this.initOpenTrack();
          }
          initBack() {
            this.querySelector('.account-order-detail__header-back-wrapper').addEventListener('click', () => {
              window.litime.eventBus.publish('account:switchTab', 'orders');
              window.litime.eventBus.publish('account:updataOrdersTab', 'all');
            });
          }
          initCopy() {
            const copy = this.querySelectorAll('[data-action="copy"]');
            copy.forEach((item) => {
              item.addEventListener('click', () => {
                if (window.litime && window.litime.copyToClipboard) {
                  window.litime.copyToClipboard(item.getAttribute('data-copy-text'));
                } else if (navigator.clipboard && navigator.clipboard.writeText) {
                  navigator.clipboard.writeText(item.getAttribute('data-copy-text')).catch(() => {});
                  window.litime.showToast('success', window.i18n.copy_susscess);
                }
              });
            });
          }
          initOpenTrack() {
            const openTrack = this.querySelectorAll('[data-action="open-track"]');
            openTrack.forEach((item) => {
              item.addEventListener('click', () => {
                this.querySelector('account-order-track').open(item.getAttribute('data-track'));
              });
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["account-order-track"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('account-order-track')) {
      customElements.define(
        'account-order-track',
        class AccountOrderTrack extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.initClose();
            this.initTabs();
            this.initCopy();
            this.initTrack();
          }
          initTrack() {
            const tracks = this.querySelectorAll('.account-order-track__tab-content-track-content');
            tracks.forEach((track) => {
              this.initTrackSingle(track.getAttribute('data-track'));
            });
          }
          open(track) {
            this.setAttribute('data-show', 'true');
            if (window.litime && window.litime.disableScroll) {
              window.litime.disableScroll();
            }
            if (track) {
              this.switchTab(track);
            } else {
              this.switchTab(this.getAttribute('data-first-track'));
            }
          }
          initTrackSingle(track) {
            // 887324513746 测试
            let idAppend = '';
            if (this.getAttribute('data-type')) {
              idAppend = '-' + this.getAttribute('data-type');
            }
            let orderId = this.getAttribute('data-order-id');
            YQV5.trackSingle({
              YQ_ContainerId: `track-${orderId}-${track}${idAppend}`,
              YQ_Height: 350,
              YQ_Fc: '0',
              YQ_Num: track,
              YQ_RmAD: true,
              YQ_RmHeader: true,
              YQ_RmLink: true,
            });
          }
          initCopy() {
            const copies = this.querySelectorAll('.account-order-track__tab-content-track-header-content-copy');
            copies.forEach((copy) => {
              copy.addEventListener('click', () => {
                if (window.litime && window.litime.copyToClipboard) {
                  window.litime.copyToClipboard(copy.getAttribute('data-copy-text'));
                } else if (navigator.clipboard && navigator.clipboard.writeText) {
                  navigator.clipboard.writeText(copy.getAttribute('data-copy-text')).catch(() => {});
                  window.litime.showToast('success', window.i18n.copy_susscess);
                }
              });
            });
          }
          initTabs() {
            const tabs = this.querySelectorAll('.account-order-track__tab-item');
            tabs.forEach((tab) => {
              tab.addEventListener('click', () => {
                this.switchTab(tab.getAttribute('data-tab'));
              });
            });
          }
          switchTab(tab) {
            const tabs = this.querySelectorAll('.account-order-track__tab-item');
            tabs.forEach((t) => t.setAttribute('data-active', 'false'));
            const tabItem = this.querySelector(`.account-order-track__tab-item[data-tab="${tab}"]`);
            tabItem.setAttribute('data-active', 'true');
            const contents = this.querySelectorAll('.account-order-track__tab-content');
            contents.forEach((content) => content.setAttribute('data-active', 'false'));
            const content = this.querySelector(`.account-order-track__tab-content[data-tab="${tab}"]`);
            content.setAttribute('data-active', 'true');
            this.setAttribute('data-current-track', tab);
            let offset = 24;
            const tabBox = this.querySelector('.account-order-track__tab');
            const tabRect = tabItem.getBoundingClientRect();
            const boxRect = tabBox.getBoundingClientRect();
            const targetScroll = tabBox.scrollLeft + tabRect.left - boxRect.left - offset;
            tabBox.scrollTo({
              left: targetScroll,
              behavior: 'smooth',
            });
          }
          initClose() {
            this.querySelector('.account-order-track__header-close').addEventListener('click', () => {
              this.close();
            });
          }
          close() {
            this.setAttribute('data-show', 'false');
            if (window.litime && window.litime.enableScroll) {
              window.litime.enableScroll();
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["account-orders"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('account-orders')) {
      customElements.define(
        'account-orders',
        class AccountOrders extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            if (window.litime && typeof window.litime.onVisibleOnce === 'function') {
              window.litime.onVisibleOnce(this, () => {
                this.init();
              });
            } else {
              this.init();
            }
            window.litime.eventBus.subscribe('account:updateReviewPoints', (pointTasks) => {
              this.initPoints(pointTasks);
            });
            window.litime.eventBus.subscribe('account:updataOrdersTab', (tab) => {
              this.switchTab(tab);
            });
          }
          init() {
            this.initTabs();

            this.initExtend();
            this.initReview();
            this.initBack();
            this.initViewDetail();
            this.initViewTracking();
          }
          initViewTracking() {
            this.querySelectorAll('.account-orders__list-item-content-products-group-view').forEach((item) => {
              item.addEventListener('click', async (event) => {
                // 先if判断body中是否有和data-order-id相同的account-order-track，如果有则直接打开，如果没有则继续执行
                const orderTrackingItem = document.querySelector(
                  `.body-account-order-track[data-order-id="${item.getAttribute('data-order-id')}"]`
                );
                if (orderTrackingItem) {
                  orderTrackingItem.open(item.getAttribute('data-tracking-number'));
                  return;
                }
                if (item.getAttribute('data-loading') == 'true') {
                  return;
                }
                try {
                  item.setAttribute('data-loading', 'true');
                  const orderUrl = item.getAttribute('data-order-url');
                  await fetch(`${orderUrl}`)
                    .then((response) => response.text())
                    .then((responseText) => {
                      const html = new DOMParser().parseFromString(responseText, 'text/html');
                      const orderTrackingItem = html.querySelector('account-order-track');
                      // 增加一个class名
                      orderTrackingItem.classList.add('body-account-order-track');
                      orderTrackingItem.setAttribute('data-type', 'body');
                      // 批量修改id，获取现有id，在id后面加上-body
                      const tracks = orderTrackingItem.querySelectorAll(
                        '.account-order-track__tab-content-track-content'
                      );
                      tracks.forEach((track) => {
                        const id = track.getAttribute('id');
                        if (id) {
                          track.setAttribute('id', id + '-body');
                        }
                      });
                      // 插入到body的最后面
                      document.body.appendChild(orderTrackingItem);
                      orderTrackingItem.open(item.getAttribute('data-tracking-number'));
                    });
                } catch (error) {
                  console.log('account-orders initViewTracking error', error);
                } finally {
                  item.setAttribute('data-loading', 'false');
                }
              });
            });
          }
          initViewDetail() {
            this.querySelectorAll(
              '.account-orders__list-item-content-footer-view, .account-orders__list-item-mobile-footer-item-view'
            ).forEach((item) => {
              item.addEventListener('click', async (event) => {
                if (item.getAttribute('data-loading') == 'true') {
                  return;
                }
                try {
                  item.setAttribute('data-loading', 'true');
                  const orderUrl = item.getAttribute('data-order-url');
                  await fetch(`${orderUrl}`)
                    .then((response) => response.text())
                    .then((responseText) => {
                      const html = new DOMParser().parseFromString(responseText, 'text/html');
                      // 替换this元素的父级有一个main-customers-account-new，这个dom中的main-customers-account-new__right-item[data-tab="order-detail"]的dom
                      const mainCustomersAccountNew = this.closest('main-customers-account-new');
                      const orderDetailItem = mainCustomersAccountNew.querySelector(
                        '.main-customers-account-new__right-item[data-tab="order-detail"]'
                      );
                      orderDetailItem.innerHTML = html.querySelector('account-order-detail').outerHTML;
                      window.litime.eventBus.publish('account:switchTab', 'orders');
                      //  修改orderDetailItem为显示状态，并且将所有main-customers-account-new__right-item改为false，然后修改main-customers-account-new__right-item[data-tab="order-detail"]的data-active为true
                      mainCustomersAccountNew
                        .querySelectorAll('.main-customers-account-new__right-item')
                        .forEach((item) => {
                          item.setAttribute('data-active', 'false');
                        });
                      orderDetailItem.setAttribute('data-active', 'true');
                      // 同时修改浏览页路由，格式为orderUrl，类似https://dev-askstarry.myshopify.com/account/orders/d807e8da0afe72fc3078c7205bec2efb
                      window.history.replaceState({}, '', orderUrl);
                      window.scrollTo(0, 0);
                    });
                } catch (error) {
                  console.log('account-orders initViewDetail error', error);
                } finally {
                  item.setAttribute('data-loading', 'false');
                }
              });
            });
          }
          initBack() {
            this.querySelector('.account-orders__header-back').addEventListener('click', () => {
              window.litime.eventBus.publish('account:switchTab', 'overview');
            });
          }
          initPoints(pointTasks) {
            const points = this.querySelectorAll('.account-orders__list-item-content-products-item-review-points');
            const pointTask = pointTasks.find((item) => item.taskType == 6);
            if (pointTask && pointTask.point > 0) {
              points.forEach((point) => {
                point.setAttribute('data-show', 'true');
                point.querySelector(
                  '.account-orders__list-item-content-products-item-review-points-value'
                ).textContent = pointTask.point;
              });
            }
          }
          initTabs() {
            const tabs = this.querySelectorAll('.account-orders__tab-item');
            tabs.forEach((tab) => {
              tab.addEventListener('click', () => {
                tabs.forEach((t) => t.setAttribute('data-active', 'false'));
                tab.setAttribute('data-active', 'true');
                const contents = this.querySelectorAll('.account-orders__tab-content');
                contents.forEach((content) => content.setAttribute('data-active', 'false'));
                const currentContent = this.querySelector(
                  `.account-orders__tab-content[data-tab="${tab.getAttribute('data-tab')}"]`
                );
                currentContent.setAttribute('data-active', 'true');
                // 同时滚动到到tabs距离左边的32px，保证点击时完全显示出来
                let offset = 32;
                if (window.innerWidth <= 576) {
                  offset = 16;
                }
                const tabBox = this.querySelector('.account-orders__tab');
                const tabRect = tab.getBoundingClientRect();
                const boxRect = tabBox.getBoundingClientRect();
                const targetScroll = tabBox.scrollLeft + tabRect.left - boxRect.left - offset;
                tabBox.scrollTo({
                  left: targetScroll,
                  behavior: 'smooth',
                });
              });
            });
          }
          switchTab(tab) {
            const tabs = this.querySelectorAll('.account-orders__tab-item');
            tabs.forEach((t) => t.setAttribute('data-active', 'false'));
            const tabItem = this.querySelector(`.account-orders__tab-item[data-tab="${tab}"]`);
            tabItem.setAttribute('data-active', 'true');
            const contents = this.querySelectorAll('.account-orders__tab-content');
            contents.forEach((content) => content.setAttribute('data-active', 'false'));
            const content = this.querySelector(`.account-orders__tab-content[data-tab="${tab}"]`);
            content.setAttribute('data-active', 'true');
            let offset = 32;
            if (window.innerWidth <= 576) {
              offset = 16;
            }
            const tabBox = this.querySelector('.account-orders__tab');
            const tabRect = tabItem.getBoundingClientRect();
            const boxRect = tabBox.getBoundingClientRect();
            const targetScroll = tabBox.scrollLeft + tabRect.left - boxRect.left - offset;
            tabBox.scrollTo({
              left: targetScroll,
              behavior: 'smooth',
            });
          }
          initExtend() {
            this.querySelectorAll('.account-orders__list-item-more').forEach((btn) => {
              btn.addEventListener('click', () => {
                const listItem = btn.closest('.account-orders__list-item');
                const products = listItem.querySelector('.account-orders__list-item-content-products');

                const isOpen = listItem.getAttribute('data-extend') === 'true';
                listItem.setAttribute('data-extend', String(!isOpen));

                if (!isOpen) {
                  // ===== 展开 =====
                  products.style.height = 'auto';
                  const height = products.scrollHeight;

                  products.style.height = '0';
                  products.offsetHeight; // 强制 reflow

                  products.style.height = height + 'px';

                  // 动画结束后释放高度
                  products.addEventListener(
                    'transitionend',
                    () => {
                      if (listItem.getAttribute('data-extend') === 'true') {
                        products.style.height = 'auto';
                      }
                    },
                    { once: true }
                  );
                } else {
                  // ===== 收起 =====
                  const height = products.scrollHeight;
                  products.style.height = height + 'px';

                  products.offsetHeight; // reflow
                  products.style.height = '0';
                }
              });
            });
          }
          initReview() {
            this.querySelectorAll('.account-orders__list-item-content-products-item-review-button').forEach((btn) => {
              btn.addEventListener('click', () => {
                const productId = btn.getAttribute('product-id');
                let reviewId;
                switch (Shopify.shop) {
                  case 'dev-askstarry.myshopify.com':
                    // 新开页面
                    // reviewId = '5g9kzMkFjL';
                    // window.open(`https://loox.io/review-items/${reviewId}`, '_blank');
                    reviewId = 'ddf8da7e-1598-46af-9dad-172294e4196c';
                    window.open(
                      `https://judge.me/product_reviews/${reviewId}/new?id=${productId}&source=shareable-link`,
                      '_blank'
                    );
                    break;
                  case 'litime-us.myshopify.com':
                    // US
                    reviewId = '566a5e93-4d26-4b9c-be5e-534a3bd327a9';
                    window.open(
                      `https://judge.me/product_reviews/${reviewId}/new?id=${productId}&source=shareable-link`,
                      '_blank'
                    );
                    break;
                  case 'litime-2.myshopify.com':
                    // CA
                    reviewId = '38f2ef47-cd48-4b68-b501-27ac73de2f0d';
                    window.open(
                      `https://judge.me/product_reviews/${reviewId}/new?id=${productId}&source=shareable-link`,
                      '_blank'
                    );
                    break;
                  case 'litime-de.myshopify.com':
                    // DE
                    reviewId = 'c71a11c6-d74e-41f9-9d1a-3efa8f8ea150';
                    window.open(
                      `https://judge.me/product_reviews/${reviewId}/new?id=${productId}&source=shareable-link`,
                      '_blank'
                    );
                    break;

                  case 'db6773.myshopify.com':
                    // JP
                    // reviewId = '41lcB_945a';
                    // window.open(`https://loox.io/review-items/${reviewId}`, '_blank');
                    reviewId = 'e6abb637-57d8-41c4-a637-e1a1ee31b6b9';
                    window.open(
                      `https://judge.me/product_reviews/${reviewId}/new?id=${productId}&source=shareable-link`,
                      '_blank'
                    );
                    break;
                  case 'fc7982-5.myshopify.com':
                    // AU
                    reviewId = 'b7ff1511-bc99-4e8d-95c8-7e8808a9da04';
                    window.open(
                      `https://judge.me/product_reviews/${reviewId}/new?id=${productId}&source=shareable-link`,
                      '_blank'
                    );
                    break;
                  case '4e91b4-ff.myshopify.com':
                    // IT
                    reviewId = '27a27da6-d794-4fb0-9882-03d9289f9434';
                    window.open(
                      `https://judge.me/product_reviews/${reviewId}/new?id=${productId}&source=shareable-link`,
                      '_blank'
                    );
                    break;
                  // case 'litime-uk.myshopify.com':
                  //   // UK
                  //   break;
                  // case 'c010a7-c0.myshopify.com':
                  //   // FR
                  //   break;
                  // case '5141dc-dd.myshopify.com':
                  //   // ES
                  //   break;
                }
              });
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["account-overview"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('account-overview')) {
      customElements.define(
        'account-overview',
        class AccountOverview extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
            window.litime.eventBus.subscribe('account:updateAvatar', (res) => {
              this.initAvatar();
            });
            window.litime.eventBus.subscribe('account:updateUserInfo', (res) => {
              this.updateUserInfo();
            });
            window.litime.eventBus.subscribe('account:initMemberPoints', (res) => {
              this.init(res);
            });
          }
          init() {
            this.initMemberRewards();
            this.initMemberPoints();
            this.initAvatar();
            this.initEvent();
            this.initViewTracking();
          }
          initViewTracking() {
            this.querySelectorAll('.account-overview__order-item-footer-track').forEach((item) => {
              item.addEventListener('click', async (event) => {
                // 先if判断body中是否有和data-order-id相同的account-order-track，如果有则直接打开，如果没有则继续执行
                const orderTrackingItem = document.querySelector(
                  `.body-account-order-track[data-order-id="${item.getAttribute('data-order-id')}"]`
                );
                if (orderTrackingItem) {
                  orderTrackingItem.open(item.getAttribute('data-tracking-number'));
                  return;
                }
                if (item.getAttribute('data-loading') == 'true') {
                  return;
                }
                try {
                  item.setAttribute('data-loading', 'true');
                  const orderUrl = item.getAttribute('data-order-url');
                  await fetch(`${orderUrl}`)
                    .then((response) => response.text())
                    .then((responseText) => {
                      const html = new DOMParser().parseFromString(responseText, 'text/html');
                      const orderTrackingItem = html.querySelector('account-order-track');
                      // 增加一个class名
                      orderTrackingItem.classList.add('body-account-order-track');
                      orderTrackingItem.setAttribute('data-type', 'body');
                      // 批量修改id，获取现有id，在id后面加上-body
                      const tracks = orderTrackingItem.querySelectorAll(
                        '.account-order-track__tab-content-track-content'
                      );
                      tracks.forEach((track) => {
                        const id = track.getAttribute('id');
                        if (id) {
                          track.setAttribute('id', id + '-body');
                        }
                      });
                      // 插入到body的最后面
                      document.body.appendChild(orderTrackingItem);
                      orderTrackingItem.open(item.getAttribute('data-tracking-number'));
                    });
                } catch (error) {
                  console.log('account-orders initViewTracking error', error);
                } finally {
                  item.setAttribute('data-loading', 'false');
                }
              });
            });
          }
          initEvent() {
            this.querySelectorAll('.account-overview__info-right-item').forEach((item) => {
              item.addEventListener('click', () => {
                window.litime.eventBus.publish('account:switchTab', item.getAttribute('data-action'));
              });
            });
            this.querySelectorAll('.account-overview__order-header-more').forEach((item) => {
              item.addEventListener('click', () => {
                window.litime.eventBus.publish('account:switchTab', 'orders');
                window.litime.eventBus.publish('account:updataOrdersTab', 'all');
              });
            });
            this.querySelectorAll('.account-overview__order-item-footer-track').forEach((item) => {
              item.addEventListener('click', () => {
                window.litime.eventBus.publish('account:trackOrder', item.getAttribute('data-order-id'));
              });
            });
            this.querySelectorAll('.account-overview__order-item-footer-view').forEach((item) => {
              item.addEventListener('click', async (event) => {
                if (item.getAttribute('data-loading') == 'true') {
                  return;
                }
                try {
                  item.setAttribute('data-loading', 'true');
                  const orderUrl = item.getAttribute('data-order-url');
                  await fetch(`${orderUrl}`)
                    .then((response) => response.text())
                    .then((responseText) => {
                      const html = new DOMParser().parseFromString(responseText, 'text/html');
                      // 替换this元素的父级有一个main-customers-account-new，这个dom中的main-customers-account-new__right-item[data-tab="order-detail"]的dom
                      const mainCustomersAccountNew = this.closest('main-customers-account-new');
                      const orderDetailItem = mainCustomersAccountNew.querySelector(
                        '.main-customers-account-new__right-item[data-tab="order-detail"]'
                      );
                      orderDetailItem.innerHTML = html.querySelector('account-order-detail').outerHTML;
                      window.litime.eventBus.publish('account:switchTab', 'orders');
                      //  修改orderDetailItem为显示状态，并且将所有main-customers-account-new__right-item改为false，然后修改main-customers-account-new__right-item[data-tab="order-detail"]的data-active为true
                      mainCustomersAccountNew
                        .querySelectorAll('.main-customers-account-new__right-item')
                        .forEach((item) => {
                          item.setAttribute('data-active', 'false');
                        });
                      orderDetailItem.setAttribute('data-active', 'true');
                      window.history.replaceState({}, '', orderUrl);
                      window.scrollTo(0, 0);
                    });
                } catch (error) {
                  console.log('account-overview initViewDetail error', error);
                } finally {
                  item.setAttribute('data-loading', 'false');
                }
              });
            });
            this.querySelector('.account-overview__info-left-detail-name-edit').addEventListener('click', () => {
              window.litime.eventBus.publish('account:switchTab', 'profile');
              window.litime.eventBus.publish('account:profile:edit');
            });
          }
          async initMemberPoints(data) {
            const container = this.querySelector('.account-overview__info-left-detail-member-level-container');
            const level = this.querySelector('.account-overview__info-left-detail-member-level');
            const points = this.querySelector(
              '.account-overview__info-right-item[data-action="points"] .account-overview__info-right-item-value'
            );
            try {
              let res;
              if (data) {
                res = data;
              } else {
                res = await this.getMemberPoints();
              }
              if (res.settingName) {
                level.textContent = res.settingName;
                container.setAttribute('data-has-member-level', 'true');
              } else {
                container.setAttribute('data-has-member-level', 'false');
              }
              if (res.currentPoint) {
                points.textContent = res.currentPoint;
              }
            } catch (error) {
              container.setAttribute('data-has-member-level', 'false');
              console.log('initMemberPoints error', error);
            }
          }
          async initMemberRewards() {
            const coupons = this.querySelector(
              '.account-overview__info-right-item[data-action="coupons"] .account-overview__info-right-item-value'
            );
            try {
              const rewardsRes = await this.getMemberRewards({
                page: 1,
                pageSize: 999,
                status: 0,
              });
              if (rewardsRes.records && rewardsRes.records?.length > 0) {
                coupons.textContent = rewardsRes.records.length;
              }
            } catch (error) {
              console.log('initMemberRewards error', error);
            }
          }
          initAvatar() {
            const localUserInfo = window.litime.getLocalStorage('ltUserInfo');
            if (localUserInfo) {
              const avatarLink = localUserInfo.avatarLink;
              if (avatarLink) {
                this.querySelector('.account-overview__info-left-avatar-image').src = avatarLink;
                this.querySelector('.account-overview__info-left-avatar-container').setAttribute(
                  'data-has-avatar',
                  'true'
                );
              } else {
                this.querySelector('.account-overview__info-left-avatar-container').setAttribute(
                  'data-has-avatar',
                  'false'
                );
              }
            }
          }
          updateUserInfo() {
            const localUserInfo = window.litime.getLocalStorage('ltUserInfo');
            // 根据localUserInfo中的firstName 和 lastName 修改this元素的account-overview__info-left-detail-name-value
            if (localUserInfo && localUserInfo.firstName && localUserInfo.lastName) {
              this.querySelector(
                '.account-overview__info-left-detail-name-value'
              ).textContent = `${localUserInfo.firstName} ${localUserInfo.lastName}`;
            } else {
              // 只显示email的@前面的部分
              this.querySelector('.account-overview__info-left-detail-name-value').textContent =
                localUserInfo?.email.split('@')[0];
            }
          }
          async getMemberPoints() {
            const url = '/shopify/user/point';
            const { data, code } = await window.litime.http.get(url);
            if (code === 200) {
              return data;
            } else {
              throw new Error(window.i18n.error_message_timeout);
            }
          }
          async getMemberRewards(data) {
            const url = '/shopify/user/page/discount';
            const res = await window.litime.http.get(url, {
              data,
            });
            if (res.code === 200) {
              return res.data;
            } else {
              throw new Error(window.i18n.error_message_timeout);
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["account-points"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('account-points')) {
      customElements.define(
        'account-points',
        class AccountReferralRewards extends HTMLElement {
          constructor() {
            super();
            // 仅使用当前 account-points 片段附近的弹窗实例
            this.modal = null;
            this.flag = false;
          }
          async connectedCallback() {
            window.litime.eventBus.subscribe('account:getMemberPoints', (res) => {
              this.flag = false;
              this.init();
            });
            if (window.litime && window.litime.onVisibleOnce) {
              window.litime.onVisibleOnce(this, () => {
                this.init();
              });
            }
          }
          async init() {
            if (this.flag) return;
            this.flag = true;
            if (window.customer) {
              // 优先拿紧挨着本组件的那个 coupon-detail-modal（本页面自己的）
              const prev = this.previousElementSibling;
              if (prev && prev.tagName === 'COUPON-DETAIL-MODAL') {
                this.modal = prev;
              } else {
                // 兜底：再从全局里找（防止以后改了渲染位置）
                this.modal = document.querySelector('coupon-detail-modal');
              }
              const mainContainer = this.querySelector('.account-points');
              try {
                // 确保开始时是 loading 状态
                mainContainer.setAttribute('data-referral-type', 'loading');

                // 使用 Promise.allSettled 并发请求所有接口，确保即使某个请求失败也能继续执行
                const results = await Promise.allSettled([
                  this.getMemberPoints(),
                  this.getReferralRewards(),
                  this.getMemberRewards({ page: 1, pageSize: 999, status: 0 }), // available
                  this.getMemberRewards({ page: 1, pageSize: 999, status: 1 }), // used
                  this.getMemberRewards({ page: 1, pageSize: 999, status: 2 }), // expired
                ]);

                const pointInfo = results[0].status === 'fulfilled' ? results[0].value : null;
                const initialSignUpRewards = results[1].status === 'fulfilled' ? results[1].value : null;
                const availableRewards = results[2].status === 'fulfilled' ? results[2].value : null;
                const usedRewards = results[3].status === 'fulfilled' ? results[3].value : null;
                const expiredRewards = results[4].status === 'fulfilled' ? results[4].value : null;

                // 存储奖励数据
                this.rewardsData = {
                  available: availableRewards,
                  used: usedRewards,
                  expired: expiredRewards,
                };

                // 更新积分信息渲染（参考 member-banner.js 的 updateUserPoints 逻辑）
                if (pointInfo) {
                  window.litime.eventBus.publish('account:initMemberPoints', pointInfo);
                  // 更新 Current Tier
                  const referralSignUpCount = $(this.querySelector('.referral-sign-up-count'));
                  referralSignUpCount.text(pointInfo.settingName || '--');

                  // 更新 LiPoints Balance
                  const referralPurchaseCount = $(this.querySelector('.referral-purchase-count'));
                  referralPurchaseCount.text(pointInfo.currentPoint || 0);

                  // 更新进度条和需要积分文本
                  const memberPointCurrent = $(this.querySelector('.member-point-current'));
                  const memberPointTotal = $(this.querySelector('.member-point-total'));
                  const memberProgress = $(this.querySelector('.member-progress'));
                  const memberNeedPoints = $(this.querySelector('.member-need-points'));
                  const memberBannerMaxLevelWrapper = $(this.querySelector('.member-banner_max_level_wrapper'));
                  const memberBannerPointsWrapper = $(this.querySelector('.member-banner_points_wrapper'));

                  if (pointInfo.nextSettingValue && pointInfo.nextSettingName) {
                    // 显示进度条区域，隐藏 max level
                    memberBannerMaxLevelWrapper.addClass('account-points__hidden');
                    memberBannerPointsWrapper.removeClass('account-points__hidden');

                    if (pointInfo.settingType === 2) {
                      // 积分类型
                      memberPointCurrent.text(pointInfo.currentPoint);
                      memberPointTotal.text(pointInfo.nextSettingValue);
                      memberProgress.css(
                        '--progress',
                        `${Math.min(100, (pointInfo.currentPoint / pointInfo.nextSettingValue) * 100)}%`
                      );

                      const memberNeedPointsText = memberNeedPoints.text();
                      memberNeedPoints.html(
                        memberNeedPointsText
                          .replace(
                            '{{ tier }}',
                            `<span class="text-primary nextSettingName">${pointInfo.nextSettingName}</span>`
                          )
                          .replace(
                            '{{ points }}',
                            `<span class="text-primary upgradePoints">${
                              pointInfo.nextSettingValue - pointInfo.currentPoint
                            }</span>`
                          )
                      );
                    } else {
                      // 金额类型
                      memberPointCurrent.text(Math.floor(pointInfo.totalAmount));
                      memberPointTotal.text(pointInfo.nextSettingValue);
                      memberProgress.css(
                        '--progress',
                        `${Math.min(100, (pointInfo.totalAmount / pointInfo.nextSettingValue) * 100)}%`
                      );

                      const memberNeedPointsText = memberNeedPoints.attr('data-max-points');
                      memberNeedPoints.html(
                        memberNeedPointsText
                          .replace(
                            '{{ dollar }}',
                            `<span class="text-primary upgradePoints">${Math.floor(
                              pointInfo.nextSettingValue - Math.floor(pointInfo.totalAmount)
                            )}</span>`
                          )
                          .replace(
                            '{{ level }}',
                            `<span class="text-primary nextSettingName">${pointInfo.nextSettingName}</span>`
                          )
                      );
                    }
                  } else {
                    // 已达到最高等级
                    memberBannerMaxLevelWrapper.removeClass('account-points__hidden');
                    memberBannerPointsWrapper.addClass('account-points__hidden');
                    const maxLevelText = memberBannerMaxLevelWrapper.text();
                    memberBannerMaxLevelWrapper.html(maxLevelText.replace('{{ level }}', pointInfo.settingName));
                  }
                }

                // 监听窗口缩放，实时调整高度
                window.addEventListener('resize', () => {
                  const activeTable = this.querySelector(
                    '[data-table-type="sign-up"] .main-customers-account-new__left-item-referral-table'
                  );
                  if (activeTable) {
                    this.lockTableHeight(activeTable);
                  }
                });

                // 默认加载数据（直接使用已经 fetch 好的数据）
                // 确保移除 loading 状态
                if (initialSignUpRewards && Array.isArray(initialSignUpRewards) && initialSignUpRewards.length > 0) {
                  mainContainer.setAttribute('data-referral-type', 'sign-up');
                  const table = this.querySelector(
                    '[data-table-type="sign-up"] .main-customers-account-new__left-item-referral-table'
                  );
                  if (table) {
                    this.addTableRow(initialSignUpRewards, table);
                    this.lockTableHeight(table);
                  }
                } else {
                  mainContainer.setAttribute('data-referral-type', 'empty');
                }

                this.querySelector('.account-points__nav .back-btn').addEventListener('click', () => {
                  window.litime.eventBus.publish('account:switchTab', 'overview');
                });

                // 初始化奖励数据
                this.initRewards();
              } catch (error) {
                console.error('Referral init error:', error);
                mainContainer.setAttribute('data-referral-type', 'empty');
                window.litime.showToast('error', error.message);
              }
            }
          }

          // 初始化奖励
          initRewards() {
            this.currentRewardTab = 'available';
            this.setupRewardTabs();
            // 确保隐藏 loading
            this.hideRewardsLoading();
            // 直接使用已获取的数据，不需要重新请求
            if (this.rewardsData && this.rewardsData.available) {
              this.renderRewardsContent('available', this.rewardsData.available);
            } else {
              this.showRewardsEmpty('available');
            }

            // 监听窗口大小改变，重新渲染当前 tab
            let resizeTimer;
            window.addEventListener('resize', () => {
              clearTimeout(resizeTimer);
              resizeTimer = setTimeout(() => {
                if (this.rewardsData && this.rewardsData[this.currentRewardTab]) {
                  this.renderRewardsContent(this.currentRewardTab, this.rewardsData[this.currentRewardTab]);
                }
              }, 200);
            });
          }

          // 设置奖励 tabs 事件
          setupRewardTabs() {
            const tabs = this.querySelectorAll('[data-reward-tab]');
            tabs.forEach((tab) => {
              tab.addEventListener('click', () => {
                const tabType = tab.getAttribute('data-reward-tab');
                this.switchRewardTab(tabType);
              });
            });
          }

          // 切换奖励 tab
          switchRewardTab(tabType) {
            if (this.currentRewardTab === tabType) return;

            this.currentRewardTab = tabType;

            // 更新 tab 样式
            const tabs = this.querySelectorAll('[data-reward-tab]');
            tabs.forEach((tab) => {
              if (tab.getAttribute('data-reward-tab') === tabType) {
                tab.classList.add('active-tab');
              } else {
                tab.classList.remove('active-tab');
              }
            });

            // 使用已获取的数据，不需要重新请求
            if (this.rewardsData && this.rewardsData[tabType]) {
              this.renderRewardsContent(tabType, this.rewardsData[tabType]);
            } else {
              this.showRewardsEmpty(tabType);
            }
          }

          // 显示加载状态
          showRewardsLoading() {
            const loading = this.querySelector('.account-points__rewards-loading');
            const empty = this.querySelector('.account-points__rewards-empty');
            const contentItems = this.querySelectorAll('[data-reward-tab-content]');
            if (loading) loading.classList.remove('account-points__hidden');
            if (empty) empty.classList.add('account-points__hidden');
            contentItems.forEach((item) => item.classList.add('account-points__hidden'));
          }

          // 隐藏加载状态
          hideRewardsLoading() {
            const loading = this.querySelector('.account-points__rewards-loading');
            if (loading) loading.classList.add('account-points__hidden');
          }

          // 获取会员奖励列表
          async getMemberRewards(data) {
            const url = '/shopify/user/page/discount';
            const res = await window.litime.http.get(url, {
              data,
            });
            if (res.code === 200) {
              return res.data;
            } else {
              throw new Error(window.i18n.error_message_timeout);
            }
          }

          // 渲染奖励内容
          renderRewardsContent(tab, data) {
            this.hideRewardsLoading();

            if (!data || !data.records || data.records.length === 0) {
              this.showRewardsEmpty(tab);
              return;
            }

            this.hideRewardsEmpty();

            // 显示对应的内容区域
            const contentItems = this.querySelectorAll('[data-reward-tab-content]');
            contentItems.forEach((item) => {
              if (item.getAttribute('data-reward-tab-content') === tab) {
                item.classList.remove('account-points__hidden');
              } else {
                item.classList.add('account-points__hidden');
              }
            });

            const contentItem = this.querySelector(`[data-reward-tab-content="${tab}"]`);
            const rewardsListWrapper = contentItem.querySelector('.rewards-list_wrapper');
            const viewMoreBtn = contentItem.querySelector('.rewards-view-more-btn');
            const viewMoreText = viewMoreBtn.querySelector('.rewards-view-more-text');

            // 清空现有内容
            rewardsListWrapper.innerHTML = '';

            // 根据屏幕尺寸计算默认显示数量
            const defaultCount = this.getDefaultRewardsCount();
            const totalCount = data.records.length;
            const shouldShowViewMore = totalCount > defaultCount;

            // 创建奖励项
            data.records.forEach((item, index) => {
              const rewardItem = this.createRewardItem(item, tab);
              // 超出默认数量的项目默认隐藏
              if (index >= defaultCount) {
                rewardItem.classList.add('account-points__hidden');
              }
              rewardsListWrapper.appendChild(rewardItem);
            });

            // 显示/隐藏 view more 按钮
            if (shouldShowViewMore) {
              viewMoreBtn.classList.remove('account-points__hidden');
              // 只更新文本节点，保留图标
              this.updateViewMoreText(viewMoreText, window.i18n.view_more);
              // 重置图标状态（不反转）
              const icon = viewMoreBtn.querySelector('.rewards-view-more-icon');
              if (icon) {
                icon.classList.remove('rewards-view-more-icon--rotated');
              }
              // 移除旧的点击事件监听器
              const newBtn = viewMoreBtn.cloneNode(true);
              viewMoreBtn.parentNode.replaceChild(newBtn, viewMoreBtn);
              // 添加新的点击事件
              newBtn.addEventListener('click', () => {
                this.toggleRewardsViewMore(tab, defaultCount, totalCount);
              });
            } else {
              viewMoreBtn.classList.add('account-points__hidden');
            }
          }

          // 获取默认显示的奖励数量
          getDefaultRewardsCount() {
            if (window.innerWidth <= 576) {
              return 4; // 576以下：2列 x 2行 = 4个
            } else if (window.innerWidth <= 768) {
              return 3; // 768以下：3列 x 1行 = 3个
            } else {
              return 4; // 默认：4列 x 1行 = 4个
            }
          }

          // 更新 View More 文本（图标在按钮中，不在文本元素内）
          updateViewMoreText(viewMoreTextElement, newText) {
            // 图标现在在 rewards-view-more-btn 中，与文本是兄弟元素，直接更新文本即可
            viewMoreTextElement.textContent = newText;
          }

          // 切换显示更多/收起奖励
          toggleRewardsViewMore(tab, defaultCount, totalCount) {
            const contentItem = this.querySelector(`[data-reward-tab-content="${tab}"]`);
            const rewardsListWrapper = contentItem.querySelector('.rewards-list_wrapper');
            const viewMoreBtn = contentItem.querySelector('.rewards-view-more-btn');
            const viewMoreText = viewMoreBtn.querySelector('.rewards-view-more-text');
            const icon = viewMoreBtn.querySelector('.rewards-view-more-icon');
            const rewardItems = rewardsListWrapper.querySelectorAll('.reward-item');

            const isExpanded = !rewardItems[defaultCount]?.classList.contains('account-points__hidden');

            if (isExpanded) {
              // 收起：隐藏超出默认数量的项目
              rewardItems.forEach((item, index) => {
                if (index >= defaultCount) {
                  item.classList.add('account-points__hidden');
                }
              });
              // 只更新文本，保留图标
              this.updateViewMoreText(viewMoreText, window.i18n.view_more);
              // 移除图标反转
              if (icon) {
                icon.classList.remove('rewards-view-more-icon--rotated');
              }
            } else {
              // 展开：显示所有项目
              rewardItems.forEach((item) => {
                item.classList.remove('account-points__hidden');
              });
              // 只更新文本，保留图标
              this.updateViewMoreText(viewMoreText, window.i18n.view_less);
              // 添加图标反转
              if (icon) {
                icon.classList.add('rewards-view-more-icon--rotated');
              }
            }
          }

          // 创建奖励项
          createRewardItem(item, tab) {
            const template = this.querySelector('.reward-item-template .reward-item');
            if (!template) return null;

            const rewardItem = template.cloneNode(true);
            const img = rewardItem.querySelector('.member-redeem-img');
            const title = rewardItem.querySelector('.member-redeem-title');
            const codeContainer = rewardItem.querySelector('.member-redeem-code');
            const codeSpan = rewardItem.querySelector('.member-redeem-code span');
            const copyIcon = rewardItem.querySelector('.copy-icon');
            const date = rewardItem.querySelector('.member-redeem-date');

            if (item.icon) {
              img.src = item.icon;
              img.alt = item.rewardName || 'reward';
            }
            // 对齐 account-coupons：点击图片时打开 coupon-detail-modal 弹窗
            img.addEventListener('click', () => {
              console.log('点击');
              if (this.modal && typeof this.modal.open === 'function') {
                console.log('点击222');
                this.modal.open(item);
              }
            });
            if (tab === 'expired') {
              img.style.filter = 'grayscale(1)';
            }

            if (title) {
              title.textContent = item.rewardName || '';
            }

            if (codeSpan) {
              codeSpan.textContent = item.discountCode || '';
            }

            // 状态为 2（已过期）时，添加 status-expired 类，通过 CSS 控制颜色
            if (item.status === 2) {
              rewardItem.classList.add('status-expired');
            }

            // 复制按钮始终显示，所有状态都可以复制
            if (copyIcon && item.discountCode) {
              copyIcon.style.display = '';
              copyIcon.addEventListener('click', (e) => {
                e.stopPropagation();
                window.litime.copyToClipboard(item.discountCode);
              });
            }

            if (date) {
              if (item.expiredAt) {
                const localTime = this.switchTimeZone(item.expiredAt);
                const expiresOnText = window.i18n.member_expires_on;
                date.textContent = expiresOnText.replace('{date}', localTime.toLocaleDateString());
              } else {
                date.textContent = window.i18n.member_no_expiration_date || 'No expiration date';
              }
            }

            return rewardItem;
          }

          // 显示空状态
          showRewardsEmpty(tab) {
            const empty = this.querySelector('.account-points__rewards-empty');
            const contentItems = this.querySelectorAll('[data-reward-tab-content]');

            contentItems.forEach((item) => item.classList.add('account-points__hidden'));
            empty.classList.remove('account-points__hidden');
          }

          // 隐藏空状态
          hideRewardsEmpty() {
            const empty = this.querySelector('.account-points__rewards-empty');
            if (empty) empty.classList.add('account-points__hidden');
          }

          // 动态计算并锁定表格高度
          lockTableHeight(table) {
            const wrapper = table.closest('.table-container_wrapper');
            if (!wrapper) return;

            const thead = table.querySelector('thead');
            const rows = table.querySelectorAll('tbody tr');

            if (!thead || rows.length === 0) return;

            // 1440以下取前10条，否则取前5条
            const targetLimit = window.innerWidth <= 1440 ? 10 : 5;

            if (rows.length <= targetLimit) {
              wrapper.style.maxHeight = 'none';
              return;
            }

            // 使用 requestAnimationFrame 确保获取的是渲染后的最新尺寸
            requestAnimationFrame(() => {
              const headerRect = thead.getBoundingClientRect();
              const targetRowRect = rows[targetLimit - 1].getBoundingClientRect();

              // 总高度 = 目标行底部 - 表头顶部
              // 加 1px 缓冲，解决浏览器缩放导致的像素舍入误差
              const calculatedMaxHeight = targetRowRect.bottom - headerRect.top + 1;

              wrapper.style.maxHeight = calculatedMaxHeight + 'px';
            });
          }

          // 获取会员积分信息（参考 member-banner.js）
          async getMemberPoints() {
            const url = '/shopify/user/point';
            const { data, code } = await window.litime.http.get(url);
            if (code === 200) {
              return data;
            } else {
              return null;
            }
          }
          // 获取积分日志
          async getReferralRewards() {
            const url = '/shopify/user/pointLog';
            const res = await window.litime.http.get(url);
            if (res.code === 200) {
              return res.data;
            } else {
              throw new Error(window.i18n.error_message_timeout);
            }
          }

          addTableRow(data, container) {
            const tbody = container.querySelector('tbody');
            tbody.innerHTML = '';
            data.forEach((item) => {
              const tr = document.createElement('tr');
              let pointNumber = 0;
              if (!item.isLimit) {
                const match = item.pointDesc.match(/-?\d+/);
                if (match) {
                  pointNumber = parseInt(match[0]);
                }
              }
              const userDate = this.switchTimeZone(item.createdTime);
              tr.innerHTML = `
                  <td>${item.businessName}</td>
                  ${
                    item.isLimit
                      ? `<td class="points-negative">${item.pointDesc}</td>`
                      : `<td class="${pointNumber > 0 ? 'points-positive' : 'points-negative'}">${item.pointDesc}</td>`
                  }
                  <td>${userDate.toLocaleString()}</td>
                  `;

              tbody.append(tr);
            });
          }
          // 切换时区时间
          switchTimeZone(cnTime) {
            // 创建北京时间对象
            const cnDate = new Date(cnTime);

            // 获取用户时区偏移（分钟）
            const userOffset = new Date().getTimezoneOffset();

            // 将用户偏移转换为小时（注意：getTimezoneOffset 返回的是负值）
            const userOffsetHours = -userOffset / 60;

            // 计算时差（小时）
            const diffHours = 8 - userOffsetHours;

            // 转换为用户本地时间
            return new Date(cnDate.getTime() - diffHours * 60 * 60 * 1000);
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["account-profile"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('account-profile')) {
      customElements.define(
        'account-profile',
        class AccountProfile extends HTMLElement {
          constructor() {
            super();
            // 获取 country.json 的 URL
            this.countryJsonUrl = window.accountProfileCountryJsonUrl || '';
            this.countryData = null;
            this.typeData = null;
          }
          connectedCallback() {
            this.init();
          }
          // 加载国家数据
          loadCountryData() {
            var self = this;
            return new Promise(function (resolve, reject) {
              if (self.countryData) {
                resolve(self.countryData);
                return;
              }
              fetch(self.countryJsonUrl)
                .then(function (response) {
                  if (!response.ok) {
                    throw new Error('Failed to load country data');
                  }
                  return response.json();
                })
                .then(function (data) {
                  self.countryData = data;
                  resolve(data);
                })
                .catch(function (error) {
                  console.error('Error loading country data:', error);
                  reject(error);
                });
            });
          }

          // 初始化国家下拉选项
          initCountryDropdown(section) {
            var self = this;
            var countryList = section.querySelector('[data-country-list]');
            var alphabetNav = section.querySelector('[data-country-alphabet-nav]');
            var countryTrigger = section.querySelector('[data-country-trigger]');
            var countryPanel = section.querySelector('[data-country-panel]');
            if (!countryList || !countryTrigger || !countryPanel) return;

            // 提前找到滚动容器
            var listContainer = countryList.parentElement;
            if (!listContainer || !listContainer.classList.contains('account-dropdown-list-container')) {
              listContainer = countryList.closest('.account-dropdown-list-container');
            }

            // 独立的下拉菜单显示/隐藏逻辑
            var isOpen = false;
            var toggleDropdown = function (skipResetSearch) {
              if (isOpen) {
                countryPanel.classList.remove('is-open');
                countryTrigger.classList.remove('open');
                isOpen = false;

                // 关闭下拉菜单时，恢复所有国家显示（不清空搜索框内容，因为已选中的国家名应该保留）
                if (!skipResetSearch) {
                  allCountryItems.forEach(function (item) {
                    item.style.display = '';
                  });
                  if (alphabetNav) {
                    alphabetNav.style.display = '';
                  }
                }
              } else {
                countryPanel.classList.add('is-open');
                countryTrigger.classList.add('open');
                isOpen = true;
              }
            };

            // 获取搜索 input 元素
            var searchInput = countryTrigger.querySelector('.account-country-search-input');
            var allCountryItems = []; // 存储所有国家选项，用于搜索过滤

            // 初始化 selectedCountryName（从 input 的当前值获取）
            if (!countryTrigger.dataset.selectedCountryName && searchInput) {
              countryTrigger.dataset.selectedCountryName = searchInput.value || '';
            }

            // 点击 trigger 显示/隐藏下拉菜单
            countryTrigger.addEventListener('click', function (e) {
              if (countryTrigger.disabled) return;
              // 如果点击的是 input 元素，不切换下拉菜单
              if (e.target === searchInput) return;
              e.preventDefault();
              e.stopPropagation();
              toggleDropdown();
            });

            // 搜索 input 获得焦点时打开下拉菜单
            if (searchInput) {
              searchInput.addEventListener('focus', function (e) {
                if (countryTrigger.disabled || searchInput.readOnly) return;
                if (!isOpen) {
                  toggleDropdown();
                }
              });

              // 搜索 input 失去焦点时恢复默认值或清空
              searchInput.addEventListener('blur', function (e) {
                // 延迟执行，以便点击选项时能够正常选择
                setTimeout(function () {
                  // 先关闭下拉菜单
                  if (isOpen) {
                    toggleDropdown();
                  }

                  // 获取已保存的国家名称
                  var savedCountryName = countryTrigger.dataset.selectedCountryName || '';

                  // 如果有原本选中的国家，恢复到原本的国家
                  if (savedCountryName) {
                    searchInput.value = savedCountryName;
                  } else {
                    // 如果没有原本选中的国家，清空输入框
                    searchInput.value = '';
                    countryTrigger.dataset.value = '';

                    // 移除 is-filled 状态
                    var field = countryTrigger.closest('.floating-field');
                    if (field) {
                      field.classList.remove('is-filled');
                    }
                  }

                  // 恢复所有国家显示
                  allCountryItems.forEach(function (item) {
                    item.style.display = '';
                  });
                  if (alphabetNav) {
                    alphabetNav.style.display = '';
                  }
                }, 200);
              });

              // 搜索 input 输入事件：过滤国家列表
              searchInput.addEventListener('input', function (e) {
                var searchTerm = searchInput.value.toLowerCase().trim();

                // 过滤所有国家选项
                allCountryItems.forEach(function (item) {
                  var countryName = item.textContent.toLowerCase();
                  if (searchTerm === '' || countryName.indexOf(searchTerm) !== -1) {
                    item.style.display = '';
                  } else {
                    item.style.display = 'none';
                  }
                });

                // 如果搜索框为空，重新显示所有国家和字母表导航
                if (searchTerm === '') {
                  if (alphabetNav) {
                    alphabetNav.style.display = '';
                  }
                } else {
                  // 有搜索内容时，隐藏字母表导航
                  if (alphabetNav) {
                    alphabetNav.style.display = 'none';
                  }
                }
              });

              // 阻止 input 的点击事件冒泡，避免触发 trigger 的点击事件
              searchInput.addEventListener('click', function (e) {
                e.stopPropagation();
                if (!isOpen && !countryTrigger.disabled && !searchInput.readOnly) {
                  toggleDropdown();
                }
              });
            }

            // 点击选项后更新显示并关闭下拉菜单
            var handleCountrySelect = function (item) {
              var value = item.getAttribute('data-value');
              var text = item.textContent.trim();

              // 保存选中的国家名称到 dataset
              countryTrigger.dataset.selectedCountryName = text;

              // 更新 trigger 显示（input 元素）
              if (searchInput) {
                searchInput.value = text;
              }
              countryTrigger.dataset.value = value;

              // 更新浮动标签状态
              var field = countryTrigger.closest('.floating-field');
              if (field) {
                field.classList.add('is-filled');
                field.classList.remove('field-error');
              }

              // 清空搜索，显示所有国家
              if (searchInput) {
                searchInput.value = text; // 保留选中的国家名称
              }
              allCountryItems.forEach(function (item) {
                item.style.display = '';
              });
              if (alphabetNav) {
                alphabetNav.style.display = '';
              }

              // 关闭下拉菜单
              toggleDropdown();
            };

            // 点击外部关闭下拉菜单
            var handleClickOutside = function (e) {
              if (isOpen && !countryPanel.contains(e.target) && !countryTrigger.contains(e.target)) {
                toggleDropdown();
              }
            };
            document.addEventListener('click', handleClickOutside);

            this.loadCountryData()
              .then(function (countries) {
                // 清空现有选项
                countryList.innerHTML = '';
                // 按国家名称排序
                var sortedCountries = countries.slice().sort(function (a, b) {
                  return a.country.localeCompare(b.country);
                });

                // 生成字母表导航
                if (alphabetNav) {
                  alphabetNav.innerHTML = '';
                  var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
                  var availableLetters = new Set();

                  // 收集所有可用的首字母
                  sortedCountries.forEach(function (country) {
                    var firstLetter = country.country.charAt(0).toUpperCase();
                    if (alphabet.includes(firstLetter)) {
                      availableLetters.add(firstLetter);
                    }
                  });

                  // 生成字母表导航项（只显示有对应国家的字母）
                  alphabet.forEach(function (letter) {
                    // 如果该字母没有对应的国家，直接跳过，不显示
                    if (!availableLetters.has(letter)) {
                      return;
                    }

                    var navItem = document.createElement('div');
                    navItem.className = 'account-dropdown-alphabet-nav-item';
                    navItem.textContent = letter;
                    navItem.setAttribute('data-letter', letter);

                    navItem.addEventListener('click', function (e) {
                      e.preventDefault();
                      e.stopPropagation();
                      e.stopImmediatePropagation(); // 阻止所有事件传播

                      // 移除其他 active 状态
                      alphabetNav.querySelectorAll('.account-dropdown-alphabet-nav-item').forEach(function (item) {
                        item.classList.remove('active');
                      });
                      navItem.classList.add('active');

                      // 独立处理滚动，不依赖任何全局下拉管理器
                      // 确保下拉菜单是打开的
                      var wasClosed = !isOpen;
                      if (wasClosed) {
                        toggleDropdown();
                      }

                      // 直接通过闭包中的 countryList 查找目标项
                      var targetItem = countryList.querySelector('[data-letter="' + letter + '"]');
                      if (targetItem) {
                        // 重新查找滚动容器，确保在正确的作用域内
                        var scrollContainer = countryList.parentElement;
                        if (scrollContainer && scrollContainer.classList.contains('account-dropdown-list-container')) {
                          // 如果下拉菜单刚打开，需要等待它完全展开
                          var delay = wasClosed ? 200 : 0;

                          setTimeout(function () {
                            // 计算目标项相对于滚动容器的位置
                            var scrollTop = targetItem.offsetTop;

                            // 使用 scrollTo 方法实现平滑滚动
                            if (scrollContainer.scrollTo) {
                              scrollContainer.scrollTo({
                                top: scrollTop,
                                behavior: 'smooth',
                              });
                            } else {
                              // 降级方案：直接设置 scrollTop（CSS scroll-behavior: smooth 会处理动画）
                              scrollContainer.scrollTop = scrollTop;
                            }
                          }, delay);
                        }
                      }
                    });

                    alphabetNav.appendChild(navItem);
                  });
                }

                // 生成选项
                sortedCountries.forEach(function (country) {
                  var li = document.createElement('li');
                  li.className = 'select-options-item account-dropdown-item';
                  li.setAttribute('data-value', country.code.toLowerCase());
                  var firstLetter = country.country.charAt(0).toUpperCase();
                  li.setAttribute('data-letter', firstLetter);
                  li.textContent = country.country;

                  // 添加点击事件处理
                  li.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    handleCountrySelect(li);
                  });

                  countryList.appendChild(li);

                  // 保存到 allCountryItems 数组，用于搜索过滤
                  allCountryItems.push(li);
                });

                // 添加滚动监听，高亮当前可见的字母
                // listContainer 已在函数开头定义，直接使用
                if (listContainer) {
                  var lastActiveLetter = null;

                  var updateActiveLetter = function () {
                    var scrollTop = listContainer.scrollTop;
                    var items = countryList.querySelectorAll('.account-dropdown-item');
                    var activeLetter = null;

                    // 查找当前可见的第一个国家
                    for (var i = 0; i < items.length; i++) {
                      var item = items[i];
                      var itemTop = item.offsetTop - listContainer.scrollTop;
                      if (itemTop >= 0) {
                        activeLetter = item.getAttribute('data-letter');
                        break;
                      }
                    }

                    // 如果没有找到，使用最后一个可见的
                    if (!activeLetter && items.length > 0) {
                      for (var j = items.length - 1; j >= 0; j--) {
                        var item = items[j];
                        var itemTop = item.offsetTop - listContainer.scrollTop;
                        var itemHeight = item.offsetHeight;
                        if (itemTop + itemHeight > 0) {
                          activeLetter = item.getAttribute('data-letter');
                          break;
                        }
                      }
                    }

                    // 更新字母表导航的 active 状态
                    if (activeLetter && activeLetter !== lastActiveLetter && alphabetNav) {
                      alphabetNav.querySelectorAll('.account-dropdown-alphabet-nav-item').forEach(function (navItem) {
                        navItem.classList.remove('active');
                      });
                      var activeNavItem = alphabetNav.querySelector('[data-letter="' + activeLetter + '"]');
                      if (activeNavItem) {
                        activeNavItem.classList.add('active');
                      }
                      lastActiveLetter = activeLetter;
                    }
                  };

                  listContainer.addEventListener('scroll', updateActiveLetter);
                  // 初始化时也更新一次
                  setTimeout(updateActiveLetter, 100);
                }
              })
              .catch(function (error) {
                console.error('Failed to initialize country dropdown:', error);
              });
          }

          // 加载 Type 数据
          loadTypeData() {
            var self = this;
            return new Promise(function (resolve, reject) {
              if (self.typeData) {
                resolve(self.typeData);
                return;
              }
              // 使用 window.litime.http 发送 GET 请求
              if (window.litime && window.litime.http && typeof window.litime.http.get === 'function') {
                window.litime.http
                  .get('/shopify/user/list/type')
                  .then(function (res) {
                    if (res && res.code === 200 && res.data) {
                      self.typeData = res.data;
                      resolve(res.data);
                    } else {
                      throw new Error(res.message);
                    }
                  })
                  .catch(function (error) {
                    console.error('Error loading type data:', error);
                    reject(error);
                  });
              }
            });
          }

          // 初始化 Type 下拉选项
          initTypeDropdown(section) {
            var self = this;
            var typeList = section.querySelector('[data-type-list]');
            if (!typeList) return;

            this.loadTypeData()
              .then(function (types) {
                // 清空现有选项
                typeList.innerHTML = '';
                // 生成选项
                if (Array.isArray(types)) {
                  types.forEach(function (type) {
                    var li = document.createElement('li');
                    li.className = 'select-options-item account-dropdown-item';
                    // 假设接口返回的数据结构包含 id 和 name 字段，根据实际接口调整
                    var value = type.id || type.value || type.code || '';
                    var label = type.name || type.label || type.text || '';
                    li.setAttribute('data-value', String(value).toLowerCase());
                    li.setAttribute('data-type-data', JSON.stringify(type)); // 存储完整数据
                    li.textContent = label;
                    typeList.appendChild(li);
                  });
                }
              })
              .catch(function (error) {
                console.error('Failed to initialize type dropdown:', error);
              });
          }

          // 显示/隐藏 Application 复选框
          updateApplicationCheckboxes(section, typeId) {
            var applicationRow = section.querySelector('[data-application-row]');
            var applicationList = section.querySelector('[data-application-list]');
            if (!applicationRow || !applicationList) return;

            // 查找选中的 Type 数据
            var selectedType = null;
            if (this.typeData && Array.isArray(this.typeData)) {
              selectedType = this.typeData.find(function (t) {
                var tId = t.id || t.value || t.code;
                return String(tId) === String(typeId);
              });
            }

            // 如果有 children，显示 Application 复选框
            if (
              selectedType &&
              selectedType.children &&
              Array.isArray(selectedType.children) &&
              selectedType.children.length > 0
            ) {
              applicationRow.classList.add('is-visible');
              // 清空现有复选框
              applicationList.innerHTML = '';
              // 生成复选框
              selectedType.children.forEach(function (child) {
                var item = document.createElement('div');
                item.className = 'account-profile-application-item';

                var checkbox = document.createElement('input');
                checkbox.type = 'checkbox';
                checkbox.className = 'account-profile-application-checkbox';
                checkbox.id = 'application-' + (child.id || child.value || child.code || '');
                checkbox.setAttribute('data-application-id', child.id || child.value || child.code || '');

                var label = document.createElement('label');
                label.className = 'account-profile-application-label-text';
                label.setAttribute('for', checkbox.id);
                label.textContent = child.name || child.label || child.text || '';

                item.appendChild(checkbox);
                item.appendChild(label);
                applicationList.appendChild(item);
              });
            } else {
              applicationRow.classList.remove('is-visible');
              applicationList.innerHTML = '';
            }
          }
          async uploadAvatar(file) {
            const formData = new FormData();
            formData.append('image', file);
            try {
              const res = await window.litime.http.post('/shopify/user/update', {
                data: formData,
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              });
              if (res.code === 200) {
                window.litime.showToast('success', window.i18n.request_successful);
                // 可选：更新本地存储或页面显示
                window.litime.setLocalStorage('ltUserInfo', { ...res.data });
                return res.data;
              } else if (res.code === 10052001) {
                throw new Error(window.i18n.error_message_10052001);
              } else if (res.code === 10052002) {
                throw new Error(window.i18n.error_message_10052002);
              } else if (res.code === 10052003) {
                throw new Error(window.i18n.error_message_10052003);
              } else if (res.code === 10052004) {
                throw new Error(window.i18n.error_message_10052004);
              } else if (res.code === 10052005) {
                throw new Error(window.i18n.error_message_10052005);
              } else {
                throw new Error(res.message || window.i18n.request_failed);
              }
            } catch (err) {
              throw new Error(err);
            }
          }
          // 初始化组件
          init() {
            var section = this.querySelector('[data-account-profile]');
            if (!section) return;

            // 返回按钮点击事件
            var backBtn = this.querySelector('.account-profile-back-btn');
            if (backBtn) {
              backBtn.addEventListener('click', function () {
                if (window.litime && window.litime.eventBus && typeof window.litime.eventBus.publish === 'function') {
                  window.litime.eventBus.publish('account:switchTab', 'overview');
                }
              });
            }

            var editBtn = section.querySelector('[data-account-profile-edit]');
            if (!editBtn) return;

            // 初始化国家下拉选项
            this.initCountryDropdown(section);
            // 初始化 Type 下拉选项
            this.initTypeDropdown(section);

            var editableElements = section.querySelectorAll('.js-account-editable');
            var saveBtn = section.querySelector('[data-account-profile-save]');
            var cancelBtn = section.querySelector('[data-account-profile-cancel]');
            var dobInput = section.querySelector('#account-dob');
            var avatarTrigger = section.querySelector('[data-account-avatar-trigger]');
            var avatarTriggerContainer = this.querySelector('.account-profile-avatar');
            var avatarInput = null;

            // 头像选择（仅前端触发事件，具体上传由上层处理）
            if (avatarTrigger) {
              avatarInput = document.createElement('input');
              avatarInput.type = 'file';
              avatarInput.accept = 'image/*';
              avatarInput.style.display = 'none';
              avatarTrigger.appendChild(avatarInput);

              var self = this;
              avatarTrigger.addEventListener('click', function () {
                avatarInput.click();
              });

              avatarInput.addEventListener('change', async function () {
                var file = avatarInput.files && avatarInput.files[0];
                if (!file) return;

                // 本地预览
                var url = URL.createObjectURL(file);
                var img = avatarTrigger.querySelector('img');
                var placeholder = avatarTrigger.querySelector('span');
                // 上传头像后：移除首字母样式，恢复白底
                avatarTriggerContainer.classList.remove('is-initial');
                if (placeholder) {
                  placeholder.style.display = 'none';
                }
                if (!img) {
                  img = document.createElement('img');
                  avatarTrigger.insertBefore(img, avatarTrigger.firstChild);
                }
                img.src = url;

                // 上传头像到服务器
                try {
                  const formData = new FormData();
                  formData.append('image', file);

                  const res = await window.litime.http.post('/shopify/user/update', {
                    data: formData,
                    headers: {
                      'Content-Type': 'multipart/form-data',
                    },
                  });

                  if (res.code === 200) {
                    window.litime.showToast('success', window.i18n.request_successful);
                    // 更新本地存储
                    if (window.litime && typeof window.litime.setLocalStorage === 'function') {
                      window.litime.setLocalStorage('ltUserInfo', { ...res.data });
                      window.litime.eventBus.publish('account:updateAvatar', res.data);
                    }
                  } else if (res.code === 10052001) {
                    throw new Error(window.i18n.error_message_10052001);
                  } else if (res.code === 10052002) {
                    throw new Error(window.i18n.error_message_10052002);
                  } else if (res.code === 10052003) {
                    throw new Error(window.i18n.error_message_10052003);
                  } else if (res.code === 10052004) {
                    throw new Error(window.i18n.error_message_10052004);
                  } else if (res.code === 10052005) {
                    throw new Error(window.i18n.error_message_10052005);
                  } else {
                    throw new Error(res.message || window.i18n.request_failed);
                  }
                } catch (err) {
                  console.error('上传头像失败:', err);
                  window.litime.showToast('error', err.message || window.i18n.request_failed);
                  // 上传失败时恢复原始头像
                  if (img && img.src && img.src.startsWith('blob:')) {
                    URL.revokeObjectURL(img.src);
                    img.remove();
                    if (placeholder) {
                      placeholder.style.display = '';
                    }
                  }
                }

                // 向外派发事件，通知其他组件（可选）
                var changeEvent = new CustomEvent('account-profile:avatar-change', {
                  detail: {
                    file: file,
                    section: section,
                  },
                });
                document.dispatchEvent(changeEvent);
              });
            }

            // 从 localStorage 读取用户信息
            var getUserInfoFromStorage = function () {
              try {
                var stored = localStorage.getItem('ltUserInfo');
                if (stored) {
                  return JSON.parse(stored);
                }
              } catch (e) {
                console.error('Failed to parse ltUserInfo from localStorage:', e);
              }
              return null;
            };

            // 获取表单元素
            var firstNameEl = section.querySelector('#account-first-name');
            var lastNameEl = section.querySelector('#account-last-name');
            var dobEl = section.querySelector('#account-dob');
            var phoneEl = section.querySelector('#account-phone');
            var genderTrigger = section.querySelector('[data-dropdown-trigger="account-gender"]');
            var countryTrigger = section.querySelector('[data-country-trigger]');
            var typeTrigger = section.querySelector('[data-dropdown-trigger="account-type"]');
            var greetingEmailEl = section.querySelector('.account-profile-greeting-email');

            // 从 localStorage 读取数据并填充表单（默认使用 localStorage 数据）
            var userInfo = getUserInfoFromStorage();
            // 填充 First Name（使用 localStorage 数据）
            if (firstNameEl) {
              firstNameEl.value = userInfo && userInfo.firstName ? userInfo.firstName : '';
            }
            // 填充 Last Name（使用 localStorage 数据）
            if (lastNameEl) {
              lastNameEl.value = userInfo && userInfo.lastName ? userInfo.lastName : '';
            }
            // 填充 Date of Birth（使用 localStorage 数据）
            if (dobEl) {
              dobEl.value = userInfo && userInfo.birthday ? userInfo.birthday : '';
            }
            // 填充 Phone Number（使用 localStorage 数据）
            if (phoneEl) {
              phoneEl.value = userInfo && userInfo.phone ? userInfo.phone : '';
            }
            if (userInfo) {
              // 填充 Gender（如果存在且不为 null）
              if (genderTrigger && userInfo.gender) {
                // 将数字格式转换为字符串，支持 1、2、3 或 "male"、"female"、"other"
                var genderNum = parseInt(userInfo.gender, 10);
                var genderValue = '';
                var genderLabel = '';

                if (!isNaN(genderNum)) {
                  // 数字格式：1=male, 2=female, 3=other
                  genderValue = String(genderNum);
                  genderLabel =
                    genderNum === 1
                      ? window.i18n.male
                      : genderNum === 2
                      ? window.i18n.female
                      : window.i18n.prefer_not_to_say;
                } else {
                  // 字符串格式（兼容旧数据）
                  var genderStr = String(userInfo.gender).toLowerCase();
                  if (genderStr === 'male') {
                    genderValue = '1';
                    genderLabel = window.i18n.male;
                  } else if (genderStr === 'female') {
                    genderValue = '2';
                    genderLabel = window.i18n.female;
                  } else if (genderStr === 'other') {
                    genderValue = '3';
                    genderLabel = window.i18n.prefer_not_to_say;
                  }
                }

                if (genderValue) {
                  genderTrigger.dataset.value = genderValue;
                  var gLabelSpan = genderTrigger.querySelector('.account-select-label');
                  if (gLabelSpan) {
                    gLabelSpan.textContent = genderLabel;
                  }
                  // 更新浮动标签状态
                  var genderField = genderTrigger.closest('.floating-field');
                  if (genderField) {
                    genderField.classList.add('is-filled');
                  }
                }
              }
              // 填充 Country（使用 localStorage 数据，从 country.json 匹配）
              if (countryTrigger && userInfo.country) {
                var countryCode = String(userInfo.country).toLowerCase();
                countryTrigger.dataset.value = countryCode;
                var countryLabel = String(userInfo.country).toUpperCase();
                var cLabelSpan = countryTrigger.querySelector('.account-select-label');
                var countryField = countryTrigger.closest('.floating-field');
                if (cLabelSpan) {
                  // 尝试从 country.json 数据中查找匹配的国家名称
                  var self = this;
                  var setCountryLabel = function () {
                    if (self.countryData) {
                      var matchedCountry = self.countryData.find(function (c) {
                        return c.code.toLowerCase() === countryCode;
                      });
                      if (matchedCountry) {
                        countryLabel = matchedCountry.country;
                      }
                    } else {
                      // 如果数据还未加载，尝试从下拉选项中查找
                      var countryDropdown = section.querySelector('[data-dropdown-content="account-country"]');
                      if (countryDropdown) {
                        var countryItem = countryDropdown.querySelector('[data-value="' + countryCode + '"]');
                        if (countryItem) {
                          countryLabel = countryItem.textContent.trim();
                        }
                      }
                    }
                    // input 元素使用 value，span 元素使用 textContent
                    if (cLabelSpan.tagName === 'INPUT') {
                      cLabelSpan.value = countryLabel;
                    } else {
                      cLabelSpan.textContent = countryLabel;
                    }
                    // 保存选中的国家名称到 dataset
                    if (countryTrigger) {
                      countryTrigger.dataset.selectedCountryName = countryLabel;
                    }
                    // 更新浮动标签状态
                    if (countryField) {
                      countryField.classList.add('is-filled');
                    }
                  };

                  // 如果数据已加载，直接设置；否则等待加载完成
                  if (this.countryData) {
                    setCountryLabel();
                  } else {
                    this.loadCountryData().then(function () {
                      setCountryLabel();
                    });
                  }
                } else if (countryField) {
                  // 即使没有 labelSpan，如果有值也应该标记为 filled
                  countryField.classList.add('is-filled');
                }
              }
              // 填充 Type（使用 localStorage 数据，从接口数据匹配）
              if (typeTrigger && userInfo.infoTypeId !== null && userInfo.infoTypeId !== undefined) {
                var typeId = userInfo.infoTypeId;
                var self = this;
                var setTypeLabel = function () {
                  var typeValue = '';
                  var typeLabel = '';
                  if (self.typeData && Array.isArray(self.typeData)) {
                    var matchedType = self.typeData.find(function (t) {
                      var tId = t.id || t.value || t.code;
                      return String(tId) === String(typeId);
                    });
                    if (matchedType) {
                      typeValue = String(matchedType.id || matchedType.value || matchedType.code || '').toLowerCase();
                      typeLabel = matchedType.name || matchedType.label || matchedType.text || '';
                    }
                  }
                  // 如果没有匹配到，使用默认值
                  if (!typeValue) {
                    typeValue = String(typeId).toLowerCase();
                    typeLabel = window.i18n.type + ' ' + typeId;
                  }
                  typeTrigger.dataset.value = typeValue;
                  var tLabelSpan = typeTrigger.querySelector('.account-select-label');
                  if (tLabelSpan) {
                    tLabelSpan.textContent = typeLabel;
                  }
                  // 更新浮动标签状态
                  var typeField = typeTrigger.closest('.floating-field');
                  if (typeField) {
                    typeField.classList.add('is-filled');
                  }
                  // 显示 Application 复选框并选中已保存的选项
                  self.updateApplicationCheckboxes(section, typeId);
                  if (userInfo.infoApplicationIds && Array.isArray(userInfo.infoApplicationIds)) {
                    // 选中已保存的 Application
                    userInfo.infoApplicationIds.forEach(function (appId) {
                      var checkbox = section.querySelector('input[data-application-id="' + appId + '"]');
                      if (checkbox) {
                        checkbox.checked = true;
                      }
                    });
                  } else if (userInfo.infoApplicationIds && typeof userInfo.infoApplicationIds === 'string') {
                    // 如果是逗号分隔的字符串，先分割
                    var appIds = userInfo.infoApplicationIds.split(',').map(function (id) {
                      return id.trim();
                    });
                    appIds.forEach(function (appId) {
                      if (appId) {
                        var checkbox = section.querySelector('input[data-application-id="' + appId + '"]');
                        if (checkbox) {
                          checkbox.checked = true;
                        }
                      }
                    });
                  }
                };

                // 如果数据已加载，直接设置；否则等待加载完成
                if (this.typeData) {
                  setTypeLabel();
                } else {
                  this.loadTypeData().then(function () {
                    setTypeLabel();
                  });
                }
              }
              // 更新邮箱显示（使用 localStorage 数据）
              if (greetingEmailEl && userInfo.email) {
                greetingEmailEl.textContent = userInfo.email;
              }
              // 更新头像（使用 localStorage 的 avatarLink）
              if (avatarTrigger) {
                var avatarContainer = avatarTrigger.closest('.account-profile-avatar');
                if (userInfo.avatarLink) {
                  // 有头像链接，显示图片（白色背景）
                  if (avatarContainer) {
                    avatarContainer.classList.remove('is-initial');
                  }
                  var img = avatarTrigger.querySelector('img');
                  var placeholder = avatarTrigger.querySelector('span');
                  if (placeholder) {
                    placeholder.style.display = 'none';
                  }
                  if (!img) {
                    img = document.createElement('img');
                    avatarTrigger.insertBefore(img, avatarTrigger.firstChild);
                  }
                  img.src = userInfo.avatarLink;
                  img.alt = 'avatar';
                  img.style.display = 'block';
                } else {
                  // 没有头像链接，显示邮箱首字母（橙色背景）
                  if (avatarContainer) {
                    avatarContainer.classList.add('is-initial');
                  }
                  var placeholder = avatarTrigger.querySelector('span');
                  if (placeholder) {
                    // 优先使用邮箱首字母，如果没有邮箱则使用 firstName 首字母
                    var initial = '';
                    if (userInfo.email && userInfo.email.length > 0) {
                      initial = userInfo.email.charAt(0);
                    }
                    placeholder.textContent = initial.toUpperCase();
                    placeholder.style.display = 'flex';
                  }
                  var img = avatarTrigger.querySelector('img');
                  if (img) {
                    img.style.display = 'none';
                  }
                }
              }
            }

            // 日期选择器：参考 main-customers-account.js 中的 flatpickr 配置 + 国际化星期
            // 使用 onFlatpickrReady 确保 flatpickr 加载完成后再初始化
            if (dobInput && window.onFlatpickrReady) {
              window.onFlatpickrReady(function () {
                try {
                  // 从 window.i18n.weekdays 中读取本地化星期名（如果存在）
                  var getWeekdayName = function (dayKey, defaultShort, defaultLong) {
                    if (window.i18n && window.i18n.weekdays && window.i18n.weekdays[dayKey]) {
                      var name = window.i18n.weekdays[dayKey];
                      var short = name.length > 3 ? name.substring(0, 3) : name;
                      return { short: short, long: name };
                    }
                    return { short: defaultShort, long: defaultLong };
                  };

                  var monday = getWeekdayName('monday', 'Mon', 'Monday');
                  var tuesday = getWeekdayName('tuesday', 'Tue', 'Tuesday');
                  var wednesday = getWeekdayName('wednesday', 'Wed', 'Wednesday');
                  var thursday = getWeekdayName('thursday', 'Thu', 'Thursday');
                  var friday = getWeekdayName('friday', 'Fri', 'Friday');
                  var saturday = getWeekdayName('saturday', 'Sat', 'Saturday');
                  var sunday = getWeekdayName('sunday', 'Sun', 'Sunday');

                  var customLocale = {
                    weekdays: {
                      shorthand: [
                        sunday.short,
                        monday.short,
                        tuesday.short,
                        wednesday.short,
                        thursday.short,
                        friday.short,
                        saturday.short,
                      ],
                      longhand: [
                        sunday.long,
                        monday.long,
                        tuesday.long,
                        wednesday.long,
                        thursday.long,
                        friday.long,
                        saturday.long,
                      ],
                    },
                  };

                  if (typeof flatpickr.localize === 'function') {
                    flatpickr.localize(customLocale);
                  }

                  flatpickr(dobInput, {
                    locale: customLocale,
                    dateFormat: 'Y-m-d',
                    disableMobile: true,
                    showMonths: 1,
                    showOutsideDays: true,
                  });
                } catch (e) {
                  console.error('flatpickr init error in account-profile:', e);
                }
              });
            }

            // 更新浮动标签状态（在填充 localStorage 数据后）
            var updateFloatingLabelState = function () {
              var floatingFields = section.querySelectorAll('.floating-field');
              floatingFields.forEach(function (field) {
                var input = field.querySelector('input');
                var trigger = field.querySelector('.account-select-trigger');

                if (!input && !trigger) return;

                var getDisplayText = function () {
                  if (input) return input.value || '';
                  var labelSpan = trigger && trigger.querySelector('.account-select-label');
                  var text = labelSpan ? labelSpan.textContent.trim() : '';
                  return text;
                };

                var baseLabel = '';
                if (trigger && trigger.dataset && trigger.dataset.label) {
                  baseLabel = trigger.dataset.label.trim();
                }

                var text = getDisplayText();
                // 对于 select trigger，如果 dataset.value 有值，也应该认为是 filled
                var hasValue = false;
                if (input) {
                  hasValue = text && text.length > 0;
                } else if (trigger) {
                  // 检查 labelSpan 的文本内容，或者 dataset.value
                  hasValue = (text && text !== baseLabel) || (trigger.dataset && trigger.dataset.value);
                }

                if (hasValue) {
                  field.classList.add('is-filled');
                } else {
                  field.classList.remove('is-filled');
                }
              });
            };

            // 在填充数据后立即更新浮动标签状态
            updateFloatingLabelState();

            // 浮动标签状态同步 + 实时校验（参考 input_text_container[data-error="true"] 行为）
            var floatingFields = section.querySelectorAll('.floating-field');
            floatingFields.forEach(function (field) {
              // 针对 input 或 select 触发器
              var input = field.querySelector('input');
              var trigger = field.querySelector('.account-select-trigger');

              if (!input && !trigger) return;

              var getDisplayText = function () {
                if (input) return input.value || '';
                var labelSpan = trigger && trigger.querySelector('.account-select-label');
                var text = labelSpan ? labelSpan.textContent.trim() : '';
                return text;
              };

              var baseLabel = '';
              if (trigger && trigger.dataset && trigger.dataset.label) {
                baseLabel = trigger.dataset.label.trim();
              }

              var isRequiredField = field.hasAttribute('data-required');

              var updateState = function () {
                var isFocus = document.activeElement === input || document.activeElement === trigger;
                if (isFocus) field.classList.add('is-focus');
                else field.classList.remove('is-focus');

                var text = getDisplayText();
                var isFilled = text && text !== baseLabel;

                if (isFilled) {
                  field.classList.add('is-filled');
                  field.classList.remove('field-error');
                } else {
                  field.classList.remove('is-filled');
                  // 如果是必填项且处于编辑状态，实时标记错误（类似 input_text_container[data-error="true"]）
                  if (isRequiredField && section.getAttribute('data-editing') === 'true') {
                    field.classList.add('field-error');
                  } else {
                    field.classList.remove('field-error');
                  }
                }
              };

              if (input) {
                input.addEventListener('focus', updateState);
                input.addEventListener('blur', updateState);
                input.addEventListener('input', updateState);
              }
              if (trigger) {
                trigger.addEventListener('focus', updateState);
                trigger.addEventListener('blur', updateState);
                // 当外部代码更新 label 文本时，可以调用 updateState 手动刷新
              }
              updateState();
            });

            function validateFields() {
              var isValid = true;
              var requiredFields = section.querySelectorAll('.floating-field[data-required="true"]');
              requiredFields.forEach(function (field) {
                var hasValue = field.classList.contains('is-filled');
                var errorEl = field.querySelector('.account-profile-error');
                if (!hasValue) {
                  isValid = false;
                  field.classList.add('field-error');
                  if (errorEl && !errorEl.textContent) {
                    errorEl.textContent = 'This field is required.';
                  }
                } else {
                  field.classList.remove('field-error');
                }
              });
              return isValid;
            }

            function setEditing(isEditing) {
              section.setAttribute('data-editing', isEditing ? 'true' : 'false');
              editableElements.forEach(function (el) {
                if ('disabled' in el) {
                  // el.disabled = !isEditing;
                }
              });
              // 启用/禁用 Application 复选框
              var applicationCheckboxes = section.querySelectorAll('input.account-profile-application-checkbox');
              applicationCheckboxes.forEach(function (checkbox) {
                // checkbox.disabled = !isEditing;
              });
              // 控制国家搜索 input 的 readonly 状态
              var countrySearchInput = section.querySelector('.account-country-search-input');
              if (countrySearchInput) {
                if (isEditing) {
                  countrySearchInput.removeAttribute('readonly');
                } else {
                  countrySearchInput.setAttribute('readonly', 'readonly');
                }
              }
            }

            // 初始化为不可编辑
            setEditing(false);

            editBtn.addEventListener('click', function (e) {
              e.preventDefault();
              var isEditing = section.getAttribute('data-editing') === 'true';
              setEditing(!isEditing);
            });

            // 导航栏中的编辑图标点击事件
            var navEditIcon = this.querySelector('.account-profile-nav-right-item');
            if (navEditIcon) {
              navEditIcon.addEventListener('click', function (e) {
                e.preventDefault();
                // 触发与原有编辑按钮相同的逻辑
                var isEditing = section.getAttribute('data-editing') === 'true';
                setEditing(!isEditing);
                navEditIcon.classList.add('hidden');
              });
            }

            // 通过事件总线控制进入编辑模式 / 监听标签切换 / 外部关闭编辑
            if (window.litime && window.litime.eventBus && typeof window.litime.eventBus.subscribe === 'function') {
              // 外部触发进入编辑模式
              window.litime.eventBus.subscribe('account:profile:edit', function () {
                setEditing(true);
                var navEditIcon = document.querySelector('.account-profile-nav-right-item');
                if (navEditIcon) {
                  navEditIcon.classList.add('hidden');
                }
              });

              // 公用的“关闭编辑并恢复初始状态”逻辑
              var closeEditAndReset = function () {
                // 关闭编辑状态
                setEditing(false);

                // 清除 profile 内所有校验错误（恢复初始状态）
                var fields = section.querySelectorAll('.floating-field');
                fields.forEach(function (field) {
                  field.classList.remove('field-error');
                });

                // 同时清理全局的 input_text_container 错误状态（PC / Mobile 统一处理）
                var errorInputs = document.querySelectorAll('.input_text_container[data-error="true"]');
                errorInputs.forEach(function (el) {
                  el.setAttribute('data-error', 'false');
                  var errorEl = el.nextElementSibling;
                  if (errorEl && errorEl.classList.contains('error-message')) {
                    errorEl.classList.add('hidden');
                  }
                });
              };

              // 当切换到其他 tab（例如 /account?type=xxx）时，重置为初始状态
              window.litime.eventBus.subscribe('account:switchTab', function (tab) {
                // 当前 tab 切走 profile 时才处理
                if (tab !== 'profile') {
                  closeEditAndReset();
                }
              });

              // 外部任意地方可调用：window.litime.eventBus.publish('account:closeEdit', true)
              window.litime.eventBus.subscribe('account:closeEdit', function (shouldClose) {
                if (shouldClose === false) return;
                closeEditAndReset();
              });
            }

            // 从 localStorage 恢复数据的函数
            var restoreFromLocalStorage = function (componentInstance) {
              var userInfo = getUserInfoFromStorage();

              // 恢复 input 字段
              if (firstNameEl) {
                firstNameEl.value = userInfo && userInfo.firstName ? userInfo.firstName : '';
              }
              if (lastNameEl) {
                lastNameEl.value = userInfo && userInfo.lastName ? userInfo.lastName : '';
              }
              if (dobEl) {
                dobEl.value = userInfo && userInfo.birthday ? userInfo.birthday : '';
              }
              if (phoneEl) {
                phoneEl.value = userInfo && userInfo.phone ? userInfo.phone : '';
              }

              // 恢复 Gender
              if (genderTrigger) {
                if (userInfo && userInfo.gender) {
                  // 将数字格式转换为字符串，支持 1、2、3 或 "male"、"female"、"other"
                  var genderNum = parseInt(userInfo.gender, 10);
                  var genderValue = '';
                  var genderLabel = '';

                  if (!isNaN(genderNum)) {
                    // 数字格式：1=male, 2=female, 3=other
                    genderValue = String(genderNum);
                    genderLabel =
                      genderNum === 1
                        ? window.i18n.male
                        : genderNum === 2
                        ? window.i18n.female
                        : window.i18n.prefer_not_to_say;
                  } else {
                    // 字符串格式（兼容旧数据）
                    var genderStr = String(userInfo.gender).toLowerCase();
                    if (genderStr === 'male') {
                      genderValue = '1';
                      genderLabel = window.i18n.male;
                    } else if (genderStr === 'female') {
                      genderValue = '2';
                      genderLabel = window.i18n.female;
                    } else if (genderStr === 'other') {
                      genderValue = '3';
                      genderLabel = window.i18n.prefer_not_to_say;
                    }
                  }

                  if (genderValue) {
                    genderTrigger.dataset.value = genderValue;
                    var gLabel = genderTrigger.querySelector('.account-select-label');
                    if (gLabel) gLabel.textContent = genderLabel;
                  } else {
                    genderTrigger.dataset.value = '';
                    var gLabel = genderTrigger.querySelector('.account-select-label');
                    if (gLabel) gLabel.textContent = '';
                  }
                } else {
                  genderTrigger.dataset.value = '';
                  var gLabel = genderTrigger.querySelector('.account-select-label');
                  if (gLabel) gLabel.textContent = '';
                }
              }

              // 恢复 Country
              if (countryTrigger) {
                if (userInfo && userInfo.country) {
                  var countryCode = String(userInfo.country).toLowerCase();
                  countryTrigger.dataset.value = countryCode;
                  var setCountryLabel = function () {
                    var countryLabel = String(userInfo.country).toUpperCase();
                    if (componentInstance.countryData) {
                      var matchedCountry = componentInstance.countryData.find(function (c) {
                        return c.code.toLowerCase() === countryCode;
                      });
                      if (matchedCountry) {
                        countryLabel = matchedCountry.country;
                      }
                    }
                    var cLabel = countryTrigger.querySelector('.account-select-label');
                    if (cLabel) {
                      // input 元素使用 value，span 元素使用 textContent
                      if (cLabel.tagName === 'INPUT') {
                        cLabel.value = countryLabel;
                      } else {
                        cLabel.textContent = countryLabel;
                      }
                    }
                    // 保存选中的国家名称到 dataset
                    countryTrigger.dataset.selectedCountryName = countryLabel;
                  };
                  if (componentInstance.countryData) {
                    setCountryLabel();
                  } else {
                    componentInstance.loadCountryData().then(function () {
                      setCountryLabel();
                    });
                  }
                } else {
                  countryTrigger.dataset.value = '';
                  countryTrigger.dataset.selectedCountryName = ''; // 清空保存的国家名称
                  var cLabel = countryTrigger.querySelector('.account-select-label');
                  if (cLabel) {
                    // input 元素使用 value，span 元素使用 textContent
                    if (cLabel.tagName === 'INPUT') {
                      cLabel.value = '';
                    } else {
                      cLabel.textContent = '';
                    }
                  }
                }
              }

              // 恢复 Type
              if (typeTrigger) {
                if (userInfo && userInfo.infoTypeId !== null && userInfo.infoTypeId !== undefined) {
                  var typeId = userInfo.infoTypeId;
                  var setTypeLabel = function () {
                    var typeValue = '';
                    var typeLabel = '';
                    if (componentInstance.typeData && Array.isArray(componentInstance.typeData)) {
                      var matchedType = componentInstance.typeData.find(function (t) {
                        var tId = t.id || t.value || t.code;
                        return String(tId) === String(typeId);
                      });
                      if (matchedType) {
                        typeValue = String(matchedType.id || matchedType.value || matchedType.code || '').toLowerCase();
                        typeLabel = matchedType.name || matchedType.label || matchedType.text || '';
                      }
                    }
                    // 如果没有匹配到，使用默认值
                    if (!typeValue) {
                      typeValue = String(typeId).toLowerCase();
                      typeLabel = window.i18n.type + ' ' + typeId;
                    }
                    typeTrigger.dataset.value = typeValue;
                    var tLabel = typeTrigger.querySelector('.account-select-label');
                    if (tLabel) tLabel.textContent = typeLabel;

                    // 显示 Application 复选框并选中已保存的选项
                    componentInstance.updateApplicationCheckboxes(section, typeId);
                    if (userInfo.infoApplicationIds) {
                      var appIds = [];
                      if (Array.isArray(userInfo.infoApplicationIds)) {
                        appIds = userInfo.infoApplicationIds;
                      } else if (typeof userInfo.infoApplicationIds === 'string') {
                        appIds = userInfo.infoApplicationIds.split(',').map(function (id) {
                          return id.trim();
                        });
                      }
                      appIds.forEach(function (appId) {
                        if (appId) {
                          var checkbox = section.querySelector('input[data-application-id="' + appId + '"]');
                          if (checkbox) {
                            checkbox.checked = true;
                          }
                        }
                      });
                    }
                  };
                  if (componentInstance.typeData) {
                    setTypeLabel();
                  } else {
                    componentInstance.loadTypeData().then(function () {
                      setTypeLabel();
                    });
                  }
                } else {
                  typeTrigger.dataset.value = '';
                  var tLabel = typeTrigger.querySelector('.account-select-label');
                  if (tLabel) tLabel.textContent = '';
                  // 隐藏 Application 复选框
                  var applicationRow = section.querySelector('[data-application-row]');
                  if (applicationRow) {
                    applicationRow.classList.remove('is-visible');
                  }
                }
              }
            };

            if (cancelBtn) {
              var self = this;
              cancelBtn.addEventListener('click', function (e) {
                e.preventDefault();

                // 从 localStorage 恢复数据
                restoreFromLocalStorage(self);
                var navEditIcon = self.querySelector('.account-profile-nav-right-item');
                if (navEditIcon) {
                  navEditIcon.classList.remove('hidden');
                }
                // 重置浮动标签与错误状态
                var fields = section.querySelectorAll('.floating-field');
                fields.forEach(function (field) {
                  field.classList.remove('field-error');
                  var errEl = field.querySelector('.account-profile-error');
                  if (errEl) {
                    // 文案保持不变，只隐藏由 CSS 控制
                  }

                  var input = field.querySelector('input');
                  var trigger = field.querySelector('.account-select-trigger');
                  var text = '';
                  if (input && input.value) {
                    text = input.value.trim();
                  } else if (trigger) {
                    var labelSpan = trigger.querySelector('.account-select-label');
                    text = labelSpan ? labelSpan.textContent.trim() : '';
                  }

                  if (text) {
                    field.classList.add('is-filled');
                  } else {
                    field.classList.remove('is-filled');
                  }
                });

                setEditing(false);
              });
            }

            // 监听下拉选项点击，更新显示文本与存值
            // 注意：国家下拉菜单已独立实现，不通过此事件处理
            var self = this;
            document.addEventListener('global-select:option-click', function (evt) {
              var detail = evt.detail || {};
              var trigger = detail.trigger;
              if (!trigger) return;
              var componentType = trigger.getAttribute('data-component');
              if (componentType !== 'account-profile') return;

              // 排除国家下拉菜单（已独立实现）
              if (trigger.hasAttribute('data-country-trigger')) return;

              var text =
                detail.data && detail.data.valueText
                  ? detail.data.valueText
                  : detail.item
                  ? detail.item.textContent.trim()
                  : '';
              var value =
                detail.data && detail.data.value
                  ? detail.data.value
                  : detail.item
                  ? detail.item.getAttribute('data-value')
                  : '';

              var labelSpan = trigger.querySelector('.account-select-label');
              if (labelSpan) {
                labelSpan.textContent = text;
              }
              if (value !== undefined) {
                trigger.dataset.value = value;
              }

              // 让浮动标签上浮
              var field = trigger.closest('.floating-field');
              if (field) {
                field.classList.add('is-filled');
                field.classList.remove('field-error');
              }

              // 如果是 Type 选择，更新 Application 复选框
              if (trigger.getAttribute('data-dropdown-trigger') === 'account-type') {
                // 获取选中的 Type ID（从 data-type-data 中获取）
                var typeId = null;
                if (detail.item) {
                  var typeDataStr = detail.item.getAttribute('data-type-data');
                  if (typeDataStr) {
                    try {
                      var typeData = JSON.parse(typeDataStr);
                      typeId = typeData.id || typeData.value || typeData.code;
                    } catch (e) {
                      console.error('Failed to parse type data:', e);
                    }
                  }
                }
                if (!typeId && value) {
                  // 如果没有从 data-type-data 获取到，尝试从 value 中获取原始 ID
                  // 需要从 typeData 中查找对应的原始 ID
                  if (self.typeData && Array.isArray(self.typeData)) {
                    var matchedType = self.typeData.find(function (t) {
                      var tValue = String(t.id || t.value || t.code || '').toLowerCase();
                      return tValue === String(value).toLowerCase();
                    });
                    if (matchedType) {
                      typeId = matchedType.id || matchedType.value || matchedType.code;
                    }
                  }
                }
                if (typeId) {
                  self.updateApplicationCheckboxes(section, typeId);
                }
              }
            });

            // Application 复选框使用原生 checkbox，点击 label 会自动勾选，无需额外处理

            if (saveBtn) {
              var self = this;
              saveBtn.addEventListener('click', async function (e) {
                e.preventDefault();

                // 校验必填项
                if (!validateFields()) {
                  return;
                }

                var formData = new FormData();
                var firstNameEl = section.querySelector('#account-first-name');
                var lastNameEl = section.querySelector('#account-last-name');
                var dobEl = section.querySelector('#account-dob');
                var phoneEl = section.querySelector('#account-phone');
                var genderTrigger = section.querySelector('[data-dropdown-trigger="account-gender"]');
                var countryTrigger = section.querySelector('[data-country-trigger]');
                var typeTrigger = section.querySelector('[data-dropdown-trigger="account-type"]');

                if (firstNameEl) formData.append('firstName', (firstNameEl.value || '').trim());
                if (lastNameEl) formData.append('lastName', (lastNameEl.value || '').trim());
                if (dobEl) formData.append('birthday', (dobEl.value || '').trim());
                if (phoneEl) formData.append('phone', (phoneEl.value || '').trim());
                if (genderTrigger && genderTrigger.dataset.value) {
                  // gender 值已经是数字格式（1、2、3），直接传递
                  formData.append('gender', genderTrigger.dataset.value);
                }
                window.litime.eventBus.publish('account:initTask');

                if (window.innerWidth <= 1200) {
                  const navEditIcon = document.querySelector('.account-profile-nav-right-item');

                  if (navEditIcon) {
                    navEditIcon.classList.remove('hidden');
                  }
                }
                if (countryTrigger) formData.append('country', countryTrigger.dataset.value || '');
                if (typeTrigger && typeTrigger.dataset.value) {
                  // 获取 Type 的原始 ID（不是小写的 value）
                  var typeValue = typeTrigger.dataset.value;
                  var typeId = null;
                  if (self.typeData && Array.isArray(self.typeData)) {
                    var matchedType = self.typeData.find(function (t) {
                      var tValue = String(t.id || t.value || t.code || '').toLowerCase();
                      return tValue === String(typeValue).toLowerCase();
                    });
                    if (matchedType) {
                      typeId = matchedType.id || matchedType.value || matchedType.code;
                    }
                  }
                  if (typeId) {
                    formData.append('infoTypeId', typeId);
                  }

                  // 收集选中的 Application IDs
                  var checkedApplications = section.querySelectorAll(
                    'input.account-profile-application-checkbox:checked'
                  );
                  var applicationIds = [];
                  checkedApplications.forEach(function (checkbox) {
                    var appId = checkbox.getAttribute('data-application-id');
                    if (appId) {
                      applicationIds.push(appId);
                    }
                  });
                  if (applicationIds.length > 0) {
                    formData.append('infoApplicationIds', applicationIds.join(','));
                  }
                }

                try {
                  // 添加 loading 状态
                  saveBtn.setAttribute('data-show-loading', 'true');
                  section.classList.add('is-loading');

                  var res = await window.litime.http.post('/shopify/user/update', { data: formData });
                  if (res && res.code === 200) {
                    if (window.litime && typeof window.litime.setLocalStorage === 'function') {
                      window.litime.setLocalStorage('ltUserInfo', res.data);
                    }
                    if (window.litime && typeof window.litime.showToast === 'function') {
                      window.litime.showToast('success', window.i18n?.save_successfully || 'Saved successfully');
                    }
                    window.litime.eventBus.publish('account:updateUserInfo');
                    window.litime.eventBus.publish('account:initTask');
                    window.litime.eventBus.publish('account:getMemberPoints');

                    setEditing(false);
                  } else {
                    throw new Error(res.message);
                  }
                } catch (err) {
                  if (window.litime && typeof window.litime.showToast === 'function') {
                    window.litime.showToast('error', window.i18n?.save_failed);
                  }
                } finally {
                  // 移除 loading 状态
                  saveBtn.removeAttribute('data-show-loading');
                  section.classList.remove('is-loading');
                }
              });
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["account-referral-rewards"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('account-referral-rewards')) {
      customElements.define(
        'account-referral-rewards',
        class AccountReferralRewards extends HTMLElement {
          constructor() {
            super();
            // 存储两个 tab 的 max-height，避免切换时重新计算导致高度塌陷
            this.tableHeights = {
              'sign-up': null,
              purchase: null,
            };
          }
          async connectedCallback() {
            if (window.litime && window.litime.onVisibleOnce) {
              window.litime.onVisibleOnce(this, () => {
                this.init();
              });
            }
          }
          async init() {
            if (window.customer) {
              const mainContainer = this.querySelector('.account-referral-rewards');
              try {
                // 确保开始时是 loading 状态
                mainContainer.setAttribute('data-referral-type', 'loading');

                // 使用 Promise.all 并发请求三个接口
                const [referralInfo, initialSignUpRewards, initialPurchaseRewards] = await Promise.all([
                  this.getReferralInfo(),
                  this.getReferralRewards({ page: 1, pageSize: 999 }),
                  this.getReferralLogs(),
                ]);

                // 更新基础信息渲染
                const referralUrl = $(this.querySelector('.main-customers-account-new__left-item-referral-url-text'));
                if (referralInfo && referralInfo.referralInviteLink) {
                  referralUrl.text(referralInfo.referralInviteLink);
                }

                const referralSignUpCount = $(this.querySelector('.referral-sign-up-count'));
                referralSignUpCount.text(referralInfo ? referralInfo.invitedNums : 0);
                const referralPurchaseCount = $(this.querySelector('.referral-purchase-count'));
                referralPurchaseCount.text(referralInfo ? referralInfo.orderRewardNums : 0);

                const memberRedeemModalBtnCopy = $(this.querySelector('.referral-url-copy-btn'));
                memberRedeemModalBtnCopy.off('click').on('click', () => {
                  if (referralInfo && referralInfo.referralInviteLink) {
                    window.litime.copyToClipboard(referralInfo.referralInviteLink);
                  }
                });
                const shareIconFacebook = $(this.querySelector('.share-icon-facebook'));
                shareIconFacebook.off('click').on('click', () => {
                  if (referralInfo && referralInfo.referralInviteLink) {
                    this.share('facebook', referralInfo.referralInviteLink);
                  }
                });
                const shareIconTwitter = $(this.querySelector('.share-icon-twitter'));
                shareIconTwitter.off('click').on('click', () => {
                  if (referralInfo && referralInfo.referralInviteLink) {
                    this.share('twitter', referralInfo.referralInviteLink);
                  }
                });

                // 初始化时先渲染两个表格的数据（即使一个是隐藏的），然后计算并保存高度
                const signUpTable = this.querySelector(
                  '[data-table-type="sign-up"] .main-customers-account-new__left-item-referral-table'
                );
                const purchaseTable = this.querySelector(
                  '[data-table-type="purchase"] .main-customers-account-new__left-item-referral-table'
                );

                // 渲染 sign-up 表格数据
                if (initialSignUpRewards && initialSignUpRewards.records && initialSignUpRewards.records.length > 0) {
                  this.addTableRow(initialSignUpRewards.records, signUpTable);
                }

                // 渲染 purchase 表格数据
                if (
                  initialPurchaseRewards &&
                  initialPurchaseRewards.records &&
                  initialPurchaseRewards.records.length > 0
                ) {
                  this.addTableRow(initialPurchaseRewards.records, purchaseTable);
                }

                // 使用 requestAnimationFrame 确保两个表格都渲染完成后再计算高度
                // 先临时显示两个表格以便正确计算高度
                const signUpWrapper = signUpTable?.closest('[data-table-type="sign-up"]');
                const purchaseWrapper = purchaseTable?.closest('[data-table-type="purchase"]');

                // 临时显示两个表格以便测量
                if (signUpWrapper) signUpWrapper.style.display = 'flex';
                if (purchaseWrapper) purchaseWrapper.style.display = 'flex';

                requestAnimationFrame(() => {
                  // 计算并保存 sign-up 表格的高度
                  if (signUpTable && signUpTable.querySelector('tbody tr')) {
                    this.tableHeights['sign-up'] = this.calculateTableHeight(signUpTable);
                  }

                  // 计算并保存 purchase 表格的高度
                  if (purchaseTable && purchaseTable.querySelector('tbody tr')) {
                    this.tableHeights['purchase'] = this.calculateTableHeight(purchaseTable);
                  }

                  // 恢复 CSS 控制的显示/隐藏
                  if (signUpWrapper) signUpWrapper.style.display = '';
                  if (purchaseWrapper) purchaseWrapper.style.display = '';

                  // 应用保存的高度到对应的 wrapper
                  this.applySavedHeights();

                  // 设置默认显示的 tab（根据数据情况决定）
                  if (initialSignUpRewards && initialSignUpRewards.records && initialSignUpRewards.records.length > 0) {
                    mainContainer.setAttribute('data-referral-type', 'sign-up');
                    mainContainer.setAttribute('data-tab-type', 'sign-up');
                  } else if (
                    initialPurchaseRewards &&
                    initialPurchaseRewards.records &&
                    initialPurchaseRewards.records.length > 0
                  ) {
                    mainContainer.setAttribute('data-referral-type', 'purchase');
                    mainContainer.setAttribute('data-tab-type', 'purchase');
                  } else {
                    mainContainer.setAttribute('data-referral-type', 'empty');
                  }
                });

                // 选项卡切换逻辑 - 切换时直接使用已保存的高度，不再重新计算
                const tabs = this.querySelectorAll('.main-customers-account-new__left-item-referral-tab');

                tabs.forEach((tab) => {
                  tab.addEventListener('click', () => {
                    const type = tab.getAttribute('data-type');
                    mainContainer.setAttribute('data-tab-type', type);

                    // 将当前点击的 tab 滚动到可视区域中心
                    tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });

                    const rewards = type === 'sign-up' ? initialSignUpRewards : initialPurchaseRewards;

                    if (rewards && rewards.records && rewards.records.length > 0) {
                      mainContainer.setAttribute('data-referral-type', type);
                      // 直接应用已保存的高度，不再重新计算
                      this.applySavedHeights();
                    } else {
                      mainContainer.setAttribute('data-referral-type', 'empty');
                    }
                  });
                });

                // 监听窗口缩放，重新计算两个表格的高度
                window.addEventListener('resize', () => {
                  const signUpWrapper = signUpTable?.closest('[data-table-type="sign-up"]');
                  const purchaseWrapper = purchaseTable?.closest('[data-table-type="purchase"]');

                  // 临时显示两个表格以便测量
                  if (signUpWrapper) signUpWrapper.style.display = 'flex';
                  if (purchaseWrapper) purchaseWrapper.style.display = 'flex';

                  requestAnimationFrame(() => {
                    // 重新计算两个表格的高度
                    if (signUpTable && signUpTable.querySelector('tbody tr')) {
                      this.tableHeights['sign-up'] = this.calculateTableHeight(signUpTable);
                    }
                    if (purchaseTable && purchaseTable.querySelector('tbody tr')) {
                      this.tableHeights['purchase'] = this.calculateTableHeight(purchaseTable);
                    }

                    // 恢复 CSS 控制的显示/隐藏
                    if (signUpWrapper) signUpWrapper.style.display = '';
                    if (purchaseWrapper) purchaseWrapper.style.display = '';

                    // 应用保存的高度
                    this.applySavedHeights();
                  });
                });

                this.querySelector('.account-referral-rewards__nav .back-btn').addEventListener('click', () => {
                  window.litime.eventBus.publish('account:switchTab', 'overview');
                });
              } catch (error) {
                console.error('Referral init error:', error);
                mainContainer.setAttribute('data-referral-type', 'empty');
                window.litime.showToast('error', error.message);
              }
            }
          }

          // 计算表格高度并返回（不直接应用）
          calculateTableHeight(table) {
            const thead = table.querySelector('thead');
            const rows = table.querySelectorAll('tbody tr');

            if (!thead || rows.length === 0) return null;

            // 1440以下取前10条，否则取前5条
            const targetLimit = window.innerWidth <= 1440 ? 10 : 5;

            if (rows.length <= targetLimit) {
              return null; // 返回 null 表示不需要限制高度
            }

            const headerRect = thead.getBoundingClientRect();
            const targetRowRect = rows[targetLimit - 1].getBoundingClientRect();

            // 总高度 = 目标行底部 - 表头顶部
            // 加 1px 缓冲，解决浏览器缩放导致的像素舍入误差
            const calculatedMaxHeight = Math.max(0, Math.ceil(targetRowRect.bottom - headerRect.top + 1));

            return calculatedMaxHeight;
          }

          // 应用已保存的高度到对应的 wrapper
          applySavedHeights() {
            const signUpWrapper = this.querySelector('[data-table-type="sign-up"] .table-container_wrapper');
            const purchaseWrapper = this.querySelector('[data-table-type="purchase"] .table-container_wrapper');

            // 应用 sign-up 表格的高度
            if (signUpWrapper) {
              if (this.tableHeights['sign-up'] !== null) {
                signUpWrapper.style.maxHeight = `${this.tableHeights['sign-up']}px`;
              } else {
                signUpWrapper.style.maxHeight = 'none';
              }
            }

            // 应用 purchase 表格的高度
            if (purchaseWrapper) {
              if (this.tableHeights['purchase'] !== null) {
                purchaseWrapper.style.maxHeight = `${this.tableHeights['purchase']}px`;
              } else {
                purchaseWrapper.style.maxHeight = 'none';
              }
            }
          }

          // 动态计算并锁定表格高度（保留此方法以兼容其他可能的调用）
          lockTableHeight(table) {
            const wrapper = table.closest('.table-container_wrapper');
            if (!wrapper) return;

            const calculatedHeight = this.calculateTableHeight(table);
            if (calculatedHeight !== null) {
              wrapper.style.maxHeight = `${calculatedHeight}px`;
            } else {
              wrapper.style.maxHeight = 'none';
            }
          }

          share(platform, url) {
            if (platform === 'facebook') {
              window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank');
            } else if (platform === 'twitter') {
              window.open(`https://twitter.com/intent/tweet?url=${url}`, '_blank');
            }
          }
          // 获取基础信息
          async getReferralInfo() {
            const url = '/shopify/referral/get/info';
            const { data, code } = await window.litime.http.get(url);
            if (code === 200) {
              return data;
            } else {
              return null;
            }
          }
          // 邀请用户日志
          async getReferralRewards(data) {
            const url = '/shopify/referral/page/log/invite';
            const res = await window.litime.http.get(url, {
              data,
            });
            if (res.code === 200) {
              return res.data;
            } else {
              throw new Error(window.i18n.error_message_timeout);
            }
          }

          // 下单奖励日志
          async getReferralLogs() {
            const url = '/shopify/referral/page/log/order';
            const res = await window.litime.http.get(url);
            if (res.code === 200) {
              return res.data;
            } else {
              throw new Error(window.i18n.error_message_timeout);
            }
          }

          addTableRow(data, container) {
            const tbody = container.querySelector('tbody');
            tbody.innerHTML = '';
            data.forEach((item) => {
              const tr = document.createElement('tr');
              const userDate = this.switchTimeZone(item.createdTime);
              tr.innerHTML = `
                <td>${item.referralInvitedEmail}</td>
                <td>${item.actionName}</td>
                <td class="referral-table-reward-cell">
                   <div class="referral-table-reward-wrapper">
                  <span>${item.reward}</span>
                           ${
                             !item.isLimit && item.discountCode
                               ? `
                      <i class="referral-table-copy-btn" data-code="${item.discountCode}">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><g><g><rect x="0" y="0" width="24" height="24" rx="0" fill="none" fill-opacity="0"/></g><g><path d="M8.40349,5L16.6575,5C17.569000000000003,5,18.3095,5.740462,18.3126,6.65515L18.3126,15.9389C18.3126,16.2812,18.032600000000002,16.5612,17.6904,16.5612C17.348100000000002,16.5612,17.0681,16.2812,17.0681,15.9389L17.0681,6.65515C17.0681,6.42803,16.8846,6.24447,16.6575,6.24447L8.40349,6.24447C8.06126,6.24447,7.78125,5.964468,7.78125,5.622237C7.78125,5.280007,8.06126,5,8.40349,5ZM5.933356,7.996090000000001L14.38023,7.996090000000001C14.89621,7.996090000000001,15.315,8.41347,15.3167,8.92945L15.3167,18.067C15.3167,18.5835,14.8998,19.0004,14.38334,19.0004L5.933356,19.0004C5.416899,19.0004,5,18.5835,5,18.067L5,8.92945C5,8.41299,5.416899,7.996090000000001,5.933356,7.996090000000001ZM6.24448,17.7559L14.07222,17.7559L14.07222,9.24057L6.24448,9.24057L6.24448,17.7559Z" fill-rule="evenodd" fill-opacity="1"/></g></g></svg>
                      </i>
                      `
                               : ''
                           }
                    ${
                      item.isLimit == 1
                        ? `
                      <div class="referral-table-limit-wrapper">
                        <i class="referral-table-limit-icon">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="12" height="12" viewBox="0 0 12 12"><g><path d="M6.0000014,1.1175874e-7C2.6625009,1.1175874e-7,0,2.6625009,0,6.0000014C0,9.3375025,2.6625004,12,6.0000014,12C9.3375034,12,12,9.3375025,12,6C12,2.6625004,9.3375025,-4.4703495e-7,6.0000014,1.1175874e-7ZM5.4225006,2.3475006C5.5800009,2.1900003,5.7150002,2.0850008,5.9700007,2.0850008C6.2550015,2.0625012,6.5175009,2.1975002,6.6225004,2.4000006C6.7425013,2.542501,6.8100004,2.857501,6.7800007,3.0450013C6.7800007,3.0975015,6.7425013,3.4500015,6.7275009,3.5475013L6.5175009,6.2100024C6.5175009,6.4725018,6.4650011,6.7350025,6.3600011,6.9375029C6.3075013,7.0950027,6.150001,7.2000022,5.9400015,7.2000022C5.7825007,7.2000022,5.6250014,7.0950022,5.5725002,6.9375029C5.4675007,6.6750026,5.4150009,6.4650025,5.4150009,6.2100024L5.272501,3.6000009C5.2200012,3.1275003,5.2200012,3.2850008,5.2200012,3.0225008C5.2200012,2.7675006,5.272501,2.5575008,5.4225006,2.3475006ZM6.5775013,9.7050009C6.4200015,9.8625021,6.2100005,9.9150009,6.0525012,9.9150009C5.8425007,9.9150009,5.6325006,9.8625021,5.4750004,9.7050009C5.3175006,9.5475025,5.212501,9.3375025,5.212501,9.0825005C5.212501,8.8725014,5.2650008,8.6625004,5.4225001,8.505003C5.5799999,8.3475008,5.7900009,8.2425013,6,8.2425013C6.2100005,8.2425013,6.4200015,8.3475018,6.5775008,8.505003C6.7350006,8.6625004,6.7875004,8.8725014,6.7875004,9.0825005C6.7799997,9.3375034,6.7275,9.5475025,6.5775013,9.7050009Z" fill="#ea5504" fill-opacity="1"/></g></svg>
                        </i>
                        <div class="referral-table-limit-tooltip">
                          ${window.i18n.limit_reached}
                        </div>
                      </div>
                      `
                        : ''
                    }
                  </div>
                </td>
                <td>${userDate.toLocaleString()}</td>
                `;

              // 为复制按钮绑定事件
              const copyBtn = tr.querySelector('.referral-table-copy-btn');
              if (copyBtn) {
                copyBtn.addEventListener('click', () => {
                  window.litime.copyToClipboard(copyBtn.getAttribute('data-code'));
                });
              }

              tbody.append(tr);
            });
          }
          // 切换时区时间
          switchTimeZone(cnTime) {
            // 创建北京时间对象
            const cnDate = new Date(cnTime);

            // 获取用户时区偏移（分钟）
            const userOffset = new Date().getTimezoneOffset();

            // 将用户偏移转换为小时（注意：getTimezoneOffset 返回的是负值）
            const userOffsetHours = -userOffset / 60;

            // 计算时差（小时）
            const diffHours = 8 - userOffsetHours;

            // 转换为用户本地时间
            return new Date(cnDate.getTime() - diffHours * 60 * 60 * 1000);
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["account-shipping-address"] && !Shopify.designMode) return;
  try {
    $(function () {
    // 在这里编写需要在文档加载完成后执行的代码
    if (!customElements.get('account-shipping-address')) {
      customElements.define(
        'account-shipping-address',
        class AccountShippingAddress extends HTMLElement {
          submitBtn = null;
          form = null;
          currentPopupId = null;
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
            this.changeCountry();
            this.optionClickHandler = this.handleOptionClickBound.bind(this);
            document.addEventListener('global-select:option-click', this.optionClickHandler);
            var backBtn = this.querySelector('.account-address-back-btn');
            if (backBtn) {
              backBtn.addEventListener('click', function () {
                if (window.litime && window.litime.eventBus && typeof window.litime.eventBus.publish === 'function') {
                  window.litime.eventBus.publish('account:switchTab', 'overview');
                }
              });
            }
          }
          disconnectedCallback() {
            if (this.optionClickHandler) {
              document.removeEventListener('global-select:option-click', this.optionClickHandler);
            }
          }
          handleOptionClickBound(event) {
            const detail = event.detail || {};
            if (detail.componentType !== 'address-input') return;
            const provincesJson = detail.data && detail.data.provinces ? detail.data.provinces : '[]';
            let provinces = [];
            try {
              provinces = JSON.parse(provincesJson);
            } catch (e) {
              provinces = [];
            }
            const currentId = this.currentPopupId || 'newAddressForm';
            const addressContainer = document.querySelector(`[data-address_id="${currentId}"]`);
            if (!addressContainer) return;

            // 同步国家 trigger 文案与隐藏 select 值
            const countryTrigger = addressContainer.querySelector('[data-dropdown-trigger^="address-country-"]');
            const countryLabel = countryTrigger ? countryTrigger.querySelector('.address-select-label') : null;
            const countrySelect = addressContainer.querySelector('select.country-selector');
            const countryText =
              (detail.data && (detail.data.valueText || detail.data.label)) ||
              (detail.item && detail.item.textContent && detail.item.textContent.trim()) ||
              '';
            const countryValue =
              (detail.data && detail.data.value) ||
              (detail.item && detail.item.getAttribute && detail.item.getAttribute('data-value')) ||
              '';
            if (countryLabel) countryLabel.textContent = countryText;
            if (countrySelect && countryValue) {
              countrySelect.value = countryValue;
              countrySelect.dispatchEvent(new Event('change', { bubbles: true }));
            }

            // 处理省份下拉
            const provinceTrigger = addressContainer.querySelector('[data-dropdown-trigger^="address-province-"]');
            const provinceLabel = provinceTrigger ? provinceTrigger.querySelector('.address-select-label') : null;
            const provincePanelHolder = addressContainer
              .querySelector('[data-address-province-options]')
              ?.closest('[data-dropdown-content]');
            const provinceList = addressContainer.querySelector('[data-address-province-options]');
            const provinceSelect = addressContainer.querySelector('select.province-selector');
            const provinceCol = provinceSelect ? provinceSelect.closest('.addr-col') : null;

            // 如果未能从事件拿到省份，尝试从国家 select 的 option 中获取
            if ((!provinces || provinces.length === 0) && countrySelect && countrySelect.value) {
              const opt = countrySelect.querySelector(`option[value="${countrySelect.value}"]`);
              const fallbackProv = opt ? opt.getAttribute('data-provinces') : null;
              if (fallbackProv) {
                try {
                  provinces = JSON.parse(fallbackProv) || [];
                } catch (e) {
                  provinces = [];
                }
              }
            }

            if (provinces && provinces.length > 0) {
              // 显示
              if (provinceTrigger) provinceTrigger.style.display = '';
              if (provincePanelHolder) provincePanelHolder.classList.remove('hidden');
              if (provinceCol) provinceCol.style.display = '';

              // 重建原生 select
              if (provinceSelect) {
                provinceSelect.innerHTML = '';
                provinces.forEach(function (pair) {
                  const code = pair[0];
                  const name = pair[1];
                  const opt = document.createElement('option');
                  opt.value = code;
                  opt.textContent = name;
                  provinceSelect.appendChild(opt);
                });
                provinceSelect.value = provinces[0][0];
                provinceSelect.dispatchEvent(new Event('change', { bubbles: true }));
              }

              // 自定义列表
              if (provinceList) {
                provinceList.innerHTML = '';
                provinces.forEach(function (pair) {
                  const code = pair[0];
                  const name = pair[1];
                  const li = document.createElement('li');
                  li.className = 'select-options-item';
                  li.setAttribute('data-value', code);
                  li.textContent = name;
                  provinceList.appendChild(li);
                });
                // 绑定点击：同步 select 与 label
                provinceList.onclick = function (evt) {
                  const item = evt.target.closest('.select-options-item');
                  if (!item) return;
                  const val = item.getAttribute('data-value');
                  const text = item.textContent ? item.textContent.trim() : '';
                  if (provinceSelect) {
                    provinceSelect.value = val;
                    provinceSelect.dispatchEvent(new Event('change', { bubbles: true }));
                  }
                  if (provinceLabel) provinceLabel.textContent = text;
                  // 选中后关闭下拉

                  document
                    .querySelectorAll('[data-dropdown-content="address-province-address-province-"]')
                    .forEach((el) => {
                      el.style.display = 'none';
                    });
                };
              }

              // label
              if (provinceLabel) {
                provinceLabel.textContent = provinces[0][1] || '';
              }
            } else {
              // 无省份，隐藏
              if (provinceTrigger) provinceTrigger.style.display = 'none';
              if (provincePanelHolder) provincePanelHolder.classList.add('hidden');
              if (provinceCol) provinceCol.style.display = 'none';
              if (provinceSelect) {
                provinceSelect.innerHTML = '';
                provinceSelect.value = '';
                provinceSelect.dispatchEvent(new Event('change', { bubbles: true }));
              }
              if (provinceLabel) provinceLabel.textContent = '';
              if (provinceList) provinceList.innerHTML = '';
            }
          }
          init() {
            const _this = this;
            const $address = $(_this.querySelectorAll('[data-address]'));
            $address.on('click', function () {
              _this.changeCountryOption();
              _this.editAddress(this.dataset.address);
            });
            const $address_cancel = $(_this.querySelectorAll('.address_cancel'));
            $address_cancel.on('click', function () {
              _this.cancelAddress();
            });
            const $add_new_address = $(_this.querySelectorAll('.account-shipping-add-btn'));
            $add_new_address.on('click', function () {
              _this.changeCountryOption();
              _this.editAddress();
            });
            const $accountMobileAddAddressContgainer = $(
              _this.querySelectorAll('.account-mobile-add-address-contgainer')
            );
            $accountMobileAddAddressContgainer.on('click', function () {
              _this.changeCountryOption();
              _this.editAddress();
            });
            const $addressDelete = $(_this.querySelectorAll('[data-delete_id]'));
            $addressDelete.on('click', function () {
              window.litime.disableScroll();
              _this.deleteAddress(this.dataset.delete_id);
            });

            // 移动端操作区（编辑 / 删除）
            const $mobileOps = $(_this.querySelectorAll('.address-card-ops-mobile-item'));
            $mobileOps.off('click').on('click', function () {
              const deleteId = $(this).attr('data-delete_id');
              const editId = $(this).attr('data-address');
              if (deleteId) {
                window.litime.disableScroll();
                _this.deleteAddress(deleteId);
              } else if (editId) {
                _this.changeCountryOption();
                _this.editAddress(editId);
              }
            });

            const $cancelDeletePopup = $(_this.querySelectorAll('.cancen_delete_popup'));

            $cancelDeletePopup.on('click', function () {
              _this.closeDeletePopup();
            });
          }

          changeCountry() {
            const _this = this;
            const $countrySelectors = $(_this.querySelectorAll('.country-selector'));
            if ($countrySelectors.length > 0) {
              $countrySelectors.each(function () {
                $(this).on('change', function () {
                  const dataCountry = $(this).val();
                  const options = $(this).find('option');
                  let provinces = null;
                  options.each((index, option) => {
                    if ($(option).val() === dataCountry) {
                      provinces = JSON.parse($(option).attr('data-provinces'));
                    }
                  });
                  const $addressForm = $(this).closest('.address-form');
                  const $provinceSelectors = $addressForm.find('.province-selector');

                  if (provinces && provinces.length > 0) {
                    const optionsHtml = provinces
                      .map(([code, name]) => `<option value="${code}">${name}</option>`)
                      .join('');
                    // 获取data-country_prov等于dataCountry的元素

                    // 根据$provinces数据生成对应的option
                    $provinceSelectors.each((index, provinceSelector) => {
                      $(provinceSelector).html(optionsHtml);
                      $(provinceSelector).find('option').eq(0).prop('selected', true);
                      $(provinceSelector).change();
                      const $addressInputContainer = $(provinceSelector).closest('.address_input_container');
                      const $placeholder_text = $addressInputContainer.find('.placeholder_text');
                    });
                  } else {
                    const $addressInputContainer = $provinceSelectors.eq(0).closest('.address_input_container');
                    const $placeholder_text = $addressInputContainer.find('.placeholder_text');
                    $provinceSelectors.html('');
                  }
                });
              });
            }
          }

          changeCountryOption() {
            const _this = this;
            const $address_id = $(_this.querySelectorAll('[data-address_id]'));

            if ($address_id.length > 0) {
              // 获取option
              $address_id.each(function () {
                const $countrySelectors = $(this).find('.country-selector');

                let dataCountry = $countrySelectors.eq(0).attr('data-country');
                const options = $countrySelectors.eq(0).find('option');
                // 根据data-country获取option 为 dataCountry 的 option
                $countrySelectors
                  .eq(0)
                  .find('option')
                  .each(function () {
                    if ($(this).val() === dataCountry) {
                      $(this).prop('selected', true);
                      $(this).change();
                    }
                    this.defaultSelected = $(this).val() === dataCountry;
                    if ($(this).val() === '---') {
                      $(this).prop('disabled', true);
                    }
                  });
                let provinces = null;
                options.each((index, option) => {
                  if ($(option).val() === dataCountry) {
                    provinces = JSON.parse($(option).attr('data-provinces'));
                  }
                });
                const $provinceSelectors = $(this).find('.province-selector');
                if (provinces) {
                  const optionsHtml = provinces
                    .map(([code, name]) => `<option value="${code}">${name}</option>`)
                    .join('');
                  // 获取data-country_prov等于dataCountry的元素

                  // 根据$provinces数据生成对应的option
                  $provinceSelectors.each((index, provinceSelector) => {
                    $(provinceSelector).html(optionsHtml);
                    // 获取provinceSelectorvalue属性
                    const provinceSelectorValue = $(provinceSelector).attr('data-country_prov');
                    // option等于provinceSelectorValue的option
                    if (provinceSelectorValue) {
                      setTimeout(() => {
                        $(provinceSelector).find(`option[value="${provinceSelectorValue}"]`).prop('selected', true);
                        $(provinceSelector)
                          .find('option')
                          .each(function () {
                            this.defaultSelected = $(this).val() === provinceSelectorValue;
                          });
                        $(provinceSelector).change();
                      }, 100);
                    } else {
                      // 第一个option
                      $(provinceSelector).find('option').eq(0).prop('selected', true);
                      $(provinceSelector).change();
                    }
                    const $addressInputContainer = $(provinceSelector).closest('.address_input_container');
                    const $placeholder_text = $addressInputContainer.find('.placeholder_text');
                  });
                } else {
                  const $placeholder_text = $provinceSelectors
                    .closest('.address_input_container')
                    .find('.placeholder_text');
                  $provinceSelectors.html('');
                }
              });
            }
          }

          deleteAddress(address_id) {
            const _this = this;
            const addressDelete = $(_this.querySelectorAll('.addressDelete-popup'));
            addressDelete.each(function () {
              $(this).css('z-index', '-99').css('opacity', '0');
            });
            const currentDeletelessPopup = $(_this.querySelector(`[data-delete="${address_id}"]`));
            currentDeletelessPopup.css('z-index', '500').css('opacity', '1');
            // 获取currentDeletelessPopup下的submit按钮
            const $submitBtn = currentDeletelessPopup.find('button[type="submit"]');
            $submitBtn.on('click', async function (e) {
              e.preventDefault();
              $(this).find('.rotate_icon').removeClass('hidden').addClass('flex');
              $(this).find('.loading-button-text').addClass('hidden').removeClass('flex');
              await _this.deleteAddressConfirm(address_id);
              $(this).find('.rotate_icon').removeClass('flex').addClass('hidden');
              $(this).find('.loading-button-text').addClass('flex').removeClass('hidden');
            });
          }

          closeDeletePopup() {
            const addressDelete = $(this.querySelectorAll('.addressDelete-popup'));
            addressDelete.each(function () {
              $(this).css('z-index', '-99').css('opacity', '0');
            });
            window.litime.enableScroll();
          }

          deleteAddressConfirm(address_id) {
            const _this = this;
            // 获取address_id弹窗下的form
            return new Promise((resolve, reject) => {
              const $form = $(_this.querySelector(`[data-delete="${address_id}"]`)).find('form');
              // 提交form
              $.ajax({
                url: $form.attr('action'),
                method: 'POST',
                data: new FormData($form[0]), // 注意：需要使用原生form元素
                processData: false, // 不处理数据
                contentType: false, // 不设置内容类型
                success: async (response) => {
                  // 关闭删除弹窗
                  _this.closeDeletePopup();

                  try {
                    // 使用当前页面地址作为数据源（如果有单独地址列表接口，可以替换为对应 URL）
                    const orderUrl = window.location.href;
                    const res = await fetch(`${orderUrl}`, { credentials: 'same-origin' });
                    if (!res.ok) throw new Error('Failed to load address list');

                    const responseText = await res.text();
                    const html = new DOMParser().parseFromString(responseText, 'text/html');

                    // 当前组件内的布局容器（包含列表 + 弹窗）
                    const currentLayout = _this.querySelector('.account-shipping-layout');
                    // 新 HTML 中对应的布局容器
                    const newLayout = html.querySelector('.account-shipping-layout');

                    if (currentLayout && newLayout) {
                      // 用新内容替换旧内容（列表 + 所有编辑/删除弹窗）
                      currentLayout.innerHTML = newLayout.innerHTML;
                      // 重新绑定事件（编辑 / 删除 / 新增 等）
                      _this.init();
                      _this.changeCountry();
                    }
                  } catch (err) {
                    console.error('刷新地址列表失败:', err);
                    if (window.litime && typeof window.litime.showToast === 'function') {
                      window.litime.showToast('error', window.i18n?.request_failed || 'Request failed');
                    }
                  }
                },
                error: (xhr, status, error) => {
                  // 显示错误信息
                  // this.showMessage(error.message, 'error');
                },
              });
            });
          }

          editAddress(address_id) {
            const _this = this;
            if (!address_id) {
              address_id = 'newAddressForm';
            }
            this.currentPopupId = address_id;
            this.setAttribute('data-current-popup', address_id);
            const addressPopups = $(_this.querySelectorAll('.address-popup'));
            addressPopups.each(function () {
              $(this).css('z-index', '-99').css('opacity', '0');
            });
            const currentAddressPopup = $(_this.querySelector(`[data-address_id="${address_id}"]`));
            currentAddressPopup.css('z-index', '500').css('opacity', '1');
            const $countrySelectors = $(currentAddressPopup.find('.country-selector'));

            window.litime.disableScroll();

            this.form = currentAddressPopup.find(`#addressForm_${address_id}`);
            this.submitBtn = currentAddressPopup.find('[type="submit"]');
            // 禁用浏览器默认校验
            this.form.attr('novalidate', true);
            this.submitBtn.on('click', (e) => this.ClickSubmit(e));
            this.form.on('submit', (e) => e.preventDefault());

            // 重置表单到原始状态（确保显示的是原始数据，而不是上次编辑的数据）
            const form = currentAddressPopup.find(`#addressForm_${address_id}`);
            if (form && form.length > 0) {
              // 重置表单
              form[0].reset();

              // 重置国家选择器到原始值
              const countrySelect = form.find('.country-selector');
              if (countrySelect.length > 0) {
                const isNewAddress = address_id === 'newAddressForm';
                let selectedCountry = '';
                let selectedCountryLabel = '';
                let selectedProvincesAttr = '';

                if (isNewAddress) {
                  // 新建地址：选中第一条数据
                  const firstOption = countrySelect.find('option:not([value=""]):not([value="---"])').first();
                  if (firstOption.length > 0) {
                    selectedCountry = firstOption.val();
                    selectedCountryLabel = firstOption.text();
                    selectedProvincesAttr = firstOption.attr('data-provinces') || '';
                  }
                } else {
                  // 编辑地址：使用 data-country
                  const dataCountry = countrySelect.attr('data-country');
                  if (dataCountry) {
                    selectedCountry = dataCountry;
                    const option = countrySelect.find(`option[value="${dataCountry}"]`);
                    if (option.length > 0) {
                      selectedCountryLabel = option.text();
                      selectedProvincesAttr = option.attr('data-provinces') || '';
                    }
                  }
                }

                // 设置选中的国家
                if (selectedCountry) {
                  countrySelect.val(selectedCountry);

                  // 重置国家下拉的显示文本
                  const countryTrigger = form.find('.address-select-trigger-country');
                  if (countryTrigger.length > 0) {
                    const countryLabelSpan = countryTrigger.find('.address-select-label');
                    if (countryLabelSpan.length > 0) {
                      countryLabelSpan.text(selectedCountryLabel);
                    }

                    // 添加 is-filled 状态到国家的 address_input_container
                    const countryInputContainer = countryTrigger.closest('.address_input_container');
                    if (countryInputContainer && countryInputContainer.length > 0) {
                      countryInputContainer.addClass('is-filled');
                    }

                    // 手动调用 address-input 组件的 updateProvinceOptions 方法来更新省份列表
                    const addressInputComponent = countryTrigger.closest('address-input')[0];
                    if (addressInputComponent && typeof addressInputComponent.updateProvinceOptions === 'function') {
                      addressInputComponent.updateProvinceOptions(selectedProvincesAttr);
                    }
                  }

                  // 最后触发 change 事件
                  countrySelect.trigger('change');
                }
              }

              // 重置省份选择器到原始值
              const provinceSelect = form.find('.province-selector');
              const provinceTrigger = form.find('.address-select-trigger-province');
              const provinceContainer =
                provinceTrigger.length > 0 ? provinceTrigger.closest('.address_input_container') : null;

              if (provinceSelect.length > 0 && provinceTrigger.length > 0 && !isNewAddress) {
                const dataProvince = provinceSelect.attr('data-country_prov');
                // 如果有原始省份数据，需要恢复显示（仅用于编辑地址）
                if (dataProvince && dataProvince !== '---' && dataProvince.trim() !== '') {
                  // 检查原始国家是否有省份数据

                  const dataCountry = countrySelect.attr('data-country');
                  if (dataCountry) {
                    // 从国家的 options 中查找对应的省份数据
                    const countryOption = countrySelect.find(`option[value="${dataCountry}"]`);
                    if (countryOption.length > 0) {
                      const provincesAttr = countryOption.attr('data-provinces');
                      if (provincesAttr) {
                        try {
                          const provinces = JSON.parse(provincesAttr);
                          if (provinces && Array.isArray(provinces) && provinces.length > 0) {
                            // 原始国家有省份数据，恢复省份选择器
                            // 清空旧选项
                            provinceSelect[0].innerHTML = '';
                            const provinceOptionsContainer = form.find('[data-address-province-options]');
                            if (provinceOptionsContainer.length > 0) {
                              provinceOptionsContainer[0].innerHTML = '';
                            }

                            // 生成省份选项
                            const provinceLabelSpan = provinceTrigger.find('.address-select-label');
                            let foundProvince = false;

                            for (let i = 0; i < provinces.length; i++) {
                              const province = provinces[i];
                              const code = province[0];
                              const name = province[1];

                              // 添加到原生 select
                              const option = document.createElement('option');
                              option.value = code;
                              option.textContent = name;
                              provinceSelect[0].appendChild(option);

                              // 添加到自定义下拉列表
                              if (provinceOptionsContainer.length > 0) {
                                const li = document.createElement('li');
                                li.className = 'select-options-item';
                                li.setAttribute('data-value', code);
                                li.textContent = name;
                                provinceOptionsContainer[0].appendChild(li);
                              }

                              // 如果匹配原始省份值，设置为选中
                              if (code === dataProvince) {
                                provinceSelect.val(code);
                                if (provinceLabelSpan.length > 0) {
                                  provinceLabelSpan.text(name);
                                }
                                foundProvince = true;
                              }
                            }

                            // 如果没有找到匹配的省份，选择第一个
                            if (!foundProvince && provinces.length > 0) {
                              const firstProvince = provinces[0];
                              provinceSelect.val(firstProvince[0]);
                              if (provinceLabelSpan.length > 0) {
                                provinceLabelSpan.text(firstProvince[1]);
                              }
                            }

                            // 显示省份 trigger 和容器
                            if (provinceContainer && provinceContainer.length > 0) {
                              provinceContainer.css('display', '');
                            }
                            provinceTrigger.css('display', '');

                            // 触发 change 事件
                            provinceSelect.trigger('change');
                          }
                        } catch (e) {
                          console.error('解析省份数据失败:', e);
                        }
                      }
                    }
                  }
                }
              }
            }

            // 更新所有 address-input 组件的填充状态
            // 使用 setTimeout 确保 DOM 已经完全渲染
            setTimeout(function () {
              const addressInputs = currentAddressPopup[0].querySelectorAll('address-input');
              addressInputs.forEach(function (inputComponent) {
                if (inputComponent && typeof inputComponent.updateFilledState === 'function') {
                  inputComponent.updateFilledState();
                }
              });
            }, 100);
          }

          cancelAddress() {
            const _this = this;
            const address_popups = $(_this.querySelectorAll('.address-popup'));
            address_popups.css('display', 'none').css('display', 'flex');
            address_popups.each(function () {
              $(this).css('z-index', '-99').css('opacity', '0');
              this.querySelector('form').reset();
              window.litime.enableScroll();

              $(this)
                .find('form')
                .find('[required]')
                .each((_, field) => {
                  _this.resetFieldStatus(field);
                });
            });
          }
          validateForm() {
            let isValid = true;
            const errors = [];

            // 校验所有必填字段
            this.$form.find('[required]').each((_, field) => {
              if (!this.validateField(field)) {
                isValid = false;
              }
            });

            this.errors = errors;
            return isValid;
          }
          validateField(field) {
            const $field = $(field);
            const value = $field.val();
            let isValid = true;

            // 必填校验
            if ($field.prop('required') && (!value || value === '' || value === '---')) {
              isValid = false;
            }

            // // 手机号校验
            // if ($field.attr('name') === 'address[phone]' && value) {
            //   isValid = this.validatePhone(value);
            // }

            // // 邮编校验
            // if ($field.attr('name') === 'address[zip]' && value) {
            //   isValid = this.validateZip(value);
            // }

            // 更新字段状态
            this.updateFieldStatus($field, isValid);
            return isValid;
          }

          resetFieldStatus(field) {
            const $field = $(field);
            const $addressInputPlaceholder = $field.siblings('.address_input_placeholder');
            // 获取父元素为 address_input_container的元素
            const $addressInputContainer = $field.parents('.address_input_container');
            // 获取与$addressInputContainer同级的 error-message元素
            const $errorMessage = $addressInputContainer.siblings('.error-message');
            $addressInputPlaceholder.css('color', '#666666');
            $addressInputContainer.removeClass('border-[#FC2323]').addClass('border-[#D9D9D9]');
            $errorMessage.addClass('hidden');
          }

          updateFieldStatus($field, isValid) {
            // 获取与$field同级的 address_input_placeholder元素
            const $addressInputPlaceholder = $field.siblings('.address_input_placeholder');
            // 获取父元素为 address_input_container的元素
            const $addressInputContainer = $field.parents('.address_input_container');

            // 获取与$addressInputContainer同级的 error-message元素
            const $errorMessage = $addressInputContainer.siblings('.error-message');

            // 对于 select 元素（国家/省份），需要给触发器添加错误样式
            const $selectTrigger = $field.siblings(
              '.address-select-trigger, .address-select-trigger-country, .address-select-trigger-province'
            );

            if (!isValid) {
              $addressInputContainer
                .removeClass('border-[#D9D9D9]')
                .addClass('border-[#FC2323]')
                .addClass('field-error');
              $addressInputPlaceholder.css('color', '#FC2323');
              $selectTrigger.css('border-color', '#FC2323');
              $errorMessage.removeClass('hidden');
            } else {
              $addressInputContainer
                .removeClass('border-[#FC2323]')
                .addClass('border-[#D9D9D9]')
                .removeClass('field-error');
              $addressInputPlaceholder.css('color', '#737373');
              $selectTrigger.css('border-color', '#D9D9D9');
              $errorMessage.addClass('hidden');
            }
          }

          getErrorMessage(field) {
            const $field = $(field);
            const fieldName = $field.attr('name');

            // 自定义错误信息
            const customMessage = $field.data('error-message');
            if (customMessage) return customMessage;

            // 默认错误信息
            const messages = {
              'address[name]': '请输入姓名',
              'address[phone]': '请输入有效的手机号',
              'address[email]': '请输入有效的邮箱地址',
              'address[zip]': '请输入有效的邮政编码',
              'address[country]': '请选择国家/地区',
              'address[province]': '请选择省份',
              'address[city]': '请选择城市',
              'address[address1]': '请输入详细地址',
            };

            return messages[fieldName] || '此字段不能为空';
          }

          ClickSubmit(e) {
            e.preventDefault();
            e.stopPropagation();
            this.handleSubmit(e);
          }

          handleSubmit(e) {
            e.preventDefault();
            const _this = this;

            // 获取jQuery对象
            const $submitBtn = $(this.submitBtn);
            const $form = $(this.form);
            let isValid = true;
            $form.find('[required]').each((_, field) => {
              // 任何一个必填项校验失败，都标记为整体无效
              if (!_this.validateField(field)) {
                isValid = false;
              }
            });
            if (!isValid) {
              return;
            }

            // 显示加载状态
            $(this.submitBtn).find('.rotate_icon').removeClass('hidden').addClass('flex');
            $(this.submitBtn).find('.loading-button-text').addClass('hidden').removeClass('flex');
            $.ajax({
              url: $form.attr('action'),
              method: 'POST',
              data: new FormData($form[0]), // 注意：需要使用原生form元素
              processData: false, // 不处理数据
              contentType: false, // 不设置内容类型
              success: async (response) => {
                // loading图标隐藏
                $(this.submitBtn).find('.rotate_icon').removeClass('flex').addClass('hidden');
                $(this.submitBtn).find('.loading-button-text').addClass('flex').removeClass('hidden');
                _this.cancelAddress();

                // 通过 currentPopupId 拿到当前编辑的 address_id
                const addressId = _this.currentPopupId;

                try {
                  // 使用当前页面地址作为数据源（如果有单独地址列表接口，可以替换为对应 URL）
                  const orderUrl = window.location.href;
                  const response = await fetch(`${orderUrl}`, {
                    credentials: 'same-origin',
                  });
                  const responseText = await response.text();
                  const html = new DOMParser().parseFromString(responseText, 'text/html');

                  // 当前组件内的布局容器（包含列表 + 弹窗）
                  const currentLayout = _this.querySelector('.account-shipping-layout');
                  // 新 HTML 中对应的布局容器
                  const newLayout = html.querySelector('.account-shipping-layout');

                  if (currentLayout && newLayout) {
                    // 用新内容替换旧内容（列表 + 所有编辑/删除弹窗）
                    currentLayout.innerHTML = newLayout.innerHTML;
                    // 重新绑定事件（编辑 / 删除 / 新增等）
                    _this.init();
                    _this.changeCountry();
                  }
                } catch (err) {
                  console.error('刷新地址列表失败:', err);
                  if (window.litime && typeof window.litime.showToast === 'function') {
                    window.litime.showToast('error', window.i18n?.request_failed || 'Request failed');
                  }
                }
              },
              error: (xhr, status, error) => {
                // 显示错误信息
                // this.showMessage(error.message, 'error');
              },
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-recommend-v2"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('cart-recommend-v2')) {
      customElements.define(
        'cart-recommend-v2',
        class CartRecommend extends HTMLElement {
          constructor() {
            super();
            this.recommendContainer = null;
            this.observer = null;
            this.handleIntersection = this.handleIntersection.bind(this);
            this.recommendMainContainer = null;
            this.hasLoaded = false; // 避免重复请求
            this.isFetching = false; // 避免并发请求
            this.cachedContent = null; // 缓存已加载的内容
            // 全局缓存：针对相同 data-url，保存已加载的 HTML 内容
            // Map 结构：{ url: { recommendationsHTML, recommendMainContainerHTML } }
            if (!window.__cartRecommendLoaded) {
              window.__cartRecommendLoaded = new Map();
            }
            // 订阅购物车渲染完成事件
            this.restoreContentHandler = this.restoreContent.bind(this);
          }

          connectedCallback() {
            this.recommendContainer = this.querySelector('.cart-recommendations');
            this.recommendMainContainer = this.querySelector('.recommend-main-container');
            if (!this.recommendContainer) return;

            const url = this.recommendContainer?.dataset.url;
            // ✅ 如果相同 URL 已经加载过，直接恢复内容
            if (url && window.__cartRecommendLoaded.has(url)) {
              const cached = window.__cartRecommendLoaded.get(url);
              if (cached && cached.recommendationsHTML) {
                this.recommendContainer.innerHTML = cached.recommendationsHTML;
                if (cached.recommendMainContainerHTML && this.recommendMainContainer) {
                  this.recommendMainContainer.innerHTML = cached.recommendMainContainerHTML;
                }
                this.hasLoaded = true;
                this.cachedContent = cached;
                // 触发自定义事件通知外部
                this.dispatchEvent(
                  new CustomEvent('recommendations-loaded', {
                    bubbles: true,
                    detail: { container: this.recommendContainer },
                  })
                );
                return;
              }
            }

            // ✅ 订阅购物车渲染完成事件，用于恢复内容
            if (window.litime && window.litime.eventBus) {
              console.log('subscribe CART_DRAWER_RENDERED-v2');
              this.unsubscribeCartRendered = window.litime.eventBus.subscribe(
                'CART_DRAWER_RENDERED-v2',
                this.restoreContentHandler
              );
            }

            // 配置 IntersectionObserver
            this.observer = new IntersectionObserver(this.handleIntersection, {
              rootMargin: '0px 0px 200px 0px',
            });

            this.observer.observe(this.recommendContainer);
          }

          disconnectedCallback() {
            if (this.observer) {
              this.observer.disconnect();
            }
            // ✅ 取消订阅事件
            if (this.unsubscribeCartRendered) {
              this.unsubscribeCartRendered();
            }
          }

          /**
           * ✅ 恢复已缓存的推荐内容（当购物车重新渲染后调用）
           */
          restoreContent() {
            if (!this.recommendContainer || !this.cachedContent) return;
            const url = this.recommendContainer?.dataset.url;
            if (url && window.__cartRecommendLoaded.has(url)) {
              const cached = window.__cartRecommendLoaded.get(url);
              if (cached && cached.recommendationsHTML) {
                this.recommendContainer.innerHTML = cached.recommendationsHTML;
                if (cached.recommendMainContainerHTML && this.recommendMainContainer) {
                  this.recommendMainContainer.innerHTML = cached.recommendMainContainerHTML;
                }
                // 触发自定义事件通知外部
                this.dispatchEvent(
                  new CustomEvent('recommendations-loaded', {
                    bubbles: true,
                    detail: { container: this.recommendContainer },
                  })
                );
              }
            }
          }

          async handleIntersection(entries) {
            const entry = entries[0];
            if (!entry.isIntersecting) return;
            if (this.hasLoaded || this.isFetching) return; // 已经加载过或正在加载则跳过

            // 停止观察目标元素
            this.observer.unobserve(entry.target);

            try {
              this.isFetching = true;
              const response = await fetch(entry.target.dataset.url);
              const text = await response.text();
              const parser = new DOMParser();
              const doc = parser.parseFromString(text, 'text/html');
              const recommendations = doc.querySelector('.cart-recommendations');
              const recommendMainContainer = doc.querySelector('.recommend-main-container');
              if (recommendations?.innerHTML.trim()) {
                this.recommendContainer.innerHTML = recommendations.innerHTML;
                if (recommendMainContainer) {
                  this.recommendMainContainer.innerHTML = recommendMainContainer.innerHTML;
                }
                this.hasLoaded = true;
                // ✅ 保存到全局缓存，包含 HTML 内容，供后续恢复使用
                if (entry.target.dataset.url) {
                  const cachedData = {
                    recommendationsHTML: recommendations.innerHTML,
                    recommendMainContainerHTML: recommendMainContainer ? recommendMainContainer.innerHTML : '',
                  };
                  window.__cartRecommendLoaded.set(entry.target.dataset.url, cachedData);
                  this.cachedContent = cachedData;
                }
                // 触发自定义事件通知外部
                this.dispatchEvent(
                  new CustomEvent('recommendations-loaded', {
                    bubbles: true,
                    detail: { container: this.recommendContainer },
                  })
                );
              } else {
                // 没有数据也视为已处理，避免重复请求
                this.hasLoaded = true;
                if (entry.target.dataset.url) {
                  const cachedData = {
                    recommendationsHTML: '',
                    recommendMainContainerHTML: '',
                  };
                  window.__cartRecommendLoaded.set(entry.target.dataset.url, cachedData);
                  this.cachedContent = cachedData;
                }
              }
            } catch (error) {
              this.dispatchEvent(
                new CustomEvent('recommendations-error', {
                  bubbles: true,
                  detail: { error },
                })
              );
            } finally {
              this.isFetching = false;
            }
          }
        }
      );
    }
  });
  $(function () {
    if (!customElements.get('cart-select-menu-v2')) {
      customElements.define(
        'cart-select-menu-v2',
        class CartSelectMenuV2 extends HTMLElement {
          constructor() {
            super();
            this.$cartRecommentSwiper = null;
            this.swiper = null;
          }

          connectedCallback() {
            this.$cartRecommentSwiper = this.querySelector('.cart-recommend-swiper');
            if (this.$cartRecommentSwiper) {
              this.initSwiper();
            }
            this.initJoinCartButton();
          }

          disconnectedCallback() {
            if (this.swiper) {
              this.swiper.destroy();
              this.swiper = null;
            }
          }

          initSwiper() {
            this.swiper = new Swiper(this.$cartRecommentSwiper, {
              slidesPerView: 'auto',
              spaceBetween: 16,
              navigation: {
                nextEl: this.querySelector('.swiper-button-next-recommend'),
                prevEl: this.querySelector('.swiper-button-prev-recommend'),
              },
            });
          }

          initJoinCartButton() {
            const joinCartBtns = this.querySelectorAll('.join-cart-btn');
            if (!joinCartBtns.length) return;

            const miniCart = this.closest('global-mini-cart-v2');
            const miniCartSectionId = miniCart?.getAttribute('data-section-id');

            joinCartBtns.forEach((joinCartBtn) => {
              joinCartBtn.addEventListener('click', async () => {
                try {
                  const card = joinCartBtn.closest('.cart-recommend-v2-item-v2');
                  const variantId = parseInt(
                    joinCartBtn.getAttribute('data-variant-id') || card?.getAttribute('data-variant-id'),
                    10
                  );

                  if (!variantId || Number.isNaN(variantId)) {
                    window.litime.showToast('error', 'Please select a variant');
                    return;
                  }

                  const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      items: [
                        {
                          id: variantId,
                          quantity: 1,
                        },
                      ],
                      sections: `${getMiniCartSectionId()},cart-icon-bubble`,
                    }),
                  });

                  if (window.gtag) {
                    gtag('event', 'conversion', { send_to: 'AW-11059876179/OfmnCMjGxIsYENOi4Zkp' });
                  }

                  if (response.ok) {
                    const cartContent = await response.json();
                    await updateCartComponents(cartContent);
                  } else {
                    const errorData = await response.json();
                    window.litime.showToast('error', errorData.description || 'Failed to Add to Cart');
                  }
                } catch (error) {
                  window.litime.showToast('error', 'Failed to Add to Cart');
                }
              });
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-recommend"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('cart-recommend')) {
      customElements.define(
        'cart-recommend',
        class CartRecommend extends HTMLElement {
          constructor() {
            super();
            this.recommendContainer = null;
            this.observer = null;
            this.handleIntersection = this.handleIntersection.bind(this);
            this.recommendMainContainer = null;
            this.hasLoaded = false; // 避免重复请求
            this.isFetching = false; // 避免并发请求
            this.cachedContent = null; // 缓存已加载的内容
            // 全局缓存：针对相同 data-url，保存已加载的 HTML 内容
            // Map 结构：{ url: { recommendationsHTML, recommendMainContainerHTML } }
            if (!window.__cartRecommendLoaded) {
              window.__cartRecommendLoaded = new Map();
            }
            // 订阅购物车渲染完成事件
            this.restoreContentHandler = this.restoreContent.bind(this);
          }

          connectedCallback() {
            this.recommendContainer = this.querySelector('.cart-recommendations');
            this.recommendMainContainer = this.querySelector('.recommend-main-container');
            if (!this.recommendContainer) return;

            const url = this.recommendContainer?.dataset.url;
            // ✅ 如果相同 URL 已经加载过，直接恢复内容
            if (url && window.__cartRecommendLoaded.has(url)) {
              const cached = window.__cartRecommendLoaded.get(url);
              if (cached && cached.recommendationsHTML) {
                this.recommendContainer.innerHTML = cached.recommendationsHTML;
                if (cached.recommendMainContainerHTML && this.recommendMainContainer) {
                  this.recommendMainContainer.innerHTML = cached.recommendMainContainerHTML;
                }
                this.hasLoaded = true;
                this.cachedContent = cached;
                // 触发自定义事件通知外部
                this.dispatchEvent(
                  new CustomEvent('recommendations-loaded', {
                    bubbles: true,
                    detail: { container: this.recommendContainer },
                  })
                );
                return;
              }
            }

            // ✅ 订阅购物车渲染完成事件，用于恢复内容
            if (window.litime && window.litime.eventBus) {
              this.unsubscribeCartRendered = window.litime.eventBus.subscribe(
                'CART_DRAWER_RENDERED',
                this.restoreContentHandler
              );
            }

            // 配置 IntersectionObserver
            this.observer = new IntersectionObserver(this.handleIntersection, {
              rootMargin: '0px 0px 200px 0px',
            });

            this.observer.observe(this.recommendContainer);
          }

          disconnectedCallback() {
            if (this.observer) {
              this.observer.disconnect();
            }
            // ✅ 取消订阅事件
            if (this.unsubscribeCartRendered) {
              this.unsubscribeCartRendered();
            }
          }

          /**
           * ✅ 恢复已缓存的推荐内容（当购物车重新渲染后调用）
           */
          restoreContent() {
            if (!this.recommendContainer || !this.cachedContent) return;
            const url = this.recommendContainer?.dataset.url;
            if (url && window.__cartRecommendLoaded.has(url)) {
              const cached = window.__cartRecommendLoaded.get(url);
              if (cached && cached.recommendationsHTML) {
                this.recommendContainer.innerHTML = cached.recommendationsHTML;
                if (cached.recommendMainContainerHTML && this.recommendMainContainer) {
                  this.recommendMainContainer.innerHTML = cached.recommendMainContainerHTML;
                }
                // 触发自定义事件通知外部
                this.dispatchEvent(
                  new CustomEvent('recommendations-loaded', {
                    bubbles: true,
                    detail: { container: this.recommendContainer },
                  })
                );
              }
            }
          }

          async handleIntersection(entries) {
            const entry = entries[0];
            if (!entry.isIntersecting) return;
            if (this.hasLoaded || this.isFetching) return; // 已经加载过或正在加载则跳过

            // 停止观察目标元素
            this.observer.unobserve(entry.target);

            try {
              this.isFetching = true;
              const response = await fetch(entry.target.dataset.url);
              const text = await response.text();
              const parser = new DOMParser();
              const doc = parser.parseFromString(text, 'text/html');
              const recommendations = doc.querySelector('.cart-recommendations');
              const recommendMainContainer = doc.querySelector('.recommend-main-container');
              if (recommendations?.innerHTML.trim()) {
                this.recommendContainer.innerHTML = recommendations.innerHTML;
                if (recommendMainContainer) {
                  this.recommendMainContainer.innerHTML = recommendMainContainer.innerHTML;
                }
                this.hasLoaded = true;
                // ✅ 保存到全局缓存，包含 HTML 内容，供后续恢复使用
                if (entry.target.dataset.url) {
                  const cachedData = {
                    recommendationsHTML: recommendations.innerHTML,
                    recommendMainContainerHTML: recommendMainContainer ? recommendMainContainer.innerHTML : '',
                  };
                  window.__cartRecommendLoaded.set(entry.target.dataset.url, cachedData);
                  this.cachedContent = cachedData;
                }
                // 触发自定义事件通知外部
                this.dispatchEvent(
                  new CustomEvent('recommendations-loaded', {
                    bubbles: true,
                    detail: { container: this.recommendContainer },
                  })
                );
              } else {
                // 没有数据也视为已处理，避免重复请求
                this.hasLoaded = true;
                if (entry.target.dataset.url) {
                  const cachedData = {
                    recommendationsHTML: '',
                    recommendMainContainerHTML: '',
                  };
                  window.__cartRecommendLoaded.set(entry.target.dataset.url, cachedData);
                  this.cachedContent = cachedData;
                }
              }
            } catch (error) {
              this.dispatchEvent(
                new CustomEvent('recommendations-error', {
                  bubbles: true,
                  detail: { error },
                })
              );
            } finally {
              this.isFetching = false;
            }
          }
        }
      );
    }
  });
  $(function () {
    if (!customElements.get('cart-select-menu')) {
      customElements.define(
        'cart-select-menu',
        class CartSelectMenu extends HTMLElement {
          constructor() {
            super();
            this.container = null;
            this.header = null;
            this.valueSpan = null;
            this.optionsList = null;
            this.optionsContainer = null;
            this.arrowIcon = null;
            this.$current_inventory_quantity = 0;
            this.$currentPrice = 0;
            this.$currentId = 0;
            this.$currentComparePrice = 0;
            this.$currentRecommendId = 0;
            this.$currentQuantity = 1;
            this.productId = null;
            this._documentClickBound = false;
            this.totalPrice = 0;
            this.totalComparePrice = 0;
            this.totalDiscount = 0;
            // 存储每个商品的选中状态 { productId: { variantId, price, comparePrice, inventoryQuantity } }
            this.selectedVariants = {};
            this.priceContribution = {
              price: 0,
              comparePrice: 0,
              discount: 0,
            };
            this.$cartRecommentSwiper = null;
          }

          connectedCallback() {
            const self = this;

            this.optionClickHandler = function (event) {
              const { componentType, dropdownId, data } = event.detail;

              // 只处理标记为 'cart-recommend' 的事件
              if (componentType !== 'cart-recommend') {
                return;
              }
              console.log('event', event);
              self.handleOptionClick(event.detail);
            };
            document.addEventListener('global-select:option-click', this.optionClickHandler);

            // 延迟扫描，确保 DOM 已就绪
            if (window.GlobalSelectManager) {
              setTimeout(() => {
                window.GlobalSelectManager.scan();
              }, 100);
            }

            // 为每个 select-menu 单独初始化
            const selectHeaders = this.querySelectorAll('.select-header');
            selectHeaders.forEach((header) => {
              if (header.hasAttribute('data-dropdown-trigger')) {
                return;
              }

              // 获取相关元素
              const valueSpan = header.querySelector('.select-value');
              const optionsContainer = header.nextElementSibling;
              const arrowIcon = header.querySelector('.arrow-icon');
              const optionsList = optionsContainer?.querySelector('ul');
              // 存储元素引用到 header 上，方便后续使用
              header._elements = {
                valueSpan,
                optionsContainer,
                arrowIcon,
                optionsList,
              };

              // 绑定事件
              if (header && optionsContainer) {
                // 点击 header 展开/收起
                header.addEventListener('click', (e) => {
                  e.stopPropagation();
                  const elements = header._elements;
                  this.toggle(header, elements.optionsContainer, elements.valueSpan, elements.arrowIcon);
                });

                // 点击选项
                optionsList?.addEventListener('click', (e) => {
                  const option = e.target.closest('.select-option');
                  if (option) {
                    e.stopPropagation();
                    const inventoryQuantity = option.getAttribute('data-inventory_quantity');
                    if (inventoryQuantity != 0) {
                      const elements = header._elements;
                      this.selectOption(option, header, elements);
                    }
                  }
                });
              }
            });

            // 点击外部关闭所有下拉
            this.addEventListener('click', () => {
              selectHeaders.forEach((header) => {
                const elements = header._elements;
                if (elements) {
                  this.close(header, elements.optionsContainer, elements.valueSpan, elements.arrowIcon);
                }
              });
            });

            // Swiper 初始化
            this.$cartRecommentSwiper = this.querySelector('.cart-recommend-swiper');
            if (this.$cartRecommentSwiper) {
              this.initSwiper();
              this.initEveryOption();
            }

            // 初始化加入购物车按钮
            this.initJoinCartButton();
          }

          /**
           *  组件卸载时移除事件监听
           */
          disconnectedCallback() {
            if (this.optionClickHandler) {
              document.removeEventListener('global-select:option-click', this.optionClickHandler);
            }
          }

          toggle(header, optionsContainer, valueSpan, arrowIcon) {
            const isActive = header.classList.contains('active-select-menu');

            if (!isActive) {
              // 展开
              header.classList.add('active-select-menu');
              optionsContainer.style.maxHeight = '300px';
              optionsContainer.style.opacity = '1';
              optionsContainer.style.pointerEvents = 'auto';
              valueSpan.style.color = '#acacac';
              arrowIcon.style.transform = 'rotate(-180deg)';
            } else {
              // 收起
              this.close(header, optionsContainer, valueSpan, arrowIcon);
            }
          }

          close(header, optionsContainer, valueSpan, arrowIcon) {
            header.classList.remove('active-select-menu');
            optionsContainer.style.maxHeight = '0';
            optionsContainer.style.opacity = '0';
            optionsContainer.style.pointerEvents = 'none';
            valueSpan.style.color = '';
            arrowIcon.style.transform = '';
          }

          /**
           *  处理 GlobalSelectManager 传递的选项点击
           * @param {Object} result - { item, data, dropdownId, trigger }
           */
          handleOptionClick(result) {
            const { item, data, dropdownId, trigger } = result;
            // 检查库存
            if (data.inventoryQuantity == 0 || item.classList.contains('cursor-not-allowed')) {
              return;
            }

            // 获取 recommendId
            const recommendId = data.recommendId;
            if (!recommendId) {
              return;
            }

            // 查找对应的 cart-select-menu 容器
            const cartSelectMenu = this.findCartSelectMenuByRecommendId(recommendId);
            if (!cartSelectMenu) {
              console.error('[cart-recommend] 找不到对应的 cart-select-menu');
              return;
            }

            // 更新选中状态
            const allOptions = item.closest('.select-options-list').querySelectorAll('.select-options-item');
            allOptions.forEach((opt) => {
              opt.classList.remove('text-orange-500', 'selected');
            });
            item.classList.add('text-orange-500', 'selected');

            // 更新触发器显示的值
            const valueSpan = trigger.querySelector('.select-value');
            if (valueSpan) {
              valueSpan.innerHTML = item.innerHTML;
            }

            // 更新价格和库存信息
            this.$current_inventory_quantity = data.inventoryQuantity != 0 ? parseInt(data.inventoryQuantity) : 1;
            this.$currentPrice = this.parsePriceString(data.price);
            this.$currentId = this.parsePriceString(data.id);
            this.$currentComparePrice = this.parsePriceString(data.compareAtPrice);
            this.productId = recommendId;

            // 存储该商品的选中状态
            this.selectedVariants[recommendId] = {
              variantId: this.parsePriceString(data.id),
              price: this.parsePriceString(data.price),
              comparePrice: this.parsePriceString(data.compareAtPrice),
              inventoryQuantity: data.inventoryQuantity != 0 ? parseInt(data.inventoryQuantity) : 1,
            };

            // 更新数量输入框
            const optionContainer = cartSelectMenu.querySelector(`.option-container[data-product-id="${recommendId}"]`);

            if (optionContainer) {
              const quantityInput = optionContainer.querySelector('input[type="text"]');
              if (quantityInput) {
                quantityInput.max = this.$current_inventory_quantity;

                const currentQuantity = parseInt(quantityInput.value);
                if (currentQuantity > this.$current_inventory_quantity) {
                  quantityInput.value = this.$current_inventory_quantity;
                  this.$currentQuantity = this.$current_inventory_quantity;
                } else {
                  this.$currentQuantity = currentQuantity;
                }
              }
            }

            // 更新价格显示
            this.updateOptionPrice();

            // 关闭下拉框
            if (window.GlobalSelectManager) {
              window.GlobalSelectManager.close(dropdownId);
            }
          }

          /**
           *  通过 recommendId 查找对应的 cart-select-menu
           */
          findCartSelectMenuByRecommendId(recommendId) {
            const allCartSelectMenus = document.querySelectorAll('cart-select-menu');
            for (let i = 0; i < allCartSelectMenus.length; i++) {
              const menu = allCartSelectMenus[i];
              if (menu.querySelector(`.option-container[data-product-id="${recommendId}"]`)) {
                return menu;
              }
            }
            return this; // 降级：返回当前实例
          }

          selectOption(option, header, elements) {
            const { valueSpan, optionsContainer, arrowIcon, optionsList } = elements;

            // 找到当前选项所在的 select-menu 容器
            const currentSelectMenu = option.closest('cart-select-menu');
            if (!currentSelectMenu) return;

            // 更新选中状态
            optionsList.querySelectorAll('.select-option').forEach((opt) => {
              opt.classList.remove('text-orange-500', 'selected');
            });
            option.classList.add('text-orange-500', 'selected');
            valueSpan.innerHTML = option.innerHTML;
            // 更新当前选中项的价格和库存信息
            this.$current_inventory_quantity =
              option.getAttribute('data-inventory_quantity') != 0
                ? parseInt(option.getAttribute('data-inventory_quantity'))
                : 1;
            this.$currentPrice = this.parsePriceString(option.getAttribute('data-price'));
            this.$currentId = this.parsePriceString(option.getAttribute('data-id'));
            this.$currentComparePrice = this.parsePriceString(option.getAttribute('data-compare_at_price'));

            // 获取当前产品的 ID
            const currentProductId = option.getAttribute('data-recommend-id');
            this.productId = currentProductId;

            // 在当前 select-menu 中查找对应产品的 option-container
            const optionContainer = currentSelectMenu.querySelector(
              `.option-container[data-product-id="${currentProductId}"]`
            );

            if (optionContainer) {
              const quantityInput = optionContainer.querySelector('input[type="text"]');
              if (quantityInput) {
                // 更新最大值
                quantityInput.max = this.$current_inventory_quantity;

                // 检查当前数量是否超过新的最大值
                const currentQuantity = parseInt(quantityInput.value);
                if (currentQuantity > this.$current_inventory_quantity) {
                  // 如果超过了，将数量调整为新的最大值
                  quantityInput.value = this.$current_inventory_quantity;
                  this.$currentQuantity = this.$current_inventory_quantity;
                } else {
                  // 如果没超过，保持当前数量
                  this.$currentQuantity = currentQuantity;
                }
              }
            }

            // 更新价格显示
            this.updateOptionPrice();

            // 关闭下拉
            this.close(header, optionsContainer, valueSpan, arrowIcon);
          }

          initEveryOption() {
            // 获取所有选项列表（多变体商品）
            const lists = this.querySelectorAll('.select-options-list');

            lists.forEach((list) => {
              // 获取当前列表中选中的选项，如果没有则获取第一个
              let selectedOption = list.querySelector('.select-options-item.selected');
              if (!selectedOption) {
                selectedOption = list.querySelector('.select-options-item');
              }
              if (!selectedOption) return;

              // 获取当前产品的信息
              const current_inventory_quantity = selectedOption.getAttribute('data-inventory_quantity');
              const currentPrice = this.parsePriceString(selectedOption.getAttribute('data-price'));
              const currentId = this.parsePriceString(selectedOption.getAttribute('data-id'));
              const currentComparePrice = this.parsePriceString(selectedOption.getAttribute('data-compare_at_price'));
              const currentRecommendId = this.parsePriceString(selectedOption.getAttribute('data-recommend-id'));

              // 初始化该商品的选中状态
              this.selectedVariants[currentRecommendId] = {
                variantId: currentId,
                price: currentPrice,
                comparePrice: currentComparePrice,
                inventoryQuantity: current_inventory_quantity != 0 ? parseInt(current_inventory_quantity) : 1,
              };

              // 找到对应的数量输入框容器
              const quantityContainer = this.querySelector(
                `.option-container[data-product-id="${currentRecommendId}"]`
              );
              if (!quantityContainer) return;

              // 设置对应的数量输入框
              const quantityInput = quantityContainer.querySelector('input[type="text"]');
              if (quantityInput) {
                // 设置最大值
                quantityInput.max = current_inventory_quantity;

                // 监听输入事件
                quantityInput.addEventListener('input', (event) => {
                  let newValue = parseInt(event.target.value);
                  const maxValue = parseInt(quantityInput.max);

                  // 限制输入范围
                  if (isNaN(newValue) || newValue < 1) {
                  } else if (newValue > maxValue) {
                    newValue = maxValue;
                    quantityInput.value = maxValue;
                  }

                  // 只在有效范围内更新价格
                  if (newValue >= 1 && newValue <= maxValue) {
                    this.$currentQuantity = newValue;
                    this.updateOptionPrice();
                  }
                });

                // 失去焦点时确保数值正确
                quantityInput.addEventListener('blur', () => {
                  let value = parseInt(quantityInput.value);
                  const maxValue = parseInt(quantityInput.max);

                  if (isNaN(value) || value < 1) {
                    value = 1;
                  } else if (value > maxValue) {
                    value = maxValue;
                  }

                  quantityInput.value = value;
                  this.$currentQuantity = value;
                  this.updateOptionPrice();
                });
              }
            });
          }
          // 更新价格显示
          updateOptionPrice() {
            // 使用唯一的类名选择器
            const priceElement = this.querySelector(`.select-price-${this.productId}`);
            const comparePriceElement = this.querySelector(`.select-compare-price-${this.productId}`);

            if (priceElement && this.$currentPrice && this.$currentQuantity) {
              // 更新价格显示
              priceElement.innerHTML = window.Shopify.formatMoney(this.$currentPrice, window.shopMoneyFormat);

              // 如果有比较价格，也更新比较价格
              if (comparePriceElement && this.$currentComparePrice) {
                comparePriceElement.innerHTML = window.Shopify.formatMoney(
                  this.$currentComparePrice,
                  window.shopMoneyFormat
                );
              } else {
                if (this.$currentComparePrice == 0) {
                  comparePriceElement.innerHTML = '';
                }
              }
            }
          }
          initSwiper() {
            this.swiper = new Swiper(this.$cartRecommentSwiper, {
              slidesPerView: 1,
              pagination: {
                el: '.swiper-pagination',
                clickable: true,
              },
              navigation: {
                nextEl: '.swiper-button-next-recommend',
                prevEl: '.swiper-button-prev-recommend',
              },
              on: {
                slideChange: function () {
                  //  Swiper 切换时关闭当前活动的下拉框
                  if (window.GlobalSelectManager && window.GlobalSelectManager.activeId) {
                    window.GlobalSelectManager.close(window.GlobalSelectManager.activeId);
                  }
                },
              },
            });
          }

          parsePriceString(priceString) {
            if (!priceString) return 0;
            // 移除所有非数字和非小数点的字符，然后转换为数字
            return parseFloat(priceString.replace(/[^0-9.]/g, '')) || 0;
          }

          initJoinCartButton() {
            // 获取所有加入购物车按钮
            const joinCartBtns = this.querySelectorAll('.join-cart-btn');
            if (!joinCartBtns.length) return;

            joinCartBtns.forEach((joinCartBtn) => {
              joinCartBtn.addEventListener('click', async () => {
                try {
                  // 找到按钮所在的父容器
                  const parentContainer = joinCartBtn.closest('.option-container-list');
                  if (!parentContainer) {
                    console.error('Cannot find parent container');
                    return;
                  }

                  // 在父容器中找到 option-container
                  const optionContainer = parentContainer.querySelector('.option-container[data-product-id]');
                  if (!optionContainer) {
                    console.error('Cannot find option container');
                    return;
                  }

                  const productId = optionContainer.getAttribute('data-product-id');

                  // 从状态中获取该商品的选中信息
                  const selectedVariant = this.selectedVariants[productId];
                  if (!selectedVariant) {
                    window.litime.showToast('error', 'Please select a variant');
                    return;
                  }

                  // 获取变体ID和数量
                  const variantId = selectedVariant.variantId;
                  const quantityInput = optionContainer.querySelector('input[type="text"]');
                  const quantity = quantityInput ? parseInt(quantityInput.value) : 1;

                  if (!variantId || isNaN(variantId)) {
                    console.error('Invalid variant ID');
                    return;
                  }

                  const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                      items: [
                        {
                          id: parseInt(variantId),
                          quantity: quantity,
                        },
                      ],
                      sections: `${getMiniCartSectionId()},cart-icon-bubble`,
                    }),
                  });
                  if (window.gtag) {
                    gtag('event', 'conversion', { send_to: 'AW-11059876179/OfmnCMjGxIsYENOi4Zkp' });
                  }
                  if (response.ok) {
                    const cartContent = await response.json();
                    await updateCartComponents(cartContent);
                  } else {
                    const errorData = await response.json();
                    console.error('Add Cart error:', errorData);
                    window.litime.showToast('error', errorData.description || 'Failed to Add to Cart');
                  }
                } catch (error) {
                  console.error('Add Cart failed:', error);
                  window.litime.showToast('error', 'Failed to Add to Cart');
                }
              });
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-filter-mobile-v2"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('collection-filter-mobile-v2')) {
      customElements.define(
        'collection-filter-mobile-v2',
        class CollectionFilterMobileV2 extends HTMLElement {
          connectedCallback() {
            this._handleClick = this.handleClick.bind(this);
            this._handleKeydown = this.handleKeydown.bind(this);

            this.trigger = this.querySelector('[data-filter-trigger]');
            this.panel = this.querySelector('[data-filter-panel]');
            this.content = this.querySelector('[data-filter-content]');

            this.addEventListener('click', this._handleClick);
            this.addEventListener('keydown', this._handleKeydown);
          }

          disconnectedCallback() {
            this.removeEventListener('click', this._handleClick);
            this.removeEventListener('keydown', this._handleKeydown);
          }

          handleClick(event) {
            if (event.target.closest('[data-filter-trigger]')) {
              event.preventDefault();
              event.stopPropagation();
              this.openDrawer();
              return;
            }

            if (event.target.closest('[data-filter-overlay], [data-filter-close]')) {
              this.closeDrawer();
              return;
            }

            if (event.target.closest('[data-filter-reset]')) {
              this.clearFiltersLocal();
              return;
            }

            if (event.target.closest('[data-filter-apply]')) {
              this.applyFilters();
              return;
            }

            const header = event.target.closest('.collection-filter-mobile-v2__filter-item-header');
            if (header && this.contains(header)) {
              this.toggleSection(header);
              return;
            }

            const categoryItem = event.target.closest('[data-type="category"] .collection-filter-mobile-v2__option');
            if (categoryItem && this.contains(categoryItem)) {
              const url = categoryItem.dataset.value;
              if (url && url !== 'javascript:;' && url !== 'javascript:void(0)') {
                window.location.href = url;
              }
              return;
            }

            const listItem = event.target.closest('.collection-filter-mobile-v2__option[data-type="list"]');
            if (listItem && this.contains(listItem)) {
              this.toggleListItem(listItem);
            }
          }

          handleKeydown(event) {
            if (event.key === 'Escape' && this.dataset.open === 'true') {
              this.closeDrawer();
              return;
            }

            if (event.key !== 'Enter' && event.key !== ' ') return;

            const header = event.target.closest('.collection-filter-mobile-v2__filter-item-header');
            if (header && this.contains(header)) {
              event.preventDefault();
              this.toggleSection(header);
            }
          }

          openDrawer() {
            this.syncContentFromPcFilter();
            this.setAttribute('data-open', 'true');
            if (this.panel) {
              this.panel.setAttribute('aria-hidden', 'false');
            }
            if (this.trigger) {
              this.trigger.setAttribute('aria-expanded', 'true');
            }
            if (window.litime?.disableScroll) {
              window.litime.disableScroll();
            }
          }

          closeDrawer() {
            this.setAttribute('data-open', 'false');
            if (this.panel) {
              this.panel.setAttribute('aria-hidden', 'true');
            }
            if (this.trigger) {
              this.trigger.setAttribute('aria-expanded', 'false');
            }
            if (window.litime?.enableScroll) {
              window.litime.enableScroll();
            }
          }

          syncContentFromPcFilter() {
            const pcRoot = this.closest('main-collection-v2')?.querySelector('collection-filter-pc-v2');
            if (!pcRoot || !this.content) return;

            pcRoot
              .querySelectorAll('.collection-filter-pc-v2__content-item-content-item[data-type="list"]')
              .forEach((pcItem) => {
                const name = pcItem.dataset.paramName;
                const value = pcItem.dataset.paramValue;
                if (!name) return;

                const mobileItem = this.content.querySelector(
                  `.collection-filter-mobile-v2__option[data-type="list"][data-param-name="${name}"][data-param-value="${CSS.escape(
                    value
                  )}"]`
                );
                if (mobileItem) {
                  mobileItem.setAttribute('data-active', pcItem.getAttribute('data-active') || 'false');
                }
              });

            const pcPriceSections = pcRoot.querySelectorAll('[data-type="price_range"]');
            const mobilePriceSections = this.content.querySelectorAll('[data-type="price_range"]');
            pcPriceSections.forEach((pcSection, index) => {
              const mobileSection = mobilePriceSections[index];
              if (!mobileSection) return;

              const pcMin = pcSection.querySelector('.collection-filter-pc-v2__content-item-content-item-input--min');
              const pcMax = pcSection.querySelector('.collection-filter-pc-v2__content-item-content-item-input--max');
              const mobileMin = mobileSection.querySelector('.collection-filter-mobile-v2__price-input--min');
              const mobileMax = mobileSection.querySelector('.collection-filter-mobile-v2__price-input--max');

              if (pcMin && mobileMin) mobileMin.value = pcMin.value;
              if (pcMax && mobileMax) mobileMax.value = pcMax.value;
            });

            const pcHeaders = pcRoot.querySelectorAll('.collection-filter-pc-v2__content-item-header');
            const mobileHeaders = this.content.querySelectorAll('.collection-filter-mobile-v2__filter-item-header');
            pcHeaders.forEach((pcHeader, index) => {
              const mobileHeader = mobileHeaders[index];
              if (!mobileHeader) return;

              mobileHeader.setAttribute('data-active', pcHeader.getAttribute('data-active') || 'true');
              mobileHeader.setAttribute('aria-expanded', pcHeader.getAttribute('aria-expanded') || 'true');
            });
          }

          syncContentToPcFilter() {
            const pcRoot = this.closest('main-collection-v2')?.querySelector('collection-filter-pc-v2');
            if (!pcRoot || !this.content) return;

            this.content
              .querySelectorAll('.collection-filter-mobile-v2__option[data-type="list"]')
              .forEach((mobileItem) => {
                const name = mobileItem.dataset.paramName;
                const value = mobileItem.dataset.paramValue;
                if (!name) return;

                const pcItem = pcRoot.querySelector(
                  `.collection-filter-pc-v2__content-item-content-item[data-type="list"][data-param-name="${name}"][data-param-value="${CSS.escape(
                    value
                  )}"]`
                );
                if (pcItem) {
                  pcItem.setAttribute('data-active', mobileItem.getAttribute('data-active') || 'false');
                }
              });

            const mobilePriceSections = this.content.querySelectorAll('[data-type="price_range"]');
            const pcPriceSections = pcRoot.querySelectorAll('[data-type="price_range"]');
            mobilePriceSections.forEach((mobileSection, index) => {
              const pcSection = pcPriceSections[index];
              if (!pcSection) return;

              const mobileMin = mobileSection.querySelector('.collection-filter-mobile-v2__price-input--min');
              const mobileMax = mobileSection.querySelector('.collection-filter-mobile-v2__price-input--max');
              const pcMin = pcSection.querySelector('.collection-filter-pc-v2__content-item-content-item-input--min');
              const pcMax = pcSection.querySelector('.collection-filter-pc-v2__content-item-content-item-input--max');

              if (mobileMin && pcMin) pcMin.value = mobileMin.value;
              if (mobileMax && pcMax) pcMax.value = mobileMax.value;
            });
          }

          toggleSection(header) {
            const isActive = header.getAttribute('data-active') === 'true';
            const nextActive = isActive ? 'false' : 'true';
            header.setAttribute('data-active', nextActive);
            header.setAttribute('aria-expanded', nextActive);
          }

          toggleListItem(listItem) {
            const isActive = listItem.getAttribute('data-active') === 'true';
            listItem.setAttribute('data-active', isActive ? 'false' : 'true');
          }

          buildFilterSearchParams() {
            const root = this.content || this;
            const params = new URLSearchParams();

            root
              .querySelectorAll('.collection-filter-mobile-v2__option[data-type="list"][data-active="true"]')
              .forEach((item) => {
                const name = item.dataset.paramName;
                const value = item.dataset.paramValue;
                if (name && value !== undefined && value !== '') {
                  params.append(name, value);
                }
              });

            root.querySelectorAll('[data-type="price_range"]').forEach((section) => {
              const minParam = section.dataset.paramMin;
              const maxParam = section.dataset.paramMax;
              const minInput = section.querySelector('.collection-filter-mobile-v2__price-input--min');
              const maxInput = section.querySelector('.collection-filter-mobile-v2__price-input--max');

              if (minParam && minInput && minInput.value !== '') {
                params.append(minParam, minInput.value);
              }
              if (maxParam && maxInput && maxInput.value !== '') {
                params.append(maxParam, maxInput.value);
              }
            });

            return params;
          }

          clearFiltersLocal() {
            const root = this.content || this;

            root.querySelectorAll('.collection-filter-mobile-v2__option[data-type="list"]').forEach((item) => {
              item.setAttribute('data-active', 'false');
            });

            root.querySelectorAll('.collection-filter-mobile-v2__price-input--min').forEach((input) => {
              input.value = '';
            });

            root.querySelectorAll('.collection-filter-mobile-v2__price-input--max').forEach((input) => {
              input.value = '';
            });
          }

          applyFilters() {
            this.syncContentToPcFilter();

            const mainCollection = this.closest('main-collection-v2');
            if (mainCollection && typeof mainCollection.applyFilters === 'function') {
              mainCollection.applyFilters(this.buildFilterSearchParams());
            }
            this.closeDrawer();
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-filter-pc-v2"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('collection-filter-pc-v2')) {
      customElements.define(
        'collection-filter-pc-v2',
        class CollectionFilterPcV2 extends HTMLElement {
          connectedCallback() {
            this._handleClick = this.handleClick.bind(this);
            this._handleKeydown = this.handleKeydown.bind(this);
            this._handleInput = this.handleInput.bind(this);
            this.debouncedSubmit = window.litime.debounce(() => {
              this.submitFilters();
            }, 500);

            this.addEventListener('click', this._handleClick);
            this.addEventListener('keydown', this._handleKeydown);
            this.addEventListener('input', this._handleInput);
          }

          disconnectedCallback() {
            this.removeEventListener('click', this._handleClick);
            this.removeEventListener('keydown', this._handleKeydown);
            this.removeEventListener('input', this._handleInput);
          }

          handleClick(event) {
            const header = event.target.closest('.collection-filter-pc-v2__content-item-header');
            if (header && this.contains(header)) {
              this.toggleSection(header);
              return;
            }

            const resetBtn = event.target.closest('.collection-filter-pc-v2__reset');
            if (resetBtn && this.contains(resetBtn)) {
              this.clearFilters();
              return;
            }

            const categoryItem = event.target.closest(
              '[data-type="category"] .collection-filter-pc-v2__content-item-content-item'
            );
            if (categoryItem && this.contains(categoryItem)) {
              const url = categoryItem.dataset.value;
              if (url && url !== 'javascript:;' && url !== 'javascript:void(0)') {
                window.location.href = url;
              }
              return;
            }

            const listItem = event.target.closest(
              '.collection-filter-pc-v2__content-item-content-item[data-type="list"]'
            );
            if (listItem && this.contains(listItem)) {
              this.toggleListItem(listItem);
            }
          }

          handleKeydown(event) {
            if (event.key !== 'Enter' && event.key !== ' ') return;

            const header = event.target.closest('.collection-filter-pc-v2__content-item-header');
            if (header && this.contains(header)) {
              event.preventDefault();
              this.toggleSection(header);
            }
          }

          handleInput(event) {
            if (event.target.matches('.collection-filter-pc-v2__content-item-content-item-input')) {
              this.debouncedSubmit();
            }
          }

          toggleSection(header) {
            const isActive = header.getAttribute('data-active') === 'true';
            const nextActive = isActive ? 'false' : 'true';
            header.setAttribute('data-active', nextActive);
            header.setAttribute('aria-expanded', nextActive);
          }

          toggleListItem(listItem) {
            const isActive = listItem.getAttribute('data-active') === 'true';
            listItem.setAttribute('data-active', isActive ? 'false' : 'true');
            this.submitFilters();
          }

          buildFilterSearchParams() {
            const params = new URLSearchParams();

            this.querySelectorAll(
              '.collection-filter-pc-v2__content-item-content-item[data-type="list"][data-active="true"]'
            ).forEach((item) => {
              const name = item.dataset.paramName;
              const value = item.dataset.paramValue;
              if (name && value !== undefined && value !== '') {
                params.append(name, value);
              }
            });

            this.querySelectorAll('[data-type="price_range"]').forEach((section) => {
              const minParam = section.dataset.paramMin;
              const maxParam = section.dataset.paramMax;
              const minInput = section.querySelector('.collection-filter-pc-v2__content-item-content-item-input--min');
              const maxInput = section.querySelector('.collection-filter-pc-v2__content-item-content-item-input--max');

              if (minParam && minInput && minInput.value !== '') {
                params.append(minParam, minInput.value);
              }
              if (maxParam && maxInput && maxInput.value !== '') {
                params.append(maxParam, maxInput.value);
              }
            });

            return params;
          }

          clearFilters() {
            this.querySelectorAll('.collection-filter-pc-v2__content-item-content-item[data-type="list"]').forEach(
              (item) => {
                item.setAttribute('data-active', 'false');
              }
            );

            this.querySelectorAll('.collection-filter-pc-v2__content-item-content-item-input--min').forEach((input) => {
              input.value = '';
            });

            this.querySelectorAll('.collection-filter-pc-v2__content-item-content-item-input--max').forEach((input) => {
              input.value = '';
            });

            this.submitFilters();
          }

          submitFilters() {
            const mainCollection = this.closest('main-collection-v2');
            if (mainCollection && typeof mainCollection.applyFilters === 'function') {
              mainCollection.applyFilters(this.buildFilterSearchParams());
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-filter-sort-v2"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('collection-filter-sort-v2')) {
      customElements.define(
        'collection-filter-sort-v2',
        class CollectionFilterSortV2 extends HTMLElement {
          connectedCallback() {
            this._handleClick = this.handleClick.bind(this);
            this._handleKeydown = this.handleKeydown.bind(this);
            this._handleDocumentClick = this.handleDocumentClick.bind(this);

            this.addEventListener('click', this._handleClick);
            this.addEventListener('keydown', this._handleKeydown);
            document.addEventListener('click', this._handleDocumentClick);
          }

          disconnectedCallback() {
            this.removeEventListener('click', this._handleClick);
            this.removeEventListener('keydown', this._handleKeydown);
            document.removeEventListener('click', this._handleDocumentClick);
          }

          handleClick(event) {
            const trigger = event.target.closest('.collection-filter-sort-v2__dropdown-trigger');
            if (trigger && this.contains(trigger)) {
              event.stopPropagation();
              this.toggleDropdown();
              return;
            }

            const pill = event.target.closest('.collection-filter-sort-v2__pill');
            if (pill && this.contains(pill)) {
              this.applySort(pill.dataset.sortValue);
              return;
            }

            const dropdownOption = event.target.closest('.collection-filter-sort-v2__dropdown-option');
            if (dropdownOption && this.contains(dropdownOption)) {
              this.applySort(dropdownOption.dataset.sortValue, dropdownOption.dataset.sortLabel);
              this.closeDropdown();
            }
          }

          handleKeydown(event) {
            if (event.key !== 'Enter' && event.key !== ' ') return;

            const trigger = event.target.closest('.collection-filter-sort-v2__dropdown-trigger');
            if (trigger && this.contains(trigger)) {
              event.preventDefault();
              this.toggleDropdown();
              return;
            }

            const pill = event.target.closest('.collection-filter-sort-v2__pill');
            if (pill && this.contains(pill)) {
              event.preventDefault();
              this.applySort(pill.dataset.sortValue);
              return;
            }

            const dropdownOption = event.target.closest('.collection-filter-sort-v2__dropdown-option');
            if (dropdownOption && this.contains(dropdownOption)) {
              event.preventDefault();
              this.applySort(dropdownOption.dataset.sortValue, dropdownOption.dataset.sortLabel);
              this.closeDropdown();
            }
          }

          handleDocumentClick(event) {
            const dropdown = this.querySelector('.collection-filter-sort-v2__dropdown');
            if (!dropdown || dropdown.getAttribute('data-visible') !== 'true') return;
            if (this.contains(event.target)) return;
            this.closeDropdown();
          }

          toggleDropdown() {
            const dropdown = this.querySelector('.collection-filter-sort-v2__dropdown');
            if (!dropdown) return;

            if (dropdown.getAttribute('data-visible') === 'true') {
              this.closeDropdown();
            } else {
              this.openDropdown();
            }
          }

          openDropdown() {
            const dropdown = this.querySelector('.collection-filter-sort-v2__dropdown');
            const trigger = this.querySelector('.collection-filter-sort-v2__dropdown-trigger');
            if (!dropdown || !trigger) return;

            dropdown.setAttribute('data-visible', 'true');
            trigger.setAttribute('aria-expanded', 'true');
          }

          closeDropdown() {
            const dropdown = this.querySelector('.collection-filter-sort-v2__dropdown');
            const trigger = this.querySelector('.collection-filter-sort-v2__dropdown-trigger');
            if (!dropdown || !trigger) return;

            dropdown.setAttribute('data-visible', 'false');
            trigger.setAttribute('aria-expanded', 'false');
          }

          setActiveSort(sortValue) {
            this.querySelectorAll('.collection-filter-sort-v2__pill').forEach((pill) => {
              pill.setAttribute('data-active', pill.dataset.sortValue === sortValue ? 'true' : 'false');
            });

            this.querySelectorAll('.collection-filter-sort-v2__dropdown-option').forEach((option) => {
              option.setAttribute('data-selected', option.dataset.sortValue === sortValue ? 'true' : 'false');
            });
          }

          applySort(sortValue, triggerLabel) {
            if (!sortValue) return;

            this.setActiveSort(sortValue);

            const triggerText = this.querySelector('[data-sort-trigger-text]');
            if (triggerText && triggerLabel) {
              triggerText.textContent = triggerLabel;
            }

            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set('sort_by', sortValue);
            urlParams.delete('page');

            const mainCollection = this.closest('main-collection-v2');
            if (mainCollection && typeof mainCollection.navigateToUrl === 'function') {
              const query = urlParams.toString();
              const url = query
                ? `${window.location.pathname}?${query}`
                : window.location.pathname;
              mainCollection.navigateToUrl(url);
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["compare-main-anchor"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('compare-main-anchor')) {
      customElements.define(
        'compare-main-anchor',
        class CompareMainAnchor extends HTMLElement {
          constructor() {
            super();
            this.isHandlingClick = false;
            this.anchorLinks = null;
            this.handleScroll = null;
            this.anchorClickHandlers = new Map();
            this.headerOffset = 195;
          }
          connectedCallback() {
            // 不需要在这里执行，而是外部执行
            // this.init();
          }
          init() {
            this.setAttribute('data-show', 'false');
            const compareMainDom = this.closest('compare-main');
            if (!compareMainDom || !compareMainDom.specNameList) {
              console.warn('compareMainDom or specNameList not found');
              return;
            }

            const specNameList = compareMainDom.specNameList;
            const anchorContainer = this.querySelector('.compare-main-anchor');

            if (!anchorContainer) {
              console.warn('anchor container not found');
              return;
            }

            // 生成锚点 HTML
            let html = '';

            // 第一个是 productMain
            if (specNameList.length > 0 && specNameList[0] === 'productMain') {
              html += `
                <div class="compare-main-anchor-item" data-active="true">
                  <div class="compare-main-anchor-item-round"></div>
                  <a class="compare-main-anchor-item-name" href="#productMain">${this.getAttribute(
                    'data-i18n-main'
                  )}</a>
                </div>
              `;
            }

            // 其他的从 specNameList 中获取
            for (let i = 1; i < specNameList.length; i++) {
              const name = specNameList[i];
              html += `
                <div class="compare-main-anchor-item">
                  <div class="compare-main-anchor-item-round"></div>
                  <a class="compare-main-anchor-item-name" href="#${name}">${name}</a>
                </div>
              `;
            }
            anchorContainer.innerHTML = html;

            // 初始化锚点功能
            this.initAnchorEvents();
            this.setAttribute('data-show', 'true');
          }

          initAnchorEvents() {
            // 清理旧事件
            this.cleanup();

            this.anchorLinks = this.querySelectorAll('.compare-main-anchor-item-name');
            this.anchorClickHandlers.clear();

            // 事件锁，控制点击和滚动
            this.isHandlingClick = false;
            this.scrollUnlockTimer = null;

            // 获取顶部 header 的高度（动态）
            const getHeaderOffset = () => {
              const header = document.querySelector('.header-sticky');
              return header ? header.offsetHeight : this.headerOffset || 0;
            };

            // 每次都实时计算元素绝对位置（不会出现 547 → 变化的问题）
            const getAbsoluteTop = (el) => {
              return el.getBoundingClientRect().top + window.pageYOffset;
            };

            // ⭐核心：更稳定的平滑滚动
            const scrollToTarget = (target) => {
              const headerOffset = getHeaderOffset();
              const targetTop = getAbsoluteTop(target) - headerOffset;

              // 事件锁打开
              this.isHandlingClick = true;

              // iOS Safari 防抖 + repaint 修复跳动
              requestAnimationFrame(() => {
                window.scrollTo({
                  top: targetTop,
                  behavior: 'smooth',
                });

                // 使用 scroll 事件检测滚动是否结束
                startScrollUnlockWatcher();
              });
            };

            // ⭐ 滚动结束自动解锁（比 setTimeout 更可靠）
            const startScrollUnlockWatcher = () => {
              if (this.scrollUnlockTimer) {
                clearTimeout(this.scrollUnlockTimer);
              }

              let lastPosition = window.pageYOffset;

              const checkEnd = () => {
                const current = window.pageYOffset;

                // 100ms 内没有变化 → 认为滚动结束
                if (Math.abs(current - lastPosition) < 1) {
                  this.isHandlingClick = false;
                  return;
                }

                lastPosition = current;
                this.scrollUnlockTimer = setTimeout(checkEnd, 100);
              };

              this.scrollUnlockTimer = setTimeout(checkEnd, 100);
            };

            // 点击锚点事件
            this.anchorLinks.forEach((anchor) => {
              const handler = (e) => {
                e.preventDefault();

                const targetId = anchor.getAttribute('href').substring(1);
                const target = document.getElementById(targetId);

                if (target) {
                  scrollToTarget(target);
                  this.activeAnchor(anchor.parentNode);
                }
              };

              this.anchorClickHandlers.set(anchor, handler);
              anchor.addEventListener('click', handler);
            });

            // --- 高亮逻辑保持原样，只加事件锁判断 ---
            this.handleScroll = () => {
              if (this.isHandlingClick) return; // 点击触发滚动时不执行高亮逻辑

              let closestAnchor = null;
              let closestDistance = Infinity;
              const headerOffset = getHeaderOffset();

              this.anchorLinks.forEach((anchor) => {
                const targetId = anchor.getAttribute('href').substring(1);
                const targetEl = document.getElementById(targetId);

                if (targetEl) {
                  const bounding = targetEl.getBoundingClientRect();
                  const distance = Math.abs(bounding.top - headerOffset);

                  if (distance < closestDistance) {
                    closestAnchor = anchor;
                    closestDistance = distance;
                  }
                }
              });

              if (closestAnchor) {
                this.activeAnchor(closestAnchor.parentNode);
              }
            };

            window.addEventListener('scroll', this.handleScroll);

            // 初次执行一次
            this.handleScroll();
          }

          activeAnchor(element) {
            const anchors = this.querySelectorAll('.compare-main-anchor-item');
            anchors.forEach((item) => {
              item.setAttribute('data-active', 'false');
            });
            element.setAttribute('data-active', 'true');
          }

          getAbsoluteTop(element) {
            return element.getBoundingClientRect().top + window.pageYOffset;
          }

          cleanup() {
            // 移除之前添加的点击事件监听器
            if (this.anchorLinks && this.anchorClickHandlers) {
              this.anchorLinks.forEach((anchor) => {
                const handler = this.anchorClickHandlers.get(anchor);
                if (handler) {
                  anchor.removeEventListener('click', handler);
                }
              });
              this.anchorClickHandlers.clear();
            }

            // 移除之前添加的滚动事件监听器
            if (this.handleScroll) {
              window.removeEventListener('scroll', this.handleScroll);
            }
          }

          disconnectedCallback() {
            // 组件被移除时清理事件监听器
            this.cleanup();
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["compare-main-sticky-top"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('compare-main-sticky-top')) {
      customElements.define(
        'compare-main-sticky-top',
        class CompareMainStickyTop extends HTMLElement {
          constructor() {
            super();
            this.isScrolling = false;
            this.mainScrollHandler = null;
            this.stickyScrollHandler = null;
          }
          connectedCallback() {
            this.compareMainDom = this.closest('compare-main');
            // 默认隐藏。当 compare-main__header 消失在距离顶部 200px 时显示

            // this.init();
          }
          initObserverHeader() {
            if (this.observerHeader) {
              this.observerHeader.disconnect();
            }
            // 查找 compare-main__header 元素
            this.headerDom =
              this.compareMainDom?.querySelector('.compare-main__header') ||
              document.querySelector('.compare-main__header');

            if (!this.headerDom) {
              console.warn('compare-main__header element not found');
              return;
            }

            this.observerHeader = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  // 当 header 消失在距离顶部 200px 的位置时显示 sticky top
                  // isIntersecting 为 false 表示元素不在视口内（或不在 rootMargin 定义的区域内）
                  if (entry.isIntersecting) {
                    this.setAttribute('data-show', 'false');
                  } else {
                    if (this.compareMainDom.getAttribute('data-loading') == 'true') {
                      return;
                    }
                    this.setAttribute('data-show', 'true');
                  }
                });
              },
              {
                // rootMargin: '-200px 0px 0px 0px' 表示当元素顶部距离视口顶部 200px 时触发
                // 负值表示缩小根边界，当元素顶部滚动到距离视口顶部 200px 以上时，isIntersecting 变为 false
                rootMargin: '200px 0px 0px 0px',
                threshold: 0,
              }
            );

            // 开始观察 header 元素
            this.observerHeader.observe(this.headerDom);
          }
          init(list) {
            if (!list || list.length === 0) {
              return;
            }
            this.list = list;
            this.renderList();
            this.initObserverHeader();
            // 增加滚动条监听
            this.initScrollbarListener();
          }
          initScrollbarListener() {
            const scrollContainerDom = this.compareMainDom?.querySelector('.compare-main__content-scrollbar');
            const stickyContentDom = this.querySelector('.compare-main-sticky-top__content');

            if (!scrollContainerDom || !stickyContentDom) {
              console.warn('Scroll containers not found');
              return;
            }

            // 清理旧监听器
            if (this.mainScrollHandler) {
              scrollContainerDom.removeEventListener('scroll', this.mainScrollHandler);
            }
            if (this.stickyScrollHandler) {
              stickyContentDom.removeEventListener('scroll', this.stickyScrollHandler);
            }

            let ticking = false; // 用于 requestAnimationFrame 锁
            let lastSource = null; // 'main' 或 'sticky'

            // GPU 加速（只在滚动时激活）
            const enableGPU = (el) => {
              el.style.willChange = 'transform';
              el.style.transform = 'translateZ(0)';
            };
            const disableGPU = (el) => {
              el.style.willChange = '';
              el.style.transform = '';
            };

            const syncScroll = () => {
              if (lastSource === 'main') {
                stickyContentDom.scrollLeft = scrollContainerDom.scrollLeft;
              } else if (lastSource === 'sticky') {
                scrollContainerDom.scrollLeft = stickyContentDom.scrollLeft;
              }

              // 滚动结束 100ms 后关闭 GPU
              clearTimeout(this._gpuTimer);
              this._gpuTimer = setTimeout(() => {
                disableGPU(scrollContainerDom);
                disableGPU(stickyContentDom);
              }, 100);

              ticking = false;
            };

            this.mainScrollHandler = () => {
              lastSource = 'main';
              enableGPU(scrollContainerDom);
              if (!ticking) {
                ticking = true;
                requestAnimationFrame(syncScroll);
              }
            };

            this.stickyScrollHandler = () => {
              lastSource = 'sticky';
              enableGPU(stickyContentDom);
              if (!ticking) {
                ticking = true;
                requestAnimationFrame(syncScroll);
              }
            };

            scrollContainerDom.addEventListener('scroll', this.mainScrollHandler, { passive: true });
            stickyContentDom.addEventListener('scroll', this.stickyScrollHandler, { passive: true });
          }

          renderList() {
            let startDom = '<div class="compare-main-sticky-top__content-product">';
            let endDom = '</div>';
            let html = '';
            this.list.forEach((item) => {
              html += `
                <div class="compare-main-sticky-top__content-product-item">
                ${this.initProductHeader(item)}
                ${this.initProductPrice(item)}
                ${this.initProductButton(item)}
                </div>
              `;
            });
            const contentDom = this.querySelector('.compare-main-sticky-top__content-product');
            let newEl = startDom + html + endDom;
            contentDom.outerHTML = newEl;
          }
          initProductHeader(item) {
            let startDom = '<div class="compare-main-sticky-top__content-product-item-header">';
            let endDom = '</div>';
            let productHeaderDom = `
              ${this.initProductHeaderImage(item)}
              ${this.initProductHeaderTitle(item)}
            `;
            return startDom + productHeaderDom + endDom;
          }
          initProductHeaderImage(item) {
            let startDom = `<img class="compare-main-sticky-top__content-product-item-image" src="${
              item.guideImageSrc || item.imageSrc
            }" alt="${item.title}">`;
            let endDom = '</img>';
            return startDom + endDom;
          }
          initProductHeaderTitle(item) {
            let startDom = `<a 
              href="/products/${item.handle}" 
              class="compare-main-sticky-top__content-product-item-title">${item.shortTitle || item.title}`;
            let endDom = '</a>';
            return startDom + endDom;
          }
          initProductPrice(item) {
            let startDom = '<div class="compare-main-sticky-top__content-product-item-price">';
            let defaultVariant = this.getDefaultVariant(item);
            let newPrice = this.getDiscountPrice(defaultVariant.price, defaultVariant.discount) * 100;
            let oldPrice = defaultVariant.compareAtPrice * 100;
            let productPriceDom = `
              ${this.initProductPriceNew(item, newPrice)}
              ${this.initProductPriceOld(item, newPrice, oldPrice)}
            `;
            let endDom = '</div>';
            return startDom + productPriceDom + endDom;
          }
          initProductPriceNew(item, price) {
            let startDom = `<div class="compare-main-sticky-top__content-product-item-price-new" data-product-id="${item.shopifyProductId}">`;
            let productPriceNewDom = `
              ${window.Shopify.formatMoney(price, window.shopMoneyFormat)}
            `;
            let endDom = '</div>';
            return startDom + productPriceNewDom + endDom;
          }
          initProductPriceOld(item, price, oldPrice) {
            let stauts = 'true';
            if (oldPrice < price) {
              stauts = 'false';
            }
            let startDom = `<div class="compare-main-sticky-top__content-product-item-price-old" data-show="${stauts}" data-product-id="${item.shopifyProductId}">`;
            let productPriceOldDom = `
              ${window.Shopify.formatMoney(oldPrice, window.shopMoneyFormat)}
            `;
            let endDom = '</div>';
            return startDom + productPriceOldDom + endDom;
          }

          initProductButton(item) {
            let defaultVariant = this.getDefaultVariant(item);
            let noStockout = defaultVariant.inventoryQuantity > 0 || defaultVariant.inventoryPolicy === 'continue';
            return `
            <div class="compare-main-sticky-top__content-product-item-buttons" data-stockout="${
              noStockout ? 'false' : 'true'
            }">
                <div class="compare-main-sticky-top__content-product-item-add" 
                    data-action="add" 
                    data-loading="false" 
                    data-variant-id="${defaultVariant.id}"
                    data-product-id="${item.shopifyProductId}"
                >
                  <div class="compare-main-sticky-top__content-product-item-add-text">${this.compareMainDom.getAttribute(
                    'data-i18n-add-to-cart'
                  )}</div>
                  <div class="compare-main-sticky-top__content-product-item-add-icon">
                    <i class="items-center justify-center rotate_icon">
                      <div
                        class="loader-animation"
                        style="border:2px solid #fff; border-left-color: transparent;"
                      ></div>
                    </i>
                  </div>
                </div>
                <div class="compare-main-sticky-top__content-product-item-stockout">
                  <div class="compare-main-sticky-top__content-product-item-stockout-text">${this.compareMainDom.getAttribute(
                    'data-i18n-stockout'
                  )}</div>
                  <klaviyo-bis-trigger class="w-full h-full left-0 top-0 absolute">
                    <div
                      class="klaviyo-bis-wrapper w-full h-full flex items-center justify-center text-[14px] transition-colors duration-300"
                      data-product="${item.shopifyProductId}"
                      data-variant="${defaultVariant.id}"
                      data-product-title="${item.shortTitle || item.title}"
                    >
                      <div class="add-to-cart-text w-full h-full flex items-center justify-center  text-[14px]   transition-colors duration-300">
                      </div>
                    </div>
                  </klaviyo-bis-trigger>
                </div>
              </div>
            `;
          }
          getDefaultVariant(item) {
            return this.compareMainDom.getDefaultVariant(item) || item.variants[0];
          }
          getDiscountPrice(price, discount) {
            if (!discount) return price;
            return this.compareMainDom.getDiscountPrice(price, discount) || price;
          }
          disconnectedCallback() {
            // 组件被移除时停止观察
            if (this.observerHeader) {
              this.observerHeader.disconnect();
            }

            // 清理滚动事件监听器
            const scrollContainerDom = this.compareMainDom?.querySelector('.compare-main__content-scrollbar');
            const stickyContentDom = this.querySelector('.compare-main-sticky-top__content');

            if (scrollContainerDom && this.mainScrollHandler) {
              scrollContainerDom.removeEventListener('scroll', this.mainScrollHandler);
            }

            if (stickyContentDom && this.stickyScrollHandler) {
              stickyContentDom.removeEventListener('scroll', this.stickyScrollHandler);
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["coupon-detail-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('coupon-detail-modal')) {
    class CouponDetailModal extends HTMLElement {
      constructor() {
        super();
        this.modalCard = this.querySelector('.modal-card');
        this.closeBtn = this.querySelector('.modal-close-btn');
        this.modalImg = this.querySelector('.modal-img');
        this.modalTitle = this.querySelector('.modal-title');
        this.modalCode = this.querySelector('.modal-code span');
        this.modalRules = this.querySelector('.modal-rules');
        this.copyBtn = this.querySelector('.modal-copy-btn');
        this.copyBtnWrapper = this.querySelector('.modal-copy-btn-wrapper');

        this.close = this.close.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', (event) => {
          if (event.target === this) {
            this.close();
          }
        });
        this.closeBtn.addEventListener('click', this.close);

        // Listen for the global event to open the modal
        document.addEventListener('show:coupon-detail', (event) => {
          this.open(event.detail.itemData);
        });
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.close);
        this.closeBtn.removeEventListener('click', this.close);
      }

      open(itemData) {
        console.log('打开弹窗', itemData);
        if (!itemData) return;

        this.modalImg.src = itemData.icon;
        this.modalImg.alt = itemData.rewardName;
        this.modalTitle.textContent = itemData.rewardName;
        this.modalCode.textContent = itemData.discountCode;
        this.modalRules.innerHTML = itemData.rule;

        // 根据 status 控制弹窗中的复制按钮是否显示
        // 只有 status 为 0（可用状态）时才显示复制按钮
        if (this.copyBtnWrapper) {
          if (itemData.status === 0 && itemData.discountCode) {
            this.copyBtnWrapper.style.display = 'flex';
            this.copyBtn.onclick = () => {
              const code = itemData.discountCode;
              if (!code) return;

              if (window.litime && window.litime.copyToClipboard) {
                window.litime.copyToClipboard(code);
                const redirecturl = `/discount/${code}`;
                window.location.href = redirecturl;
              } else if (navigator.clipboard) {
                navigator.clipboard.writeText(code).catch((err) => console.error('Copy failed', err));
              }
            };
          } else {
            this.copyBtnWrapper.style.display = 'none';
            this.copyBtn.onclick = null;
          }
        }

        this.classList.add('is-open');
        window.litime.disableScroll();
      }

      close() {
        this.classList.remove('is-open');
        window.litime.enableScroll();
      }
    }
    customElements.define('coupon-detail-modal', CouponDetailModal);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dialog-simple"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (customElements.get('dialog-simple')) return;

    const createDialogRoot = () => {
      const existingRoot = document.getElementById('dialog-simple__root');
      if (existingRoot) return existingRoot;

      const root = document.createElement('div');
      root.id = 'dialog-simple__root';
      document.body.appendChild(root);
      return root;
    };

    customElements.define(
      'dialog-simple',
      class DialogSimple extends HTMLElement {
        static getRoot() {
          if (!this._root) {
            this._root = createDialogRoot();
          }
          return this._root;
        }

        static get observedAttributes() {
          return ['data-show', 'data-title', 'data-desc', 'data-button-text', 'data-button-link', 'data-img'];
        }

        connectedCallback() {
          if (this._initialized) return;
          this._initialized = true;

          this.placeholder = document.createElement('span');
          this.placeholder.className = 'dialog-simple__placeholder';
          this.parentElement?.insertBefore(this.placeholder, this);

          this.querySelector('.dialog-close')?.addEventListener('click', () => {
            this.setAttribute('data-show', 'false');
          });

          this._initializeContent();

          if (this.getAttribute('data-show') === 'true') {
            this.openDialog();
          }
        }

        disconnectedCallback() {
          if (this.getAttribute('data-show') === 'true') {
            window.litime?.enableScroll?.();
          }
          this.placeholder?.remove();
          this._initialized = false;
        }

        mountToBody() {
          if (this.parentElement === DialogSimple.getRoot()) return;
          DialogSimple.getRoot().appendChild(this);
        }

        unmountToPlaceholder() {
          if (!this.placeholder?.isConnected || this.parentElement === this.placeholder.parentElement) return;
          this.placeholder.parentElement.insertBefore(this, this.placeholder.nextSibling);
        }

        openDialog() {
          this.mountToBody();
          $(this).show();
          window.litime?.disableScroll?.();
        }

        attributeChangedCallback(name, oldValue, newValue) {
          if (oldValue === newValue) return;

          switch (name) {
            case 'data-show':
              if (newValue === 'true') {
                this.openDialog();
              } else {
                $(this).hide();
                window.litime?.enableScroll?.();
                this.unmountToPlaceholder();
              }
              break;
            case 'data-title':
              $(this)
                .find('.dialog-title')
                .html(newValue || '');
              break;
            case 'data-desc':
              $(this)
                .find('.dialog-desc')
                .html(newValue || '');
              break;
            case 'data-button-text':
              $(this).find('.dialog-button a').text(newValue);
              break;
            case 'data-button-link': {
              const buttonContainer = $(this).find('.dialog-button');
              const buttonEl = buttonContainer.find('a');
              if (newValue) {
                buttonEl.attr('href', newValue);
                buttonContainer.show();
              } else {
                buttonContainer.hide();
              }
              break;
            }
            case 'data-img': {
              const imgContainer = $(this).find('.dialog-img');
              if (newValue) {
                imgContainer.attr('src', newValue);
                imgContainer.show();
              } else {
                imgContainer.hide();
              }
              break;
            }
          }
        }

        _initializeContent() {
          const title = this.getAttribute('data-title');
          const desc = this.getAttribute('data-desc');
          const buttonText = this.getAttribute('data-button-text');
          const buttonLink = this.getAttribute('data-button-link');
          const img = this.getAttribute('data-img');

          $(this)
            .find('.dialog-title')
            .text(title || '');
          if (desc) $(this).find('.dialog-desc').html(desc);
          if (buttonText) $(this).find('.dialog-button a').text(buttonText);
          if (buttonLink) {
            const buttonContainer = $(this).find('.dialog-button');
            const buttonEl = buttonContainer.find('a');
            buttonEl.attr('href', buttonLink);
            buttonContainer.show();
          } else {
            $(this).find('.dialog-button').hide();
          }
          if (img) {
            const imgEl = $(this).find('.dialog-img');
            imgEl.attr('src', img);
            imgEl.show();
          } else {
            $(this).find('.dialog-img').hide();
          }
        }
      }
    );
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dialog-subscribe"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('dialog-subscribe')) {
      customElements.define(
        'dialog-subscribe',
        class DialogSimple extends HTMLElement {
          constructor() {
            super();
            this.dialog = null;
            this.productId = null;
            this.variantId = null;
            this.email = null;
            this.companyId = 'WViBvu';
            this.listId = 'XVbpHP';
            this.backInStockUrl = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/';
            this.listUrl = 'https://a.klaviyo.com/client/subscriptions/';
            // 绑定事件函数，确保 removeEventListener 生效
            this.handleWrapperClick = this.handleWrapperClick.bind(this);

            this.init();
            this.setupMutationObserver();
            this.submitSubscribe();
          }

          connectedCallback() {
            this.dialog = document.querySelector('.dialog-subscribe');
            this.closeDialog();
          }

          closeDialog() {
            const dialog = this;
            const close = $(dialog).find('.dialog-close');
            close.on('click', () => {
              $(dialog).addClass('hidden');
              window.litime.enableScroll();
            });
          }

          klaviyoBisWrapperClick() {
            const wrappers = document.querySelectorAll('.klaviyo-bis-wrapper,.global-notify-me-trigger');
            wrappers.forEach((wrapper) => {
              wrapper.addEventListener('click', this.handleWrapperClick);
            });
          }

          handleWrapperClick(event) {
            const wrapper = event.currentTarget;
            window.litime.disableScroll();

            const checkbox = this.querySelector('#subscribeCheckbox');
            if (checkbox) checkbox.checked = true;

            this.productId = wrapper.getAttribute('data-product');
            this.variantId = wrapper.getAttribute('data-variant');
            this.productTitle = wrapper.getAttribute('data-product-title');

            document.querySelector('.dialog-subscribe').classList.remove('hidden');
          }

          agreeCheckboxFunction(id) {
            const checked = this.querySelector(id);
            if (checked && checked.checked) {
              return true;
            } else {
              return false;
            }
          }
          submitSubscribe() {
            const subscribeBtn = this.querySelector('.subscribe-btn');
            subscribeBtn.addEventListener('click', () => {
              const checkboxShow = this.agreeCheckboxFunction('#subscribeCheckbox');
              const $inputDom = this.querySelector('.input_text');
              const $inputTextContainer = $inputDom.closest('.input_text_container');

              const inputText = $inputDom.value;

              const rule = $inputTextContainer.dataset.rule;
              if (rule) {
                if (rule === 'email' && ltUtils.rule.email.test(inputText)) {
                  this.email = ltUtils.rule.email.test(inputText);
                  if (inputText) {
                    this.email = inputText;
                  }
                  if (this.productId && this.variantId && this.email && this.productTitle) {
                    const rotateIcon = subscribeBtn.querySelector('.rotate_icon');
                    const loadingText = subscribeBtn.querySelector('.loading-button-text');

                    if (rotateIcon) {
                      rotateIcon.classList.add('flex');
                      rotateIcon.classList.remove('hidden');
                    }
                    if (loadingText) {
                      loadingText.classList.add('hidden');
                      loadingText.classList.remove('flex');
                    }
                    this.fetchSubscribe(
                      this.productId,
                      this.variantId,
                      this.email,
                      this.productTitle,
                      checkboxShow,
                      rotateIcon,
                      loadingText
                    );
                  }
                } else {
                  $inputTextContainer.setAttribute('data-error', 'true');
                }
              }
            });
          }
          async fetchSubscribe(productId, variantId, email, productTitle, checkboxShow, rotateIcon, loadingText) {
            const modifiedTimestamp = this.modifyTimestamp(new Date().getTime());
            const headers_subscribe = {
              'Content-Type': 'application/json',
              nonce: this.getAttribute('data-nonce'),
              ticket: this.getAttribute('data-ticket'),
              timestamp: modifiedTimestamp,
              shop: window.Shopify.shop,
            };
            // 将productTitle中的逗号转义成空格
            const newProductTitle = productTitle.replace(/,/g, ' ');
            const body = {
              email: email,
              tag: '到货订阅,' + newProductTitle + '',
              acceptsMarketing: checkboxShow ? 1 : 0,
            };
            let baseUrl = '';
            if (base_info.url == 'dev-askstarry.myshopify.com') {
              baseUrl = 'https://dev-api.askstarry.com';
            } else {
              baseUrl = 'https://api.askstarry.com';
            }
            try {
              const response = await fetch(baseUrl + '/business-api/shopify/subscribe/email', {
                method: 'POST',
                headers: headers_subscribe,
                body: JSON.stringify(body),
              });

              if (response.status != 200) {
                if (rotateIcon) {
                  rotateIcon.classList.add('hidden');
                  rotateIcon.classList.remove('flex');
                }
                if (loadingText) {
                  loadingText.classList.add('flex');
                  loadingText.classList.remove('hidden');
                }
                window.litime.showToast('error', 'Failed to subscribe', 2000);
                window.litime.enableScroll();
                $(this).addClass('hidden');
                return;
              }

              const data = await response.json();

              const successText =
                this.getAttribute('data-success-text') || 'Back In Stock Reminder Subscribe Successfully';
              window.litime.showToast('success', successText, 2000);
              $(this).addClass('hidden');
              if (rotateIcon) {
                rotateIcon.classList.add('hidden');
                rotateIcon.classList.remove('flex');
              }
              if (loadingText) {
                loadingText.classList.add('flex');
                loadingText.classList.remove('hidden');
              }
              window.litime.enableScroll();
            } catch (error) {
              console.error('请求失败:', error);
              if (rotateIcon) {
                rotateIcon.classList.add('hidden');
                rotateIcon.classList.remove('flex');
              }
              if (loadingText) {
                loadingText.classList.add('flex');
                loadingText.classList.remove('hidden');
              }
              window.litime.showToast('error', 'Failed to subscribe', 2000);
            }
            const customVariantId = '$shopify:::$default:::' + variantId;

            const backInStockData = {
              data: {
                type: 'back-in-stock-subscription',
                attributes: {
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: { email },
                    },
                  },
                  channels: ['EMAIL'],
                },
                relationships: {
                  variant: {
                    data: {
                      type: 'catalog-variant',
                      id: customVariantId,
                    },
                  },
                },
              },
            };

            const listSubscriptionData = {
              data: {
                type: 'subscription',
                attributes: {
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email,
                        properties: {
                          $source: 'Back in Stock',
                        },
                      },
                    },
                  },
                },
                relationships: {
                  list: {
                    data: {
                      type: 'list',
                      id: this.listId,
                    },
                  },
                },
              },
            };

            const headers = {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              REVISION: '2024-02-15',
            };

            // 前两个请求静默处理
            Promise.allSettled([
              fetch(`${this.backInStockUrl}?company_id=${this.companyId}`, {
                method: 'POST',
                headers,
                body: JSON.stringify(backInStockData),
              }),
              fetch(`${this.listUrl}?company_id=${this.companyId}`, {
                method: 'POST',
                headers,
                body: JSON.stringify(listSubscriptionData),
              }),
            ]).catch(() => {
              console.log('第三方接口请求失败');
            });
          }

          // 移除事件监听器
          removeEventListeners() {
            const elements = document.querySelectorAll('.klaviyo-bis-wrapper');
            elements.forEach((element) => {
              element.removeEventListener('click', this.handleWrapperClick);
            });
          }
          modifyTimestamp(timestamp, mod = 10) {
            const str = timestamp.toString();
            const first12 = str.slice(0, 12);
            const sum = [...first12].reduce((acc, digit) => acc + Number(digit), 0);
            const replacement = sum % mod;
            return Number(first12 + replacement);
          }

          // 初始化
          init() {
            this.removeEventListeners();
            this.klaviyoBisWrapperClick();
          }
          // 获取当前日期
          getCurrentDate() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始
            const day = String(now.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
          }
          // 设置观察者
          setupMutationObserver() {
            const observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                if (mutation.type === 'childList') {
                  this.init();
                }
              });
            });

            observer.observe(document.body, {
              childList: true,
              subtree: true,
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["exhibition-activity-filter-dialog"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('exhibition-activity-filter-dialog')) {
      customElements.define(
        'exhibition-activity-filter-dialog',
        class ExhibitionActivityFilterDialog extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this._root = this.querySelector('.exhibition-activity-filter-dialog');
            this._onClick = this._onClick.bind(this);
            this.addEventListener('click', this._onClick);
            this.init();
          }
          disconnectedCallback() {
            this.removeEventListener('click', this._onClick);
          }
          init() {
            this.subscribeEvent();
          }
          _getRoot() {
            return this._root || this.querySelector('.exhibition-activity-filter-dialog');
          }
          subscribeEvent() {
            window.litime.eventBus.subscribe('exhibition-activity:open-filter-dialog', (data) => {
              this.setAttribute('data-show', 'true');
              window.litime.disableScroll();
              const filterData = data && data.filterData ? data.filterData : {};
              this.initFilterData(filterData);
            });
          }
          initFilterData(filterData) {
            const root = this._getRoot();
            if (!root) return;
            const fd = filterData || {};
            const types = ['scene', 'type', 'year', 'month', 'country'];
            types.forEach((type) => {
              const selectedIds = Array.isArray(fd[type]) ? fd[type].map(String) : [];
              root
                .querySelectorAll('.exhibition-activity-filter-item__item[data-type="' + type + '"]')
                .forEach((el) => {
                  const id = el.getAttribute('data-id');
                  const active = id != null && selectedIds.indexOf(String(id)) !== -1;
                  el.setAttribute('data-active', active ? 'true' : 'false');
                });
            });
            this._updateItemCounts();
            this._updateHeaderCount(this._buildStateFromDOM());
          }
          _buildStateFromDOM() {
            const root = this._getRoot();
            const state = { scene: [], type: [], year: [], month: [], country: [] };
            if (!root) return state;
            root.querySelectorAll('.exhibition-activity-filter-item__item[data-active="true"]').forEach((item) => {
              const t = item.getAttribute('data-type');
              const id = item.getAttribute('data-id');
              if (t && state[t] && id != null) state[t].push(id);
            });
            return state;
          }
          _updateHeaderCount(state) {
            const root = this._getRoot();
            if (!root) return;
            const total =
              ((state.scene && state.scene.length) || 0) +
              ((state.type && state.type.length) || 0) +
              ((state.year && state.year.length) || 0) +
              ((state.month && state.month.length) || 0) +
              ((state.country && state.country.length) || 0);
            const countEl = root.querySelector('.exhibition-activity-filter-dialog__header-left-count');
            if (countEl) countEl.textContent = total;
          }
          _countActivitiesByOption(filterType, optionId) {
            const activities = window.ACTIVITIES;
            if (!Array.isArray(activities) || !optionId) return 0;
            const id = String(optionId);
            return activities.filter((activity) => {
              if (filterType === 'scene') {
                const scene = activity.scene;
                return scene && Array.isArray(scene) && scene.some((s) => s && String(s.unique_id) === id);
              }
              const ref = activity[filterType];
              return ref && String(ref.unique_id) === id;
            }).length;
          }
          _updateItemCounts() {
            const root = this._getRoot();
            if (!root) return;
            root.querySelectorAll('.exhibition-activity-filter-item__item').forEach((itemEl) => {
              const type = itemEl.getAttribute('data-type');
              const optionId = itemEl.getAttribute('data-id');
              const countEl = itemEl.querySelector('.exhibition-activity-filter-item__item-count-number');
              if (!countEl || !type) return;
              countEl.textContent = this._countActivitiesByOption(type, optionId);
            });
          }
          _publishFilterChange(state) {
            if (window.litime && window.litime.eventBus && window.litime.eventBus.publish) {
              window.litime.eventBus.publish('exhibition-activity:change-filter', {
                ...state,
                page: 1,
                needFullRefresh: true,
              });
            }
          }
          _onClick(e) {
            const root = this._getRoot();
            if (!root || !this.contains(e.target)) return;

            if (e.target.closest('.exhibition-activity-filter-dialog__header-close')) {
              e.preventDefault();
              this.setAttribute('data-show', 'false');
              window.litime.enableScroll();
              return;
            }

            if (e.target.closest('.exhibition-activity-filter-dialog__footer-reset')) {
              e.preventDefault();
              root
                .querySelectorAll('.exhibition-activity-filter-item__item[data-active="true"]')
                .forEach((el) => el.setAttribute('data-active', 'false'));
              const state = { scene: [], type: [], year: [], month: [], country: [], page: 1 };
              this._updateHeaderCount(state);
              this._publishFilterChange(state);
              this.setAttribute('data-show', 'false');
              window.litime.enableScroll();
              return;
            }
            if (e.target.closest('.exhibition-activity-filter-dialog__footer-apply')) {
              e.preventDefault();
              const state = this._buildStateFromDOM();
              state.page = 1;
              this._publishFilterChange(state);
              this.setAttribute('data-show', 'false');
              window.litime.enableScroll();
              return;
            }

            const header = e.target.closest('.exhibition-activity-filter-item__header');
            if (header) {
              e.preventDefault();
              const wrap = header.closest('.exhibition-activity-filter-item');
              if (wrap) {
                const expanded = wrap.getAttribute('data-expanded') !== 'true';
                wrap.setAttribute('data-expanded', expanded ? 'true' : 'false');
              }
              return;
            }

            const item = e.target.closest('.exhibition-activity-filter-item__item');
            if (item) {
              e.preventDefault();
              const type = item.getAttribute('data-type');
              const id = item.getAttribute('data-id');
              if (!type || id == null) return;
              const isActive = item.getAttribute('data-active') === 'true';
              item.setAttribute('data-active', isActive ? 'false' : 'true');
              this._updateHeaderCount(this._buildStateFromDOM());
              return;
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["exhibition-activity-filter"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('exhibition-activity-filter')) {
      customElements.define(
        'exhibition-activity-filter',
        class ExhibitionActivityFilter extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this._root = this.querySelector('.exhibition-activity-filter');
            this._onClick = this._onClick.bind(this);
            this.addEventListener('click', this._onClick);
            this._updateItemCounts();
            this.subscribeEvent();
            var self = this;
            setTimeout(function () {
              if (window.litime && window.litime.eventBus && window.litime.eventBus.publish) {
                window.litime.eventBus.publish('exhibition-activity:request-initial-filter');
              }
            }, 0);
          }
          disconnectedCallback() {
            this.removeEventListener('click', this._onClick);
            if (this._unsubscribe && typeof this._unsubscribe === 'function') {
              this._unsubscribe();
            }
          }
          subscribeEvent() {
            var self = this;
            var handler = function (data) {
              if (data && data.filterData) self.renderFilter(data.filterData);
            };
            if (window.litime && window.litime.eventBus && window.litime.eventBus.subscribe) {
              this._unsubscribe = window.litime.eventBus.subscribe('exhibition-activity:render-filter', handler);
            }
          }
          renderFilter(filterData) {
            var root = this._getRoot();
            if (!root) return;
            var fd = filterData || {};
            var arrayKeys = ['scene', 'type', 'year', 'month', 'country'];
            root.querySelectorAll('.exhibition-activity-filter-item__item').forEach(function (el) {
              var type = el.getAttribute('data-type');
              var id = el.getAttribute('data-id');
              if (!type || id == null) return;
              var selectedIds = (Array.isArray(fd[type]) ? fd[type] : []).map(function (s) {
                return String(s);
              });
              var isSelected = selectedIds.indexOf(String(id)) !== -1;
              el.setAttribute('data-active', isSelected ? 'true' : 'false');
            });
            var state = {
              scene: fd.scene || [],
              type: fd.type || [],
              year: fd.year || [],
              month: fd.month || [],
              country: fd.country || [],
            };
            this._updateHeaderCount(state);
          }
          _countActivitiesByOption(filterType, optionId) {
            var activities = window.ACTIVITIES;
            if (!Array.isArray(activities) || !optionId) return 0;
            var id = String(optionId);
            return activities.filter(function (activity) {
              if (filterType === 'scene') {
                var scene = activity.scene;
                return (
                  scene &&
                  Array.isArray(scene) &&
                  scene.some(function (s) {
                    return s && String(s.unique_id) === id;
                  })
                );
              }
              var ref = activity[filterType];
              return ref && String(ref.unique_id) === id;
            }).length;
          }
          _updateItemCounts() {
            var root = this._getRoot();
            if (!root) return;
            var activities = window.ACTIVITIES;
            if (!Array.isArray(activities)) return;
            root.querySelectorAll('.exhibition-activity-filter-item__item').forEach(
              function (itemEl) {
                var type = itemEl.getAttribute('data-type');
                var optionId = itemEl.getAttribute('data-id');
                var countEl = itemEl.querySelector('.exhibition-activity-filter-item__item-count-number');
                if (!countEl || !type) return;
                var count = this._countActivitiesByOption(type, optionId);
                countEl.textContent = count;
              }.bind(this)
            );
          }
          _getRoot() {
            return this._root || this.querySelector('.exhibition-activity-filter');
          }
          _buildStateFromDOM() {
            var root = this._getRoot();
            var state = { scene: [], type: [], year: [], month: [], country: [] };
            if (!root) return state;
            root
              .querySelectorAll('.exhibition-activity-filter-item__item[data-active="true"]')
              .forEach(function (item) {
                var t = item.getAttribute('data-type');
                var id = item.getAttribute('data-id');
                if (t && state[t] && id != null) state[t].push(id);
              });
            return state;
          }
          _updateHeaderCount(state) {
            var root = this._getRoot();
            if (!root) return;
            var total = (state.scene && state.scene.length) || 0;
            total += (state.type && state.type.length) || 0;
            total += (state.year && state.year.length) || 0;
            total += (state.month && state.month.length) || 0;
            total += (state.country && state.country.length) || 0;
            var countEl = root.querySelector('.exhibition-activity-filter__header-count');
            if (countEl) countEl.textContent = total;
          }
          _publishFilterChange(state, needFullRefresh) {
            if (window.litime && window.litime.eventBus && window.litime.eventBus.publish) {
              window.litime.eventBus.publish('exhibition-activity:change-filter', {
                ...state,
                needFullRefresh: needFullRefresh !== false,
              });
            }
          }
          _onClick(e) {
            var root = this._getRoot();
            if (!root || !root.contains(e.target)) return;

            var header = e.target.closest('.exhibition-activity-filter-item__header');
            if (header) {
              e.preventDefault();
              var wrap = header.closest('.exhibition-activity-filter-item');
              if (wrap) {
                var expanded = wrap.getAttribute('data-expanded') !== 'true';
                wrap.setAttribute('data-expanded', expanded ? 'true' : 'false');
              }
              return;
            }

            if (e.target.closest('.exhibition-activity-filter__header-reset')) {
              e.preventDefault();
              root
                .querySelectorAll('.exhibition-activity-filter-item__item[data-active="true"]')
                .forEach(function (el) {
                  el.setAttribute('data-active', 'false');
                });
              var state = { scene: [], type: [], year: [], month: [], country: [], page: 1 };
              this._updateHeaderCount(state);
              this._publishFilterChange(state, true);
              return;
            }

            var item = e.target.closest('.exhibition-activity-filter-item__item');
            if (item) {
              e.preventDefault();
              var type = item.getAttribute('data-type');
              var id = item.getAttribute('data-id');
              if (!type || id == null) return;
              var isActive = item.getAttribute('data-active') === 'true';
              item.setAttribute('data-active', isActive ? 'false' : 'true');
              var state = this._buildStateFromDOM();
              state.page = 1;
              this._updateHeaderCount(state);
              this._publishFilterChange(state, true);
              return;
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facebook-google-login"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('facebook-google-login')) {
      customElements.define(
        'facebook-google-login',
        class FacebookGoogleLogin extends HTMLElement {
          constructor() {
            super();
          }

          connectedCallback() {
            const _this = this;
            // window.fbAsyncInit = function () {
            //   if (window.FB) {
            //     FB.init({
            //       appId: '1065970665293276',
            //       cookie: true,
            //       xfbml: true,
            //       version: 'v22.0',
            //     });
            //     FB.AppEvents.logPageView();
            //     console.log('FB.init', FB);
            //   }
            // };
            // if (window.FB) {
            //   console.log('window.FB window.FB');
            //   window.fbAsyncInit();
            // }
            window.checkLoginState = function () {
              FB.getLoginStatus(async function (response) {
                if (response.status === 'connected') {
                  await _this.handleFBLogin(response);
                } else {
                  // window.litime.showToast('error', window.i18n.cancel_login);
                }
              });
            };

            // 在 facebook-google-login.js 中添加
            window.handleFacebookLogin = function () {
              FB.login(
                function (response) {
                  if (response.authResponse) {
                    // 登录成功，获取用户信息
                    FB.api('/me', { fields: 'name,email,picture' }, function (userInfo) {
                      console.log('Facebook 用户信息:', userInfo);
                      // 调用你的登录处理函数
                      window.checkLoginState();
                    });
                  } else {
                    console.log('用户取消登录或未授权');
                    window.litime.showToast('error', window.i18n.cancel_login);
                  }
                },
                { scope: 'public_profile,email' }
              );
            };

            // 修改 Facebook 初始化代码
            window.fbAsyncInit = function () {
              FB.init({
                appId: '1065970665293276',
                cookie: true,
                xfbml: true,
                version: 'v22.0',
              });

              // 检查登录状态
              FB.getLoginStatus(function (response) {
                if (response.status === 'connected') {
                  console.log('已登录 Facebook');
                }
              });
            };
            // 检查 SDK 是否已加载
            function checkFBLoaded() {
              if (window.FB) {
                console.log('window.FB window.FB');
                window.fbAsyncInit();
              } else {
                setTimeout(checkFBLoaded, 100);
              }
            }

            checkFBLoaded();

            // // 确保 SDK 加载完成
            // (function (d, s, id) {
            //   var js,
            //     fjs = d.getElementsByTagName(s)[0];
            //   if (d.getElementById(id)) return;
            //   js = d.createElement(s);
            //   js.id = id;
            //   js.src = 'https://connect.facebook.net/en_US/sdk.js';
            //   fjs.parentNode.insertBefore(js, fjs);
            // })(document, 'script', 'facebook-jssdk');

            window.handleGoogleLogin = function (resp) {
              if (window.customer) return;
              _this.handleGoogleLogin(resp);
            };
          }

          disconnectedCallback() {}

          // 第三方登录
          async handleFBLogin(resp) {
            const url = '/oauth/login';
            const urlParams = new URLSearchParams(window.location.search);
            let redirectUrl = urlParams.get('return_url') || urlParams.get('checkout_url') || '/';
            if (redirectUrl === '/') {
              if (window.location.href.includes('/login') || window.location.href.includes('/register')) {
                redirectUrl = window.location.origin;
              } else {
                redirectUrl = window.location.href;
              }
            } else {
              redirectUrl = window.location.origin + redirectUrl;
            }
            const res = await window.litime.http.post(url, {
              data: {
                type: 4,
                credential: resp.authResponse.accessToken,
                returnTo: redirectUrl,
              },
            });
            if (res.code === 200) {
              window.litime.eventBus.publish('CLOSE_DRAWER');
              window.litime.showToast('success', window.i18n.login_success);
              window.litime.setLocalStorage('ltUserInfo', JSON.stringify(res.data));
              window.litime.setLocalStorage('ltToken', res.data.token);

              window.location.href = res.data.mutilpass;
            } else if (res.code === 10051106) {
              window.litime.eventBus.publish('CHANGE_PASSWORD', {
                sign: res.data.sign,
              });
              window.litime.showToast('error', window.i18n.error_message_10051106);
            } else if (res.code === 10051102) {
              window.litime.showToast('error', window.i18n.error_message_10051102);
            } else if (res.code === 10051105) {
              window.litime.showToast('error', window.i18n.error_message_10051105);
            } else if (res.code === 10051109) {
              window.litime.showToast('error', window.i18n.error_message_10051109);
            } else {
              window.litime.showToast('error', window.i18n.request_failed);
            }
          }
          async handleGoogleLogin(resp) {
            const url = '/oauth/login';
            const urlParams = new URLSearchParams(window.location.search);
            let redirectUrl = urlParams.get('return_url') || urlParams.get('checkout_url') || '/';
            if (redirectUrl === '/') {
              if (window.location.href.includes('/login') || window.location.href.includes('/register')) {
                redirectUrl = window.location.origin;
              } else {
                redirectUrl = window.location.href;
              }
            } else {
              redirectUrl = window.location.origin + redirectUrl;
            }
            const res = await window.litime.http.post(url, {
              data: {
                type: 2,
                credential: resp.credential,
                returnTo: redirectUrl,
              },
            });
            if (res.code === 200) {
              window.litime.eventBus.publish('CLOSE_DRAWER');
              window.litime.showToast('success', window.i18n.login_success);
              window.litime.setLocalStorage('ltUserInfo', JSON.stringify(res.data));
              window.litime.setLocalStorage('ltToken', res.data.token);

              window.location.href = res.data.mutilpass;
            } else if (res.code === 10051106) {
              window.litime.eventBus.publish('CHANGE_PASSWORD', {
                sign: res.data.sign,
              });
              window.litime.showToast('error', window.i18n.error_message_10051106);
            } else if (res.code === 10051102) {
              window.litime.showToast('error', window.i18n.error_message_10051102);
            } else if (res.code === 10051105) {
              window.litime.showToast('error', window.i18n.error_message_10051105);
            } else if (res.code === 10051109) {
              window.litime.showToast('error', window.i18n.error_message_10051109);
            } else {
              window.litime.showToast('error', window.i18n.request_failed);
            }
          }
        }
      );
    }
  });
  window.addEventListener('load', function () {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    document.head.appendChild(script);
    script.onload = function () {
      const isLoggedIn = Boolean(window.customer); // 假设 Shopify 登录后 window.customer 有值

      google.accounts.id.initialize({
        client_id: '653357230133-birnhs247u0h6tsrjcvicvua8rrj6d7d.apps.googleusercontent.com',
        callback: handleGoogleLogin,
        ux_mode: 'popup',
        auto_select: false,
        cancel_on_tap_outside: false, // 添加这行
        context: 'signin', // 添加这行
      });

      // 初始化按钮（不论是否已登录都显示按钮）
      const googleButtonPlaceholders = document.querySelectorAll('.google-button-placeholder');
      googleButtonPlaceholders.forEach((placeholder) => {
        google.accounts.id.renderButton(placeholder, {
          theme: 'outline',
          size: 'medium',
          type: 'standard',
        });
      });

      // 控制是否显示 One Tap
      if (!isLoggedIn) {
        setTimeout(() => {
          const isLoginOut = window.litime.getLocalStorage('lt-login_out') || 0;
          const nowTime = new Date().getTime();
          if (nowTime - isLoginOut > 1000 * 60 * 30) {
            google.accounts.id.prompt(); // 显示 One Tap 弹窗
          }
        }, 1000);
      } else {
        // 显式禁止 One Tap 弹窗再次出现
        if (google) {
          google.accounts.id.disableAutoSelect();
          google.accounts.id.cancel();
        }
      }
    };
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["global-add-cart"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('global-add-cart')) {
      customElements.define(
        'global-add-cart',
        class GlobalAddCart extends HTMLElement {
          constructor() {
            super();
            this.trigger = this.querySelector('.global-add-cart__trigger');
            this.spinner = this.querySelector('.global-spinner');
            this.isOpenDrawer = this.trigger?.dataset.isOpenDrawer !== 'false';
            this.bundleKey = this.trigger?.dataset.bundleKey;
          }

          connectedCallback() {
            this.init();
          }

          init() {
            // 初始化时隐藏 spinner
            if (this.spinner) {
              this.spinner.style.display = 'none';
            }

            // 绑定点击事件
            this.trigger?.addEventListener('click', (e) => {
              const button = e.target.closest('.global-add-cart__button');
              // 如果没找到按钮或按钮被禁用，则不处理
              if (!button || button.hasAttribute('disabled')) return;

              e.preventDefault();
              this.handleAddToCart(button);
            });
          }

          // 显示/隐藏加载状态
          toggleLoading(button, show) {
            if (!button) return;

            if (show) {
              // 保存按钮原始内容和样式
              button.dataset.originalContent = button.innerHTML;
              button.dataset.originalPosition = button.style.position;

              // 添加relative样式
              button.style.position = 'relative';

              // 清空按钮内容并插入spinner
              button.innerHTML = '';
              const spinnerClone = this.spinner.cloneNode(true);
              spinnerClone.style.display = 'block';
              button.appendChild(spinnerClone);
            } else {
              // 恢复按钮原始内容和样式
              button.innerHTML = button.dataset.originalContent;
              button.style.position = button.dataset.originalPosition || '';

              // 清理dataset
              delete button.dataset.originalContent;
              delete button.dataset.originalPosition;
            }

            // 设置禁用状态
            button.disabled = show;
          }

          // 处理加入购物车
          async handleAddToCart(button) {
            try {
              // 验证必要参数
              const variantId = button.dataset.variantId;
              const quantity = parseInt(button.dataset.quantity);

              if (!variantId || isNaN(quantity)) {
                throw new Error('Missing required parameters: variantId or quantity');
              }

              this.toggleLoading(button, true);

              // 构建购物车项
              let items = [
                {
                  id: parseInt(variantId),
                  quantity: quantity,
                },
              ];

              // 如果有捆绑产品配置，添加捆绑产品
              if (this.bundleKey && window.litime && window.litime[this.bundleKey]) {
                const bundleProducts = window[this.bundleKey];
                const bundleItems = bundleProducts.map((product) => ({
                  id: parseInt(product.variantId),
                  quantity: parseInt(product.quantity || 1),
                }));
                items = [...items, ...bundleItems];
              }

              // 发送加入购物车请求
              const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  items,
                  sections: `${getMiniCartSectionId()},cart-icon-bubble`,
                }),
              });
              if (window.gtag) {
                gtag('event', 'conversion', { send_to: 'AW-11059876179/OfmnCMjGxIsYENOi4Zkp' });
              }
              if (response.ok) {
                const cartContent = await response.json();
                await updateCartComponents(cartContent);

                // 打开购物车抽屉
                if (this.isOpenDrawer) {
                  const cartDrawer = document.querySelector('cart-drawer');
                  if (cartDrawer) {
                    cartDrawer.open();
                  } else {
                    const miniCart = document.querySelector('global-mini-cart-v2');
                    if (miniCart) {
                      typeof miniCart.renderContents === 'function' && miniCart.renderContents(cartContent);
                    }
                  }
                }
              } else {
                const errorData = await response.json();
                throw new Error(errorData.description || 'Failed to add items to cart');
              }
            } catch (error) {
              if (window.litime && window.litime.showToast) {
                window.litime.showToast('error', error.message);
              }
              // 这里可以添加错误提示
            } finally {
              this.toggleLoading(button, false);
            }
          }

          disconnectedCallback() {
            // 清理事件监听
            this.trigger?.removeEventListener('click', this.handleAddToCart);
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["global-back-button-v2"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('global-back-button-v2')) {
      customElements.define(
        'global-back-button-v2',
        class GlobalBackButtonV2 extends HTMLElement {
          constructor() {
            super();
            this.handlePageshow = this.handlePageshow.bind(this);
          }

          connectedCallback() {
            this.button = this.querySelector('.global-back-button-v2__button');
            this.updateVisibility();
            this.bindEvents();
            window.addEventListener('pageshow', this.handlePageshow);
          }

          disconnectedCallback() {
            window.removeEventListener('pageshow', this.handlePageshow);
          }

          canGoBack() {
            if (window.navigation && typeof window.navigation.canGoBack === 'boolean') {
              return window.navigation.canGoBack;
            }
            return window.history.length > 1;
          }

          updateVisibility() {
            this.setAttribute('data-show', this.canGoBack() ? 'true' : 'false');
          }

          bindEvents() {
            if (!this.button || this.button.dataset.backBound === 'true') return;
            this.button.dataset.backBound = 'true';
            this.button.addEventListener('click', (e) => {
              e.preventDefault();
              if (!this.canGoBack()) return;
              window.history.back();
            });
          }

          handlePageshow(event) {
            if (event.persisted) {
              this.updateVisibility();
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["global-discount"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('global-discount')) {
      customElements.define(
        'global-discount',
        class globalDiscount extends HTMLElement {
          constructor() {
            super();
            this.shopMoneyFormat = window.shopMoneyFormat;
          }
          static get observedAttributes() {
            return ['data-total', 'data-price', 'data-type'];
          }

          attributeChangedCallback(name, oldValue, newValue) {
            if (oldValue === newValue) return;
            switch (name) {
              case 'data-total':
                this.total = JSON.parse(newValue);
                this.price = parseFloat(this.total.price);
                this.comparePrice = parseFloat(this.total.compare_price);
                this.updatePrice();
                break;
            }
          }
          connectedCallback() {
            this.type = this.getAttribute('data-type');
          }
          updatePrice() {
            const computeShowEl = document.querySelector('.compute-show');
            const quotaDiscountEl = this.querySelector('.quota-discount');
            const scaleDiscountEl = this.querySelector('.scale-discount');
            const actualDiscountContainer = document.querySelector('.actual_discount-total-container');

            if (this.price > 0 && this.comparePrice > 0) {
              if (this.type === 'quota') {
                this.discount = this.comparePrice - this.price;
                this.discountFormat = window.Shopify.formatMoney(this.discount, this.shopMoneyFormat);

                if (parseInt(this.discount) > 0) {
                  if (computeShowEl) {
                    computeShowEl.classList.remove('hidden');
                  }
                  if (actualDiscountContainer) {
                    actualDiscountContainer.classList.remove('hidden');
                  }

                  const computeQuotaEl = document.querySelector('.compute-show .quota-discount');
                  if (computeQuotaEl) {
                    computeQuotaEl.innerHTML = this.discountFormat;
                  }
                  if (quotaDiscountEl) {
                    quotaDiscountEl.innerHTML = this.discountFormat;
                  }
                } else {
                  if (computeShowEl) {
                    computeShowEl.classList.add('hidden');
                  }
                  if (actualDiscountContainer) {
                    actualDiscountContainer.classList.add('hidden');
                  }
                }
              } else if (this.type === 'percentage') {
                this.discount = ((this.comparePrice - this.price) / this.comparePrice) * 100;
                this.discount = Math.floor(this.discount);

                if (parseInt(this.discount) > 0) {
                  if (computeShowEl) {
                    computeShowEl.classList.remove('hidden');
                  }
                  if (actualDiscountContainer) {
                    actualDiscountContainer.classList.remove('hidden');
                  }

                  const computeScaleEl = document.querySelector('.compute-show .scale-discount');
                  if (computeScaleEl) {
                    computeScaleEl.innerHTML = this.discount;
                  }
                  if (scaleDiscountEl) {
                    scaleDiscountEl.innerHTML = this.discount;
                  }
                } else {
                  if (computeShowEl) {
                    computeShowEl.classList.add('hidden');
                  }
                  if (actualDiscountContainer) {
                    actualDiscountContainer.classList.add('hidden');
                  }
                }
              }
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["global-image-lazy"] && !Shopify.designMode) return;
  try {
    if (!window.__starryLazyInit) {
    window.__starryLazyInit = true;

    document.addEventListener('DOMContentLoaded', () => {
      const images = document.querySelectorAll('img[data-starry-lazy-src]');

      const loadImage = (img) => {
        const src = img.dataset.starryLazySrc;
        if (!src) return;

        // 图片加载完成后再加 class
        img.addEventListener(
          'load',
          () => {
            img.classList.add('starry-lazy-entered', 'starry-lazy-loaded');
            img.setAttribute('data-ll-status', 'loaded');
          },
          { once: true }
        );

        img.src = src;
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              loadImage(entry.target);
              obs.unobserve(entry.target);
            }
          });
        });

        images.forEach((img) => observer.observe(img));
      } else {
        images.forEach(loadImage);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["global-modal"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('global-modal')) {
      // 创建弹窗根容器
      const createModalRoot = () => {
        const existingRoot = document.getElementById('global-modal__root');
        if (existingRoot) return existingRoot;

        const root = document.createElement('div');
        root.id = 'global-modal__root';
        root.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 500;
      `;
        document.body.appendChild(root);
        return root;
      };

      customElements.define(
        'global-modal',
        class GlobalModal extends HTMLElement {
          // 基础索引
          static baseZIndex = 501;
          // 实例集合
          static instances = new Set();
          // 弹窗根容器
          static root = null;

          // 获取或创建根容器
          static getRoot() {
            if (!this.root) {
              this.root = createModalRoot();
            }
            return this.root;
          }

          constructor() {
            super();
            this.modalId = this.dataset.modalId;
            this.lazyLoad = this.dataset.lazyLoad == 'true';
            this.closeOnClickMask = this.dataset.closeOnClickMask == 'true';

            this.containerEle = this.querySelector('.global-modal__container');
            this.wrapperEle = this.querySelector('.global-modal__wrapper');
            this.closeBtnEle = this.querySelector('.global-modal__close_btn');
            this.isRendered = false;

            this.isOpen = false;
            this.level = 0;
            this.isMoving = false;
            GlobalModal.instances.add(this);
          }

          connectedCallback() {
            if (this.parentElement?.id === 'global-modal__root') return;
            this.templateContent = document.getElementById(`modal-template-${this.modalId}`);

            this.isMoving = true;
            // 创建占位符
            this.placeholder = document.createElement('div');
            this.placeholder.dataset.modalPlaceholder = this.modalId;

            // 保存原始位置并移动到根容器
            this.parentElement.insertBefore(this.placeholder, this);
            GlobalModal.getRoot().appendChild(this);

            this.isMoving = false;

            this.init();
          }

          init() {
            if (this.wrapperEle && this.closeOnClickMask) {
              this.wrapperEle.addEventListener('click', this.handleWrapperClick.bind(this));
            }
            if (this.closeBtnEle) {
              this.closeBtnEle.addEventListener('click', this.handleCloseBtnClick.bind(this));
            }
          }

          handleWrapperClick(event) {
            if (event.target == this.wrapperEle) {
              const currentLevel = this.level;
              Array.from(GlobalModal.instances)
                .filter((modal) => modal.level >= currentLevel && modal.isOpen)
                .forEach((modal) => modal.close());
            }
          }

          handleCloseBtnClick() {
            console.log('handleCloseBtnClick', this.modalId);
            // 移除临时缓存
            window.sessionStorage.removeItem('custom_stack_event');
            this.close();
          }

          // 打开弹窗
          open() {
            if (!this.containerEle || this.isOpen) return;

            // 在弹窗打开前按需渲染内容
            if (!this.isRendered && this.lazyLoad && this.templateContent) {
              const contentContainer = this.wrapperEle || this.containerEle;
              // 将模板内容添加到弹窗中
              if (contentContainer && this.templateContent.content) {
                // 使用深度克隆以确保所有子元素和属性都被复制
                const clone = document.importNode(this.templateContent.content, true);
                contentContainer.appendChild(clone);

                // 重新获取可能通过模板添加的关闭按钮
                if (!this.closeBtnEle) {
                  this.closeBtnEle = this.querySelector('.global-modal__close_btn');
                  if (this.closeBtnEle) {
                    this.closeBtnEle.addEventListener('click', this.handleCloseBtnClick.bind(this));
                  }
                }
                this.isRendered = true;
              }
            }

            // 获取当前打开的所有弹窗
            const openModals = Array.from(GlobalModal.instances).filter((modal) => modal.isOpen);
            this.level = openModals.length;

            this.containerEle.style.zIndex = GlobalModal.baseZIndex + this.level * 2 + 1;
            this.dataset.isOpen = 'true';
            window.litime.disableScroll();

            requestAnimationFrame(() => {
              this.containerEle.style.visibility = 'visible';
              this.containerEle.style.opacity = 1;

              // 重排line-clamp元素，兼容ipad端省略不生效
              const lineClamps = this.containerEle.querySelectorAll('[class*="line-clamp-"]');
              lineClamps.forEach((el) => {
                el.style.display = 'none';
                el.offsetHeight;
                el.style.display = '';
              });

              this.isOpen = true;
              this.dispatchEvent(
                new CustomEvent('modal-opened', {
                  detail: {
                    modalId: this.modalId,
                    level: this.level,
                    wrapperEle: this.wrapperEle,
                  },
                })
              );
            });
          }

          // 关闭弹窗
          close() {
            if (!this.containerEle || !this.isOpen) return;

            Array.from(GlobalModal.instances)
              .filter((modal) => modal.level > this.level && modal.isOpen)
              .forEach((modal) => modal.close());
            delete this.dataset.isOpen;

            // 检查是否还有其他打开弹窗
            const hasOpenModals = Array.from(GlobalModal.instances).some((modal) => modal !== this && modal.isOpen);
            if (!hasOpenModals) {
              window.litime.enableScroll();
            }

            this.containerEle.style.visibility = 'hidden';
            this.containerEle.style.opacity = 0;

            this.isOpen = false;

            // 触发关闭事件
            this.dispatchEvent(
              new CustomEvent('modal-closed', {
                detail: {
                  modalId: this.modalId,
                  level: this.level,
                  wrapperEle: this.wrapperEle,
                },
              })
            );
          }

          disconnectedCallback() {
            if (this.isMoving) return;
            if (this.wrapperEle) {
              this.wrapperEle.removeEventListener('click', this.handleWrapperClick.bind(this));
            }
            if (this.closeBtnEle) {
              this.closeBtnEle.removeEventListener('click', this.handleCloseBtnClick.bind(this));
            }
            this.placeholder?.remove();
            GlobalModal.instances.delete(this);
          }
        }
      );
    }
  });

  $(function () {
    if (window.ModalController) return;

    // 弹窗控制器
    class ModalController {
      #modals = new Map();
      constructor() {
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') {
            const openModals = Array.from(document.querySelectorAll('global-modal[data-is-open]'))
              .filter((modal) => modal.isOpen)
              .sort((a, b) => b.level - a.level);
            openModals[0]?.close();
          }
        });
      }

      register(modalId, { onOpen, onClose } = {}) {
        const modal = document.querySelector(`global-modal[data-modal-id="${modalId}"]`);
        if (!modal) return;

        if (onOpen) modal.addEventListener('modal-opened', (event) => onOpen(event.detail.wrapperEle));
        if (onClose) modal.addEventListener('modal-closed', (event) => onClose(event.detail.wrapperEle));

        this.#modals.set(modalId, modal);
        return modal;
      }

      getModal(modalId) {
        return this.#modals.get(modalId);
      }

      open(modalId) {
        this.#modals.get(modalId)?.open();
      }

      // 关闭指定弹窗
      close(modalId) {
        this.#modals.get(modalId)?.close();
      }
    }
    window.ModalController = ModalController;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["global-product-2-v2"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('global-product-2-v2')) {
      customElements.define(
        'global-product-2-v2',
        class GlobalProduct2V2 extends HTMLElement {
          connectedCallback() {
            // this.initCta();
            // this.syncCompareState();
          }

          initCta() {
            const cta = this.querySelector('.global-product-2-v2__cta[data-variant-id]');
            if (!cta || cta.dataset.bound === 'true') return;

            cta.dataset.bound = 'true';
            cta.addEventListener('click', (event) => {
              event.preventDefault();
              event.stopPropagation();

              const variantId = cta.dataset.variantId;
              const quantity = cta.dataset.quantity || 1;
              if (!variantId || cta.dataset.loading === 'true') return;

              cta.dataset.loading = 'true';
              window.location.href = `/cart/${variantId}:${quantity}`;
            });
          }

          syncCompareState() {
            const compareBtn = this.querySelector('.global-product-2-v2__compare');
            if (!compareBtn) return;

            const ltCompareData = window.litime.getLocalStorage('ltCompareData') || [];
            const isActive = ltCompareData.some((item) => String(item.id) === String(compareBtn.dataset.compareId));
            compareBtn.setAttribute('data-compare-active', isActive ? 'true' : 'false');
            compareBtn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["global-product"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('global-product')) {
      // 创建弹窗根容器
      const createModalRoot = () => {
        const existingRoot = document.getElementById('global-modal__root');
        if (existingRoot) return existingRoot;

        const root = document.createElement('div');
        root.id = 'global-modal__root';
        root.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 500;
      `;
        document.body.appendChild(root);
        return root;
      };
      customElements.define(
        'global-product',
        class GlobalProduct extends HTMLElement {
          shopMoneyFormat = null;
          // 弹窗根容器
          static root = null;
          // 存储当前组件的弹窗元素
          productDetailModal = null;
          mobileClickStatus = false;
          // 获取或创建根容器
          static getRoot() {
            if (!this.root) {
              this.root = createModalRoot();
            }
            return this.root;
          }
          constructor() {
            super();
          }
          connectedCallback() {
            const _this = this;
            window.addEventListener('pagehide', (event) => {
              this.checkoutLoading = false;
              $(this.querySelector('.buy-now-btn-card-button-popup'))
                .find('.rotate_icon')
                .removeClass('flex')
                .addClass('hidden');
              if (event.persisted) {
              } else {
              }
            });
            this.init();
            this.openQuickViewButton();
            this.initBuyNowButton();
            // 获取function_icon_wrapper
            const $functionIconWrapper = $(this).find('.function_icon_wrapper');
            const function_text_wrapper = $(this).find('.function_text_wrapper');
            const function_icon = $(this).find('.function_icon');

            const clearClickStatus = () => {
              this.mobileClickStatus = false;
              function_text_wrapper.css('opacity', 0).css('top', '0');
              $functionIconWrapper.each(function () {
                $(this).attr('data-click-status', 'false');
              });
              function_icon.removeClass('hover_icon');
            };
            $functionIconWrapper.on('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              // 判断屏幕宽度小于1200px
              if ($(window).width() <= 1200) {
                _this.mobileClickStatus = true;
                if ($(this).attr('data-click-status') === 'false') {
                  function_text_wrapper.css('opacity', 0).css('top', '0');
                  function_icon.removeClass('hover_icon');
                  $functionIconWrapper.each(function () {
                    $(this).attr('data-click-status', 'false');
                  });
                  $(this).attr('data-click-status', 'true');
                  $(this).find('.function_icon').addClass('hover_icon');
                  $(this)
                    .find('.function_text_wrapper')
                    .addClass('block')
                    .removeClass('hidden')
                    .css('opacity', 1)
                    .css('top', '-12px');
                } else {
                  clearClickStatus();
                }
              }
            });
            document.addEventListener('click', (e) => {
              if (this.mobileClickStatus) {
                clearClickStatus();
              }
            });
          }

          init() {
            const _this = this;
            const hoverWidth = $(this).find('.hover-width');
            hoverWidth.on('mouseenter', function () {
              if ($(this).find('.hover_text').is(':visible')) {
                $(this).css('width', 'auto');
                const autoWidth = $(this).width();
                $(this).css('width', '32px');
                setTimeout(() => {
                  $(this).css('width', `${autoWidth}px`);
                }, 50);
              }
            });
            hoverWidth.on('mouseout', function () {
              if ($(this).find('.hover_text').is(':visible')) {
                setTimeout(() => {
                  if (!$(this).is(':hover')) {
                    $(this).css('width', '32px');
                  }
                }, 50);
              }
            });
            this.shopMoneyFormat = window.shopMoneyFormat;

            // 获取弹窗并移动到root
            const $productDetailModal = $(this).find('.product-detail-data-modal');
            if ($productDetailModal.length) {
              // 将弹窗移动到root节点
              const root = this.constructor.getRoot();
              $productDetailModal.appendTo(root);

              // 确保弹窗可以接收点击事件
              $productDetailModal.css('pointer-events', 'auto');

              // 保存移动后的弹窗引用
              this.productDetailModal = $productDetailModal;
              // 重新初始化product-detail-data-popup组件
              if (window.customElements) {
                window.customElements.upgrade(this.productDetailModal[0]);
              }
            }

            // 获取所有data-product-handle的元素
            const $productHandles = $(this).find('[data-product-handle]');

            $productHandles.on('click', function (event) {
              event.preventDefault();
            });

            const addCartButton = $(this).find('[data-first_variant_id]').find('[type="submit"]');

            addCartButton.on('click', function (event) {
              // 阻止默认事件
              event.preventDefault();
              // 获取index
              const index = $(_this).find('[data-first_variant_id]').find('[type="submit"]').index(this);
              const dataFirstVariantId = $(_this).find('[data-first_variant_id]').eq(index).data('first_variant_id');
              const skuCount = $(_this).find('[data-first_variant_id]').eq(index).data('sku-count');
              const inventoryPolicy = $(_this).find('[data-first_variant_id]').eq(index).data('inventory-policy');
              const view = $(_this).find('[data-first_variant_id]').eq(index).data('view');
              if (skuCount > 1) {
                window.litime.disableScroll();
                const $swiperSlide = $(_this).closest('.swiper-slide');
                const $globalProduct = $(this).closest('.global-product');
                const modalTrigger =
                  $swiperSlide.find('.open-product-detail-modal')[0] ||
                  $globalProduct.find('.open-product-detail-modal')[0] ||
                  $globalProduct.find('dynamic-add-to-cart')[0];
                if (modalTrigger) {
                  _this.openProductDetailModal(modalTrigger, inventoryPolicy, view);
                }
              } else {
                if (view === 'add_to_cart') {
                  $(this).find('i').removeClass('hidden').addClass('flex');
                  _this.addToCart(this, dataFirstVariantId, 1);
                }
              }
            });
          }
          openQuickViewButton() {
            const index = $(this).find('[data-first_variant_id]').find('[type="submit"]').index(this);
            const $globalProduct = $(this).closest('.global-product');
            const inventoryPolicy = $(this).find('[data-first_variant_id]').eq(index).data('inventory-policy');
            const view = $(this).find('[data-first_variant_id]').eq(index).data('view');
            if (this.querySelector('.open-product-detail-modal')) {
              this.querySelector('.open-product-detail-modal').addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                const modalTrigger =
                  $globalProduct.find('.open-product-detail-modal')[0] || $globalProduct.find('dynamic-add-to-cart')[0];
                if (modalTrigger) {
                  this.openProductDetailModal(modalTrigger, inventoryPolicy, view);
                }
              });
            }
          }
          openProductDetailModal(element, inventoryPolicy, view) {
            const _this = this;
            // 兼容传入的是 jQuery 集合/NodeList 的情况，只取第一个元素
            if (element && element.length) {
              element = element[0];
            }
            const $element = $(element);
            const $card = $element.closest('.global-product');
            const productHandle =
              $element.data('product-handle') || $card.find('[data-product-handle]').first().data('product-handle');
            let productVariantId = $element.data('product-variant-id') || $element.data('variant-id');
            if (!productVariantId && $card.length) {
              productVariantId =
                $card.find('[data-product-variant-id]').first().data('product-variant-id') ||
                $card.find('dynamic-add-to-cart').data('variant-id');
            }
            let skuCount = parseInt($element.data('sku-count'), 10) || parseInt($element.data('variant-size'), 10) || 0;
            const $productJsonElement = $card.find('[id^="ProductJson-"]');
            let productData = null;
            try {
              if ($productJsonElement.length > 0) {
                productData = JSON.parse($productJsonElement.html());
                if (!skuCount && productData?.variants?.length) {
                  skuCount = productData.variants.length;
                }
              }
            } catch (error) {
              console.error('Error parsing product json:', error);
            }

            // 从 ProductJson 获取变体位置
            let productPosition = 1;
            try {
              if (productData?.variants && productVariantId) {
                const variant = productData.variants.find((variant) => variant.id == productVariantId);
                if (variant?.featured_image?.position) {
                  productPosition = variant.featured_image.position;
                }
              }
            } catch (error) {
              console.error('Error getting product position:', error);
            }

            // 多变体商品打开弹窗时必须带 variant，才能保持正确的变体图片顺序
            let url = '';
            if (productVariantId && skuCount > 1) {
              url = `/products/${productHandle}?variant=${productVariantId}&view=modal`;
            } else {
              url = `/products/${productHandle}?view=modal`;
            }

            const variantIdForV2 = productVariantId && skuCount > 1 ? productVariantId : undefined;
            if (
              window.litime.tryOpenProductModalV2?.(productHandle, variantIdForV2, {
                onBefore: () => window.litime.showLoading(false),
                onFinally: () => window.litime.hideLoading(false),
              })
            ) {
              return;
            }

            // 禁用浏览器滚动
            window.litime.disableScroll();
            window.litime.showLoading(false);
            fetch(url)
              .then((response) => {
                if (response.status === 200) {
                  return response.text();
                } else {
                  throw new Error('Network response was not ok');
                }
              })
              .then((responseText) => {
                const html = responseText;
                _this.renderProductDetailModal(html, inventoryPolicy, view, productPosition, element);
              })
              .finally(() => {
                window.litime.hideLoading(false);
              });
          }

          renderProductDetailModal(html, inventoryPolicy, view, productPosition, element) {
            const _this = this;
            const quickshopPopup = new DOMParser()
              .parseFromString(html, 'text/html')
              .getElementById('quickshop-popup')?.innerHTML;
            const $productDetailModal = $('#global-product-card-popup');

            $productDetailModal.html(quickshopPopup);
            // 同步 home-product-list 的折扣透传与展示刷新
            try {
              const preferType = element && element.getAttribute('data-global-preferential-type');
              const popupEl = $productDetailModal.find('product-detail-data-popup')[0];
              if (popupEl && preferType) {
                popupEl.setAttribute('data-global-preferential-type', preferType);
              }

              if (popupEl && popupEl.applyPreferentialMode) {
                popupEl.applyPreferentialMode();
              }
            } catch (e) {
              console.warn('set preferential data failed:', e);
            }
            // let app = document.querySelector('.product-detail-modal_wrapper');
            let modalWrapper = $productDetailModal.find('.product-detail-modal_wrapper');
            // 判断预售逻辑 start
            if (inventoryPolicy === 'continue' && view === 'buy_now_to_cart') {
              let $preOrderButton = modalWrapper
                .find('.product-detail-popup_button')
                .find('.buy-now-btn-card-button-popup');

              $preOrderButton.removeClass('hidden').addClass('flex');
              const $preOrderSubmitButton = modalWrapper
                .find('.product-detail-popup_form_wrapper')
                .find('.buy-now-btn-card-submit-button');
              $preOrderSubmitButton.addClass('hidden').removeClass('flex');
            } else {
              let $preOrderButton = modalWrapper
                .find('.product-detail-popup_form_wrapper')
                .find('.buy-now-btn-card-button-popup');
              $preOrderButton.addClass('hidden').removeClass('flex');
              const $preOrderSubmitButton = modalWrapper
                .find('.product-detail-popup_form_wrapper')
                .find('.buy-now-btn-card-submit-button');
              $preOrderSubmitButton.removeClass('hidden').addClass('flex');
            }

            // 轮播图切换逻辑
            setTimeout(() => {
              const productDetailPopup = document.querySelector('product-detail-data-popup');
              if (
                productDetailPopup &&
                productDetailPopup.productDetailModalBigPictrueSwiper &&
                productDetailPopup.productDetailModalSmallPictrueSwiper
              ) {
                productDetailPopup.productDetailModalBigPictrueSwiper.slideToLoop(productPosition - 1);
                productDetailPopup.productDetailModalSmallPictrueSwiper.slideToLoop(productPosition - 1);
              }
            }, 100);
          }
          initBuyNowButton() {
            const inputNumber = $(this.querySelector('.global-number_input'));
            const quantity = inputNumber.val();
            const buyNowBtn = this.querySelector('.buy-now-btn-card-button-popup');
            const dataFirstVariantId = $(this).find('[data-first_variant_id]').data('first_variant_id');

            if (buyNowBtn) {
              buyNowBtn.addEventListener('click', async (e) => {
                e.preventDefault();
                this.checkoutLoading = true;
                if (this.checkoutLoading) {
                  $(buyNowBtn).find('.rotate_icon').removeClass('hidden').addClass('flex');
                }

                window.location.href = `/cart/${dataFirstVariantId}:${quantity}`;
              });
            }
          }
          addToCart(event, productId, quantity) {
            const _this = this;

            $(event).find('.rotate_icon').removeClass('hidden').addClass('flex');
            $(event).find('.loading-button-text').addClass('hidden').removeClass('flex');
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                items: [
                  {
                    id: productId,
                    quantity,
                  },
                ],
                sections: `${getMiniCartSectionId()},cart-icon-bubble`,
              }),
            })
              .then((response) => response.json())
              .then((data) => {
                $(event).find('.rotate_icon').addClass('hidden').removeClass('flex');
                $(event).find('.loading-button-text').addClass('flex').removeClass('hidden');
                if (window.gtag) {
                  gtag('event', 'conversion', { send_to: 'AW-11059876179/OfmnCMjGxIsYENOi4Zkp' });
                }
                if (data.status && data.status != 200) {
                  window.litime.showToast('error', data.message);
                } else {
                  if (window.location.pathname === '/cart') {
                    window.location.reload();
                    window.scrollTo(0, 0);
                  } else {
                    // 使用 updateCartComponents 更新购物车
                    updateCartComponents(data);
                    // 打开购物车抽屉
                    const cartDrawer = document.querySelector('cart-drawer');
                    if (cartDrawer) {
                      cartDrawer.open();
                    } else {
                      const miniCart = document.querySelector('global-mini-cart-v2');
                      if (miniCart) {
                        typeof miniCart.renderContents === 'function' && miniCart.renderContents(data);
                      }
                    }
                  }
                }
              })
              .catch((error) => {
                $(event).find('.rotate_icon').addClass('hidden').removeClass('flex');
                $(event).find('.loading-button-text').addClass('flex').removeClass('hidden');
              });
          }

          destroy() {
            // 恢复浏览器滚动
            window.litime.enableScroll();

            if (this.productDetailModalSmallPictrueSwiper) {
              this.productDetailModalSmallPictrueSwiper.destroy();
            }
            if (this.productDetailModalBigPictrueSwiper) {
              this.productDetailModalBigPictrueSwiper.destroy();
            }

            // 移除时同时清理弹窗
            if (this.productDetailModal) {
              this.productDetailModal.remove();
              this.productDetailModal = null;
            }
          }

          disconnectedCallback() {
            this.destroy();
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["global-toast"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('global-toast')) {
      customElements.define(
        'global-toast',
        class GlobalToast extends HTMLElement {
          constructor() {
            super();
            this.container = this.querySelector('div');
            this.template = this.querySelector('.global-toast__template');
            this.toasts = new Map();
            this.counter = 0;

            if (!window.litime) window.litime = {};
            window.litime.showToast = this.showToast.bind(this);
          }

          connectedCallback() {
            this.init();
          }

          init() {}

          showToast(type, message, duration = 2000) {
            const id = `toast-${this.counter++}`;

            // 创建新的toast元素
            const newToast = this.createToast(id, type, message);
            this.container.appendChild(newToast);

            // 存储toast引用
            this.toasts.set(id, {
              element: newToast,
              timer: null,
            });

            // 显示动画 - 使用CSS transition
            newToast.style.opacity = '0';
            newToast.style.transform = 'translateY(-15px)';

            // 强制重绘
            newToast.offsetHeight;

            // 应用显示样式
            newToast.style.opacity = '1';
            newToast.style.transform = 'translateY(0)';
            newToast.style.transition = 'opacity 0.25s ease, transform 0.25s ease';

            // 动画完成后设置自动关闭定时器
            setTimeout(() => {
              const timer = setTimeout(() => {
                this.removeToast(id);
              }, duration);

              // 更新计时器引用
              if (this.toasts.has(id)) {
                this.toasts.get(id).timer = timer;
              }
            }, 250); // 等待动画完成

            return id; // 返回ID，可用于手动关闭
          }

          removeToast(id) {
            const toast = this.toasts.get(id);
            if (!toast) return;

            // 清除定时器
            if (toast.timer) {
              clearTimeout(toast.timer);
            }

            // 隐藏动画 - 使用CSS transition
            toast.element.style.transition = 'opacity 0.25s ease, transform 0.25s ease';
            toast.element.style.opacity = '0';
            toast.element.style.transform = 'translateY(-15px)';

            // 动画完成后移除元素
            setTimeout(() => {
              if (toast.element.parentNode) {
                toast.element.parentNode.removeChild(toast.element);
              }
              // 从Map中移除
              this.toasts.delete(id);
            }, 250); // 等待动画完成
          }

          createToast(id, type, message) {
            // 克隆模板
            const clone = this.template.content.cloneNode(true).firstElementChild;

            // 设置ID和数据属性
            clone.id = id;
            clone.dataset.type = type;

            // 设置消息内容
            clone.querySelector('.global-toast__message').innerHTML = message;

            // 设置图标和背景颜色
            const icons = clone.querySelectorAll('.global-toast__icon i');
            icons.forEach((icon) => icon.classList.add('hidden'));

            let backgroundColor;
            switch (type) {
              case 'success':
                icons[0].classList.remove('hidden'); // success图标
                backgroundColor = 'var(--bg-success-color)';
                break;
              case 'warning':
                icons[1].classList.remove('hidden'); // warning图标
                backgroundColor = 'var(--bg-warning-color)';
                break;
              case 'error':
                icons[2].classList.remove('hidden'); // error图标
                backgroundColor = 'var(--bg-error-color)';
                break;
            }

            clone.style.backgroundColor = backgroundColor;

            return clone;
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["global-video"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('global-video')) {
      customElements.define(
        'global-video',
        class GlobalVideo extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.initEvent();
          }
          initEvent() {
            const closeBtn = this.querySelector('.global-video__close_btn');
            closeBtn.addEventListener('click', () => {
              this.setAttribute('data-video-show', 'false');
              this.querySelector('video').pause();
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-input"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('header-input')) {
      customElements.define(
        'header-input',
        class headerInput extends HTMLElement {
          constructor() {
            super();
          }
          requiredText = '';
          formatText = '';
          rule = '';
          connectedCallback() {
            this.init();
            const $container = $(this.querySelector('.input_text_container'));
            this.requiredText = $container.data('tipEmpty');
            this.formatText = $container.data('tipFormat');
            var ruleType = $container.data('rule');
            switch (ruleType) {
              case 'email':
                this.rule = ltUtils.rule.email;
                break;
              case 'password':
                this.rule = ltUtils.rule.password; // 密码规则: 至少包含一个字母和一个数字
                break;
              case 'password_confirmation':
                this.rule = ltUtils.rule.password_confirmation;
                break;
              // 其他规则可以继续添加
              default:
                this.rule = null; // 默认情况，如果没有匹配规则，可以设置为 null 或空正则
            }
          }

          init() {
            const _this = this;
            const $placeholder_text = $(this.querySelector('.placeholder_text'));
            const $inputContainer = this.querySelector('.input_text_container');
            this.addEventListener('click', function (e) {
              // 判断点击的元素是否是input
              const $input = $(e.target);
              console.log($input.is('input'));
              _this.focusInput();
              $inputContainer.setAttribute('data-focus', 'true');
            });
            const $input = $(this.querySelector('input'));
            $input.on('change', function () {
              _this.querySelector('.input_text_container').setAttribute('data-has-value', 'true');
            });

            // 获取input的value
            const value = $input.val();
            if (value) {
              _this.querySelector('.input_text_container').setAttribute('data-has-value', 'true');
            }
            $input.on('input', this.blurInput.bind(this));
            $input.on('blur', () => {
              this.querySelector('.input_text_container').setAttribute('data-focus', 'false');
              this.blurInput();
            });

            // 获取data-eye-status="open"的元素
            const $eyeStatus = $(this.querySelector('[data-eye-status="open"]'));
            const $eyeStatusClose = $(this.querySelector('[data-eye-status="close"]'));

            $eyeStatus.on('click', function (e) {
              e.stopPropagation();
              e.preventDefault();
              $input.attr('type', 'password');
              $eyeStatus.addClass('header-input--hidden');
              $eyeStatusClose.removeClass('header-input--hidden');
            });

            // 获取data-eye-status="close"的元素
            $eyeStatusClose.on('click', function (e) {
              e.stopPropagation();
              e.preventDefault();
              $input.attr('type', 'text');
              $eyeStatus.removeClass('header-input--hidden');
              $eyeStatusClose.addClass('header-input--hidden');
            });
          }

          focusInput() {
            const input = this.querySelector('input');
            if (input) {
              input.focus();
            }
          }

          blurInput() {
            const $input = $(this.querySelector('input'));
            const value = $input.val();
            // 判断元素是否为必填
            const required = $input.attr('required');
            // 获取父元素为 input_text_container
            const $inputContainer = $input.parents('.input_text_container');
            // 获取与$inputContainer同级的 error-message元素
            const $errorMessage = $inputContainer.siblings('.error-message');
            if (!value) {
              $inputContainer.attr('data-has-value', 'false');
              if (required) {
                $inputContainer.attr('data-error', 'true');
                $errorMessage.text(this.requiredText);
              }
            } else {
              if (this.rule) {
                if (this.rule.test(value)) {
                  $inputContainer.attr('data-error', 'false');
                } else {
                  $inputContainer.attr('data-error', 'true');
                  $errorMessage.text(this.formatText);
                }
              } else {
                $inputContainer.attr('data-error', 'false');
              }
              $inputContainer.attr('data-has-value', 'true');
            }

            if (window.location.pathname.includes('/account/reset')) {
              let reset_customer = $('.reset_customer')[0];
              const passwordInput = reset_customer.querySelector('input[name="customer[password]"]');
              const passwordConfirmInput = reset_customer.querySelector(
                'input[name="customer[password_confirmation]"]'
              );
              const inputContainer = passwordConfirmInput.closest('.input_text_container'); // 获取最近的父容器
              if (passwordConfirmInput.value && passwordInput.value !== passwordConfirmInput.value) {
                if (passwordConfirmInput) {
                  let siblingErrorMessage = Array.from(inputContainer.parentNode.children).find(
                    (child) => child !== inputContainer && child.classList.contains('error-message')
                  );

                  siblingErrorMessage.textContent = window.i18n.password_confirmation_different;
                  inputContainer.setAttribute('data-error', 'true');
                  return false;
                }
              } else if (passwordInput.value == passwordConfirmInput.value) {
                inputContainer.setAttribute('data-error', 'false');
              }
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-search-v2"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('header-search-v2')) {
      customElements.define(
        'header-search-v2',
        class HeaderSearch extends HTMLElement {
          constructor() {
            super();
            this.timestamp = 0;
            this.$overlay;
            this.debouncedInputChange = this.debounce(this.inputChange.bind(this), 500);
          }

          connectedCallback() {
            this.init();
          }
          init() {
            console.log('init111');
            this.initSwiper();
            this.initEvent();
          }
          initEvent() {
            const self = this;
            const root = $(this);
            const $inputMain = root.find('.header-search-v2__input-main');
            const $input = root.find('.header-search-v2__input');
            const $searchInputIcon = root.find('.header-search-v2__search-icon');
            const $closeInputIcon = root.find('.header-search-v2__close-icon');
            const $searchIconBubble = $('#search-icon-bubble');
            const $searchMobileIcon = $('#search-mobile-icon');
            const $productViewAll = root.find('.header-search-v2__view-all.product-view-all');
            const $blogViewAll = root.find('.header-search-v2__view-all.blog-view-all');
            const $recommendedItem = root.find('.header-search-v2__recommend-item');
            const $customerService = root.find('.header-search-v2__customer-service .highlight');

            $inputMain.on('click', () => {
              $input.focus();
            });
            $input.on('focus', () => {
              root.attr('data-focus', 'true');
            });

            $input.on('input', (e) => {
              self.debouncedInputChange(e);
            });
            $input.on('keydown', (e) => {
              if (e.key === 'Enter') {
                if ($input.val().length > 0) {
                  window.location.href = '/search?q=' + $input.val();
                }
              }
            });
            $searchInputIcon.on('click', () => {
              if ($input.val().length > 0) {
                window.location.href = '/search?q=' + $input.val();
              }
            });

            $closeInputIcon.on('click', () => {
              root.attr('data-show', 'false');
              $input.val('');
              if (window.litime && window.litime.enableScroll) {
                window.litime.enableScroll();
              }
              root.attr('data-type', 'default');
              root.attr('data-loading', 'false');
              root.attr('data-focus', 'false');
              root.find('.header-search-v2__hot-selling').show();
              $('.header-v2').removeClass('transform-none-important');
              window.overlayManager.hide('header-search-v2');
            });
            const openSearch = () => {
              console.log('openSearch');
              const isMobile = window.innerWidth <= 1200;
              if (isMobile) {
                if (window.litime && window.litime.disableScroll) {
                  window.litime.disableScroll();
                }
                root.attr('data-focus', 'true');
                root.attr('data-show', 'true');
                root.attr('data-type', 'default');
                root.find('.header-search-v2__hot-selling').show();
              } else {
                root.attr('data-show', 'true');
                $inputMain.click();
                this.$overlay = window.overlayManager.show('header-search-v2');
                const ltHeader = document.querySelector('#lt-header-v2');
                if (ltHeader) {
                  ltHeader.setAttribute('data-show', 'true');
                }
                this.$overlay.on('click', () => {
                  $closeInputIcon.click();
                });
              }
            };

            $searchIconBubble.on('click', openSearch);
            $searchMobileIcon.on('click', openSearch);

            $productViewAll.on('click', () => {
              window.location.href = '/search?q=' + $input.val() + '&type=product';
            });
            $blogViewAll.on('click', () => {
              window.location.href = '/search?q=' + $input.val() + '&type=article';
            });
            $recommendedItem.on('click', (e) => {
              const $currentItem = $(e.currentTarget);
              const url = $currentItem.attr('data-url');
              const keyword = $currentItem.attr('data-keyword');
              if (url) {
                window.location.href = url;
              } else {
                $input.val(keyword);
                self.fetchData(keyword);
              }
            });
            $customerService.on('click', () => {
              window.litime.openChatApp();
            });
          }

          inputChange(e) {
            const self = this;
            const root = $(this);
            const value = e.target.value;
            if (value.length > 0) {
              self.fetchData(value);
            } else {
              const timestamp = new Date().getTime();
              this.timestamp = timestamp;
              root.attr('data-type', 'default');
              root.find('.header-search-v2__hot-selling').show();
            }
          }
          fetchData(value) {
            const self = this;
            const root = $(this);
            const timestamp = new Date().getTime();
            this.timestamp = timestamp;
            root.attr('data-loading', 'true');
            root.find('.header-search-v2__list-mobile').hide();
            root.find('.header-search-v2__swiper').hide();
            let data = {
              q: value.trim(),
              resources: {
                type: 'product,article',
                limit_scope: 'each',
              },
            };
            // 将data对象转换为URL查询参数
            const params = new URLSearchParams();
            params.append('q', data.q);
            params.append('resources[type]', data.resources.type);
            params.append('resources[limit_scope]', data.resources.limit_scope);

            // 生成完整的URL路径
            let url = window.Shopify.routes.root + `search/suggest.json?${params.toString()}`;
            fetch(url)
              .then((response) => response.json())
              .then((suggestions) => {
                const results = suggestions.resources.results;
                if (timestamp !== this.timestamp) {
                  return;
                }
                if (results.products.length > 0 || results.articles.length > 0) {
                  if (results.products.length > 0) {
                    let product_5 = results.products.slice(0, 5);
                    root
                      .find('.product-list')
                      .html(product_5.map((product) => this.itemTemplate(product.title, product.url, data.q)).join(''));
                  } else {
                    root.find('.product-list').html(this.emptyText());
                  }
                  if (results.articles.length > 0) {
                    let article_5 = results.articles.slice(0, 5);
                    root
                      .find('.blog-list')
                      .html(article_5.map((article) => this.itemTemplate(article.title, article.url, data.q)).join(''));
                  } else {
                    root.find('.blog-list').html(this.emptyText());
                  }
                  root.find('.total-count').text(results.products.length + results.articles.length);
                  root.attr('data-type', 'result');
                } else {
                  root.attr('data-type', 'empty');
                  root.find('.total-count').text('0');
                  root.find('.header-search-v2__hot-selling').hide();
                }
                root.attr('data-loading', 'false');
              })
              .catch((error) => {
                console.error('Error fetching data:', error);
                if (timestamp != this.timestamp) {
                  return;
                }
                root.attr('data-type', 'empty');
                root.attr('data-loading', 'false');
                root.find('.total-count').text('0');
                root.find('.header-search-v2__hot-selling').hide();
              });
          }
          emptyText() {
            const root = $(this);
            const emptyText = root.attr('data-empty-text');
            return `<span class="empty-text">${emptyText}</span>`;
          }
          itemTemplate(title, url, q) {
            const highlight = title.replace(new RegExp(`(${q})`, 'gi'), '<span class="highlight">$1</span>');
            return `<a href="${url}" class="data-item">${highlight}</a>`;
          }
          initSwiper() {
            const self = this;
            const root = $(this);
            const $swiper = root.find('.my-swiper');
            const $buttonPrev = root.find('.swiper-button-prev');
            const $buttonNext = root.find('.swiper-button-next');
            new Swiper($swiper[0], {
              slidesPerView: 'auto',
              spaceBetween: 25,
              slidesOffsetBefore: 16,
              slidesOffsetAfter: 16,
              breakpoints: {
                576: {
                  slidesOffsetBefore: 32,
                  slidesOffsetAfter: 32,
                },
              },
              navigation: {
                nextEl: $buttonNext[0],
                prevEl: $buttonPrev[0],
              },
            });
          }
          debounce(fn, delay) {
            let timer = null;
            return function () {
              const context = this;
              const args = arguments;
              clearTimeout(timer);
              timer = setTimeout(() => {
                fn.apply(context, args);
              }, delay);
            };
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('header-search')) {
      customElements.define(
        'header-search',
        class HeaderSearch extends HTMLElement {
          constructor() {
            super();
            this.timestamp = 0;
            this.$overlay;
            this.debouncedInputChange = this.debounce(this.inputChange.bind(this), 500);
          }

          connectedCallback() {
            this.init();
          }
          init() {
            this.initSwiper();
            this.initEvent();
          }
          initEvent() {
            const self = this;
            const root = $(this);
            const $inputMain = root.find('.header-search__input-main');
            const $input = root.find('.header-search__input');
            const $searchInputIcon = root.find('.header-search__search-icon');
            const $closeInputIcon = root.find('.header-search__close-icon');
            const $searchIconBubble = $('#search-icon-bubble');
            const $searchMobileIcon = $('#search-mobile-icon');
            const $productViewAll = root.find('.header-search__view-all.product-view-all');
            const $blogViewAll = root.find('.header-search__view-all.blog-view-all');
            const $recommendedItem = root.find('.header-search__recommend-item');
            const $customerService = root.find('.header-search__customer-service .highlight');

            $inputMain.on('click', () => {
              $input.focus();
            });
            $input.on('focus', () => {
              root.attr('data-focus', 'true');
            });

            $input.on('input', (e) => {
              self.debouncedInputChange(e);
            });
            $input.on('keydown', (e) => {
              if (e.key === 'Enter') {
                if ($input.val().length > 0) {
                  window.location.href = '/search?q=' + $input.val();
                }
              }
            });
            $searchInputIcon.on('click', () => {
              if ($input.val().length > 0) {
                window.location.href = '/search?q=' + $input.val();
              }
            });

            $closeInputIcon.on('click', () => {
              root.attr('data-show', 'false');
              $input.val('');
              if (window.litime && window.litime.enableScroll) {
                window.litime.enableScroll();
              }
              root.attr('data-type', 'default');
              root.attr('data-loading', 'false');
              root.attr('data-focus', 'false');
              $('.header-01').removeClass('transform-none-important');
              window.overlayManager.hide('header-search');
            });
            $searchIconBubble.on('click', () => {
              root.attr('data-show', 'true');
              $inputMain.click();
              this.$overlay = window.overlayManager.show('header-search');
              const ltHeader = document.querySelector('lt-header');
              ltHeader.closePopup();
              this.$overlay.on('click', () => {
                $closeInputIcon.click();
              });
            });

            $searchMobileIcon.on('click', () => {
              if (window.litime && window.litime.disableScroll) {
                window.litime.disableScroll();
              }
              $('.header-01').addClass('transform-none-important');
              root.attr('data-focus', 'true');

              // 使用requestAnimationFrame确保在下一帧执行
              requestAnimationFrame(() => {
                // 监听transform过渡完成
                $('.header-01').one('transitionend', () => {
                  root.attr('data-show', 'true');
                  root.attr('data-type', 'default');
                });
              });
            });

            $productViewAll.on('click', () => {
              window.location.href = '/search?q=' + $input.val() + '&type=product';
            });
            $blogViewAll.on('click', () => {
              window.location.href = '/search?q=' + $input.val() + '&type=article';
            });
            $recommendedItem.on('click', (e) => {
              const $currentItem = $(e.currentTarget);
              const url = $currentItem.attr('data-url');
              const keyword = $currentItem.attr('data-keyword');
              if (url) {
                window.location.href = url;
              } else {
                $input.val(keyword);
                self.fetchData(keyword);
              }
            });
            $customerService.on('click', () => {
              window.litime.openChatApp();
            });
          }

          inputChange(e) {
            const self = this;
            const root = $(this);
            const value = e.target.value;
            if (value.length > 0) {
              self.fetchData(value);
            } else {
              const timestamp = new Date().getTime();
              this.timestamp = timestamp;
              root.attr('data-type', 'default');
            }
          }
          fetchData(value) {
            const self = this;
            const root = $(this);
            const timestamp = new Date().getTime();
            this.timestamp = timestamp;
            root.attr('data-loading', 'true');
            let data = {
              q: value.trim(),
              resources: {
                type: 'product,article',
                limit_scope: 'each',
              },
            };
            // 将data对象转换为URL查询参数
            const params = new URLSearchParams();
            params.append('q', data.q);
            params.append('resources[type]', data.resources.type);
            params.append('resources[limit_scope]', data.resources.limit_scope);

            // 生成完整的URL路径
            let url = window.Shopify.routes.root + `search/suggest.json?${params.toString()}`;
            fetch(url)
              .then((response) => response.json())
              .then((suggestions) => {
                const results = suggestions.resources.results;
                if (timestamp !== this.timestamp) {
                  return;
                }
                if (results.products.length > 0 || results.articles.length > 0) {
                  if (results.products.length > 0) {
                    let product_5 = results.products.slice(0, 5);
                    root
                      .find('.product-list')
                      .html(product_5.map((product) => this.itemTemplate(product.title, product.url, data.q)).join(''));
                  } else {
                    root.find('.product-list').html(this.emptyText());
                  }
                  if (results.articles.length > 0) {
                    let article_5 = results.articles.slice(0, 5);
                    root
                      .find('.blog-list')
                      .html(article_5.map((article) => this.itemTemplate(article.title, article.url, data.q)).join(''));
                  } else {
                    root.find('.blog-list').html(this.emptyText());
                  }
                  root.find('.total-count').text(results.products.length + results.articles.length);
                  root.attr('data-type', 'result');
                } else {
                  root.attr('data-type', 'empty');
                  root.find('.total-count').text('0');
                }
                root.attr('data-loading', 'false');
              })
              .catch((error) => {
                console.error('Error fetching data:', error);
                if (timestamp != this.timestamp) {
                  return;
                }
                root.attr('data-type', 'empty');
                root.attr('data-loading', 'false');
                root.find('.total-count').text('0');
              });
          }
          emptyText() {
            const root = $(this);
            const emptyText = root.attr('data-empty-text');
            return `<span class="empty-text">${emptyText}</span>`;
          }
          itemTemplate(title, url, q) {
            const highlight = title.replace(new RegExp(`(${q})`, 'gi'), '<span class="highlight">$1</span>');
            return `<a href="${url}" class="data-item">${highlight}</a>`;
          }
          initSwiper() {
            const self = this;
            const root = $(this);
            const $swiper = root.find('.my-swiper');
            const $buttonPrev = root.find('.swiper-button-prev');
            const $buttonNext = root.find('.swiper-button-next');
            new Swiper($swiper[0], {
              slidesPerView: 'auto',
              spaceBetween: 25,
              slidesOffsetBefore: 16,
              slidesOffsetAfter: 16,
              breakpoints: {
                576: {
                  slidesOffsetBefore: 32,
                  slidesOffsetAfter: 32,
                },
              },
              navigation: {
                nextEl: $buttonNext[0],
                prevEl: $buttonPrev[0],
              },
            });
          }
          debounce(fn, delay) {
            let timer = null;
            return function () {
              const context = this;
              const args = arguments;
              clearTimeout(timer);
              timer = setTimeout(() => {
                fn.apply(context, args);
              }, delay);
            };
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-switch-site"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('header-switch-site')) {
      customElements.define(
        'header-switch-site',
        class PqHeaderSwitchSite extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            this.initData();
            this.initClose();
            this.initConfirm();
            this.initCancel();
            this.initRedirect();
          }
          initConfirm() {
            const button = this.querySelector('.header-switch-site__handle-confirm');
            if (button) {
              button.addEventListener('click', async (e) => {
                try {
                  button.setAttribute('data-loading', 'true');
                  const data = {
                    sign: this.sign,
                  };
                  const res = await this.changeShopInfo(data);
                  if (res.code === 200) {
                    this.setAttribute('data-show', 'false');
                    window.litime.showToast('success', window.i18n.login_success);
                    if (res.data?.referralInvitedReward) {
                      window.litime.setLocalStorage('referralInvitedReward', res.data.referralInvitedReward);
                    }
                    window.litime.setLocalStorage('ltUserInfo', res.data);
                    window.litime.setLocalStorage('ltToken', res.data.token);
                    window.location.href = res.data.mutilpass;
                  }
                } catch (error) {
                  window.litime.showToast('error', error.message);
                  console.error('login error', error);
                } finally {
                  button.setAttribute('data-loading', 'false');
                }
              });
            }
          }
          // 切换店铺后获取用户信息
          async changeShopInfo(data) {
            const url = '/shopify/auth/change/shop/info';
            const res = await window.litime.http.get(url, {
              data: {
                ...data,
              },
            });
            if (res.code === 200) {
              return res;
            } else if (res.code === 10051102) {
              throw new Error(window.i18n.error_message_10051102);
            } else if (res.code === 10051105) {
              throw new Error(window.i18n.error_message_10051105);
            } else if (res.code === 10051109) {
              throw new Error(window.i18n.error_message_10051109_login);
            } else {
              throw new Error(window.i18n.request_failed);
            }
          }
          initCancel() {
            const cancel = this.querySelector('.header-switch-site__handle-cancel');
            cancel.addEventListener('click', () => {
              window.litime.eventBus.publish('REGISTER');
              this.setAttribute('data-show', 'false');
            });
          }
          initClose() {
            const close = this.querySelector('.header-switch-site__content-close');
            close.addEventListener('click', () => {
              this.setAttribute('data-show', 'false');
            });
          }
          initData() {
            console.log('header-switch-site initData');
            const urlParams = new URLSearchParams(window.location.search);
            const email = this.querySelector('.header-switch-site__content-text-email');
            // 获取路径中的email邮箱
            const type = urlParams.get('type');
            if (type === 'changeShop') {
              // if (window.customer) {
              if (!window.customer) {
                const emailValue = urlParams.get('email');
                const signValue = urlParams.get('sign');
                if (emailValue) {
                  email.textContent = emailValue;
                }
                this.sign = signValue;
                this.setAttribute('data-show', 'true');
                this.initShow();
              }
              // 移除路径中的email和sign参数
              window.history.replaceState({}, '', window.location.pathname);
            }
          }
          initShow() {
            // 设置五秒后关闭，鼠标移入暂停关闭，鼠标移出重新计时关闭
            let timer = setTimeout(() => {
              this.setAttribute('data-show', 'false');
            }, 5000);
            this.addEventListener('mouseenter', () => {
              clearTimeout(timer);
            });
            this.addEventListener('mouseleave', () => {
              timer = setTimeout(() => {
                this.setAttribute('data-show', 'false');
              }, 5000);
            });
          }
          initRedirect() {
            if (window.customer && window.litime.getLocalStorage('ltToken')) {
              const switchSiteLink = document.querySelectorAll('[data-action="switch-site"]');
              switchSiteLink.forEach((link) => {
                link.addEventListener('click', async (e) => {
                  e.preventDefault();
                  try {
                    // 完整的域名，带上https://
                    const domain = link.href;
                    // const domain = 'https://dev-askstarry.myshopify.com/';
                    const data = {
                      domain: domain,
                    };
                    const res = await this.getMutilpass(data);
                    if (res.code === 200) {
                      window.location.href = res.data.mutilpass;
                    }
                  } catch (error) {
                    window.location.href = link.href;
                  }
                });
              });
            }
          }
          // 切换店铺获取mutilpass
          async getMutilpass(data) {
            const url = '/shopify/auth/change/shop';
            const res = await window.litime.http.get(url, {
              data: {
                ...data,
              },
            });
            if (res.code === 200) {
              return res;
            } else {
              throw new Error(window.i18n.request_failed);
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["input-text"] && !Shopify.designMode) return;
  try {
    $(function () {
    // 在这里编写需要在文档加载完成后执行的代码
    if (!customElements.get('input-text')) {
      customElements.define(
        'input-text',
        class inputText extends HTMLElement {
          constructor() {
            super();
          }
          requiredText = '';
          formatText = '';
          rule = '';
          connectedCallback() {
            this.init();
            const $container = $(this.querySelector('.input_text_container'));
            this.requiredText = $container.data('tipEmpty');
            this.formatText = $container.data('tipFormat');
            var ruleType = $container.data('rule');
            switch (ruleType) {
              case 'email':
                this.rule = ltUtils.rule.email;
                break;
              case 'password':
                this.rule = ltUtils.rule.password; // 密码规则: 至少包含一个字母和一个数字
                break;
              case 'password_confirmation':
                this.rule = ltUtils.rule.password_confirmation;
                break;
              // 其他规则可以继续添加
              default:
                this.rule = null; // 默认情况，如果没有匹配规则，可以设置为 null 或空正则
            }
          }

          init() {
            const _this = this;
            const $placeholder_text = $(this.querySelector('.placeholder_text'));
            this.addEventListener('click', function () {
              $placeholder_text.css('top', '0.5rem').css('transform', 'translateY(0)');
              _this.focusInput();
              this.querySelector('.input_text_container').setAttribute('data-focus', 'true');
            });
            const $input = $(this.querySelector('input'));
            $input.on('change', function () {
              $placeholder_text.css('top', '0.5rem').css('transform', 'translateY(0)');
            });

            // 获取input的value
            const value = $input.val();
            if (value) {
              $placeholder_text.css('top', '0.5rem').css('transform', 'translateY(0)');
            }
            $input.blur(this.blurInput.bind(this));
          }

          focusInput() {
            const input = this.querySelector('input');

            if (input) {
              input.focus();
            }
          }

          blurInput() {
            this.querySelector('.input_text_container').setAttribute('data-focus', 'false');
            const $input = $(this.querySelector('input'));
            const value = $input.val();
            // 判断元素是否为必填
            const required = $input.attr('required');
            // 获取父元素为 input_text_container
            const $inputContainer = $input.parents('.input_text_container');
            // 获取与$inputContainer同级的 error-message元素
            const $errorMessage = $inputContainer.siblings('.error-message');
            if (!value) {
              const $placeholder_text = $(this.querySelector('.placeholder_text'));
              $placeholder_text.css('top', '50%').css('transform', 'translateY(-50%)');
              if (required) {
                $inputContainer.attr('data-error', 'true');
                $errorMessage.text(this.requiredText);
              }
            } else {
              if (this.rule) {
                if (this.rule.test(value)) {
                  $inputContainer.attr('data-error', 'false');
                } else {
                  $inputContainer.attr('data-error', 'true');
                  $errorMessage.text(this.formatText);
                }
              } else {
                $inputContainer.attr('data-error', 'false');
              }
            }

            if (window.location.pathname.includes('/account/reset')) {
              let reset_customer = $('.reset_customer')[0];
              const passwordInput = reset_customer.querySelector('input[name="customer[password]"]');
              const passwordConfirmInput = reset_customer.querySelector(
                'input[name="customer[password_confirmation]"]'
              );
              const inputContainer = passwordConfirmInput.closest('.input_text_container'); // 获取最近的父容器
              if (passwordConfirmInput.value && passwordInput.value !== passwordConfirmInput.value) {
                if (passwordConfirmInput) {
                  let siblingErrorMessage = Array.from(inputContainer.parentNode.children).find(
                    (child) => child !== inputContainer && child.classList.contains('error-message')
                  );

                  siblingErrorMessage.innerHTML = window.i18n.password_confirmation_different;
                  inputContainer.setAttribute('data-error', 'true');
                  return false;
                }
              } else if (passwordInput.value == passwordConfirmInput.value) {
                inputContainer.setAttribute('data-error', 'false');
              }
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["integrated-service-pagination"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('integrated-service-pagination')) {
      customElements.define(
        'integrated-service-pagination',
        class integratedServicePagination extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            const previousButton = this.querySelector('.integrated-service-pagination-previous');
            const nextButton = this.querySelector('.integrated-service-pagination-next');

            previousButton.addEventListener('click', function () {
              const previousId = previousButton.getAttribute('data-id');
              const moduleId = previousButton.getAttribute('data-module-id');
              document.querySelector(`#${previousId}`)?.setAttribute('data-show', 'true');
              document.querySelector(`#${moduleId}`)?.setAttribute('data-show', 'false');
              const urlParams = new URLSearchParams(window.location.search);
              urlParams.set('currentId', previousId);
              window.history.pushState({}, '', window.location.pathname + '?' + urlParams.toString());
            });
            nextButton.addEventListener('click', function () {
              const nextId = nextButton.getAttribute('data-id');
              const moduleId = nextButton.getAttribute('data-module-id');
              document.querySelector(`#${nextId}`)?.setAttribute('data-show', 'true');
              document.querySelector(`#${moduleId}`)?.setAttribute('data-show', 'false');
              // 将nextID 设置到url中参数中，如果url中已经存在则替换，如果不存在则添加参数名为currentid
              const urlParams = new URLSearchParams(window.location.search);
              urlParams.set('currentId', nextId);
              window.history.pushState({}, '', window.location.pathname + '?' + urlParams.toString());
            });
            document.addEventListener('shopify:section:load', (event) => {
              const moduleId = this.getAttribute('data-module-id');
              const urlParams = new URLSearchParams(window.location.search);
              const currentId = urlParams.get('currentId');
              console.log('moduleId', moduleId, currentId, currentId === moduleId);
              if (currentId === moduleId) {
                const siblings = document.querySelectorAll(`[data-type="integrated-service"]`);
                siblings.forEach((sibling) => {
                  sibling.setAttribute('data-show', 'false');
                });
                document.querySelector(`#${currentId}`)?.setAttribute('data-show', 'true');
              }
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["judgeme-badge-v2"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('judgeme-badge-component-v2')) {
      customElements.define(
        'judgeme-badge-component-v2',
        class JudgemeBadgeComponent extends HTMLElement {
          constructor() {
            super();
          }

          connectedCallback() {
            this.init();
          }

          init() {
            const rating = parseFloat(this.dataset.rating) || 0;
            const count = parseInt(this.dataset.count) || 0;

            // 只有当有评价数据时才显示组件
            if (count > 0 && rating > 0) {
              const starContainers = this.querySelectorAll('.judgeme-badge__star-container');
              this.renderStars(starContainers, rating);

              // 渲染完成后显示组件
              this.classList.add('loaded');
            }
          }

          renderStars(starContainers, rating) {
            starContainers.forEach((container, index) => {
              const starNumber = index + 1;

              // 获取每个容器内的三个 SVG
              const fullStar = container.querySelector('.judgeme-badge__star-full');
              const halfStar = container.querySelector('.judgeme-badge__star-half');
              const emptyStar = container.querySelector('.judgeme-badge__star-empty');

              // 隐藏所有星星
              fullStar.classList.remove('active');
              halfStar.classList.remove('active');
              emptyStar.classList.remove('active');

              // 计算当前星星的小数部分
              const starFraction = rating - (starNumber - 1);

              if (rating >= starNumber) {
                // 完整星星：评分大于等于当前星星数字
                fullStar.classList.add('active');
              } else if (starFraction > 0.25 && starFraction <= 0.75) {
                // 半星：大于 x.25 且小于或等于 x.75
                halfStar.classList.add('active');
              } else if (starFraction > 0 && starFraction <= 0.25) {
                // 空星：大于 0 但小于或等于 x.25
                emptyStar.classList.add('active');
              } else if (starFraction > 0.75 && starFraction < 1) {
                // 完整星星：大于 x.75 但小于 1
                fullStar.classList.add('active');
              } else {
                // 空星：评分为 0 或小于当前星星
                emptyStar.classList.add('active');
              }
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["judgeme-badge"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('judgeme-badge-component')) {
      customElements.define(
        'judgeme-badge-component',
        class JudgemeBadgeComponent extends HTMLElement {
          constructor() {
            super();
          }

          connectedCallback() {
            this.init();
          }

          init() {
            const rating = parseFloat(this.dataset.rating) || 0;
            const count = parseInt(this.dataset.count) || 0;

            // 只有当有评价数据时才显示组件
            if (count > 0 && rating > 0) {
              const starContainers = this.querySelectorAll('.judgeme-badge__star-container');
              this.renderStars(starContainers, rating);

              // 渲染完成后显示组件
              this.classList.add('loaded');
            }
          }

          renderStars(starContainers, rating) {
            starContainers.forEach((container, index) => {
              const starNumber = index + 1;

              // 获取每个容器内的三个 SVG
              const fullStar = container.querySelector('.judgeme-badge__star-full');
              const halfStar = container.querySelector('.judgeme-badge__star-half');
              const emptyStar = container.querySelector('.judgeme-badge__star-empty');

              // 隐藏所有星星
              fullStar.classList.remove('active');
              halfStar.classList.remove('active');
              emptyStar.classList.remove('active');

              // 计算当前星星的小数部分
              const starFraction = rating - (starNumber - 1);

              if (rating >= starNumber) {
                // 完整星星：评分大于等于当前星星数字
                fullStar.classList.add('active');
              } else if (starFraction > 0.25 && starFraction <= 0.75) {
                // 半星：大于 x.25 且小于或等于 x.75
                halfStar.classList.add('active');
              } else if (starFraction > 0 && starFraction <= 0.25) {
                // 空星：大于 0 但小于或等于 x.25
                emptyStar.classList.add('active');
              } else if (starFraction > 0.75 && starFraction < 1) {
                // 完整星星：大于 x.75 但小于 1
                fullStar.classList.add('active');
              } else {
                // 空星：评分为 0 或小于当前星星
                emptyStar.classList.add('active');
              }
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-cart-recommend-product-list-v2"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('main-cart-recommend-product-list-v2')) {
      customElements.define(
        'main-cart-recommend-product-list-v2',
        class CartRecommendProductListV2 extends HTMLElement {
          constructor() {
            super();
            this.swiper = null;
            this.hasLoaded = false;
            this.isFetching = false;
            this.cachedContent = null;
            this.restoreContentHandler = this.restoreContent.bind(this);
          }

          connectedCallback() {
            this.wrapper = this.querySelector('#main-cart-recommend-product-list-v2-wrapper');
            if (!this.wrapper) return;

            const url = this.wrapper?.dataset.url;
            if (!url) return;

            if (window.litime && window.litime.eventBus) {
              this.unsubscribeCartRendered = window.litime.eventBus.subscribe(
                'CART_DRAWER_RENDERED',
                this.restoreContentHandler
              );
            }

            if (!window.__cartRecommendLoaded) {
              window.__cartRecommendLoaded = new Map();
            }

            this.loadRecommendations();
          }

          disconnectedCallback() {
            if (this.swiper) {
              this.swiper.destroy();
              this.swiper = null;
            }
            if (this.unsubscribeCartRendered) {
              this.unsubscribeCartRendered();
            }
          }

          restoreContent() {
            if (!this.wrapper || !this.cachedContent) return;
            const url = this.wrapper?.dataset.url;
            if (!url || !window.__cartRecommendLoaded.has(url)) return;
            const cached = window.__cartRecommendLoaded.get(url);
            if (cached && cached.recommendationsHTML) {
              this.wrapper.innerHTML = cached.recommendationsHTML;
              this.initSwiper();
              this.initJoinCartButton();
            }
          }

          async loadRecommendations() {
            if (this.hasLoaded || this.isFetching) return;

            try {
              this.isFetching = true;
              const url = this.wrapper.dataset.url;
              const response = await fetch(url);
              const text = await response.text();
              const parser = new DOMParser();
              const doc = parser.parseFromString(text, 'text/html');
              const recommendationsContainer = doc.querySelector('.cart-recommendations');

              if (recommendationsContainer?.innerHTML.trim()) {
                const tempDiv = doc.createElement('div');
                tempDiv.innerHTML = recommendationsContainer.innerHTML;
                this.wrapper.innerHTML = tempDiv.innerHTML;
                this.hasLoaded = true;

                const cachedData = { recommendationsHTML: tempDiv.innerHTML };
                window.__cartRecommendLoaded.set(url, cachedData);
                this.cachedContent = cachedData;

                this.initSwiper();
                this.initJoinCartButton();
              } else {
                this.hasLoaded = true;
                window.__cartRecommendLoaded.set(url, { recommendationsHTML: '' });
              }
            } catch (error) {
              console.error('Failed to load recommendations:', error);
            } finally {
              this.isFetching = false;
            }
          }

          initSwiper() {
            const swiperEl = this.querySelector('.main-cart-recommend-product-list-v2__swiper .swiper');
            if (!swiperEl) return;

            const prevEl = this.querySelector('.main-cart-recommend-product-list-v2__nav-btn--prev');
            const nextEl = this.querySelector('.main-cart-recommend-product-list-v2__nav-btn--next');
            const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
            if (slideCount <= 1) return;

            this.swiper = new Swiper(swiperEl, {
              slidesPerView: 'auto',
              spaceBetween: 24,
              watchOverflow: true,
              navigation: {
                prevEl,
                nextEl,
              },
            });
          }

          initJoinCartButton() {
            const joinCartBtns = this.querySelectorAll('.join-cart-btn');
            if (!joinCartBtns.length) return;

            joinCartBtns.forEach((joinCartBtn) => {
              joinCartBtn.addEventListener('click', async () => {
                try {
                  const card = joinCartBtn.closest('.cart-recommend-item-v2');
                  const variantId = parseInt(
                    joinCartBtn.getAttribute('data-variant-id') || card?.getAttribute('data-variant-id'),
                    10
                  );

                  if (!variantId || Number.isNaN(variantId)) {
                    window.litime.showToast('error', 'Please select a variant');
                    return;
                  }

                  const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      items: [{ id: variantId, quantity: 1 }],
                      sections: `${getMiniCartSectionId()},cart-icon-bubble`,
                    }),
                  });

                  if (window.gtag) {
                    gtag('event', 'conversion', { send_to: 'AW-11059876179/OfmnCMjGxIsYENOi4Zkp' });
                  }

                  if (response.ok) {
                    const cartContent = await response.json();
                    await updateCartComponents(cartContent);
                  } else {
                    const errorData = await response.json();
                    window.litime.showToast('error', errorData.description || 'Failed to Add to Cart');
                  }
                } catch (error) {
                  window.litime.showToast('error', 'Failed to Add to Cart');
                }
              });
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-product-compare-anchor-v2"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('main-product-compare-anchor-v2')) {
      customElements.define(
        'main-product-compare-anchor-v2',
        class MainProductCompareAnchorV2 extends HTMLElement {
          constructor() {
            super();
            this.isHandlingClick = false;
            this.anchorLinks = null;
            this.handleScroll = null;
            this.anchorClickHandlers = new Map();
            this.headerOffset = 195;
          }
          connectedCallback() {
            // 不需要在这里执行，而是外部执行
            // this.init();
          }
          init() {
            this.setAttribute('data-show', 'false');
            const compareMainDom = this.closest('main-product-compare-v2');
            if (!compareMainDom || !compareMainDom.specNameList) {
              console.warn('compareMainDom or specNameList not found');
              return;
            }

            const specNameList = compareMainDom.specNameList;
            const anchorContainer = this.querySelector('.main-product-compare-anchor-v2-items');

            if (!anchorContainer) {
              console.warn('anchor container not found');
              return;
            }

            // 生成锚点 HTML
            let html = '';

            // 第一个是 productMain
            if (specNameList.length > 0 && specNameList[0] === 'productMain') {
              html += `
                <div class="main-product-compare-anchor-v2-item" data-active="true">
                  <span class="main-product-compare-anchor-v2-item-indicator" aria-hidden="true"></span>
                  <a class="main-product-compare-anchor-v2-item-name" href="#productMain">${this.getAttribute(
                    'data-i18n-main'
                  )}</a>
                </div>
              `;
            }

            // 其他的从 specNameList 中获取
            for (let i = 1; i < specNameList.length; i++) {
              const name = specNameList[i];
              html += `
                <div class="main-product-compare-anchor-v2-item">
                  <span class="main-product-compare-anchor-v2-item-indicator" aria-hidden="true"></span>
                  <a class="main-product-compare-anchor-v2-item-name" href="#${name}">${name}</a>
                </div>
              `;
            }
            anchorContainer.innerHTML = html;

            // 初始化锚点功能
            this.initAnchorEvents();
            this.setAttribute('data-show', 'true');
          }

          initAnchorEvents() {
            // 清理旧事件
            this.cleanup();

            this.anchorLinks = this.querySelectorAll('.main-product-compare-anchor-v2-item-name');
            this.anchorClickHandlers.clear();

            // 事件锁，控制点击和滚动
            this.isHandlingClick = false;
            this.scrollUnlockTimer = null;

            // 获取顶部 header 的高度（动态）
            const getHeaderOffset = () => {
              const header = document.querySelector('.header-sticky');
              return header ? header.offsetHeight : this.headerOffset || 0;
            };

            // 每次都实时计算元素绝对位置（不会出现 547 → 变化的问题）
            const getAbsoluteTop = (el) => {
              return el.getBoundingClientRect().top + window.pageYOffset;
            };

            // ⭐核心：更稳定的平滑滚动
            const scrollToTarget = (target) => {
              const headerOffset = getHeaderOffset();
              const targetTop = getAbsoluteTop(target) - headerOffset;

              // 事件锁打开
              this.isHandlingClick = true;

              // iOS Safari 防抖 + repaint 修复跳动
              requestAnimationFrame(() => {
                window.scrollTo({
                  top: targetTop,
                  behavior: 'smooth',
                });

                // 使用 scroll 事件检测滚动是否结束
                startScrollUnlockWatcher();
              });
            };

            // ⭐ 滚动结束自动解锁（比 setTimeout 更可靠）
            const startScrollUnlockWatcher = () => {
              if (this.scrollUnlockTimer) {
                clearTimeout(this.scrollUnlockTimer);
              }

              let lastPosition = window.pageYOffset;

              const checkEnd = () => {
                const current = window.pageYOffset;

                // 100ms 内没有变化 → 认为滚动结束
                if (Math.abs(current - lastPosition) < 1) {
                  this.isHandlingClick = false;
                  return;
                }

                lastPosition = current;
                this.scrollUnlockTimer = setTimeout(checkEnd, 100);
              };

              this.scrollUnlockTimer = setTimeout(checkEnd, 100);
            };

            // 点击锚点事件
            this.anchorLinks.forEach((anchor) => {
              const handler = (e) => {
                e.preventDefault();

                const targetId = anchor.getAttribute('href').substring(1);
                const target = document.getElementById(targetId);

                if (target) {
                  scrollToTarget(target);
                  this.activeAnchor(anchor.parentNode);
                }
              };

              this.anchorClickHandlers.set(anchor, handler);
              anchor.addEventListener('click', handler);
            });

            // --- 高亮逻辑保持原样，只加事件锁判断 ---
            this.handleScroll = () => {
              if (this.isHandlingClick) return; // 点击触发滚动时不执行高亮逻辑

              let closestAnchor = null;
              let closestDistance = Infinity;
              const headerOffset = getHeaderOffset();

              this.anchorLinks.forEach((anchor) => {
                const targetId = anchor.getAttribute('href').substring(1);
                const targetEl = document.getElementById(targetId);

                if (targetEl) {
                  const bounding = targetEl.getBoundingClientRect();
                  const distance = Math.abs(bounding.top - headerOffset);

                  if (distance < closestDistance) {
                    closestAnchor = anchor;
                    closestDistance = distance;
                  }
                }
              });

              if (closestAnchor) {
                this.activeAnchor(closestAnchor.parentNode);
              }
            };

            window.addEventListener('scroll', this.handleScroll);

            // 初次执行一次
            this.handleScroll();
          }

          activeAnchor(element) {
            const anchors = this.querySelectorAll('.main-product-compare-anchor-v2-item');
            anchors.forEach((item) => {
              item.setAttribute('data-active', 'false');
            });
            element.setAttribute('data-active', 'true');
          }

          getAbsoluteTop(element) {
            return element.getBoundingClientRect().top + window.pageYOffset;
          }

          cleanup() {
            // 移除之前添加的点击事件监听器
            if (this.anchorLinks && this.anchorClickHandlers) {
              this.anchorLinks.forEach((anchor) => {
                const handler = this.anchorClickHandlers.get(anchor);
                if (handler) {
                  anchor.removeEventListener('click', handler);
                }
              });
              this.anchorClickHandlers.clear();
            }

            // 移除之前添加的滚动事件监听器
            if (this.handleScroll) {
              window.removeEventListener('scroll', this.handleScroll);
            }
          }

          disconnectedCallback() {
            // 组件被移除时清理事件监听器
            this.cleanup();
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-product-compare-sticky-top-v2"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('main-product-compare-sticky-top-v2')) {
      customElements.define(
        'main-product-compare-sticky-top-v2',
        class MainProductCompareStickyTopV2 extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.compareMainDom = this.closest('main-product-compare-v2');
          }
          initObserverHeader() {
            if (this.observerHeader) {
              this.observerHeader.disconnect();
            }
            this.headerDom =
              this.compareMainDom?.querySelector('.main-product-compare-v2__header') ||
              document.querySelector('.main-product-compare-v2__header');

            if (!this.headerDom) {
              console.warn('main-product-compare-v2__header element not found');
              return;
            }

            this.observerHeader = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) {
                    this.setAttribute('data-show', 'false');
                  } else {
                    if (this.compareMainDom.getAttribute('data-loading') == 'true') {
                      return;
                    }
                    this.setAttribute('data-show', 'true');
                  }
                });
              },
              {
                rootMargin: '200px 0px 0px 0px',
                threshold: 0,
              }
            );

            this.observerHeader.observe(this.headerDom);
          }
          init(list) {
            if (!list || list.length === 0) {
              return;
            }
            this.list = list;
            this.renderList();
            this.bindProductRemove();
            this.initObserverHeader();
          }

          renderList() {
            let startDom = '<div class="main-product-compare-sticky-top-v2__content-product">';
            let endDom = '</div>';
            let html = '';
            this.list.forEach((item) => {
              html += `
                <div class="main-product-compare-sticky-top-v2__content-product-item">
                  ${this.initProductCard(item)}
                </div>
              `;
            });
            const contentDom = this.querySelector('.main-product-compare-sticky-top-v2__content-product');
            contentDom.outerHTML = startDom + html + endDom;
          }
          canShowRemoveButton() {
            const count = this.compareMainDom?.productIds?.length ?? this.list?.length ?? 0;
            return count > 2;
          }
          initProductCard(item) {
            const productId = item.shopifyProductId;
            const imageSrc = item.guideImageSrc || item.imageSrc;
            const title = item.shortTitle || item.title;
            const removeLabel = this.compareMainDom?.getAttribute('data-remove-label') || 'Remove';
            const removeBtn = this.canShowRemoveButton()
              ? `
                <button
                  type="button"
                  class="main-product-compare-sticky-top-v2__content-product-item-remove"
                  data-action="remove"
                  data-product-id="${productId}"
                  aria-label="${removeLabel}"
                ></button>
              `
              : '';
            return `
              <div class="main-product-compare-sticky-top-v2__content-product-item-card">
                ${removeBtn}
                <div class="main-product-compare-sticky-top-v2__content-product-item-header">
                  <img
                    class="main-product-compare-sticky-top-v2__content-product-item-image"
                    src="${imageSrc}"
                    width="80"
                    height="80"
                    alt="${title}"
                  >
                  <a
                    href="/products/${item.handle}"
                    class="main-product-compare-sticky-top-v2__content-product-item-title"
                  >${title}</a>
                </div>
              </div>
            `;
          }
          bindProductRemove() {
            const removeIconTemplate = this.compareMainDom?.querySelector('[data-remove-icon-template]');
            this.querySelectorAll('.main-product-compare-sticky-top-v2__content-product-item-remove').forEach((btn) => {
              if (removeIconTemplate?.content && btn.childElementCount === 0) {
                btn.appendChild(removeIconTemplate.content.cloneNode(true));
              }
              if (btn.dataset.removeBound === 'true') return;
              btn.dataset.removeBound = 'true';
              btn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                const productId = btn.getAttribute('data-product-id');
                if (!productId || String(productId).startsWith('placeholder')) return;
                if (typeof this.compareMainDom?.removeProduct === 'function') {
                  this.compareMainDom.removeProduct(productId);
                }
              });
            });
          }
          disconnectedCallback() {
            if (this.observerHeader) {
              this.observerHeader.disconnect();
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-product-modal-v2-bottom"] && !Shopify.designMode) return;
  try {
    $(function () {
    // 需要将js代码集成到main-product-modal-v2.js文件中
    if (!customElements.get('main-product-modal-v2-bottom')) {
      customElements.define(
        'main-product-modal-v2-bottom',
        class MainProductModalV2Bottom extends HTMLElement {
          connectedCallback() {
            this.bindQuantityChange();
            this.bindVariantChange();
            this.bindAddToCart();
            this.bindCheckout();
          }

          disconnectedCallback() {
            this.unsubscribeQuantityChange?.();
            this.unsubscribeQuantityChange = null;
            this.unsubscribeVariantChange?.();
            this.unsubscribeVariantChange = null;
          }

          isSameModal(sourceRoot) {
            if (!sourceRoot) return true;
            return this.closest('main-product-modal-v2') === sourceRoot;
          }

          bindVariantChange() {
            if (this.unsubscribeVariantChange || !window.litime?.eventBus) return;

            this.unsubscribeVariantChange = window.litime.eventBus.subscribe(
              'main-product-modal-v2-variant:change',
              (payload) => {
                if (!this.isSameModal(payload?.sourceRoot)) return;
                this.applyVariantChange(payload);
              }
            );
          }

          applyVariantChange(payload) {
            if (!payload?.variantId) return;

            this.setAttribute('data-variant-id', payload.variantId);
            this.setAttribute('data-current-price', payload.displayPrice);
            this.setAttribute('data-compare-price', payload.comparePrice);
            this.setAttribute('data-inventory-policy', payload.inventoryPolicy);

            const rawInventoryQuantity = Number.isFinite(payload.rawInventoryQuantity)
              ? payload.rawInventoryQuantity
              : payload.inventoryQuantity;

            const canPurchase =
              rawInventoryQuantity > 0 || (payload.inventoryPolicy === 'continue' && rawInventoryQuantity <= 0);
            const showNotifyMe = !canPurchase;
            const hideBuyNow = rawInventoryQuantity <= 0 && payload.inventoryPolicy === 'continue';

            const buttonsEl = this.querySelector('.main-product-modal-v2-bottom__buttons');
            if (buttonsEl) {
              buttonsEl.setAttribute('data-show', canPurchase ? 'true' : 'false');
            }

            const notifyEl = this.querySelector('.global-notify-me-trigger');
            if (notifyEl) {
              notifyEl.setAttribute('data-show', showNotifyMe ? 'true' : 'false');
              notifyEl.setAttribute('data-variant', payload.variantId);
            }

            const checkoutAction = this.querySelector('[data-action="checkout"]');
            if (checkoutAction) {
              if (payload.taxExempt) {
                checkoutAction.setAttribute('data-tax-type', 'global');
              } else {
                checkoutAction.removeAttribute('data-tax-type');
              }

              const checkoutBtn = this.getButtonEl(checkoutAction);
              const textEl = checkoutBtn?.querySelector('.global-button-v2__text');
              if (textEl) {
                textEl.textContent = hideBuyNow ? this.dataset.preOrderText : this.dataset.buyNowText;
              }
            }

            this.updatePriceDisplay();
          }

          bindQuantityChange() {
            if (this.unsubscribeQuantityChange || !window.litime?.eventBus) return;

            this.unsubscribeQuantityChange = window.litime.eventBus.subscribe(
              'main-product-modal-v2-quantity:change',
              ({ quantity }) => {
                if (!Number.isFinite(quantity) || quantity <= 0) return;
                this.setAttribute('data-quantity', quantity);
                // this.updatePriceDisplay();
              }
            );
          }

          getUnitPrice() {
            const price = parseInt(this.getAttribute('data-current-price'), 10);
            return Number.isFinite(price) ? price : 0;
          }

          getUnitComparePrice() {
            const price = parseInt(this.getAttribute('data-compare-price'), 10);
            return Number.isFinite(price) ? price : 0;
          }

          updatePriceDisplay() {
            const quantity = this.getQuantity();
            const totalPrice = this.getUnitPrice() * quantity;
            const totalComparePrice = this.getUnitComparePrice() * quantity;
            const moneyFormat = window.shopMoneyFormat;

            if (!window.Shopify?.formatMoney) return;

            const priceCurrentEl = this.querySelector('.main-product-modal-v2-bottom__price-current');
            if (priceCurrentEl) {
              priceCurrentEl.innerHTML = window.Shopify.formatMoney(totalPrice, moneyFormat);
            }

            const showCompare = totalComparePrice > totalPrice && totalComparePrice > 0;
            const priceCompareEl = this.querySelector('.main-product-modal-v2-bottom__price-compare');
            if (priceCompareEl) {
              priceCompareEl.setAttribute('data-show', showCompare ? 'true' : 'false');
              if (showCompare) {
                priceCompareEl.innerHTML = window.Shopify.formatMoney(totalComparePrice, moneyFormat);
              }
            }

            const priceDiscountEl = this.querySelector('.main-product-modal-v2-bottom__price-discount');
            if (priceDiscountEl) {
              priceDiscountEl.setAttribute('data-show', showCompare ? 'true' : 'false');
            }

            const globalDiscountEl = this.querySelector(
              '.main-product-modal-v2-bottom__price-discount global-discount'
            );
            if (globalDiscountEl && showCompare) {
              globalDiscountEl.setAttribute(
                'data-total',
                JSON.stringify({
                  price: totalPrice,
                  compare_price: totalComparePrice,
                })
              );
            }
          }

          getVariantId() {
            return this.getAttribute('data-variant-id');
          }

          getQuantity() {
            const quantity = parseInt(this.getAttribute('data-quantity'), 10);
            return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
          }

          getCartItems() {
            const variantId = parseInt(this.getVariantId(), 10);
            if (!Number.isFinite(variantId)) return [];

            return [{ id: variantId, quantity: this.getQuantity() }];
          }

          getCheckoutUrl() {
            const variantId = parseInt(this.getVariantId(), 10);
            if (!Number.isFinite(variantId)) return '/cart';

            return `/cart/${variantId}:${this.getQuantity()}`;
          }

          getButtonEl(actionEl) {
            return actionEl.querySelector('.global-button-v2');
          }

          setButtonLoading(buttonEl, loading) {
            if (!buttonEl) return;
            buttonEl.setAttribute('data-loading', loading ? 'true' : 'false');
          }

          bindAddToCart() {
            const actionEl = this.querySelector('[data-action="add-to-cart"]');
            if (!actionEl || actionEl.dataset.bound === 'true') return;

            actionEl.dataset.bound = 'true';
            actionEl.addEventListener('click', async (e) => {
              e.preventDefault();
              e.stopPropagation();

              const buttonEl = this.getButtonEl(actionEl);
              if (buttonEl?.getAttribute('data-loading') === 'true') return;

              const variantId = this.getVariantId();
              if (!variantId) return;

              const cartItems = this.getCartItems();
              if (!cartItems.length) return;

              try {
                this.setButtonLoading(buttonEl, true);
                await window.litime.addCart(cartItems);
                window.litime?.eventBus?.publish('main-product-modal-v2:add-to-cart-success', {
                  sourceRoot: this.closest('main-product-modal-v2'),
                });
              } catch (error) {
                console.error('[main-product-modal-v2-bottom] add to cart error:', error);
              } finally {
                this.setButtonLoading(buttonEl, false);
              }
            });
          }

          bindCheckout() {
            const actionEl = this.querySelector('[data-action="checkout"]');
            if (!actionEl || actionEl.dataset.bound === 'true') return;

            actionEl.dataset.bound = 'true';
            actionEl.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();

              const buttonEl = this.getButtonEl(actionEl);
              if (buttonEl?.getAttribute('data-loading') === 'true') return;

              const variantId = this.getVariantId();
              if (!variantId) return;

              this.setButtonLoading(buttonEl, true);
              window.location.href = this.getCheckoutUrl();
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-product-modal-v2-coupon"] && !Shopify.designMode) return;
  try {
    // 需要将js代码集成到main-product-modal-v2.js文件中
  $(function () {
    if (!customElements.get('main-product-modal-v2-coupon')) {
      customElements.define(
        'main-product-modal-v2-coupon',
        class MainProductV2Coupon extends HTMLElement {
          connectedCallback() {
            this._timer = null;
            this._expiryNotified = false;
            this._runCountdown();
            this.bindVariantChange();
          }

          disconnectedCallback() {
            if (this._timer) {
              clearInterval(this._timer);
              this._timer = null;
            }
            this.unsubscribeVariantChange?.();
            this.unsubscribeVariantChange = null;
          }

          isSameModal(sourceRoot) {
            if (!sourceRoot) return true;
            return this.closest('main-product-modal-v2') === sourceRoot;
          }

          bindVariantChange() {
            if (this.unsubscribeVariantChange || !window.litime?.eventBus) return;

            this.unsubscribeVariantChange = window.litime.eventBus.subscribe(
              'main-product-modal-v2-variant:change',
              (payload) => {
                if (!this.isSameModal(payload?.sourceRoot)) return;
                this.applyVariantChange(payload);
              }
            );
          }

          applyVariantChange(payload) {
            this._expiryNotified = false;
            const showCoupon = Boolean(payload.couponTitle);
            this.dataset.show = showCoupon ? 'true' : 'false';

            const titleEl = this.querySelector('.main-product-modal-v2-coupon__title');
            if (titleEl) {
              titleEl.textContent = payload.couponTitle || '';
            }

            const countdownEl = this.querySelector('[data-ref="countdown"]');
            const timeEl = this.querySelector('.time[data-time]');

            if (timeEl) {
              timeEl.dataset.time = payload.couponEndAt || '';
            }

            if (this._timer) {
              clearInterval(this._timer);
              this._timer = null;
            }

            if (showCoupon && payload.couponEndAt) {
              this._runCountdown();
            } else if (countdownEl) {
              countdownEl.dataset.show = 'false';
            }
          }

          _runCountdown() {
            const timeEl = this.querySelector('.time[data-time]');
            const countdownEl = this.querySelector('[data-ref="countdown"]');
            if (!timeEl) return;

            const endRaw = timeEl.dataset.time;

            if (!endRaw) {
              if (countdownEl) countdownEl.dataset.show = 'false';
              if (this._timer) {
                clearInterval(this._timer);
                this._timer = null;
              }
              return;
            }

            let endTime = parseInt(endRaw, 10);
            if (endTime < 10000000000) endTime *= 1000;

            const diff = endTime - Date.now();

            if (diff <= 0) {
              this._hideComponent(countdownEl);
              return;
            }

            if (countdownEl) countdownEl.dataset.show = 'true';
            this._renderTime(diff, timeEl);

            if (!this._timer) {
              this._timer = setInterval(() => this._runCountdown(), 1000);
            }
          }

          _renderTime(diff, timeEl) {
            const days = Math.floor(diff / 86400000);
            const hours = Math.floor((diff % 86400000) / 3600000);
            const minutes = Math.floor((diff % 3600000) / 60000);
            const seconds = Math.floor((diff % 60000) / 1000);
            const pad = (n) => String(n).padStart(2, '0');

            const setText = (sel, val) => {
              const el = timeEl.querySelector(sel);
              if (el) el.textContent = val;
            };
            setText('.days', pad(days));
            setText('.hrs', pad(hours));
            setText('.min', pad(minutes));
            setText('.sec', pad(seconds));
          }

          _hideComponent(countdownEl) {
            if (countdownEl) countdownEl.dataset.show = 'false';
            this.dataset.show = 'false';
            if (this._timer) {
              clearInterval(this._timer);
              this._timer = null;
            }
            this._notifyExpiry();
          }

          _notifyExpiry() {
            if (this._expiryNotified) return;
            this._expiryNotified = true;
            window.litime?.eventBus?.publish('main-product-modal-v2-coupon:expired');
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-product-modal-v2-image"] && !Shopify.designMode) return;
  try {
    $(function () {
    // 需要将js代码集成到main-product-modal-v2.js文件中
    if (!customElements.get('main-product-modal-v2-image')) {
      customElements.define(
        'main-product-modal-v2-image',
        class MainProductModalV2Image extends HTMLElement {
          connectedCallback() {
            this.galleryEl = this.querySelector('.main-product-modal-v2-image');
            this.bindVariantChange();
            this.syncInitialImage();
          }

          disconnectedCallback() {
            this.unsubscribeVariantChange?.();
            this.unsubscribeVariantChange = null;
          }

          isSameModal(sourceRoot) {
            if (!sourceRoot) return true;
            return this.closest('main-product-modal-v2') === sourceRoot;
          }

          bindVariantChange() {
            if (this.unsubscribeVariantChange || !window.litime?.eventBus) return;

            this.unsubscribeVariantChange = window.litime.eventBus.subscribe(
              'main-product-modal-v2-variant:change',
              (payload) => {
                if (!this.isSameModal(payload?.sourceRoot)) return;
                this.goToImage(payload.featuredImagePosition);
              }
            );
          }

          syncInitialImage() {
            const modal = this.closest('main-product-modal-v2');
            const activeItem = modal?.querySelector('.main-product-modal-v2-multiattribute__item[data-active="true"]');
            if (!activeItem) return;

            const position = parseInt(activeItem.dataset.featuredImagePosition, 10) || 1;
            this.goToImage(position, false);
          }

          goToImage(position, smooth = true) {
            if (!this.galleryEl || !Number.isFinite(position) || position <= 0) return;

            const target = this.querySelector(`.main-product-modal-v2-image__item[data-image-position="${position}"]`);
            if (!target) return;

            const isHorizontal = window.matchMedia('(max-width: 768px)').matches;
            const behavior = smooth ? 'smooth' : 'auto';
            const containerRect = this.galleryEl.getBoundingClientRect();
            const targetRect = target.getBoundingClientRect();

            if (isHorizontal) {
              this.galleryEl.scrollTo({
                left: this.galleryEl.scrollLeft + (targetRect.left - containerRect.left),
                behavior,
              });
              return;
            }

            this.galleryEl.scrollTo({
              top: this.galleryEl.scrollTop + (targetRect.top - containerRect.top),
              behavior,
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-product-modal-v2-info"] && !Shopify.designMode) return;
  try {
    $(function () {
    // 需要将js代码集成到main-product-modal-v2.js文件中
    if (!customElements.get('main-product-modal-v2-info')) {
      customElements.define(
        'main-product-modal-v2-info',
        class MainProductModalV2Info extends HTMLElement {
          connectedCallback() {
            this.richEl = this.querySelector('.main-product-modal-v2-info__rich');
            this.moreBtn = this.querySelector('.main-product-modal-v2-info__rich-content-more');
            this.moreTextEl = this.querySelector('.main-product-modal-v2-info__rich-content-more-text');

            if (!this.richEl || !this.moreBtn) return;

            this.moreText = this.dataset.moreText || 'Show more';
            this.lessText = this.dataset.lessText || 'Show less';

            this.onToggleClick = this.onToggleClick.bind(this);
            this.onTransitionEnd = this.onTransitionEnd.bind(this);

            this.initCollapse();
            this.moreBtn.addEventListener('click', this.onToggleClick);
            this.richEl.addEventListener('transitionend', this.onTransitionEnd);
          }

          disconnectedCallback() {
            this.moreBtn?.removeEventListener('click', this.onToggleClick);
            this.richEl?.removeEventListener('transitionend', this.onTransitionEnd);
          }

          getCollapsedHeight() {
            const style = getComputedStyle(this.richEl);
            const collapsedHeight = parseInt(style.getPropertyValue('--rich-collapsed-height'), 10);
            return collapsedHeight || parseInt(style.height, 10) || 42;
          }

          initCollapse() {
            const collapsedHeight = this.getCollapsedHeight();

            this.richEl.style.height = 'auto';
            this.fullHeight = this.richEl.scrollHeight;
            this.richEl.style.height = `${collapsedHeight}px`;

            if (this.fullHeight <= collapsedHeight) {
              this.moreBtn.hidden = true;
              this.richEl.style.height = 'auto';
              this.richEl.style.overflow = 'visible';
            }
          }

          onToggleClick() {
            if (this.moreBtn.getAttribute('aria-expanded') === 'true') {
              this.collapse();
            } else {
              this.expand();
            }
          }

          expand() {
            const collapsedHeight = this.getCollapsedHeight();

            this.richEl.style.height = `${collapsedHeight}px`;
            this.richEl.offsetHeight;
            requestAnimationFrame(() => {
              this.richEl.style.height = `${this.fullHeight}px`;
            });

            this.moreBtn.setAttribute('aria-expanded', 'true');
            if (this.moreTextEl) this.moreTextEl.textContent = this.lessText;
          }

          collapse() {
            if (this.richEl.style.height === 'auto') {
              this.fullHeight = this.richEl.scrollHeight;
              this.richEl.style.height = `${this.fullHeight}px`;
            }

            this.richEl.offsetHeight;
            requestAnimationFrame(() => {
              this.richEl.style.height = `${this.getCollapsedHeight()}px`;
            });

            this.moreBtn.setAttribute('aria-expanded', 'false');
            if (this.moreTextEl) this.moreTextEl.textContent = this.moreText;
          }

          onTransitionEnd(event) {
            if (event.propertyName !== 'height' || this.moreBtn.getAttribute('aria-expanded') !== 'true') return;
            this.richEl.style.height = 'auto';
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-product-modal-v2-multiattribute"] && !Shopify.designMode) return;
  try {
    $(function () {
    // 需要将js代码集成到main-product-modal-v2.js文件中
    if (!customElements.get('main-product-modal-v2-multiattribute')) {
      customElements.define(
        'main-product-modal-v2-multiattribute',
        class MainProductModalV2Multiattribute extends HTMLElement {
          connectedCallback() {
            this._handleClick = this.handleClick.bind(this);
            this.addEventListener('click', this._handleClick);
            this.bindCouponExpiry();
          }

          disconnectedCallback() {
            this.removeEventListener('click', this._handleClick);
            this.unbindCouponExpiry();
          }

          bindCouponExpiry() {
            if (this.unsubscribeCouponExpiry || !window.litime?.eventBus) return;

            this.unsubscribeCouponExpiry = window.litime.eventBus.subscribe(
              'main-product-modal-v2-coupon:expired',
              () => {
                const activeItem = this.querySelector(
                  '.main-product-modal-v2-multiattribute__item[data-active="true"]'
                );
                if (!activeItem) return;

                const payload = this.getVariantPayloadFromItem(activeItem);
                payload.displayPrice = payload.originalPrice;
                payload.couponEndAt = '';
                payload.couponTitle = '';
                payload.sourceRoot = this.closest('main-product-modal-v2');
                window.litime.eventBus.publish('main-product-modal-v2-variant:change', payload);
              }
            );
          }

          unbindCouponExpiry() {
            this.unsubscribeCouponExpiry?.();
            this.unsubscribeCouponExpiry = null;
          }

          handleClick(event) {
            const item = event.target.closest('.main-product-modal-v2-multiattribute__item');
            if (!item || !this.contains(item)) return;
            if (item.getAttribute('data-active') === 'true') return;

            this.switchVariant(item);
          }

          getVariantPayloadFromItem(item) {
            const inventoryQuantity = parseInt(item.dataset.inventoryQuantity, 10) || 0;
            const rawInventoryQuantity = parseInt(item.dataset.rawInventoryQuantity, 10);
            const parsedRawInventoryQuantity = Number.isFinite(rawInventoryQuantity) ? rawInventoryQuantity : 0;

            return {
              variantId: item.dataset.variantId,
              displayPrice: parseInt(item.dataset.price, 10) || 0,
              originalPrice: parseInt(item.dataset.originalPrice, 10) || 0,
              originalComparePrice: parseInt(item.dataset.originalComparePrice, 10) || 0,
              comparePrice: parseInt(item.dataset.comparePrice, 10) || 0,
              couponEndAt: item.dataset.couponEnd || '',
              couponTitle: item.dataset.couponTitle || '',
              inventoryPolicy: item.dataset.inventoryPolicy || 'deny',
              inventoryQuantity,
              rawInventoryQuantity: parsedRawInventoryQuantity,
              taxExempt: item.dataset.taxExempt === 'true',
              stockout: item.dataset.stockout === 'true',
            };
          }

          switchVariant(item) {
            this.querySelectorAll('.main-product-modal-v2-multiattribute__item').forEach((el) => {
              el.setAttribute('data-active', el === item ? 'true' : 'false');
            });

            const payload = this.getVariantPayloadFromItem(item);
            payload.sourceRoot = this.closest('main-product-modal-v2');
            window.litime?.eventBus?.publish('main-product-modal-v2-variant:change', payload);
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-product-modal-v2-price"] && !Shopify.designMode) return;
  try {
    // 需要将js代码集成到main-product-modal-v2.js文件中
  $(function () {
    if (!customElements.get('main-product-modal-v2-price')) {
      customElements.define(
        'main-product-modal-v2-price',
        class MainProductModalV2Price extends HTMLElement {
          connectedCallback() {
            this.bindVariantChange();
          }

          disconnectedCallback() {
            this.unsubscribeVariantChange?.();
            this.unsubscribeVariantChange = null;
          }

          isSameModal(sourceRoot) {
            if (!sourceRoot) return true;
            return this.closest('main-product-modal-v2') === sourceRoot;
          }

          bindVariantChange() {
            if (this.unsubscribeVariantChange || !window.litime?.eventBus) return;

            this.unsubscribeVariantChange = window.litime.eventBus.subscribe(
              'main-product-modal-v2-variant:change',
              (payload) => {
                if (!this.isSameModal(payload?.sourceRoot)) return;
                this.applyVariantChange(payload);
              }
            );
          }

          applyVariantChange(payload) {
            if (!payload?.variantId || !window.Shopify?.formatMoney) return;

            const currentPrice = payload.originalPrice;
            const comparePrice = payload.originalComparePrice;

            const container = this.querySelector('.main-product-modal-v2-price__container');
            if (container) {
              container.dataset.currentPrice = currentPrice;
              container.dataset.comparePrice = comparePrice;
            }

            const moneyFormat = window.shopMoneyFormat;
            const showCompare = comparePrice > currentPrice && comparePrice > 0;

            const currentEl = this.querySelector('.main-product-modal-v2-price__current');
            if (currentEl) {
              currentEl.innerHTML = window.Shopify.formatMoney(currentPrice, moneyFormat);
            }

            const compareEl = this.querySelector('.main-product-modal-v2-price__compare');
            if (compareEl) {
              compareEl.setAttribute('data-show', showCompare ? 'true' : 'false');
              if (showCompare) {
                compareEl.innerHTML = window.Shopify.formatMoney(comparePrice, moneyFormat);
              }
            }

            const discountEl = this.querySelector('.main-product-modal-v2-price__discount');
            if (discountEl) {
              discountEl.setAttribute('data-show', showCompare ? 'true' : 'false');
            }

            const globalDiscountEl = this.querySelector('.main-product-modal-v2-price__discount global-discount');
            if (globalDiscountEl && showCompare) {
              globalDiscountEl.setAttribute(
                'data-total',
                JSON.stringify({
                  price: currentPrice,
                  compare_price: comparePrice,
                })
              );
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-product-modal-v2-quantity"] && !Shopify.designMode) return;
  try {
    $(function () {
    // 需要将js代码集成到main-product-modal-v2.js文件中
    if (!customElements.get('main-product-modal-v2-quantity')) {
      customElements.define(
        'main-product-modal-v2-quantity',
        class MainProductV2Quantity extends HTMLElement {
          connectedCallback() {
            this.inputRoot = this.querySelector('.global-number-input-v2');
            this.input = this.querySelector('[data-action="input"]');
            this.minusBtn = this.querySelector('[data-action="minus"]');
            this.plusBtn = this.querySelector('[data-action="plus"]');

            if (!this.inputRoot || !this.input) return;

            this.bindMinus();
            this.bindPlus();
            this.bindInput();
            this.bindVariantChange();
            this.setQuantity(this.parseQuantity(this.input.value));
          }

          disconnectedCallback() {
            this.unsubscribeVariantChange?.();
            this.unsubscribeVariantChange = null;
          }

          isSameModal(sourceRoot) {
            if (!sourceRoot) return true;
            return this.closest('main-product-modal-v2') === sourceRoot;
          }

          bindVariantChange() {
            if (this.unsubscribeVariantChange || !window.litime?.eventBus) return;

            this.unsubscribeVariantChange = window.litime.eventBus.subscribe(
              'main-product-modal-v2-variant:change',
              (payload) => {
                if (!this.isSameModal(payload?.sourceRoot)) return;
                this.applyVariantChange(payload);
              }
            );
          }

          applyVariantChange(payload) {
            let max = 999;

            if (payload.inventoryPolicy === 'deny') {
              if (payload.inventoryQuantity > 0) {
                max = Math.min(payload.inventoryQuantity, 999);
              } else {
                max = 1;
              }
            }

            this.setAttribute('data-max', max);
            this.setQuantity(1);
          }

          getMin() {
            const min = parseInt(this.getAttribute('data-min'), 10);
            return Number.isFinite(min) && min > 0 ? min : 1;
          }

          getMax() {
            const max = parseInt(this.getAttribute('data-max'), 10);
            return Number.isFinite(max) && max > 0 ? max : 999;
          }

          parseQuantity(value) {
            const quantity = parseInt(String(value).replace(/[^\d]/g, ''), 10);
            return Number.isFinite(quantity) ? quantity : this.getMin();
          }

          clampQuantity(value) {
            return Math.min(Math.max(value, this.getMin()), this.getMax());
          }

          updateDisabledState(value) {
            this.inputRoot.setAttribute('data-minus-disabled', value <= this.getMin() ? 'true' : 'false');
            this.inputRoot.setAttribute('data-plus-disabled', value >= this.getMax() ? 'true' : 'false');
          }

          setQuantity(value) {
            const next = this.clampQuantity(value);
            this.input.value = String(next);
            this.updateDisabledState(next);
            this.syncQuantity(next);
            return next;
          }

          syncQuantity(quantity) {
            this.setAttribute('data-value', quantity);
            window.litime?.eventBus?.publish('main-product-modal-v2-quantity:change', { quantity });
          }

          bindMinus() {
            if (!this.minusBtn || this.minusBtn.dataset.bound === 'true') return;

            this.minusBtn.dataset.bound = 'true';
            this.minusBtn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();

              if (this.inputRoot.getAttribute('data-minus-disabled') === 'true') return;

              this.setQuantity(this.parseQuantity(this.input.value) - 1);
            });
          }

          bindPlus() {
            if (!this.plusBtn || this.plusBtn.dataset.bound === 'true') return;

            this.plusBtn.dataset.bound = 'true';
            this.plusBtn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();

              if (this.inputRoot.getAttribute('data-plus-disabled') === 'true') return;

              this.setQuantity(this.parseQuantity(this.input.value) + 1);
            });
          }

          bindInput() {
            if (!this.input || this.input.dataset.bound === 'true') return;

            this.input.dataset.bound = 'true';

            this.input.addEventListener('input', () => {
              const sanitized = this.input.value.replace(/[^\d]/g, '');
              const max = this.getMax();

              if (sanitized === '') {
                this.input.value = '';
                return;
              }

              const next = parseInt(sanitized, 10);
              this.input.value = String(next > max ? max : next);
              this.updateDisabledState(this.parseQuantity(this.input.value));
            });

            this.input.addEventListener('blur', () => {
              if (this.input.value === '') {
                this.setQuantity(this.getMin());
                return;
              }

              this.setQuantity(this.parseQuantity(this.input.value));
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-product-v2-bar"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('main-product-v2-bar')) {
      customElements.define(
        'main-product-v2-bar',
        class MainProductV2Bar extends HTMLElement {
          connectedCallback() {
            this.bindQuantityChange();
            this.bindRecommendProductChange();
            this.bindBuyPanelVisibility();
            this.bindAddToCart();
            this.bindCheckout();
          }

          disconnectedCallback() {
            if (this.unsubscribeQuantityChange) {
              this.unsubscribeQuantityChange();
              this.unsubscribeQuantityChange = null;
            }
            if (this.unsubscribeRecommendChange) {
              this.unsubscribeRecommendChange();
              this.unsubscribeRecommendChange = null;
            }
            this.unbindBuyPanelVisibility();
          }

          bindBuyPanelVisibility() {
            this.unbindBuyPanelVisibility();

            const syncBarVisibility = (entries) => {
              const buyPanel = document.querySelector('main-product-v2-buy-panel');
              if (!buyPanel?.isConnected) {
                this.setAttribute('data-show', 'true');
                return;
              }

              let isIntersecting = false;
              if (entries?.[0]) {
                isIntersecting = entries[0].isIntersecting;
              } else {
                isIntersecting = window.litime.isRectIntersectingViewport(buyPanel.getBoundingClientRect());
              }

              this.setAttribute('data-show', isIntersecting ? 'false' : 'true');
            };

            this._syncBarVisibility = syncBarVisibility;
            this._onViewportChange = () => syncBarVisibility();

            const buyPanel = document.querySelector('main-product-v2-buy-panel');
            if (!buyPanel) {
              this.setAttribute('data-show', 'true');
              return;
            }

            this.buyPanelObserver = new IntersectionObserver(syncBarVisibility, {
              threshold: [0, 1],
            });

            requestAnimationFrame(() => {
              requestAnimationFrame(() => {
                if (!this.buyPanelObserver) return;
                this.buyPanelObserver.observe(buyPanel);
                syncBarVisibility();
              });
            });

            window.visualViewport?.addEventListener('resize', this._onViewportChange);
            window.visualViewport?.addEventListener('scroll', this._onViewportChange);
          }

          unbindBuyPanelVisibility() {
            if (this.buyPanelObserver) {
              this.buyPanelObserver.disconnect();
              this.buyPanelObserver = null;
            }

            if (this._onViewportChange) {
              window.visualViewport?.removeEventListener('resize', this._onViewportChange);
              window.visualViewport?.removeEventListener('scroll', this._onViewportChange);
              this._onViewportChange = null;
            }

            this._syncBarVisibility = null;
          }

          bindQuantityChange() {
            if (this.unsubscribeQuantityChange || !window.litime?.eventBus) return;

            this.unsubscribeQuantityChange = window.litime.eventBus.subscribe(
              'main-product-v2-quantity:change',
              ({ quantity }) => {
                if (!Number.isFinite(quantity) || quantity <= 0) return;
                this.setAttribute('data-quantity', quantity);
                this.updatePriceDisplay();
              }
            );
          }

          bindRecommendProductChange() {
            if (this.unsubscribeRecommendChange || !window.litime?.eventBus) return;

            this.selectedRecommendProducts = window.litime.mainProductV2RecommendSelectedProducts || [];
            this.unsubscribeRecommendChange = window.litime.eventBus.subscribe(
              'main-product-v2-recommend-product:change',
              ({ selectedProducts }) => {
                this.selectedRecommendProducts = Array.isArray(selectedProducts) ? selectedProducts : [];
                window.litime.mainProductV2RecommendSelectedProducts = this.selectedRecommendProducts;
                this.updatePriceDisplay();
              }
            );
          }

          getRecommendTotals() {
            let price = 0;
            let compare = 0;

            for (const item of this.selectedRecommendProducts || []) {
              const qty = item.quantity || 1;
              const unitPrice = item.price || 0;
              const unitCompare = item.comparePrice || 0;

              price += unitPrice * qty;
              if (unitCompare > unitPrice && unitCompare > 0) {
                compare += unitCompare * qty;
              } else {
                compare += unitPrice * qty;
              }
            }

            return { price, compare };
          }

          getUnitPrice() {
            const price = parseInt(this.getAttribute('data-current-price'), 10);
            return Number.isFinite(price) ? price : 0;
          }

          getUnitComparePrice() {
            const price = parseInt(this.getAttribute('data-compare-price'), 10);
            return Number.isFinite(price) ? price : 0;
          }

          updatePriceDisplay() {
            const quantity = this.getQuantity();
            const unitPrice = this.getUnitPrice();
            const unitComparePrice = this.getUnitComparePrice();
            const recommendTotals = this.getRecommendTotals();
            const totalPrice = unitPrice * quantity + recommendTotals.price;
            const totalComparePrice = unitComparePrice * quantity + recommendTotals.compare;
            const moneyFormat = window.shopMoneyFormat;

            if (!window.Shopify?.formatMoney) return;

            const priceNewEl = this.querySelector('.main-product-v2-bar__price-new');
            if (priceNewEl) {
              priceNewEl.innerHTML = window.Shopify.formatMoney(totalPrice, moneyFormat);
            }

            const priceOldEl = this.querySelector('.main-product-v2-bar__price-old');
            const showCompare = totalComparePrice > totalPrice && totalComparePrice > 0;
            if (priceOldEl) {
              priceOldEl.setAttribute('data-show', showCompare ? 'true' : 'false');
              if (showCompare) {
                priceOldEl.innerHTML = window.Shopify.formatMoney(totalComparePrice, moneyFormat);
              }
            }

            const priceDiscountEl = this.querySelector('.main-product-v2-bar__price-discount');
            if (priceDiscountEl) {
              priceDiscountEl.setAttribute('data-show', showCompare ? 'true' : 'false');
            }

            const globalDiscountEl = this.querySelector('.main-product-v2-bar__price-discount global-discount');
            if (globalDiscountEl && totalComparePrice > totalPrice) {
              globalDiscountEl.setAttribute(
                'data-total',
                JSON.stringify({
                  price: totalPrice,
                  compare_price: totalComparePrice,
                })
              );
            }
          }

          getVariantId() {
            return this.getAttribute('data-variant-id');
          }

          getQuantity() {
            const quantity = parseInt(this.getAttribute('data-quantity'), 10);
            return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
          }

          getCartItems() {
            const variantId = parseInt(this.getVariantId(), 10);
            if (!Number.isFinite(variantId)) return [];

            const items = [
              {
                id: variantId,
                quantity: this.getQuantity(),
              },
            ];

            for (const product of this.selectedRecommendProducts || []) {
              const id = parseInt(product.variantId, 10);
              const quantity = parseInt(product.quantity, 10) || 1;
              if (Number.isFinite(id) && id > 0) {
                items.push({ id, quantity });
              }
            }

            return items;
          }

          getCheckoutUrl() {
            const variantId = parseInt(this.getVariantId(), 10);
            if (!Number.isFinite(variantId)) return '/cart';

            const segments = [
              `${variantId}:${this.getQuantity()}`,
              ...(this.selectedRecommendProducts || []).map((product) => {
                const id = parseInt(product.variantId, 10);
                const quantity = parseInt(product.quantity, 10) || 1;
                if (!Number.isFinite(id) || id <= 0) return null;
                return `${id}:${quantity}`;
              }),
            ].filter(Boolean);

            return `/cart/${segments.join(',')}`;
          }

          getButtonEl(actionEl) {
            return actionEl.querySelector('.global-button-v2');
          }

          setButtonLoading(buttonEl, loading) {
            if (!buttonEl) return;
            buttonEl.setAttribute('data-loading', loading ? 'true' : 'false');
          }

          bindAddToCart() {
            const actionEl = this.querySelector('[data-action="add-to-cart"]');
            if (!actionEl || actionEl.dataset.bound === 'true') return;

            actionEl.dataset.bound = 'true';
            actionEl.addEventListener('click', async (e) => {
              e.preventDefault();
              e.stopPropagation();

              const buttonEl = this.getButtonEl(actionEl);
              if (buttonEl?.getAttribute('data-loading') === 'true') return;

              const variantId = this.getVariantId();
              if (!variantId) return;

              const cartItems = this.getCartItems();
              if (!cartItems.length) return;

              try {
                this.setButtonLoading(buttonEl, true);
                await window.litime.addCart(cartItems);
              } catch (error) {
                console.error('[main-product-v2-bar] add to cart error:', error);
              } finally {
                this.setButtonLoading(buttonEl, false);
              }
            });
          }

          bindCheckout() {
            const actionEl = this.querySelector('[data-action="checkout"]');
            if (!actionEl || actionEl.dataset.bound === 'true') return;

            actionEl.dataset.bound = 'true';
            actionEl.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();

              const buttonEl = this.getButtonEl(actionEl);
              if (buttonEl?.getAttribute('data-loading') === 'true') return;

              const variantId = this.getVariantId();
              if (!variantId) return;

              this.setButtonLoading(buttonEl, true);
              window.location.href = this.getCheckoutUrl();
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-product-v2-gallery"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (customElements.get('main-product-v2-gallery')) return;

    const HIDDEN = 'main-product-v2-gallery__hidden';
    const MODEL_SOFT_HIDDEN = 'main-product-v2-gallery__model-soft-hidden';
    const TAB_ACTIVE = 'main-product-v2-gallery__tab--active';

    customElements.define(
      'main-product-v2-gallery',
      class MainProductV2Gallery extends HTMLElement {
        connectedCallback() {
          this.imageSwiperEl = this.querySelector('[data-ref="image-swiper"]');
          if (!this.imageSwiperEl) return;

          this.imageStage = this.querySelector('[data-panel="image"]');
          this.thumbsEl = this.querySelector('[data-ref="thumbs"]');
          this.thumbsSwiperEl = this.querySelector('[data-ref="thumbs-swiper"]');
          this.videoSwiperEl = this.querySelector('[data-ref="video-swiper"]');
          this.modelPanelEl = this.querySelector('[data-panel="model"]');
          this.panels = this.querySelectorAll('[data-panel]');
          this.tabsEl = this.querySelector('[data-ref="tabs"]');

          this._activeTab = 'image';
          this._modelVisited = false;
          this._modelInterrupted = false;

          this.autoplayEnabled = this.dataset.autoplay === 'true';
          const interval = Number(this.dataset.autoplayInterval);
          this.autoplayIntervalMs = Number.isFinite(interval) && interval > 0 ? interval * 1000 : 5000;
          this.initialSlide = Math.max(0, parseInt(this.dataset.initialSlide, 10) || 0);

          this.initThumbs();
          this.initImageSwiper();
          this.initVideoSwiper();
          this.bindTabs();
          this.bindZoom();
        }

        disconnectedCallback() {
          this.imageSwiper?.destroy(true, true);
          this.videoSwiper?.destroy(true, true);
          this.thumbsSwiper?.destroy(true, true);
          clearTimeout(this._thumbsResizeTimer);
        }

        initImageSwiper() {
          this.imageSwiper = new Swiper(this.imageSwiperEl, {
            initialSlide: this.initialSlide,
            spaceBetween: 10,
            autoplay: this.autoplayEnabled ? { delay: this.autoplayIntervalMs, disableOnInteraction: false } : false,
            navigation: {
              nextEl: this.imageSwiperEl.querySelector('.swiper-button-next'),
              prevEl: this.imageSwiperEl.querySelector('.swiper-button-prev'),
            },
            watchOverflow: true,
            observer: true,
            observeParents: true,
            speed: 300,
            on: {
              slideChange: () => this.onMainSlideChange(),
            },
          });

          this.updateThumbActive();
        }

        // The thumbnail strip IS a Swiper, laid out at full thumbnail size; CSS
        // scales it down to dots at rest. At rest the row is group-centered so
        // the dots stay symmetric; on hover it can be dragged (the dots only
        // receive pointer events while the stage is hovered), and navigating
        // re-centers the active thumbnail so later thumbnails are revealed.
        initThumbs() {
          if (!this.thumbsSwiperEl) return;

          this._thumbsHovering = false;

          this.thumbsSwiper = new Swiper(this.thumbsSwiperEl, {
            slidesPerView: 'auto',
            spaceBetween: 12,
            freeMode: true,
            grabCursor: true,
            watchSlidesProgress: true,
            on: {
              resize: () => {
                clearTimeout(this._thumbsResizeTimer);
                this._thumbsResizeTimer = setTimeout(() => this.layoutThumbs(0), 150);
              },
            },
          });

          this.thumbsSwiper.on('click', (swiper) => {
            const index = swiper.clickedIndex;
            if (index == null || index < 0 || !this.imageSwiper) return;

            this.imageSwiper.slideTo(index);
          });

          if (this.imageStage) {
            // The dot <-> thumbnail morph is a pure CSS scale around the active
            // thumbnail (see layoutThumbs), so entering/leaving needs no JS: the
            // active stays put and only the surrounding items zoom. We only flag
            // the hover state and, on leave, snap a freely-dragged strip back to
            // its canonical (symmetric) layout.
            this.imageStage.addEventListener('mouseenter', () => {
              this._thumbsHovering = true;
            });
            this.imageStage.addEventListener('mouseleave', () => {
              this._thumbsHovering = false;
              this.layoutThumbs(300);
            });
          }

          this.layoutThumbs(0);
        }

        onMainSlideChange() {
          this.updateThumbActive();
          // While hovering, scrolling to the new active reveals the thumbnails
          // after it; at rest this only re-anchors the scale pivot (no motion).
          this.layoutThumbs(this._thumbsHovering ? 300 : 0);
        }

        updateThumbActive() {
          if (!this.thumbsSwiper) return;

          const active = this.imageSwiper ? this.imageSwiper.activeIndex : this.initialSlide;
          this.thumbsSwiper.slides.forEach((slide, i) => {
            slide.classList.toggle('swiper-slide-thumb-active', i === active);
          });
        }

        // Position the strip so that:
        //   - at rest the dots are symmetric (the row is centred in the viewport);
        //   - the CSS scale pivots exactly on the active thumbnail, so growing to
        //     thumbnails / shrinking to dots keeps the active item perfectly
        //     still (no pan on hover-enter or mouse-leave);
        //   - the active thumbnail is always inside the visible window on hover.
        // It pairs a wrapper translate (T) with a transform-origin (O = the active
        // thumbnail's centre) derived from the resting scale.
        layoutThumbs(speed = 0) {
          const swiper = this.thumbsSwiper;
          if (!swiper?.slidesGrid) return;

          const index = this.imageSwiper ? this.imageSwiper.activeIndex : this.initialSlide;
          if (swiper.slidesGrid[index] == null) return;

          const restScale = 0.26667;
          const viewport = swiper.size;
          const rowCenter = swiper.virtualSize / 2;
          let translate;
          let origin;

          if (swiper.virtualSize <= viewport) {
            // Everything fits even at full size: keep it group-centred.
            translate = (viewport - swiper.virtualSize) / 2;
            origin = viewport / 2;
          } else {
            const activeCenter = swiper.slidesGrid[index] + (swiper.slidesSizesGrid[index] || 0) / 2;
            translate = viewport / 2 - activeCenter - (rowCenter - activeCenter) * restScale;
            origin = activeCenter + translate;
          }

          this.thumbsSwiperEl.style.transformOrigin = `${origin}px 100%`;
          swiper.setTransition(speed);
          swiper.setTranslate(translate);
        }

        initVideoSwiper() {
          if (!this.videoSwiperEl?.querySelector('.swiper-slide')) return;

          this.videoSwiper = new Swiper(this.videoSwiperEl, {
            spaceBetween: 10,
            navigation: {
              nextEl: this.videoSwiperEl.querySelector('.swiper-button-next'),
              prevEl: this.videoSwiperEl.querySelector('.swiper-button-prev'),
            },
            on: {
              slideChange: (swiper) => swiper.slides[swiper.activeIndex - 1]?.querySelector('video')?.pause(),
            },
          });
        }

        bindTabs() {
          if (!this.tabsEl) return;

          this.tabsEl.addEventListener('click', (e) => {
            const tab = e.target.closest('.main-product-v2-gallery__tab');
            if (!tab) return;

            this.switchTab(tab.dataset.tab);
          });
        }

        switchTab(activeTab) {
          const prevTab = this._activeTab;
          this._activeTab = activeTab;

          if (prevTab === 'model' && activeTab !== 'model') {
            this.onModelTabLeave();
          }

          if (this.tabsEl) {
            this.tabsEl.querySelectorAll('.main-product-v2-gallery__tab').forEach((el) => {
              el.classList.toggle(TAB_ACTIVE, el.dataset.tab === activeTab);
            });
          }

          this.panels.forEach((panel) => {
            const panelType = panel.dataset.panel;

            if (panelType === 'model') {
              this.updateModelPanelVisibility(activeTab === 'model');
              return;
            }

            panel.classList.toggle(HIDDEN, panelType !== activeTab);
          });

          if (activeTab === 'model') {
            this.activateModelViewer();
          }
        }

        updateModelPanelVisibility(isActive) {
          if (!this.modelPanelEl) return;

          if (isActive) {
            this._modelVisited = true;
            this.modelPanelEl.classList.remove(HIDDEN, MODEL_SOFT_HIDDEN);
            return;
          }

          if (this._modelVisited) {
            this.modelPanelEl.classList.remove(HIDDEN);
            this.modelPanelEl.classList.add(MODEL_SOFT_HIDDEN);
            return;
          }

          this.modelPanelEl.classList.add(HIDDEN);
          this.modelPanelEl.classList.remove(MODEL_SOFT_HIDDEN);
        }

        onModelTabLeave() {
          const modelViewer = this.getModelViewer();
          if (modelViewer && !modelViewer.loaded) {
            this._modelInterrupted = true;
          }
        }

        getModelViewer() {
          return this.modelPanelEl?.querySelector('model-viewer') ?? null;
        }

        activateModelViewer() {
          const modelViewer = this.getModelViewer();
          if (!modelViewer) return;

          const syncModelViewer = () => {
            modelViewer.updateFraming?.();

            if (!modelViewer.loaded && this._modelInterrupted) {
              this.reloadModelViewer(modelViewer);
            }

            this._modelInterrupted = false;
          };

          if (modelViewer.loaded) {
            requestAnimationFrame(syncModelViewer);
            return;
          }

          const onLoad = () => {
            modelViewer.removeEventListener('load', onLoad);
            requestAnimationFrame(syncModelViewer);
          };

          modelViewer.addEventListener('load', onLoad);
          requestAnimationFrame(syncModelViewer);
        }

        reloadModelViewer(modelViewer) {
          const src = modelViewer.getAttribute('src');
          if (!src) return;

          modelViewer.removeAttribute('src');
          requestAnimationFrame(() => modelViewer.setAttribute('src', src));
        }

        bindZoom() {
          this.imageSwiperEl.addEventListener('click', (e) => {
            if (
              !e.target.closest('.swiper-slide img') ||
              e.target.closest('.swiper-button-next, .swiper-button-prev')
            ) {
              return;
            }

            const imageZoom = document.querySelector('product-image-zoom');
            if (!imageZoom) return;

            const images = [...this.imageSwiperEl.querySelectorAll('.swiper-slide img')].map((img, index) => ({
              [`${index + 1}.img`]: img.currentSrc || img.src,
            }));

            imageZoom.setImages(images);
            imageZoom.openPreview(this.imageSwiper.activeIndex);
          });
        }

        goToSlide(index) {
          const slideIndex = Math.max(0, parseInt(index, 10) || 0);
          if (!this.imageSwiper) return;

          this.imageSwiper.slideTo(slideIndex);
        }
      }
    );
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-product-v2-service"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (customElements.get('main-product-v2-service')) return;

    customElements.define(
      'main-product-v2-service',
      class MainProductV2Service extends HTMLElement {
        connectedCallback() {
          this.init();
        }

        init() {
          const items = this.querySelectorAll('.main-product-v2-service__item');
          this.$dialog = $(this).find('dialog-simple');

          items.forEach((item) => {
            if (!item.dataset.desc) {
              item.style.pointerEvents = 'none';
              item.style.cursor = 'default';
            }
          });

          items.forEach((item) => {
            item.addEventListener('click', () => {
              if (!item.dataset.desc) return;
              this.$dialog.attr({
                'data-show': 'true',
                'data-title': item.dataset.title,
                'data-desc': item.dataset.desc,
                'data-button-text': item.dataset.buttonText,
                'data-button-link': item.dataset.buttonLink,
              });
            });
          });
        }
      }
    );
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["marketing-discount"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('marketing-discount')) {
      customElements.define(
        'marketing-discount',
        class globalDiscount extends HTMLElement {
          constructor() {
            super();
            this.shopMoneyFormat = window.shopMoneyFormat;
          }
          static get observedAttributes() {
            return ['data-total', 'data-price', 'data-type'];
          }

          attributeChangedCallback(name, oldValue, newValue) {
            if (oldValue === newValue) return;
            switch (name) {
              case 'data-total':
                this.total = JSON.parse(newValue);
                this.price = parseFloat(this.total.price);
                this.comparePrice = parseFloat(this.total.compare_price);
                this.updatePrice();
                break;
            }
          }
          connectedCallback() {
            this.type = this.getAttribute('data-type');
          }
          updatePrice() {
            let computeShowEl = document.querySelector('.compute-show');

            if (this.price > 0 && this.comparePrice > 0) {
              if (this.type === 'quota') {
                this.discount = this.comparePrice - this.price;
                this.discountFormat = window.Shopify.formatMoney(this.discount, this.shopMoneyFormat);

                // 将折扣值转换为整数后比较
                if (parseInt(this.discount) > 0) {
                  if (computeShowEl) {
                    computeShowEl.classList.remove('hidden');
                  }

                  document.querySelector('.actual_discount-total-container').classList.remove('hidden');
                  document.querySelector('.compute-show .quota-discount').innerHTML = this.discountFormat;
                } else {
                  if (computeShowEl) {
                    computeShowEl.classList.add('hidden');
                  }
                  document.querySelector('.actual_discount-total-container').classList.add('hidden');
                }
              } else if (this.type === 'percentage') {
                this.discount = ((this.comparePrice - this.price) / this.comparePrice) * 100;
                this.discount = Math.floor(this.discount);

                // 将折扣值转换为整数后比较
                if (parseInt(this.discount) > 0) {
                  if (computeShowEl) {
                    computeShowEl.classList.remove('hidden');
                  }
                  document.querySelector('.actual_discount-total-container').classList.remove('hidden');

                  document.querySelector('.compute-show .scale-discount').innerHTML = this.discount;
                } else {
                  if (computeShowEl) {
                    computeShowEl.classList.add('hidden');
                  }
                  document.querySelector('.actual_discount-total-container').classList.add('hidden');
                }
              }
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["marketing-scene-buy-btn"] && !Shopify.designMode) return;
  try {
    class MarketingSceneBuyBtn extends HTMLElement {
    constructor() {
      super();
      this._onBuyClick = this._handleBuyClick.bind(this);
      this._onCartClick = this._handleCartClick.bind(this);
    }

    connectedCallback() {
      this._init();
    }

    disconnectedCallback() {
      this._cleanup();
    }

    _init() {
      const modelDetailsShow = this.getAttribute('data-model-details_show');
      const variantSize = parseInt(this.getAttribute('data-variant-size') || '1', 10);

      // 如果设置了显示模态框并且变体数量 > 1，禁用按钮内的 dynamic-add-to-cart
      if (modelDetailsShow === 'show' && !isNaN(variantSize) && variantSize > 1) {
        const buyDynamicAddToCart = this.querySelector('.btn-buy dynamic-add-to-cart');
        if (buyDynamicAddToCart) {
          buyDynamicAddToCart.style.pointerEvents = 'none';

          // 确保loading图标不会显示
          const loading = buyDynamicAddToCart.querySelector('.rotate_icon');
          if (loading) {
            loading.classList.add('hidden');
            loading.classList.remove('flex');
          }
        }

        const cartDynamicAddToCart = this.querySelector('.btn-cart dynamic-add-to-cart');
        if (cartDynamicAddToCart) {
          cartDynamicAddToCart.style.pointerEvents = 'none';

          // 确保loading图标不会显示
          const loading = cartDynamicAddToCart.querySelector('.rotate_icon');
          if (loading) {
            loading.classList.add('hidden');
            loading.classList.remove('flex');
          }
        }
      }

      const btnBuy = this.querySelector('.btn-buy');
      if (btnBuy) {
        btnBuy.addEventListener('click', this._onBuyClick, true); // 使用捕获阶段
      }

      const btnCart = this.querySelector('.btn-cart');
      if (btnCart) {
        btnCart.addEventListener('click', this._onCartClick, true); // 使用捕获阶段
      }
    }

    _cleanup() {
      const btnBuy = this.querySelector('.btn-buy');
      if (btnBuy) {
        btnBuy.removeEventListener('click', this._onBuyClick, true);
      }

      const btnCart = this.querySelector('.btn-cart');
      if (btnCart) {
        btnCart.removeEventListener('click', this._onCartClick, true);
      }
    }

    _handleBuyClick(e) {
      e.preventDefault();

      const modelDetailsShow = this.getAttribute('data-model-details_show');
      const productHandle = this.getAttribute('data-product-handle');
      const variantSize = parseInt(this.getAttribute('data-variant-size') || '1', 10);

      // Check if should show product detail modal
      // 只有当 modelDetailsShow === 'show' 并且变体数量 > 1 时才打开模态框
      if (modelDetailsShow === 'show' && !isNaN(variantSize) && variantSize > 1 && productHandle) {
        this._openProductDetailModal(productHandle, 'buy');
        return;
      }

      // 如果变体数量大于1但没有设置显示模态框，阻止导航
      if (!isNaN(variantSize) && variantSize > 1) {
        return;
      }

      const variantId = this.getAttribute('data-first-variant-id');
      if (!variantId) return;

      const selector = this.getAttribute('data-quantity-selector');
      const quantityInput = selector ? document.querySelector(selector) : null;
      let quantity = 1;

      if (quantityInput && quantityInput.value) {
        const q = parseInt(quantityInput.value, 10);
        quantity = isNaN(q) || q <= 0 ? 1 : q;
      }

      // 只有当变体数量小于等于1时才显示加载状态
      if (variantSize <= 1) {
        // Show loading state for buy button
        const btnBuy = this.querySelector('.btn-buy');
        const loading = btnBuy ? btnBuy.querySelector('.rotate_icon') : null;
        if (loading) {
          loading.classList.remove('hidden');
          loading.classList.add('flex');
        }

        const textEl = btnBuy ? btnBuy.querySelector('.loading-button-text') : null;
        if (textEl) {
          textEl.classList.add('hidden');
        }
      }

      // Navigate to cart
      window.location.href = '/cart/' + variantId + ':' + quantity;
    }

    _handleCartClick(e) {
      const modelDetailsShow = this.getAttribute('data-model-details_show');
      const productHandle = this.getAttribute('data-product-handle');
      const variantSize = parseInt(this.getAttribute('data-variant-size') || '1', 10);

      // 只有当 modelDetailsShow === 'show' 并且变体数量 > 1 时才打开模态框
      if (modelDetailsShow === 'show' && !isNaN(variantSize) && variantSize > 1 && productHandle) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this._openProductDetailModal(productHandle, 'cart');
        return false;
      }

      // 否则让 dynamic-add-to-cart 组件处理
      // 不阻止事件，让 dynamic-add-to-cart 正常处理
    }

    _openProductDetailModal(productHandle, buttonType = 'buy') {
      const _this = this;
      // 存储按钮类型供后续使用
      this._currentButtonType = buttonType;
      // 禁用浏览器滚动
      window.litime.disableScroll();
      window.litime.showLoading(false);

      // 获取变体数量
      const variantSize = parseInt(this.getAttribute('data-variant-size') || '1', 10);

      // 只有当变体数量小于等于1时才显示加载状态
      if (variantSize <= 1) {
        // Show loading state for the correct button
        let loading, textEl;
        if (buttonType === 'cart') {
          // 对于 cart 按钮，选择 btn-cart 内的元素
          const btnCart = this.querySelector('.btn-cart');
          loading = btnCart ? btnCart.querySelector('.rotate_icon') : null;
          textEl = btnCart ? btnCart.querySelector('.loading-button-text') : null;
        } else {
          // 对于 buy 按钮，选择 btn-buy 内的元素
          const btnBuy = this.querySelector('.btn-buy');
          loading = btnBuy ? btnBuy.querySelector('.rotate_icon') : null;
          textEl = btnBuy ? btnBuy.querySelector('.loading-button-text') : null;
        }

        if (loading) {
          loading.classList.remove('hidden');
          loading.classList.add('flex');
        }

        if (textEl) {
          textEl.classList.add('hidden');
        }
      }

      // 请求productHandle
      if (
        window.litime.tryOpenProductModalV2?.(productHandle, undefined, {
          onBefore: () => {},
          onFinally: () => {
            window.litime.hideLoading(false);
            const variantSize = parseInt(_this.getAttribute('data-variant-size') || '1', 10);
            if (variantSize <= 1) {
              _this._resetLoadingState(_this._currentButtonType);
            }
          },
        })
      ) {
        return;
      }

      fetch(`/products/${productHandle}?view=modal`)
        .then((response) => {
          if (response.status === 200) {
            return response.text();
          } else {
            throw new Error('Network response was not ok');
          }
        })
        .then((responseText) => {
          const html = responseText;

          // 直接从当前组件获取 inventory-policy
          const inventoryPolicy =
            _this.querySelector('[data-inventory-policy]')?.getAttribute('data-inventory-policy') || 'deny';

          _this._renderProductDetailModal(html, inventoryPolicy, 'buy_now_to_cart');
        })
        .finally(() => {
          window.litime.hideLoading(false);
          // 只有当变体数量小于等于1时才重置加载状态
          const variantSize = parseInt(_this.getAttribute('data-variant-size') || '1', 10);
          if (variantSize <= 1) {
            _this._resetLoadingState(_this._currentButtonType);
          }
        });
    }

    _renderProductDetailModal(html, inventoryPolicy, view) {
      const _this = this;
      const quickshopPopup = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('quickshop-popup')?.innerHTML;
      const $productDetailModal = $('#global-product-card-popup');

      $productDetailModal.html(quickshopPopup);
      try {
        // _this 本身就是 marketing-scene-buy-btn 元素，直接从它获取属性
        const preferType = _this.getAttribute('data-global-preferential-type');
        const popupEl = $productDetailModal.find('product-detail-data-popup')[0];
        if (popupEl && preferType) {
          popupEl.setAttribute('data-global-preferential-type', preferType);
        }

        if (popupEl && popupEl.applyPreferentialMode) {
          popupEl.applyPreferentialMode();
        }
      } catch (e) {
        console.warn('set data-global-preferential-type failed:', e);
      }
      // let app = document.querySelector('.product-detail-modal_wrapper');
      let modalWrapper = $productDetailModal.find('.product-detail-modal_wrapper');
      // 判断预售逻辑 start
      if (inventoryPolicy === 'continue' && view === 'buy_now_to_cart') {
        let $preOrderButton = modalWrapper
          .find('.product-detail-popup_button')
          .eq(0)
          .find('.buy-now-btn-card-button-popup');

        $preOrderButton.removeClass('hidden').addClass('flex');
        const $preOrderSubmitButton = modalWrapper
          .find('.product-detail-popup_form_wrapper')
          .eq(0)
          .find('.buy-now-btn-card-submit-button');
        $preOrderSubmitButton.addClass('hidden').removeClass('flex');
      } else {
        let $preOrderButton = modalWrapper
          .find('.product-detail-popup_form_wrapper')
          .eq(0)
          .find('.buy-now-btn-card-button-popup');
        $preOrderButton.addClass('hidden').removeClass('flex');
        const $preOrderSubmitButton = modalWrapper
          .find('.product-detail-popup_form_wrapper')
          .eq(0)
          .find('.buy-now-btn-card-submit-button');
        $preOrderSubmitButton.removeClass('hidden').addClass('flex');
      }
    }

    _resetLoadingState(buttonType = 'buy') {
      // Reset loading state for the correct button
      let loading, textEl;
      if (buttonType === 'cart') {
        // 对于 cart 按钮，选择 btn-cart 内的元素
        const btnCart = this.querySelector('.btn-cart');
        loading = btnCart ? btnCart.querySelector('.rotate_icon') : null;
        textEl = btnCart ? btnCart.querySelector('.loading-button-text') : null;
      } else {
        // 对于 buy 按钮，选择 btn-buy 内的元素
        const btnBuy = this.querySelector('.btn-buy');
        loading = btnBuy ? btnBuy.querySelector('.rotate_icon') : null;
        textEl = btnBuy ? btnBuy.querySelector('.loading-button-text') : null;
      }

      if (loading) {
        loading.classList.add('hidden');
        loading.classList.remove('flex');
      }

      if (textEl) {
        textEl.classList.remove('hidden');
      }
    }
  }

  // Register custom element
  if (!customElements.get('marketing-scene-buy-btn')) {
    customElements.define('marketing-scene-buy-btn', MarketingSceneBuyBtn);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["marketing-scene-more-btn"] && !Shopify.designMode) return;
  try {
    class MarketingSceneMoreBtn extends HTMLElement {
    constructor() {
      super();
      this._onBtnClick = this._handleBtnClick.bind(this);
    }

    connectedCallback() {
      this._init();
    }

    disconnectedCallback() {
      this._cleanup();
    }

    _init() {
      const btn = this.querySelector('.btn');
      if (btn) {
        btn.addEventListener('click', this._onBtnClick);
      }
    }

    _cleanup() {
      const btn = this.querySelector('.btn');
      if (btn) {
        btn.removeEventListener('click', this._onBtnClick);
      }
    }

    _handleBtnClick(e) {
      // Show loading state
      const loading = this.querySelector('.rotate_icon');
      if (loading) {
        loading.classList.remove('hidden');
        loading.classList.add('flex');
      }

      const textEl = this.querySelector('.loading-button-text');
      if (textEl) {
        textEl.classList.add('hidden');
      }
    }
  }

  // Register custom element
  if (!customElements.get('marketing-scene-more-btn')) {
    customElements.define('marketing-scene-more-btn', MarketingSceneMoreBtn);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["marketing-scene-product"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('global-product')) {
      // 创建弹窗根容器
      const createModalRoot = () => {
        const existingRoot = document.getElementById('global-modal__root');
        if (existingRoot) return existingRoot;

        const root = document.createElement('div');
        root.id = 'global-modal__root';
        root.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 500;
      `;
        document.body.appendChild(root);
        return root;
      };
      customElements.define(
        'global-product',
        class GlobalProduct extends HTMLElement {
          shopMoneyFormat = null;
          // 弹窗根容器
          static root = null;
          // 存储当前组件的弹窗元素
          productDetailModal = null;
          mobileClickStatus = false;
          // 获取或创建根容器
          static getRoot() {
            if (!this.root) {
              this.root = createModalRoot();
            }
            return this.root;
          }
          constructor() {
            super();
          }
          connectedCallback() {
            const _this = this;
            window.addEventListener('pagehide', (event) => {
              this.checkoutLoading = false;
              $(this.querySelector('.buy-now-btn-card-button-popup'))
                .find('.rotate_icon')
                .removeClass('flex')
                .addClass('hidden');
              if (event.persisted) {
              } else {
              }
            });
            this.init();
            this.openQuickViewButton();
            this.initBuyNowButton();
            // 获取function_icon_wrapper
            const $functionIconWrapper = $(this).find('.function_icon_wrapper');
            const function_text_wrapper = $(this).find('.function_text_wrapper');
            const function_icon = $(this).find('.function_icon');

            const clearClickStatus = () => {
              this.mobileClickStatus = false;
              function_text_wrapper.css('opacity', 0).css('top', '0');
              $functionIconWrapper.each(function () {
                $(this).attr('data-click-status', 'false');
              });
              function_icon.removeClass('hover_icon');
            };
            $functionIconWrapper.on('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              // 判断屏幕宽度小于1200px
              if ($(window).width() <= 1200) {
                _this.mobileClickStatus = true;
                if ($(this).attr('data-click-status') === 'false') {
                  function_text_wrapper.css('opacity', 0).css('top', '0');
                  function_icon.removeClass('hover_icon');
                  $functionIconWrapper.each(function () {
                    $(this).attr('data-click-status', 'false');
                  });
                  $(this).attr('data-click-status', 'true');
                  $(this).find('.function_icon').addClass('hover_icon');
                  $(this)
                    .find('.function_text_wrapper')
                    .addClass('block')
                    .removeClass('hidden')
                    .css('opacity', 1)
                    .css('top', '-12px');
                } else {
                  clearClickStatus();
                }
              }
            });
            document.addEventListener('click', (e) => {
              if (this.mobileClickStatus) {
                clearClickStatus();
              }
            });
          }

          init() {
            const _this = this;
            const hoverWidth = $(this).find('.hover-width');
            hoverWidth.on('mouseenter', function () {
              if ($(this).find('.hover_text').is(':visible')) {
                $(this).css('width', 'auto');
                const autoWidth = $(this).width();
                $(this).css('width', '32px');
                setTimeout(() => {
                  $(this).css('width', `${autoWidth}px`);
                }, 50);
              }
            });
            hoverWidth.on('mouseout', function () {
              if ($(this).find('.hover_text').is(':visible')) {
                setTimeout(() => {
                  if (!$(this).is(':hover')) {
                    $(this).css('width', '32px');
                  }
                }, 50);
              }
            });
            this.shopMoneyFormat = window.shopMoneyFormat;

            // 获取弹窗并移动到root
            const $productDetailModal = $(this).find('.product-detail-data-modal');
            if ($productDetailModal.length) {
              // 将弹窗移动到root节点
              const root = this.constructor.getRoot();
              $productDetailModal.appendTo(root);

              // 确保弹窗可以接收点击事件
              $productDetailModal.css('pointer-events', 'auto');

              // 保存移动后的弹窗引用
              this.productDetailModal = $productDetailModal;
              // 重新初始化product-detail-data-popup组件
              if (window.customElements) {
                window.customElements.upgrade(this.productDetailModal[0]);
              }
            }

            // 获取所有data-product-handle的元素
            const $productHandles = $(this).find('[data-product-handle]');

            $productHandles.on('click', function (event) {
              event.preventDefault();
            });

            const addCartButton = $(this).find('[data-first_variant_id]').find('[type="submit"]');

            addCartButton.on('click', function (event) {
              // 阻止默认事件
              event.preventDefault();
              // 获取index
              const index = $(_this).find('[data-first_variant_id]').find('[type="submit"]').index(this);
              const dataFirstVariantId = $(_this).find('[data-first_variant_id]').eq(index).data('first_variant_id');
              const skuCount = $(_this).find('[data-first_variant_id]').eq(index).data('sku-count');
              const inventoryPolicy = $(_this).find('[data-first_variant_id]').eq(index).data('inventory-policy');
              const view = $(_this).find('[data-first_variant_id]').eq(index).data('view');
              if (skuCount > 1) {
                window.litime.disableScroll();
                const $swiperSlide = $(_this).closest('.swiper-slide');
                const $productHandle = $swiperSlide.find('[data-product-handle]');
                if ($productHandle.length > 0) {
                  _this.openProductDetailModal($productHandle[0], inventoryPolicy, view);
                } else {
                  const $globalProduct = $(this).closest('.global-product');
                  _this.openProductDetailModal($globalProduct.find('[data-product-handle]'), inventoryPolicy, view);
                }
              } else {
                if (view === 'add_to_cart') {
                  $(this).find('i').removeClass('hidden').addClass('flex');
                  _this.addToCart(this, dataFirstVariantId, 1);
                }
              }
            });
          }
          openQuickViewButton() {
            const index = $(this).find('[data-first_variant_id]').find('[type="submit"]').index(this);
            const $globalProduct = $(this).closest('.global-product');
            const inventoryPolicy = $(this).find('[data-first_variant_id]').eq(index).data('inventory-policy');
            const view = $(this).find('[data-first_variant_id]').eq(index).data('view');
            if (this.querySelector('.open-product-detail-modal')) {
              this.querySelector('.open-product-detail-modal').addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                this.openProductDetailModal(
                  $globalProduct.find('[data-product-handle]'),
                  $globalProduct.find('[data-inventory-policy]'),
                  view
                );
              });
            }
          }
          openProductDetailModal(element, inventoryPolicy, view) {
            const _this = this;
            // 禁用浏览器滚动
            window.litime.disableScroll();
            window.litime.showLoading(false);
            const productHandle = $(element).data('product-handle');
            const productVariantId = $(element).data('product-variant-id');
            const productVariantShow = $(element).data('product-show');

            // 从 ProductJson 获取变体位置
            let productPosition = 1; // 默认位置
            try {
              const $productJsonElement = $(element).closest('.global-product').find('[id^="ProductJson-"]');
              if ($productJsonElement.length > 0) {
                const productData = JSON.parse($productJsonElement.html());
                if (productData && productData.variants && productVariantId) {
                  const variant = productData.variants.find((variant) => variant.id == productVariantId);
                  if (variant && variant.featured_image && variant.featured_image.position) {
                    productPosition = variant.featured_image.position;
                  }
                }
              }
            } catch (error) {
              console.error('Error getting product position:', error);
            }

            // 请求productHandle
            let url = '';

            if (Boolean(productVariantShow)) {
              url = `/products/${productHandle}?variant=${productVariantId}&view=modal`;
            } else {
              url = `/products/${productHandle}?view=modal`;
            }

            const variantIdForV2 = Boolean(productVariantShow) ? productVariantId : undefined;
            if (
              window.litime.tryOpenProductModalV2?.(productHandle, variantIdForV2, {
                onBefore: () => window.litime.showLoading(false),
                onFinally: () => window.litime.hideLoading(false),
              })
            ) {
              return;
            }

            fetch(url)
              .then((response) => {
                if (response.status === 200) {
                  return response.text();
                } else {
                  throw new Error('Network response was not ok');
                }
              })
              .then((responseText) => {
                const html = responseText;
                _this.renderProductDetailModal(html, inventoryPolicy, view, productPosition, element);
              })
              .finally(() => {
                window.litime.hideLoading(false);
              });
          }

          renderProductDetailModal(html, inventoryPolicy, view, productPosition, element) {
            const _this = this;
            const quickshopPopup = new DOMParser()
              .parseFromString(html, 'text/html')
              .getElementById('quickshop-popup')?.innerHTML;
            const $productDetailModal = $('#global-product-card-popup');

            $productDetailModal.html(quickshopPopup);
            const popupEl = $productDetailModal.find('product-detail-data-popup')[0];
            const preferType =
              element && element.getAttribute ? element.getAttribute('data-global-preferential-type') : null;
            const productDiscountType =
              element && element.getAttribute ? element.getAttribute('data-product-discount-type') : null;
            if (popupEl && preferType) {
              popupEl.setAttribute('data-global-preferential-type', preferType);
            }
            if (popupEl && productDiscountType) {
              popupEl.setAttribute('data-product-discount-type', productDiscountType);
            }

            if (popupEl && popupEl.applyPreferentialMode) {
              popupEl.applyPreferentialMode();
            }
            // let app = document.querySelector('.product-detail-modal_wrapper');
            let modalWrapper = $productDetailModal.find('.product-detail-modal_wrapper');
            // 判断预售逻辑 start
            if (inventoryPolicy === 'continue' && view === 'buy_now_to_cart') {
              let $preOrderButton = modalWrapper
                .find('.product-detail-popup_button')
                .find('.buy-now-btn-card-button-popup');

              $preOrderButton.removeClass('hidden').addClass('flex');
              const $preOrderSubmitButton = modalWrapper
                .find('.product-detail-popup_form_wrapper')
                .find('.buy-now-btn-card-submit-button');
              $preOrderSubmitButton.addClass('hidden').removeClass('flex');
            } else {
              let $preOrderButton = modalWrapper
                .find('.product-detail-popup_form_wrapper')
                .find('.buy-now-btn-card-button-popup');
              $preOrderButton.addClass('hidden').removeClass('flex');
              const $preOrderSubmitButton = modalWrapper
                .find('.product-detail-popup_form_wrapper')
                .find('.buy-now-btn-card-submit-button');
              $preOrderSubmitButton.removeClass('hidden').addClass('flex');
            }

            // 轮播图切换逻辑
            setTimeout(() => {
              const productDetailPopup = document.querySelector('product-detail-data-popup');
              if (
                productDetailPopup &&
                productDetailPopup.productDetailModalBigPictrueSwiper &&
                productDetailPopup.productDetailModalSmallPictrueSwiper
              ) {
                productDetailPopup.productDetailModalBigPictrueSwiper.slideToLoop(productPosition - 1);
                productDetailPopup.productDetailModalSmallPictrueSwiper.slideToLoop(productPosition - 1);
              }
            }, 100);
          }
          initBuyNowButton() {
            const inputNumber = $(this.querySelector('.global-number_input'));
            const quantity = inputNumber.val();
            const buyNowBtn = this.querySelector('.buy-now-btn-card-button-popup');
            const dataFirstVariantId = $(this).find('[data-first_variant_id]').data('first_variant_id');

            if (buyNowBtn) {
              buyNowBtn.addEventListener('click', async (e) => {
                e.preventDefault();
                this.checkoutLoading = true;
                if (this.checkoutLoading) {
                  $(buyNowBtn).find('.rotate_icon').removeClass('hidden').addClass('flex');
                }

                window.location.href = `/cart/${dataFirstVariantId}:${quantity}`;
              });
            }
          }
          addToCart(event, productId, quantity) {
            const _this = this;

            $(event).find('.rotate_icon').removeClass('hidden').addClass('flex');
            $(event).find('.loading-button-text').addClass('hidden').removeClass('flex');
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                items: [
                  {
                    id: productId,
                    quantity,
                  },
                ],
                sections: `${getMiniCartSectionId()},cart-icon-bubble`,
              }),
            })
              .then((response) => response.json())
              .then((data) => {
                $(event).find('.rotate_icon').addClass('hidden').removeClass('flex');
                $(event).find('.loading-button-text').addClass('flex').removeClass('hidden');
                if (window.gtag) {
                  gtag('event', 'conversion', { send_to: 'AW-11059876179/OfmnCMjGxIsYENOi4Zkp' });
                }
                if (data.status && data.status != 200) {
                  window.litime.showToast('error', data.message);
                } else {
                  if (window.location.pathname === '/cart') {
                    window.location.reload();
                    window.scrollTo(0, 0);
                  } else {
                    // 使用 updateCartComponents 更新购物车
                    updateCartComponents(data);
                    // 打开购物车抽屉
                    const cartDrawer = document.querySelector('cart-drawer');
                    if (cartDrawer) {
                      cartDrawer.open();
                    } else {
                      const miniCart = document.querySelector('global-mini-cart-v2');
                      if (miniCart) {
                        typeof miniCart.renderContents === 'function' && miniCart.renderContents(data);
                      }
                    }
                  }
                }
              })
              .catch((error) => {
                $(event).find('.rotate_icon').addClass('hidden').removeClass('flex');
                $(event).find('.loading-button-text').addClass('flex').removeClass('hidden');
              });
          }

          destroy() {
            // 恢复浏览器滚动
            window.litime.enableScroll();

            if (this.productDetailModalSmallPictrueSwiper) {
              this.productDetailModalSmallPictrueSwiper.destroy();
            }
            if (this.productDetailModalBigPictrueSwiper) {
              this.productDetailModalBigPictrueSwiper.destroy();
            }

            // 移除时同时清理弹窗
            if (this.productDetailModal) {
              this.productDetailModal.remove();
              this.productDetailModal = null;
            }
          }

          disconnectedCallback() {
            this.destroy();
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["menu-mobile-list"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('menu-mobile-list')) {
      customElements.define(
        'menu-mobile-list',
        class menuMobileList extends HTMLElement {
          constructor() {
            super();
            this.$mobileToolbarList = null;
            this.$listItems = null;
            this.$mobileToolbarItem = null;
            this.$plan2SwiperList = null;
            this.$plan3Swiper = null;
            this.$plan1MenuItemName = null;
            this.$popupContainer = null;
            this.$navLaunchMainCenterNavList = null;
            this.$popupContainerMainListTag = null;
            this.$activeNavList = [];
            this.$mobileProductList = [];
            this.$childItemDataIndex = 0;
            this.$body = null;
          }
          connectedCallback() {
            // 点击展开移动端导航菜单列表
            this.$mobileToolbarList = this.querySelector('.mobile-toolbar-list');
            this.$mobileToolbarItem = this.$mobileToolbarList.querySelectorAll('.mobile-toolbar-item');
            this.$listItems = this.querySelectorAll('.icon-dropdown-series-item');
            this.$plan2SwiperList = this.querySelectorAll('.plan2Swiper');
            this.$plan3Swiper = this.querySelectorAll('.plan3SwiperMobile');
            this.$body = $('body');
            this.init();
            this.swiperFuntion();
          }

          init() {
            // 展开列表数据
            this.$mobileToolbarItem.forEach((item) => {
              customEventListener(item, 'click', (event) => {
                // 获取当前点击的元素
                const currentItem = event.currentTarget;
                // 获取当前点击元素的 data-target 属性
                this.currentTarget = currentItem.getAttribute('data-target');

                const dropdown = item.nextElementSibling;

                // 点击导航-> li 有多级或者直接展示在当前弹窗的样式
                if (dropdown && dropdown.classList.contains('icon-dropdown-series-item')) {
                  const iconDropdown = item.querySelector('.icon-dropdown');
                  iconDropdown.classList.toggle('rotate-effect');
                  this.$mobileToolbarItem.forEach((item) => {
                    const otherDropdown = item.nextElementSibling;
                    if (otherDropdown && otherDropdown !== dropdown) {
                      // 如果classList包含show，则移除
                      if (otherDropdown && otherDropdown.classList.contains('show')) {
                        otherDropdown.classList.remove('show');
                      }
                      dropdown.classList.add('active');
                      item.querySelector('.icon-dropdown').classList.remove('rotate-effect');
                    }
                    if (item.getAttribute('data-target') == 'menu-plan-5') {
                      const menuItemsLi = otherDropdown.querySelectorAll('.icon-dropdown-series-item-li');
                      menuItemsLi.forEach((childItem) => {
                        // 将三级菜单的子项关闭
                        if (iconDropdown && !iconDropdown.classList.contains('rotate-effect')) {
                          childItem.querySelector('.icon-dropdown').classList.remove('rotate-effect');
                          const subItem = otherDropdown.querySelectorAll('.icon-dropdown-series-sub-item');
                          subItem.forEach((res) => {
                            if (res.classList.contains('subItemOpen')) {
                              res.classList.remove('subItemOpen');
                            }
                          });
                        }
                        customEventListener(childItem, 'click', () => {
                          const targetClass = Array.from(childItem.classList).find((cls) => cls.startsWith('target-'));
                          const iconDropdown = childItem.querySelector('.icon-dropdown');
                          iconDropdown.classList.toggle('rotate-effect');
                          // 查找对应的 sub-item 元素
                          const subItem = otherDropdown.querySelector(`.icon-dropdown-series-sub-item.${targetClass}`);
                          // 隐藏所有的 sub-items
                          otherDropdown.querySelectorAll('.icon-dropdown-series-sub-item').forEach((sub) => {
                            // 如果 sub 不是当前的 subItem，将其隐藏
                            if (sub !== subItem) {
                              sub.classList.remove('subItemOpen');
                              sub.classList.add('subItemClose');
                            }
                          });
                          // 切换当前子菜单的显示状态
                          if (subItem.classList.contains('subItemOpen')) {
                            // 如果当前 sub-item 已显示，则隐藏它
                            subItem.classList.remove('subItemOpen');
                            subItem.classList.add('subItemClose');
                          } else {
                            // 否则，显示当前 sub-item
                            subItem.classList.remove('subItemClose');
                            subItem.classList.add('subItemOpen');
                          }
                        });
                      });
                    }

                    if (item.getAttribute('data-target') == 'menu-plan-1') {
                      const menuItemsLi = otherDropdown.querySelectorAll('.icon-dropdown-series-item-li');
                      menuItemsLi.forEach((childItem) => {
                        customEventListener(childItem, 'click', () => {
                          const childItemDataIndex = childItem.getAttribute('data-index');
                          this.$childItemDataIndex = childItem.getAttribute('data-index');

                          // 导航点击二次弹窗的样式
                          const navLaunch = otherDropdown.querySelector('.mobile-starry-nav-launch');
                          navLaunch.style.display = 'flex';

                          // 处理二级弹窗的标题
                          this.plan1MenuItemName = childItem.querySelector('span').innerText;
                          const secondaryContainer = navLaunch.querySelector('.starry-secondary-container');
                          const navLeft = secondaryContainer.querySelector('.starry-nav-m-left');
                          const navMcenter = secondaryContainer.querySelector('.starry-nav-m-center');
                          navMcenter.innerText = this.plan1MenuItemName;
                          customEventListener(navLeft, 'click', () => {
                            navLaunch.style.display = '';
                          });
                          //处理二级弹窗end
                          // 筛选对比
                          const crumbsContainer = navLaunch.querySelector('.mobile-crumbs-container');
                          const compareList = crumbsContainer.querySelectorAll('.compare-list');
                          compareList.forEach((res) => {
                            const navListDataIndex = res.getAttribute('data-index');
                            if (childItemDataIndex === navListDataIndex) {
                              res.classList.add('flex');
                              res.classList.remove('hidden');
                            } else {
                              res.classList.remove('flex');
                              res.classList.add('hidden');
                            }
                          });
                          // 筛选Tab start
                          const navLaunchPosition = navLaunch.querySelector(
                            '.mobile-starry-nav-launch-main-center-position'
                          );
                          const chooseListElement = navLaunchPosition?.querySelector('.chooseList');
                          if (chooseListElement) {
                            chooseListElement.classList.remove('hidden');
                            chooseListElement.classList.add('flex');
                          }
                          if (navLaunchPosition) {
                            navLaunchPosition.classList.remove('hidden');
                            navLaunchPosition.classList.add('flex');
                          }
                          const navList = chooseListElement
                            ? chooseListElement.querySelectorAll('.mobile-starry-nav-launch-main-center-nav-list')
                            : [];

                          let PopupButton = navLaunch.querySelector('.PopupButton');
                          this.$overlay = navLaunch.querySelector('.overlay');
                          this.$popupContainer = navLaunch.querySelector('.starry-popup-container');

                          customEventListener(PopupButton, 'click', () => {
                            this.$popupContainer.classList.remove('hidden');
                            this.$popupContainer.classList.add('flex');
                            this.$overlay.style.display = 'flex';
                            // 处理移动端右侧弹窗逻辑
                            const popupChooseContainer = this.$popupContainer.querySelector('.popup-choose-container');
                            const containerMainList = popupChooseContainer.querySelectorAll(
                              '.starry-popup-container-main-list'
                            );

                            if (containerMainList && containerMainList.length > 0) {
                              containerMainList.forEach((res) => {
                                const containerMainListDataIndex = res.getAttribute('data-index');
                                if (this.$childItemDataIndex == containerMainListDataIndex) {
                                  res.classList.remove('hidden');
                                  res.classList.add('block');

                                  this.$popupContainerMainListTag = res.querySelectorAll(
                                    '.starry-popup-container-main-item'
                                  );
                                  this.$popupContainerMainListTag.forEach((childRes) => {
                                    const spanContent = childRes.querySelector('span')?.innerHTML;

                                    if (spanContent && this.$activeNavList.includes(spanContent)) {
                                      childRes.classList.add('nav-active');
                                    }
                                    customEventListener(childRes, 'click', () => {
                                      childRes.classList.toggle('nav-active');
                                      // 更新 activeNavList
                                      if (childRes.classList.contains('nav-active')) {
                                        // 添加到 activeNavList
                                        if (!this.$activeNavList.includes(spanContent)) {
                                          this.$activeNavList.push(spanContent);
                                        }
                                      } else {
                                        // 从 activeNavList 移除
                                        const index = this.$activeNavList.indexOf(spanContent);
                                        if (index > -1) {
                                          this.$activeNavList.splice(index, 1);
                                        }
                                      }
                                    });
                                  });
                                } else {
                                  res.classList.remove('block');
                                  res.classList.add('hidden');
                                }
                              });
                            }
                            //  右侧弹窗逻辑end
                          });
                          const formConfirmButton = this.$popupContainer.querySelector('.formConfirmButton');
                          const formClearButton = this.$popupContainer.querySelector('.formClearButton');
                          customEventListener(this.$overlay, 'click', () => {
                            this.$overlay.style.display = '';
                            this.$popupContainer.classList.add('hidden');
                            this.$popupContainer.classList.remove('flex');
                          });
                          // 弹窗OK确认事件
                          customEventListener(formConfirmButton, 'click', () => {
                            this.$popupContainer.classList.add('hidden');
                            this.$popupContainer.classList.remove('flex');
                            this.$overlay.style.display = '';
                            if (this.$navLaunchMainCenterNavList) {
                              this.$navLaunchMainCenterNavList.forEach((navLaunchMainCenterNavItem) => {
                                const spanContent = navLaunchMainCenterNavItem.querySelector('span')?.innerHTML;

                                if (spanContent && this.$activeNavList.includes(spanContent)) {
                                  navLaunchMainCenterNavItem.classList.add('nav-active');
                                } else {
                                  navLaunchMainCenterNavItem.classList.remove('nav-active');
                                }
                              });
                            }
                            this.filterProductFunction();
                          });
                          // 弹窗Clear清空事件
                          customEventListener(formClearButton, 'click', () => {
                            this.$popupContainer.classList.add('hidden');
                            this.$popupContainer.classList.remove('flex');
                            this.$overlay.style.display = '';
                            this.$activeNavList = [];
                            if (this.$navLaunchMainCenterNavList) {
                              this.$navLaunchMainCenterNavList.forEach((item) => {
                                item.classList.remove('nav-active');
                              });
                            }
                            if (this.$popupContainerMainListTag) {
                              this.$popupContainerMainListTag.forEach((item) => {
                                item.classList.remove('nav-active');
                              });
                            }
                            this.filterProductFunction();
                          });
                          navList.forEach((res) => {
                            const navListDataIndex = res.getAttribute('data-index');
                            if (childItemDataIndex === navListDataIndex) {
                              const liLength = res.querySelectorAll('li').length;
                              if (liLength <= 0) {
                                // 隐藏 chooseList 及其父级 filter-position，去掉 flex 避免与 hidden 同时存在
                                const chooseList = navLaunch.querySelector('.chooseList');
                                if (chooseList) {
                                  chooseList.classList.add('hidden');
                                  chooseList.classList.remove('flex');
                                  const filterPosition = chooseList.closest(
                                    '.mobile-starry-nav-launch-main-center-position'
                                  );
                                  if (filterPosition) {
                                    filterPosition.classList.add('hidden');
                                    filterPosition.classList.remove('flex');
                                  }
                                }
                              } else {
                                // 显示 chooseList 及其父级 filter-position
                                const chooseList = navLaunch.querySelector('.chooseList');
                                if (chooseList) {
                                  chooseList.classList.remove('hidden');
                                  chooseList.classList.add('flex');
                                  const filterPosition = chooseList.closest(
                                    '.mobile-starry-nav-launch-main-center-position'
                                  );
                                  if (filterPosition) {
                                    filterPosition.classList.remove('hidden');
                                    filterPosition.classList.add('flex');
                                  }
                                }
                              }
                              res.classList.add('flex');
                              res.classList.remove('hidden');
                              this.$navLaunchMainCenterNavList = res.querySelectorAll(
                                '.mobile-starry-nav-launch-main-center-nav-item'
                              );
                              this.$navLaunchMainCenterNavList.forEach((navLaunchMainCenterNavItem) => {
                                customEventListener(navLaunchMainCenterNavItem, 'click', () => {
                                  let activeItemInnerHTML = navLaunchMainCenterNavItem.querySelector('span').innerHTML;
                                  navLaunchMainCenterNavItem.classList.toggle('nav-active');
                                  if (navLaunchMainCenterNavItem.classList.contains('nav-active')) {
                                    this.$activeNavList.push(activeItemInnerHTML);
                                  } else {
                                    this.$activeNavList = this.$activeNavList.filter(
                                      (item) => item !== activeItemInnerHTML
                                    );
                                  }
                                  // 假设 this.$activeNavList 和 this.$mobileProductList 是你已经定义好的 DOM 列表

                                  this.filterProductFunction();
                                });
                              });
                            } else {
                              res.classList.remove('flex');
                              res.classList.add('hidden');
                            }
                          });
                          // 筛选Tab end
                          const menuPlan1ProductList = navLaunch.querySelector('.menu-plan-1-product-list');
                          const menuPlan1Expand = menuPlan1ProductList.querySelector('.menu-plan-1-expand');
                          const navLaunchMainCenterList = menuPlan1Expand.querySelectorAll(
                            '.mobile-starry-nav-launch-main-center-list'
                          );
                          navLaunchMainCenterList.forEach((res) => {
                            const navLaunchMainCenterResDataIndex = res.getAttribute('data-index');
                            if (childItemDataIndex === navLaunchMainCenterResDataIndex) {
                              this.$mobileProductList = res.querySelectorAll(
                                '.mobile-starry-nav-launch-main-center-item'
                              );

                              res.classList.add('flex');
                              res.classList.remove('hidden');
                            } else {
                              res.classList.remove('flex');
                              res.classList.add('hidden');
                            }
                          });
                        });
                      });
                    } else if (item.getAttribute('data-target') == 'menu-plan-2') {
                      if (otherDropdown && otherDropdown.classList.contains('active')) {
                        const navLaunch = otherDropdown.querySelector('.mobile-starry-nav-launch');
                        const secondaryContainer = navLaunch.querySelector('.starry-secondary-container');
                        const navLeft = secondaryContainer.querySelector('.starry-nav-m-left');
                        const navMcenter = secondaryContainer.querySelector('.starry-nav-m-center');
                        const childItemName = item.querySelector('span')?.innerHTML;
                        navMcenter.innerText = childItemName;

                        if (window.innerWidth <= 576) {
                          if (this.currentTarget == 'menu-plan-2') {
                            navLaunch.style.display = 'flex';
                            navLaunch.style.position = 'fixed';
                            navLaunch.style.top = '0';
                            navLaunch.style.zIndex = '50';
                            document.querySelector('#header-01').appendChild(navLaunch);
                          }

                          // 点击事件
                          customEventListener(navLeft, 'click', () => {
                            navLaunch.style.display = '';
                            this.$mobileToolbarItem.forEach((item) => {
                              const otherDropdown = item.nextElementSibling;
                              if (otherDropdown && otherDropdown.classList.contains('show')) {
                                otherDropdown.classList.remove('show');
                                otherDropdown.classList.remove('active');

                                document.querySelector('#header-01').removeChild(navLaunch);
                                otherDropdown.appendChild(navLaunch);
                              }

                              item.querySelector('.icon-dropdown').classList.remove('rotate-effect');
                            });
                          });
                          // 定义 resize 事件处理 逻辑
                          const resizeHandler = () => {
                            this.$mobileToolbarItem.forEach((item) => {
                              const otherDropdown = item.nextElementSibling;
                              if (otherDropdown && otherDropdown.classList.contains('show')) {
                                otherDropdown.classList.remove('show');
                              }
                              item.querySelector('.icon-dropdown').classList.remove('rotate-effect');
                            });

                            if (window.innerWidth > 576) {
                              // 移除 resize 监听器
                              window.removeEventListener('resize', resizeHandler);
                            }
                          };

                          // 添加 resize 监听
                          customEventListener(window, 'resize', resizeHandler);
                        }
                      }
                    } else if (item.getAttribute('data-target') === 'menu-plan-4') {
                      if (otherDropdown && otherDropdown.classList.contains('active')) {
                        const navLaunch = otherDropdown.querySelector('.mobile-starry-nav-launch');
                        const secondaryContainer = navLaunch.querySelector('.starry-secondary-container');
                        const navLeft = secondaryContainer.querySelector('.starry-nav-m-left');
                        const navMcenter = secondaryContainer.querySelector('.starry-nav-m-center');
                        const childItemName = item.querySelector('span')?.innerHTML;

                        navMcenter.innerText = childItemName;

                        if (window.innerWidth <= 576) {
                          if (this.currentTarget == 'menu-plan-4') {
                            navLaunch.style.display = 'flex';
                            navLaunch.style.position = 'fixed';
                            navLaunch.style.top = '0';
                            navLaunch.style.zIndex = '50';
                            document.querySelector('#header-01').appendChild(navLaunch);
                          }

                          requestAnimationFrame(() => {
                            // 确保 navLaunch  已经显示
                          });
                          customEventListener(navLeft, 'click', () => {
                            navLaunch.style.display = '';
                            this.$mobileToolbarItem.forEach((item) => {
                              const otherDropdown = item.nextElementSibling;
                              if (otherDropdown && otherDropdown.classList.contains('show')) {
                                otherDropdown.classList.remove('show');
                                otherDropdown.classList.remove('active');
                                document.querySelector('#header-01').removeChild(navLaunch);
                                otherDropdown.appendChild(navLaunch);
                              }
                              item.querySelector('.icon-dropdown').classList.remove('rotate-effect');
                            });
                          });
                          // 定义 resize 事件处理逻辑
                          const resizeHandler = () => {
                            this.$mobileToolbarItem.forEach((item) => {
                              const otherDropdown = item.nextElementSibling;
                              if (otherDropdown && otherDropdown.classList.contains('show')) {
                                otherDropdown.classList.remove('show');
                              }
                              item.querySelector('.icon-dropdown').classList.remove('rotate-effect');
                            });

                            if (window.innerWidth > 576) {
                              navLaunch.style.display = 'flex';
                              navLaunch.style.position = 'fixed';
                              navLaunch.style.top = '0';
                              navLaunch.style.zIndex = '50';
                              document.querySelector('#header-01').appendChild(navLaunch);
                              // 移除 resize 监听器
                              window.removeEventListener('resize', resizeHandler);
                            }
                          };

                          // 添加一次性 resize 监听器
                          window.addEventListener('resize', resizeHandler);
                        }
                      }
                    }
                  });

                  // 展开或收起当前点击的菜单
                  dropdown.classList.toggle('show');
                  // dropdown.classList.remove('active');
                } else {
                }
              });
            });
          }
          filterProductFunction() {
            if (this.$mobileProductList && this.$mobileProductList.length > 0) {
              this.$mobileProductList.forEach((mobileItem) => {
                // 如果 activeNavList 为空，直接显示所有 items
                if (!this.$activeNavList || this.$activeNavList.length === 0) {
                  mobileItem.style.display = 'flex';
                  return;
                }

                // 获取 data-target 属性值并分割
                let dataTarget = mobileItem.getAttribute('data-target');

                if (dataTarget && dataTarget.trim() !== '') {
                  let targetsArray = dataTarget.split(',').map((tag) => tag.trim());

                  // 判断 activeNavList 是否完全包含于 targetsArray
                  let isMatch = this.$activeNavList.every((activeItem) => targetsArray.includes(activeItem));

                  // 根据 isMatch 结果设置样式
                  if (isMatch) {
                    mobileItem.style.display = 'flex'; // 显示
                  } else {
                    mobileItem.style.display = 'none'; // 隐藏
                  }
                } else {
                  // dataTarget 为空或无效，直接隐藏
                  mobileItem.style.display = 'none';
                }
              });
            }
          }
          swiperFuntion() {
            // 执行场景swiper
            this.$plan2SwiperList.forEach((item, index) => {
              new Swiper(item, {
                slidesPerView: 5,
                spaceBetween: 21,
                freeMode: false,
                cssMode: true,
                breakpoints: {
                  1100: {
                    slidesPerView: 5,
                  },
                  992: {
                    slidesPerView: 4,
                  },
                  768: {
                    slidesPerView: 3,
                  },
                  576: {
                    slidesPerView: 2,
                  },

                  370: {
                    slidesPerView: 2,
                  },
                },
              });
            });

            this.$plan3Swiper.forEach((res) => {
              new Swiper(res, {
                slidesPerView: 5,
                spaceBetween: 21,
                freeMode: true,
                cssMode: true,
                breakpoints: {
                  1400: {
                    slidesPerView: 5,
                  },
                  1100: {
                    slidesPerView: 5,
                  },
                  992: {
                    slidesPerView: 4,
                  },
                  768: {
                    slidesPerView: 3,
                  },
                  576: {
                    slidesPerView: 2,
                  },

                  370: {
                    slidesPerView: 2,
                  },
                },
              });
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["menu-plan-1"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('menu-plan-1')) {
      customElements.define(
        'menu-plan-1',
        class menuPlan1 extends HTMLElement {
          constructor() {
            super();
            this.$menuPlan1 = null; //产品菜单
            this.$launchMainAside = null;
            this.$activeList = null;
            this.$launchMainList = null;
            this.$activeNavList = null;
            this.$activeItemList = null;
            this.$nowCompareList = null;
            this.nowCompareListMain = null;
          }

          connectedCallback() {
            this.$menuPlan1 = this.querySelector('.menu-plan-1');
            this.$launchMainAside = this.querySelector('.launch-main-aside');
            if (this.$menuPlan1) {
              this.$launchMainList = this.$menuPlan1.querySelectorAll('.launch-main-list');
              this.$activeList = this.$menuPlan1.querySelectorAll('.nav-launch-main-center-list');
              this.$nowCompareListMain = this.$menuPlan1.querySelector('.launch-footer-main');
            }
            if (this.$nowCompareListMain) {
              this.$nowCompareList = this.$nowCompareListMain.querySelectorAll('.nav-launch-main-center-footer-main');
            }
            this.init();
          }
          init() {
            this.productMenu();
          }
          productMenu() {
            if (this.$launchMainAside) {
              const navItems = this.$launchMainAside.querySelectorAll('.launch-main-aside-item');
              this.$launchMainList.forEach((item, index) => {
                if (index === 0) {
                  item.classList.add('grid');
                  item.classList.remove('hidden');
                  this.$activeItemList = item;
                } else {
                  item.classList.add('hidden');
                  item.classList.remove('grid');
                }
              });

              this.$nowCompareList.forEach((item, index) => {
                if (index === 0) {
                  item.classList.add('flex');
                  item.classList.remove('hidden');
                } else {
                  item.classList.add('hidden');
                  item.classList.remove('flex');
                }
              });
              navItems.forEach((item, index) => {
                if (index === 0) {
                  item.classList.add('active');
                  item.setAttribute('data-active', 'true');
                  this.$activeList.forEach((res) => {
                    let dataIndex = res.getAttribute('data-index');
                    if (dataIndex == 1) {
                      res.classList.add('flex');
                      res.classList.remove('hidden');
                      this.$activeNavList = res;
                    } else {
                      res.classList.add('hidden');
                      res.classList.remove('flex');
                    }
                  });
                } else {
                  item.classList.remove('active');
                  item.setAttribute('data-active', 'false');
                }

                // Add mouseenter event
                customEventListener(item, 'mouseenter', () => {
                  // Remove previous event handlers to avoid duplication
                  navItems.forEach((otherItem) => {
                    otherItem.classList.remove('active');
                    otherItem.setAttribute('data-active', 'false');
                  });

                  // Activate current item
                  item.classList.add('active');
                  item.setAttribute('data-active', 'true');

                  let dataIndex = item.getAttribute('data-index');
                  this.$activeList.forEach((res) => {
                    let listIndex = res.getAttribute('data-index');
                    if (dataIndex == listIndex) {
                      res.classList.add('flex');
                      res.classList.remove('hidden');
                      this.$activeNavList = res;
                    } else {
                      res.classList.add('hidden');
                      res.classList.remove('flex');
                    }
                  });

                  this.$nowCompareList.forEach((item) => {
                    let footerIndex = item.getAttribute('data-index');

                    if (dataIndex == footerIndex) {
                      item.classList.add('flex');
                      item.classList.remove('hidden');
                    } else {
                      item.classList.add('hidden');
                      item.classList.remove('flex');
                    }
                  });

                  this.$launchMainList.forEach((item, index) => {
                    if (dataIndex == index + 1) {
                      item.classList.add('grid');
                      item.classList.remove('hidden');
                      this.$activeItemList = item;
                    } else {
                      item.classList.add('hidden');
                      item.classList.remove('grid');
                    }
                  });

                  // Set nav click handler here to avoid multiple bindings
                  if (this.$activeNavList && this.$activeItemList) {
                    this.setNavClickHandler(this.$activeNavList, this.$activeItemList);
                  }
                });
              });

              if (this.$activeNavList && this.$activeItemList) {
                this.setNavClickHandler(this.$activeNavList, this.$activeItemList);
              }
            }
          }

          setNavClickHandler(navList, productList) {
            const spans = navList.querySelectorAll('.nav-active span');
            const resultArray = Array.from(spans).map((span) => {
              // 获取 innerText 并去掉开头的 #
              return span.innerText.startsWith('#') ? span.innerText.slice(1).trim() : span.innerText;
            });

            // 移除之前的点击事件
            navList.querySelectorAll('li').forEach((targetLi) => {
              targetLi.removeEventListener('click', this.handleNavClick);
            });

            if (productList.classList.contains('grid')) {
              let nowDataTarget = JSON.parse(JSON.stringify(productList.getAttribute('data-target')));
              let productListTargetList = nowDataTarget.split(', ');

              productListTargetList[0] = productListTargetList[0].replace(/^\[|\"/, '').replace(/\"/g, '');
              productListTargetList[productListTargetList.length - 1] = productListTargetList[
                productListTargetList.length - 1
              ]
                .replace(/["\\]/g, '')
                .replace(/\]$/, '');

              // 为每个 li 添加点击事件
              navList.querySelectorAll('li').forEach((targetLi) => {
                // Ensure this event is not added multiple times
                if (!targetLi._hasNavClickHandler) {
                  targetLi.addEventListener('click', (event) => {
                    this.handleNavClick(event, productList, productListTargetList, resultArray, navList);
                  });
                  targetLi._hasNavClickHandler = true; // Mark that the handler is added
                }
              });
            }
          }

          handleNavClick(event, productList, productListTargetList, resultArray, navList) {
            event.stopPropagation(); // 阻止事件冒泡
            const targetLi = event.target.closest('li'); // 获取点击的li
            if (targetLi) {
              const isActive = targetLi.classList.contains('nav-active');
              const productList_item = productList.querySelectorAll('.product-item');
              if (!isActive) {
                targetLi.classList.add('nav-active');
                this.addTagToScene(
                  targetLi.innerText.trim(),
                  productListTargetList,
                  productList,
                  productList_item,
                  resultArray,
                  navList
                );
              } else {
                targetLi.classList.remove('nav-active');
                this.removeTagFromScene(
                  targetLi.innerText.trim(),
                  productListTargetList,
                  productList,
                  productList_item,
                  resultArray,
                  navList
                );
              }
            }
          }
          addTagToScene(tag, filter_scenes = '', productList, productList_item, resultArray, navList) {
            let cleanedTag = tag.replace(/^[\s#]+/, '').trim(); // 去掉空格和特殊字符
            if (!resultArray.includes(cleanedTag)) {
              resultArray.push(cleanedTag); // 添加当前标签
              this.filterProduct(resultArray, productList, productList_item, resultArray, navList);
            }
          }
          filterProduct(filter_scenes = '', productList, productList_item, resultArray, navList) {
            const tagsShow = this.hasActiveClass(navList);
            productList_item.forEach((item) => {
              if (productList.classList.contains('grid')) {
                // 获取 data-target 的值并转换为数组
                let itemDataTarget = item.getAttribute('data-target')
                  ? item.getAttribute('data-target').split(', ')
                  : [];
                if (itemDataTarget && itemDataTarget.length > 0) {
                  // 判断 itemDataTarget 是否完全包含 resultArray
                  const shouldDisplay = resultArray.every((tag) =>
                    itemDataTarget.map((t) => t.trim()).includes(tag.trim())
                  );

                  if (shouldDisplay) {
                    item.style.display = 'flex'; // 如果 itemDataTarget 包含 resultArray 中的所有元素，显示
                  } else {
                    item.style.display = 'none'; // 否则隐藏
                  }
                } else {
                  item.style.display = 'none'; // 如果没有 itemDataTarget 则隐藏
                }

                if (!tagsShow) {
                  item.style.display = 'flex'; // 如果 tagsShow 为 false，显示为 flex
                }
              }
            });
          }

          hasActiveClass(navList) {
            // 使用 querySelector 查找 navList 的子级中是否有包含 'active' 的元素
            if (navList.querySelector('.nav-active')) {
              return true; // 如果找到包含 active 类的子元素，返回 true
            }
            return false; // 否则返回 false
          }
          removeTagFromScene(tag, filter_scenes, productList, productList_item, resultArray, navList) {
            let cleanedTag = tag.replace(/^[\s#]+/, '').trim(); // 去掉空格和特殊字符
            const index = resultArray.indexOf(cleanedTag);

            if (index > -1) {
              resultArray.splice(index, 1); // 如果找到，移除该项
              this.filterProduct(filter_scenes, productList, productList_item, resultArray, navList);
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["menu-plan-4"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('menu-plan-4')) {
      customElements.define(
        'menu-plan-4',
        class menuPlan4 extends HTMLElement {
          constructor() {
            super();
            this.$swiperContainer = null;
            this.$swiper = null;
          }

          connectedCallback() {
            this.$swiperContainer = this.querySelector('.plan3Swiper');
            this.init();
          }
          init() {
            this.$swiper = new Swiper('.plan3Swiper', {
              slidesPerView: 5,
              spaceBetween: 21,
              freeMode: true,
              cssMode: true,
              breakpoints: {
                1400: {
                  slidesPerView: 5,
                },
                1100: {
                  slidesPerView: 5,
                },
                992: {
                  slidesPerView: 4,
                },
                768: {
                  slidesPerView: 3,
                },
                576: {
                  slidesPerView: 2,
                },

                370: {
                  slidesPerView: 2,
                },
              },
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-video-controller"] && !Shopify.designMode) return;
  try {
    // 移动端视频控制器类
  class MobileVideoController {
    constructor(options = {}) {
      this.isMobile = window.innerWidth <= (options.mobileBreakpoint || 768);
      this.videoElement = options.videoElement;
      this.containerElement = options.containerElement;
      this.isPlaying = options.initialState || false;
      this.type = options.type || 'html5'; // 'html5' 或 'youtube'

      this.init();
    }

    init() {
      if (!this.videoElement && !this.containerElement) {
        console.error('MobileVideoController: 需要提供videoElement或containerElement');
        return;
      }

      this.bindEvents();
      this.checkMobile();
    }

    bindEvents() {
      // 窗口大小变化时重新检测移动端
      window.addEventListener('resize', () => {
        this.checkMobile();
      });

      // 点击事件
      const targetElement = this.containerElement || this.videoElement;
      targetElement.addEventListener('click', (e) => {
        this.handleClick(e);
      });

      // 触摸事件（移动端）
      targetElement.addEventListener('touchend', (e) => {
        this.handleTouch(e);
      });

      // 监听YouTube播放状态变化
      if (this.type === 'youtube') {
        window.addEventListener('message', (event) => {
          this.handleYouTubeMessage(event);
        });
      }
    }

    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    }

    handleClick(e) {
      if (!this.isMobile) return;

      e.preventDefault();
      e.stopPropagation();
      this.togglePlayPause();
    }

    handleTouch(e) {
      if (!this.isMobile) return;

      e.preventDefault();
      e.stopPropagation();
      this.togglePlayPause();
    }

    togglePlayPause() {
      if (this.type === 'html5') {
        this.toggleHTML5Video();
      } else if (this.type === 'youtube') {
        this.toggleYouTubeVideo();
      }
    }

    toggleHTML5Video() {
      if (this.videoElement.paused) {
        this.videoElement.play();
        this.isPlaying = true;
      } else {
        this.videoElement.pause();
        this.isPlaying = false;
      }
    }

    toggleYouTubeVideo() {
      const iframe = this.containerElement.querySelector('iframe');
      if (!iframe) return;

      try {
        if (this.isPlaying) {
          // 暂停视频
          iframe.contentWindow.postMessage(
            JSON.stringify({
              event: 'command',
              func: 'pauseVideo',
            }),
            '*'
          );
          this.isPlaying = false;
        } else {
          // 播放视频
          iframe.contentWindow.postMessage(
            JSON.stringify({
              event: 'command',
              func: 'playVideo',
            }),
            '*'
          );
          this.isPlaying = true;
        }
      } catch (error) {
        console.error('Failed to control YouTube video:', error);
      }
    }

    handleYouTubeMessage(event) {
      if (event.origin !== 'https://www.youtube.com') return;

      try {
        const data = JSON.parse(event.data);
        if (data.event === 'video-progress') {
          // YouTube视频状态更新
          if (data.info && data.info.playerState !== undefined) {
            this.isPlaying = data.info.playerState === 1; // 1 = 播放中
          }
        }
      } catch (error) {
        // 忽略解析错误
      }
    }

    // 公共方法：更新播放状态
    updatePlayingState(isPlaying) {
      this.isPlaying = isPlaying;
    }

    // 公共方法：销毁控制器
    destroy() {
      window.removeEventListener('resize', this.checkMobile);
      window.removeEventListener('message', this.handleYouTubeMessage);
    }
  }

  // 全局暴露控制器类
  window.MobileVideoController = MobileVideoController;
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["price-range"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('price-range')) {
      customElements.define(
        'price-range',
        class priceRange extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            const rangeInput = this.querySelectorAll('.range-input input');
            const priceInput = this.querySelectorAll('.price-input input');
            const progress = this.querySelector('.slider .progress');
            let priceGap = 1;

            this.updatePrice(rangeInput);
            rangeInput.forEach((input) => {
              input.addEventListener('input', (event) => this.updatePrice(event));
            });

            priceInput.forEach((input) => {
              input.addEventListener('input', (e) => {
                let minVal = parseFloat(priceInput[0].value);
                let maxVal = parseFloat(priceInput[1].value);
                const min = parseFloat(input.min);
                const max = parseFloat(input.max);
                if (minVal < min) {
                  $(this).val(min);
                }
                if (maxVal > max) {
                  $(this).val(max);
                }

                if (maxVal - minVal >= priceGap && maxVal <= 999999.99) {
                  if (e.target.className === 'input-min') {
                    rangeInput[0].value = minVal;
                    progress.style.left = (minVal / rangeInput[0].max) * 100 + '%';
                  } else {
                    rangeInput[1].value = maxVal;
                    progress.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + '%';
                  }
                }
              });
            });
          }

          updatePrice = (e) => {
            const rangeInput = this.querySelectorAll('.range-input input');
            const priceInput = this.querySelectorAll('.price-input input');
            const progress = this.querySelector('.slider .progress');
            let priceGap = 1;
            let minVal = parseInt(rangeInput[0].value);
            let maxVal = parseInt(rangeInput[1].value);

            if (maxVal - minVal < priceGap) {
              if (e.target.className === 'range-min') {
                rangeInput[0].value = maxVal - priceGap;
              } else {
                rangeInput[1].value = minVal + priceGap;
              }
            } else {
              priceInput[0].value = minVal;
              priceInput[1].value = maxVal;
              progress.style.left = (minVal / rangeInput[0].max) * 100 + '%';
              progress.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + '%';
            }
          };
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-content-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    if (!customElements.get('product-content-product-set')) {
      customElements.define(
        'product-content-product-set',
        class RoProductContentProductSet extends HTMLElement {
          constructor() {
            super();
            this.selectedOption = null;
          }

          connectedCallback() {
            this.init();
          }

          init() {
            this.options = this.querySelectorAll('.product-content-product-set__option');
            this.bindEvents();

            // 监听页面可见性变化（移动端返回页面时触发）
            document.addEventListener('visibilitychange', () => {
              if (!document.hidden) {
                this.setInitialSelection();
              }
            });

            // 监听 pageshow 事件（捕获浏览器前进/返回操作）
            window.addEventListener('pageshow', (e) => {
              if (e.persisted) {
                // 从 bfcache 返回，重新初始化
                this.setInitialSelection();
              }
            });

            this.setInitialSelection();
          }

          bindEvents() {
            // 点击选项
            this.options.forEach((option) => {
              option.addEventListener('click', (e) => {
                e.preventDefault();
                this.selectOption(option);
              });
            });
          }

          setInitialSelection() {
            // 通过当前页面 URL 匹配选项
            const currentPath = window.location.pathname;
            const currentOption = Array.from(this.options).find((opt) => {
              try {
                const optionUrl = new URL(opt.href, window.location.origin);
                return optionUrl.pathname === currentPath;
              } catch (e) {
                // 如果 href 是相对路径，直接比较
                return opt.getAttribute('href') === currentPath;
              }
            });

            if (currentOption) {
              this.selectOption(currentOption, false);
            } else {
              // 如果没有找到匹配的，保持第一个选中状态
              const selectedOption = this.querySelector('.product-content-product-set__option.selected');
              if (selectedOption) {
                this.selectedOption = selectedOption;
              }
            }
          }

          selectOption(option, navigate = true) {
            // 移除之前的选中状态
            this.options.forEach((opt) => opt.classList.remove('selected'));

            // 设置新的选中状态
            option.classList.add('selected');
            this.selectedOption = option;

            // 如果需要导航，跳转到产品页面
            if (navigate && option.href) {
              window.location.href = option.href;
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-image-zoom-v2"] && !Shopify.designMode) return;
  try {
    // Load PhotoSwipe scripts dynamically before use

  $(function () {
    if (!customElements.get('product-image-zoom')) {
      customElements.define(
        'product-image-zoom',
        class ProductImageZoom extends HTMLElement {
          constructor() {
            super();
            this.imagesArray = [];
            this.pswp = null;
            this.currentIndex = 0;
            this.isPlaying = false;
            this._isClosing = false;
            this._playTimer = null;
            this._thumbBarEl = null;
            this._playStartTime = null;
            this._playRafId = null;
            this._playDuration = 2000;
            this._dataItems = [];
            this._playIndex = 0;
            this.currentRotation = 0;
          }

          connectedCallback() {}

          disconnectedCallback() {
            this._stopPlay();
            this._destroyPswp();
          }

          setImages(images) {
            if (!Array.isArray(images)) {
              console.error('setImages: images must be an array');
              return;
            }
            this.imagesArray = images;
            this._dataItems = images.map(function (m) {
              var src = '';
              if (typeof m === 'string') {
                src = m;
              } else if (m.src) {
                src = m.src;
              } else if (m.preview_image?.src) {
                src = m.preview_image.src;
              } else if (m.url) {
                src = m.url;
              } else {
                for (var k in m) {
                  if (m.hasOwnProperty(k) && typeof m[k] === 'string') {
                    src = m[k];
                    break;
                  }
                }
              }
              return {
                src: src,
                w: m.width || m.preview_image?.width || 1200,
                h: m.height || m.preview_image?.height || 900,
              };
            });
            this._buildPageThumbs();
          }

          // ─── Page-level thumbnail strip ───────────────────────────────────

          _buildPageThumbs() {
            var strip = this.querySelector('.piz-page-thumbs');
            if (!strip) return;
            var inner = strip.querySelector('.piz-page-thumbs-inner');
            if (!inner) return;

            // Remove old thumbnail items
            var oldThumbs = inner.querySelectorAll('.piz-page-thumb');
            oldThumbs.forEach(function (t) {
              t.remove();
            });

            if (!this._dataItems || this._dataItems.length === 0) {
              strip.classList.remove('show');
              return;
            }

            var self = this;
            this._dataItems.forEach(function (item, i) {
              var src = item.src || item.thumb;
              if (!src) return;

              var thumb = document.createElement('div');
              thumb.className = 'piz-page-thumb';
              thumb.setAttribute('role', 'listitem');
              thumb.dataset.index = i;

              var img = document.createElement('img');
              img.src = src;
              img.alt = '';

              thumb.appendChild(img);

              thumb.addEventListener('click', function () {
                // Reset auto-play timer when user manually selects (keep playing)
                var wasPlaying = self.isPlaying;
                if (wasPlaying) {
                  self._stopPlay();
                }
                self.currentIndex = i;
                self._updatePageProgress(0);
                // Switch PhotoSwipe to the selected image if it's open
                if (self.pswp) {
                  self.pswp.goTo(i);
                  self._syncPageThumbs(i);
                }
                // Resume auto-play if it was playing before
                if (wasPlaying) {
                  self._startPlay();
                }
                // Sync swiper slide
                self.dispatchEvent(
                  new CustomEvent('piz:thumb-click', {
                    bubbles: true,
                    composed: true,
                    detail: { index: i },
                  })
                );
              });

              inner.appendChild(thumb);
            });

            strip.classList.add('show');
            this._syncPageThumbs(0);
          }

          _syncPageThumbs(activeIndex) {
            var strip = this.querySelector('.piz-page-thumbs');
            if (!strip) return;
            var inner = this.querySelector('.piz-page-thumbs-inner');
            if (!inner) return;

            var thumbs = strip.querySelectorAll('.piz-page-thumb');
            thumbs.forEach(function (thumb, i) {
              var isActive = parseInt(thumb.dataset.index) === activeIndex;
              thumb.classList.toggle('active', isActive);
            });

            // 找到当前激活的缩略图
            var activeThumb = strip.querySelector('.piz-page-thumb.active');
            if (activeThumb && inner) {
              // 计算滚动位置使当前项居中
              var containerWidth = inner.offsetWidth;
              var thumbLeft = activeThumb.offsetLeft;
              var thumbWidth = activeThumb.offsetWidth;
              var scrollTarget = thumbLeft - containerWidth / 2 + thumbWidth / 2;

              // 确保不超出边界
              var maxScroll = inner.scrollWidth - containerWidth;
              scrollTarget = Math.max(0, Math.min(scrollTarget, maxScroll));

              inner.scrollTo({ left: scrollTarget, behavior: 'smooth' });
            }
          }

          _updatePageProgress(progress) {
            var strip = this.querySelector('.piz-page-thumbs');
            if (!strip) return;
            strip.style.setProperty('--piz-progress', progress.toFixed(4));
          }

          _showPageThumbs() {
            var strip = this.querySelector('.piz-page-thumbs');
            if (strip) strip.classList.add('show');
          }
          _showCounter(currentIndex, totalIndex) {
            var counter = this.querySelector('.piz-counter');
            if (counter) {
              counter.innerHTML = `${currentIndex} / ${totalIndex}`;
              counter.classList.add('show');
            }
          }
          _hidePageThumbs() {
            var strip = this.querySelector('.piz-page-thumbs');
            if (strip) strip.classList.remove('show');
          }
          _hideCounter() {
            var counter = this.querySelector('.piz-counter');
            if (counter) counter.classList.remove('show');
          }
          syncToSwiperSlide(index) {
            this.currentIndex = index;
            this._syncPageThumbs(index);
          }

          // ─── PhotoSwipe lifecycle ───────────────────────────────────────────

          _destroyPswp() {
            if (this.pswp) {
              this.pswp.destroy();
              this.pswp = null;
            }
          }

          _startPlay() {
            // Unified auto-play: PhotoSwipe switch + page thumbnail progress + main swiper
            this.isPlaying = true;
            this._playStartTime = performance.now();
            this._playIndex = this.currentIndex;
            var self = this;
            var tick = function (now) {
              if (!self.isPlaying) return;
              var elapsed = now - self._playStartTime;
              var progress = Math.min(elapsed / 3000, 1);
              self._updateProgressBar(progress);
              self._updatePageProgress(progress);
              if (progress >= 1) {
                var nextIndex = (self.currentIndex + 1) % self._dataItems.length;
                self.currentIndex = nextIndex;
                self._syncPageThumbs(self.currentIndex);
                self._updatePageProgress(0);
                if (self.pswp) {
                  self.pswp.goTo(nextIndex);
                }
                self._updateProgressBar(0);
                self.dispatchEvent(
                  new CustomEvent('piz:page-next', {
                    bubbles: true,
                    composed: true,
                    detail: { index: self.currentIndex },
                  })
                );
                self._playStartTime = now;
              }
              self._playRafId = requestAnimationFrame(tick);
            };
            this._playRafId = requestAnimationFrame(tick);
          }

          _stopPlay() {
            this.isPlaying = false;
            if (this._playRafId) {
              cancelAnimationFrame(this._playRafId);
              this._playRafId = null;
            }
            this._playStartTime = null;
            this._updateProgressBar(0);
            this._updatePageProgress(0);
          }

          rotateImage() {
            this.currentRotation = (this.currentRotation + 90) % 360;
            const img = this._getCurrentPswpImg();
            if (img) {
              img.style.transition = 'transform 0.3s ease';
              img.style.transform = 'rotate(' + this.currentRotation + 'deg)';
              setTimeout(() => {
                img.style.transition = '';
              }, 300);
            }
          }

          _getCurrentPswpImg() {
            const currSlide = this.pswp?.currSlide;
            const contentEl = currSlide?.content?.element;
            if (contentEl && contentEl.tagName === 'IMG') return contentEl;
            if (contentEl) {
              const nestedImg = contentEl.querySelector('img');
              if (nestedImg) return nestedImg;
            }

            const pswpEl = this.pswp?.element;
            if (!pswpEl) return null;
            return pswpEl.querySelector('.pswp__img') || pswpEl.querySelector('img');
          }

          toggleFullscreen() {
            if (!document.fullscreenElement) {
              document.documentElement.requestFullscreen?.();
            } else {
              document.exitFullscreen?.();
            }
          }

          // ─── Page-level thumbnail bar ─────────────────────────────────────

          _createThumbBar() {
            if (this._thumbBarEl) return;
            const bar = document.createElement('div');
            bar.className = 'piz-thumb-bar';

            this._dataItems.forEach((item, i) => {
              const src = item.src || item.thumb;
              if (!src) return;
              const thumbItem = document.createElement('div');
              thumbItem.className = 'piz-thumb-item' + (i === this.currentIndex ? ' active' : '');
              thumbItem.dataset.index = i;

              const img = document.createElement('img');
              img.src = src;
              img.alt = '';
              thumbItem.appendChild(img);

              thumbItem.addEventListener('click', () => {
                this.pswp?.goTo(i);
              });

              bar.appendChild(thumbItem);
            });

            document.body.appendChild(bar);
            this._thumbBarEl = bar;
          }

          _removeThumbBar() {
            if (this._thumbBarEl) {
              this._thumbBarEl.remove();
              this._thumbBarEl = null;
            }
          }

          _updateThumbBar() {
            if (!this._thumbBarEl) return;
            const items = this._thumbBarEl.querySelectorAll('.piz-thumb-item');
            items.forEach((item, i) => {
              const isActive = i === this.currentIndex;
              if (item.classList.contains('active') !== isActive) {
                item.classList.toggle('active', isActive);
              }
              if (isActive) {
                item.scrollIntoView({ behavior: 'instant', inline: 'nearest', block: 'nearest' });
              }
            });
          }

          _updateProgressBar(progress) {
            if (!this._thumbBarEl) return;
            this._thumbBarEl.style.setProperty('--piz-progress', progress.toFixed(4));
          }

          openPreview(index) {
            console.log('[PhotoSwipe] openPreview called, index:', index);
            this._isClosing = false;
            this._hidePageThumbs();
            this._hideCounter();
            const self = this;

            const rawProductMedia = this.querySelector('.product-media');
            console.log(rawProductMedia, 'rawProductMedia');
            let rawMedia = [];

            if (rawProductMedia && rawProductMedia.textContent.trim()) {
              try {
                const productData = JSON.parse(rawProductMedia.textContent);
                rawMedia = (Array.isArray(productData) ? productData : [])
                  .filter(function (m) {
                    if (!m) return false;
                    if (m.media_type === 'image' && m.preview_image) return true;
                    if (m.preview_image?.src) return true;
                    if (m.src) return true;
                    return false;
                  })
                  .map(function (m) {
                    return {
                      src: m.preview_image?.src || m.src || '',
                      w: m.preview_image?.width || m.width || 1200,
                      h: m.preview_image?.height || m.height || 900,
                    };
                  });
              } catch (e) {
                console.error('[PhotoSwipe] failed to parse product-media:', e);
              }
            }

            if (rawMedia.length === 0) {
              console.warn('[PhotoSwipe] No images to preview');
              return;
            }

            this._dataItems = rawMedia;
            console.log('[PhotoSwipe] items:', this._dataItems.length, '(product mode)');

            this._destroyPswp();

            // Load scripts if not already loaded, then open
            loadPswpScripts()
              .then(function () {
                console.log('[PhotoSwipe] scripts loaded, creating PhotoSwipe...');
                // Manually create PhotoSwipe Core to avoid loadAndOpen overriding dataSource
                var pswpModule = PhotoSwipe;
                self.pswp = new pswpModule({
                  dataSource: self._dataItems,
                  index: index,
                  loop: true,
                  showHideAnimationType: 'fade',
                  zoom: true,
                  allowPanToNext: false,
                  spacing: 0,
                  bgOpacity: 1,
                  bgBackgroundColor: 'rgba(255,255,255,1)',
                  margin: 0,
                  counter: false,
                  toolbar: false,
                  arrowPrev: false,
                  arrowNext: false,
                  close: false,
                  captionContent: false,
                  initialZoomLevel: 'fit',
                  secondaryZoomLevel: 1,
                  maxZoomLevel: 2,
                  closeOnVerticalDrag: false,
                  pinchToClose: false,
                  allowReturnFromMinZoom: false,
                  padding: { top: 60, bottom: 160 },
                });

                self.pswp.on('afterInit', function () {
                  console.log('[PhotoSwipe] afterInit event fired');
                  var pswpEl = self.pswp.element;
                  if (!pswpEl) return;

                  // 从模板克隆控制按钮
                  var template = document.getElementById('piz-ctrl-template');
                  if (!template) return;
                  var clonedContent = template.content.cloneNode(true);
                  var controls = clonedContent.querySelector('.piz-ctrl');
                  var navBtns = clonedContent.querySelectorAll('.piz-nav-btn');
                  pswpEl.appendChild(controls);
                  navBtns.forEach(function (btn) {
                    pswpEl.appendChild(btn);
                  });

                  // 绑定旋转按钮
                  var btnRotate = controls.querySelector('[data-action="rotate"]');
                  if (btnRotate) {
                    btnRotate.addEventListener('click', function () {
                      self.rotateImage();
                    });
                  }

                  // 绑定全屏按钮
                  var btnFullscreen = controls.querySelector('[data-action="fullscreen"]');
                  var iconFull = btnFullscreen ? btnFullscreen.querySelector('.icon-full') : null;
                  var iconShrink = btnFullscreen ? btnFullscreen.querySelector('.icon-shrink') : null;
                  if (btnFullscreen) {
                    btnFullscreen.addEventListener('click', function () {
                      self.toggleFullscreen();
                    });
                  }

                  // 监听全屏状态变化，同步图标
                  function onFullscreenChange() {
                    var isFs = !!document.fullscreenElement;
                    if (iconFull) iconFull.style.display = isFs ? 'none' : '';
                    if (iconShrink) iconShrink.style.display = isFs ? '' : 'none';
                    if (btnFullscreen) btnFullscreen.title = isFs ? 'Exit Fullscreen' : 'Fullscreen';
                  }
                  document.addEventListener('fullscreenchange', onFullscreenChange);

                  // 绑定播放/停止按钮
                  var btnPlay = controls.querySelector('[data-action="play"]');
                  var iconPlay = btnPlay ? btnPlay.querySelector('.icon-play') : null;
                  var iconStop = btnPlay ? btnPlay.querySelector('.icon-stop') : null;
                  if (btnPlay) {
                    btnPlay.addEventListener('click', function () {
                      if (self.isPlaying) {
                        self._stopPlay();
                        if (iconPlay) iconPlay.style.display = '';
                        if (iconStop) iconStop.style.display = 'none';
                      } else {
                        self._startPlay();
                        if (iconPlay) iconPlay.style.display = 'none';
                        if (iconStop) iconStop.style.display = '';
                      }
                    });
                  }

                  // 绑定关闭按钮
                  var btnClose = controls.querySelector('[data-action="close"]');
                  if (btnClose) {
                    btnClose.addEventListener('click', function () {
                      requestAnimationFrame(function () {
                        requestAnimationFrame(function () {
                          if (self.pswp && typeof self.pswp.close === 'function') {
                            self.pswp.close();
                          }
                        });
                      });
                    });
                  }

                  // 绑定左右切换按钮
                  var btnPrev = pswpEl.querySelector('[data-action="prev"]');
                  var btnNext = pswpEl.querySelector('[data-action="next"]');
                  if (btnPrev) {
                    btnPrev.addEventListener('click', function () {
                      self.pswp.goTo(self.pswp.currIndex - 1);
                    });
                  }
                  if (btnNext) {
                    btnNext.addEventListener('click', function () {
                      self.pswp.goTo(self.pswp.currIndex + 1);
                    });
                  }

                  // 隐藏原生 zoom 按钮
                  var style = document.createElement('style');
                  style.textContent =
                    '.pswp__button--zoom { display: none !important; } .pswp__bg { background: #ffffff !important; }';
                  pswpEl.appendChild(style);
                });

                self.pswp.on('change', function () {
                  console.log('[PhotoSwipe] change fired, currIndex:', self.pswp.currIndex);
                  console.log(
                    '[PhotoSwipe] Current: ' + (self.pswp.currIndex + 1) + ' / Total: ' + self._dataItems.length
                  );
                  let currentIndex = self.pswp.currIndex + 1;
                  let totalIndex = self._dataItems.length;
                  self.currentIndex = self.pswp.currIndex;
                  // 等 pswp--open 出现后再执行
                  requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                      setTimeout(function () {
                        self._showCounter(currentIndex, totalIndex);
                        self._showPageThumbs();
                        self._updateThumbBar();
                        self._syncPageThumbs(self.currentIndex);
                        self._updatePageProgress(0);
                      }, 100);
                    });
                  });
                  // Reset play timer if auto-play is running
                  if (self.isPlaying) {
                    self._playStartTime = performance.now();
                  }
                });

                self.pswp.on('firstZoomPanAnimShow', function () {
                  console.log('[PhotoSwipe] firstZoomPanAnimShow fired');
                  self.currentIndex = index;
                  // 等 pswp--open 和动画完成后再执行
                  requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                      setTimeout(function () {
                        self._createThumbBar();
                        self._updateThumbBar();
                        self._showCounter(index + 1, self._dataItems.length);
                        self._showPageThumbs();
                        self._syncPageThumbs(index);
                        self._updatePageProgress(0);
                      }, 100); // 额外等待 50ms 确保 DOM 完全渲染
                    });
                  });
                });

                self.pswp.on('close', function () {
                  console.log('[PhotoSwipe] close fired');
                  // 阻止通过 pinch-to-close 关闭
                  if (self._pinchCloseTriggered) {
                    console.log('[PhotoSwipe] pinch-to-close blocked');
                    self._pinchCloseTriggered = false;
                    return;
                  }
                  self._stopPlay();
                  self._hidePageThumbs();
                  self._hideCounter();
                });

                self.pswp.on('destroy', function () {
                  console.log('[PhotoSwipe] destroy fired');
                  self._isClosing = false;
                  self._pinchCloseTriggered = false;
                  self._removeThumbBar();
                  self.pswp = null;
                });

                self.pswp.on('error', function (e) {
                  console.error('[PhotoSwipe] error:', e);
                });

                self.pswp.on('loadError', function (e) {
                  console.error('[PhotoSwipe] loadError:', e);
                });

                // init() opens the gallery directly
                self.pswp.init();
                console.log('[PhotoSwipe] init() called');
              })
              .catch(function (err) {
                console.error('[PhotoSwipe] failed to load scripts:', err);
              });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-image-zoom"] && !Shopify.designMode) return;
  try {
    // Load PhotoSwipe scripts dynamically before use

  $(function () {
    if (!customElements.get('product-image-zoom')) {
      customElements.define(
        'product-image-zoom',
        class ProductImageZoom extends HTMLElement {
          constructor() {
            super();
            this.imagesArray = [];
            this.isPackageMode = false;
            this.pswp = null;
            this.currentIndex = 0;
            this.isPlaying = false;
            this._isClosing = false;
            this._playTimer = null;
            this._thumbBarEl = null;
            this._playStartTime = null;
            this._playRafId = null;
            this._playDuration = 2000;
            this._dataItems = [];
            this._playIndex = 0;
            this.currentRotation = 0;
          }

          connectedCallback() {}

          disconnectedCallback() {
            this._stopPlay();
            this._destroyPswp();
          }

          setMode(isPackage) {
            this.isPackageMode = isPackage;
          }

          setImages(images) {
            if (!Array.isArray(images)) {
              console.error('setImages: images must be an array');
              return;
            }
            this.imagesArray = images;
            this._dataItems = images.map(function (m) {
              var src = '';
              if (typeof m === 'string') {
                src = m;
              } else if (m.src) {
                src = m.src;
              } else if (m.preview_image?.src) {
                src = m.preview_image.src;
              } else if (m.url) {
                src = m.url;
              } else {
                for (var k in m) {
                  if (m.hasOwnProperty(k) && typeof m[k] === 'string') {
                    src = m[k];
                    break;
                  }
                }
              }
              return {
                src: src,
                w: m.width || m.preview_image?.width || 1200,
                h: m.height || m.preview_image?.height || 900,
              };
            });
            this._buildPageThumbs();
          }

          // ─── Page-level thumbnail strip ───────────────────────────────────

          _buildPageThumbs() {
            var strip = this.querySelector('.piz-page-thumbs');
            if (!strip) return;
            var inner = strip.querySelector('.piz-page-thumbs-inner');
            if (!inner) return;

            // Remove old thumbnail items
            var oldThumbs = inner.querySelectorAll('.piz-page-thumb');
            oldThumbs.forEach(function (t) {
              t.remove();
            });

            if (!this._dataItems || this._dataItems.length === 0) {
              strip.classList.remove('show');
              return;
            }

            var self = this;
            this._dataItems.forEach(function (item, i) {
              var src = item.src || item.thumb;
              if (!src) return;

              var thumb = document.createElement('div');
              thumb.className = 'piz-page-thumb';
              thumb.setAttribute('role', 'listitem');
              thumb.dataset.index = i;

              var img = document.createElement('img');
              img.src = src;
              img.alt = '';

              thumb.appendChild(img);

              thumb.addEventListener('click', function () {
                // Reset auto-play timer when user manually selects (keep playing)
                var wasPlaying = self.isPlaying;
                if (wasPlaying) {
                  self._stopPlay();
                }
                self.currentIndex = i;
                self._updatePageProgress(0);
                // Switch PhotoSwipe to the selected image if it's open
                if (self.pswp) {
                  self.pswp.goTo(i);
                  self._syncPageThumbs(i);
                }
                // Resume auto-play if it was playing before
                if (wasPlaying) {
                  self._startPlay();
                }
                // Sync swiper slide
                self.dispatchEvent(
                  new CustomEvent('piz:thumb-click', {
                    bubbles: true,
                    composed: true,
                    detail: { index: i },
                  })
                );
              });

              inner.appendChild(thumb);
            });

            strip.classList.add('show');
            this._syncPageThumbs(0);
          }

          _syncPageThumbs(activeIndex) {
            var strip = this.querySelector('.piz-page-thumbs');
            if (!strip) return;
            var inner = this.querySelector('.piz-page-thumbs-inner');
            if (!inner) return;

            var thumbs = strip.querySelectorAll('.piz-page-thumb');
            thumbs.forEach(function (thumb, i) {
              var isActive = parseInt(thumb.dataset.index) === activeIndex;
              thumb.classList.toggle('active', isActive);
            });

            // 找到当前激活的缩略图
            var activeThumb = strip.querySelector('.piz-page-thumb.active');
            if (activeThumb && inner) {
              // 计算滚动位置使当前项居中
              var containerWidth = inner.offsetWidth;
              var thumbLeft = activeThumb.offsetLeft;
              var thumbWidth = activeThumb.offsetWidth;
              var scrollTarget = thumbLeft - containerWidth / 2 + thumbWidth / 2;

              // 确保不超出边界
              var maxScroll = inner.scrollWidth - containerWidth;
              scrollTarget = Math.max(0, Math.min(scrollTarget, maxScroll));

              inner.scrollTo({ left: scrollTarget, behavior: 'smooth' });
            }
          }

          _updatePageProgress(progress) {
            var strip = this.querySelector('.piz-page-thumbs');
            if (!strip) return;
            strip.style.setProperty('--piz-progress', progress.toFixed(4));
          }

          _showPageThumbs() {
            var strip = this.querySelector('.piz-page-thumbs');
            if (strip) strip.classList.add('show');
          }
          _showCounter(currentIndex, totalIndex) {
            var counter = this.querySelector('.piz-counter');
            if (counter) {
              counter.innerHTML = `${currentIndex} / ${totalIndex}`;
              counter.classList.add('show');
            }
          }
          _hidePageThumbs() {
            var strip = this.querySelector('.piz-page-thumbs');
            if (strip) strip.classList.remove('show');
          }
          _hideCounter() {
            var counter = this.querySelector('.piz-counter');
            if (counter) counter.classList.remove('show');
          }
          syncToSwiperSlide(index) {
            this.currentIndex = index;
            this._syncPageThumbs(index);
          }

          // ─── PhotoSwipe lifecycle ───────────────────────────────────────────

          _destroyPswp() {
            if (this.pswp) {
              this.pswp.destroy();
              this.pswp = null;
            }
          }

          _startPlay() {
            // Unified auto-play: PhotoSwipe switch + page thumbnail progress + main swiper
            this.isPlaying = true;
            this._playStartTime = performance.now();
            this._playIndex = this.currentIndex;
            var self = this;
            var tick = function (now) {
              if (!self.isPlaying) return;
              var elapsed = now - self._playStartTime;
              var progress = Math.min(elapsed / 3000, 1);
              self._updateProgressBar(progress);
              self._updatePageProgress(progress);
              if (progress >= 1) {
                var nextIndex = (self.currentIndex + 1) % self._dataItems.length;
                self.currentIndex = nextIndex;
                self._syncPageThumbs(self.currentIndex);
                self._updatePageProgress(0);
                if (self.pswp) {
                  self.pswp.goTo(nextIndex);
                }
                self._updateProgressBar(0);
                self.dispatchEvent(
                  new CustomEvent('piz:page-next', {
                    bubbles: true,
                    composed: true,
                    detail: { index: self.currentIndex },
                  })
                );
                self._playStartTime = now;
              }
              self._playRafId = requestAnimationFrame(tick);
            };
            this._playRafId = requestAnimationFrame(tick);
          }

          _stopPlay() {
            this.isPlaying = false;
            if (this._playRafId) {
              cancelAnimationFrame(this._playRafId);
              this._playRafId = null;
            }
            this._playStartTime = null;
            this._updateProgressBar(0);
            this._updatePageProgress(0);
          }

          rotateImage() {
            this.currentRotation = (this.currentRotation + 90) % 360;
            const img = this._getCurrentPswpImg();
            if (img) {
              img.style.transition = 'transform 0.3s ease';
              img.style.transform = 'rotate(' + this.currentRotation + 'deg)';
              setTimeout(() => {
                img.style.transition = '';
              }, 300);
            }
          }

          _getCurrentPswpImg() {
            const currSlide = this.pswp?.currSlide;
            const contentEl = currSlide?.content?.element;
            if (contentEl && contentEl.tagName === 'IMG') return contentEl;
            if (contentEl) {
              const nestedImg = contentEl.querySelector('img');
              if (nestedImg) return nestedImg;
            }

            const pswpEl = this.pswp?.element;
            if (!pswpEl) return null;
            return pswpEl.querySelector('.pswp__img') || pswpEl.querySelector('img');
          }

          toggleFullscreen() {
            if (!document.fullscreenElement) {
              document.documentElement.requestFullscreen?.();
            } else {
              document.exitFullscreen?.();
            }
          }

          // ─── Page-level thumbnail bar ─────────────────────────────────────

          _createThumbBar() {
            if (this._thumbBarEl) return;
            const bar = document.createElement('div');
            bar.className = 'piz-thumb-bar';

            this._dataItems.forEach((item, i) => {
              const src = item.src || item.thumb;
              if (!src) return;
              const thumbItem = document.createElement('div');
              thumbItem.className = 'piz-thumb-item' + (i === this.currentIndex ? ' active' : '');
              thumbItem.dataset.index = i;

              const img = document.createElement('img');
              img.src = src;
              img.alt = '';
              thumbItem.appendChild(img);

              thumbItem.addEventListener('click', () => {
                this.pswp?.goTo(i);
              });

              bar.appendChild(thumbItem);
            });

            document.body.appendChild(bar);
            this._thumbBarEl = bar;
          }

          _removeThumbBar() {
            if (this._thumbBarEl) {
              this._thumbBarEl.remove();
              this._thumbBarEl = null;
            }
          }

          _updateThumbBar() {
            if (!this._thumbBarEl) return;
            const items = this._thumbBarEl.querySelectorAll('.piz-thumb-item');
            items.forEach((item, i) => {
              const isActive = i === this.currentIndex;
              if (item.classList.contains('active') !== isActive) {
                item.classList.toggle('active', isActive);
              }
              if (isActive) {
                item.scrollIntoView({ behavior: 'instant', inline: 'nearest', block: 'nearest' });
              }
            });
          }

          _updateProgressBar(progress) {
            if (!this._thumbBarEl) return;
            this._thumbBarEl.style.setProperty('--piz-progress', progress.toFixed(4));
          }

          openPreview(index) {
            console.log('[PhotoSwipe] openPreview called, index:', index);
            this._isClosing = false;
            this._hidePageThumbs();
            this._hideCounter();
            const self = this;

            const rawProductMedia = this.querySelector('.product-media');
            console.log(rawProductMedia, 'rawProductMedia');
            const rawPackageMedia = this.querySelector('.package-media');
            let rawMedia = [];

            if (this.isPackageMode && rawPackageMedia && rawPackageMedia.textContent.trim()) {
              try {
                const pkgData = JSON.parse(rawPackageMedia.textContent);
                if (pkgData && Object.keys(pkgData).length > 0) {
                  rawMedia = Object.entries(pkgData).map(([k, url]) => {
                    const safeUrl = typeof url === 'string' && url.startsWith('//') ? 'https:' + url : url;
                    return { src: safeUrl, w: 1200, h: 900 };
                  });
                }
              } catch (e) {
                console.error('[PhotoSwipe] failed to parse package-media:', e);
              }
            }

            if (rawMedia.length === 0 && rawProductMedia && rawProductMedia.textContent.trim()) {
              try {
                const productData = JSON.parse(rawProductMedia.textContent);
                rawMedia = (Array.isArray(productData) ? productData : [])
                  .filter(function (m) {
                    if (!m) return false;
                    if (m.media_type === 'image' && m.preview_image) return true;
                    if (m.preview_image?.src) return true;
                    if (m.src) return true;
                    return false;
                  })
                  .map(function (m) {
                    return {
                      src: m.preview_image?.src || m.src || '',
                      w: m.preview_image?.width || m.width || 1200,
                      h: m.preview_image?.height || m.height || 900,
                    };
                  });
              } catch (e) {
                console.error('[PhotoSwipe] failed to parse product-media:', e);
              }
            }

            if (rawMedia.length === 0) {
              console.warn('[PhotoSwipe] No images to preview');
              return;
            }

            this._dataItems = rawMedia;
            console.log(
              '[PhotoSwipe] items:',
              this._dataItems.length,
              this.isPackageMode ? '(package mode)' : '(product mode)'
            );

            this._destroyPswp();

            // Load scripts if not already loaded, then open
            loadPswpScripts()
              .then(function () {
                console.log('[PhotoSwipe] scripts loaded, creating PhotoSwipe...');
                // Manually create PhotoSwipe Core to avoid loadAndOpen overriding dataSource
                var pswpModule = PhotoSwipe;
                self.pswp = new pswpModule({
                  dataSource: self._dataItems,
                  index: index,
                  loop: true,
                  showHideAnimationType: 'fade',
                  zoom: true,
                  allowPanToNext: false,
                  spacing: 0,
                  bgOpacity: 1,
                  bgBackgroundColor: 'rgba(255,255,255,1)',
                  margin: 0,
                  counter: false,
                  toolbar: false,
                  arrowPrev: false,
                  arrowNext: false,
                  close: false,
                  captionContent: false,
                  initialZoomLevel: 'fit',
                  secondaryZoomLevel: 1,
                  maxZoomLevel: 2,
                  closeOnVerticalDrag: false,
                  pinchToClose: false,
                  allowReturnFromMinZoom: false,
                  padding: { top: 60, bottom: 160 },
                });

                self.pswp.on('afterInit', function () {
                  console.log('[PhotoSwipe] afterInit event fired');
                  var pswpEl = self.pswp.element;
                  if (!pswpEl) return;

                  // 从模板克隆控制按钮
                  var template = document.getElementById('piz-ctrl-template');
                  if (!template) return;
                  var clonedContent = template.content.cloneNode(true);
                  var controls = clonedContent.querySelector('.piz-ctrl');
                  var navBtns = clonedContent.querySelectorAll('.piz-nav-btn');
                  pswpEl.appendChild(controls);
                  navBtns.forEach(function (btn) {
                    pswpEl.appendChild(btn);
                  });

                  // 绑定旋转按钮
                  var btnRotate = controls.querySelector('[data-action="rotate"]');
                  if (btnRotate) {
                    btnRotate.addEventListener('click', function () {
                      self.rotateImage();
                    });
                  }

                  // 绑定全屏按钮
                  var btnFullscreen = controls.querySelector('[data-action="fullscreen"]');
                  var iconFull = btnFullscreen ? btnFullscreen.querySelector('.icon-full') : null;
                  var iconShrink = btnFullscreen ? btnFullscreen.querySelector('.icon-shrink') : null;
                  if (btnFullscreen) {
                    btnFullscreen.addEventListener('click', function () {
                      self.toggleFullscreen();
                    });
                  }

                  // 监听全屏状态变化，同步图标
                  function onFullscreenChange() {
                    var isFs = !!document.fullscreenElement;
                    if (iconFull) iconFull.style.display = isFs ? 'none' : '';
                    if (iconShrink) iconShrink.style.display = isFs ? '' : 'none';
                    if (btnFullscreen) btnFullscreen.title = isFs ? 'Exit Fullscreen' : 'Fullscreen';
                  }
                  document.addEventListener('fullscreenchange', onFullscreenChange);

                  // 绑定播放/停止按钮
                  var btnPlay = controls.querySelector('[data-action="play"]');
                  var iconPlay = btnPlay ? btnPlay.querySelector('.icon-play') : null;
                  var iconStop = btnPlay ? btnPlay.querySelector('.icon-stop') : null;
                  if (btnPlay) {
                    btnPlay.addEventListener('click', function () {
                      if (self.isPlaying) {
                        self._stopPlay();
                        if (iconPlay) iconPlay.style.display = '';
                        if (iconStop) iconStop.style.display = 'none';
                      } else {
                        self._startPlay();
                        if (iconPlay) iconPlay.style.display = 'none';
                        if (iconStop) iconStop.style.display = '';
                      }
                    });
                  }

                  // 绑定关闭按钮
                  var btnClose = controls.querySelector('[data-action="close"]');
                  if (btnClose) {
                    btnClose.addEventListener('click', function () {
                      requestAnimationFrame(function () {
                        requestAnimationFrame(function () {
                          if (self.pswp && typeof self.pswp.close === 'function') {
                            self.pswp.close();
                          }
                        });
                      });
                    });
                  }

                  // 绑定左右切换按钮
                  var btnPrev = pswpEl.querySelector('[data-action="prev"]');
                  var btnNext = pswpEl.querySelector('[data-action="next"]');
                  if (btnPrev) {
                    btnPrev.addEventListener('click', function () {
                      self.pswp.goTo(self.pswp.currIndex - 1);
                    });
                  }
                  if (btnNext) {
                    btnNext.addEventListener('click', function () {
                      self.pswp.goTo(self.pswp.currIndex + 1);
                    });
                  }

                  // 隐藏原生 zoom 按钮
                  var style = document.createElement('style');
                  style.textContent =
                    '.pswp__button--zoom { display: none !important; } .pswp__bg { background: #ffffff !important; }';
                  pswpEl.appendChild(style);
                });

                self.pswp.on('change', function () {
                  console.log('[PhotoSwipe] change fired, currIndex:', self.pswp.currIndex);
                  console.log(
                    '[PhotoSwipe] Current: ' + (self.pswp.currIndex + 1) + ' / Total: ' + self._dataItems.length
                  );
                  let currentIndex = self.pswp.currIndex + 1;
                  let totalIndex = self._dataItems.length;
                  self.currentIndex = self.pswp.currIndex;
                  // 等 pswp--open 出现后再执行
                  requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                      setTimeout(function () {
                        self._showCounter(currentIndex, totalIndex);
                        self._showPageThumbs();
                        self._updateThumbBar();
                        self._syncPageThumbs(self.currentIndex);
                        self._updatePageProgress(0);
                      }, 100);
                    });
                  });
                  // Reset play timer if auto-play is running
                  if (self.isPlaying) {
                    self._playStartTime = performance.now();
                  }
                });

                self.pswp.on('firstZoomPanAnimShow', function () {
                  console.log('[PhotoSwipe] firstZoomPanAnimShow fired');
                  self.currentIndex = index;
                  // 等 pswp--open 和动画完成后再执行
                  requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                      setTimeout(function () {
                        self._createThumbBar();
                        self._updateThumbBar();
                        self._showCounter(index + 1, self._dataItems.length);
                        self._showPageThumbs();
                        self._syncPageThumbs(index);
                        self._updatePageProgress(0);
                      }, 100); // 额外等待 50ms 确保 DOM 完全渲染
                    });
                  });
                });

                self.pswp.on('close', function () {
                  console.log('[PhotoSwipe] close fired');
                  // 阻止通过 pinch-to-close 关闭
                  if (self._pinchCloseTriggered) {
                    console.log('[PhotoSwipe] pinch-to-close blocked');
                    self._pinchCloseTriggered = false;
                    return;
                  }
                  self._stopPlay();
                  self._hidePageThumbs();
                  self._hideCounter();
                });

                self.pswp.on('destroy', function () {
                  console.log('[PhotoSwipe] destroy fired');
                  self._isClosing = false;
                  self._pinchCloseTriggered = false;
                  self._removeThumbBar();
                  self.pswp = null;
                });

                self.pswp.on('error', function (e) {
                  console.error('[PhotoSwipe] error:', e);
                });

                self.pswp.on('loadError', function (e) {
                  console.error('[PhotoSwipe] loadError:', e);
                });

                // init() opens the gallery directly
                self.pswp.init();
                console.log('[PhotoSwipe] init() called');
              })
              .catch(function (err) {
                console.error('[PhotoSwipe] failed to load scripts:', err);
              });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-endorsement-v2"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-media-endorsement-v2')) {
    customElements.define(
      'product-media-endorsement-v2',
      class ProductMediaEndorsementV2 extends HTMLElement {
        connectedCallback() {
          if (typeof Swiper === 'undefined') {
            console.error('[product-media-endorsement-v2] Swiper is not loaded.');
            return;
          }

          this._initialized = false;
          this._activeIndex = 0;
          this._visibleSlotCount = 5;
          this._logosEl = this.querySelector('.product-media-endorsement-v2__logos');
          this._trackEl = this.querySelector('.product-media-endorsement-v2__logos-track');
          this._logoButtons = Array.from(this.querySelectorAll('.product-media-endorsement-v2__logo'));
          this._boundClickHandler = this._handleLogoClick.bind(this);
          this._slideCount =
            Number(this.dataset.slideCount) ||
            this.querySelectorAll('.product-media-endorsement-v2__main .swiper-slide').length;

          this._panel = this.closest('.product-tabs-content-v2__panel');
          this._onPanelChange = () => this._tryInit();

          if (this._panel) {
            this._panelObserver = new MutationObserver(this._onPanelChange);
            this._panelObserver.observe(this._panel, {
              attributes: true,
              attributeFilter: ['class', 'aria-hidden'],
            });
          }

          this._onResize = () => {
            if (!this._initialized) return;
            this._applyLogoLayout(this._activeIndex);
            this._syncQuoteHeight();
          };
          window.addEventListener('resize', this._onResize);
          this._tryInit();
        }

        disconnectedCallback() {
          this._panelObserver?.disconnect();
          window.removeEventListener('resize', this._onResize);
          if (this._logosEl) {
            this._logosEl.removeEventListener('click', this._boundClickHandler);
          }
          this._destroy();
          this._initialized = false;
        }

        /** Tab 面板可见后再初始化 Swiper，避免 display:none 时尺寸为 0 */
        _tryInit() {
          if (this._initialized) return;

          if (this._panel) {
            if (this._panel.getAttribute('aria-hidden') === 'true') return;
            if (!this._panel.classList.contains('product-tabs-content-v2__panel--active')) return;
          }

          if (this._slideCount <= 0) return;

          this._init();
          this._initialized = true;
        }

        _destroy() {
          if (this._mainSwiper) {
            this._mainSwiper.destroy(true, true);
            this._mainSwiper = null;
          }
        }

        _getCenterOffset() {
          const visibleCount = Math.min(this._visibleSlotCount, this._slideCount);
          return Math.floor(visibleCount / 2);
        }

        _getLogoSlot(index, activeIndex) {
          const n = this._slideCount;
          const centerOffset = this._getCenterOffset();
          const orderPos = (index - activeIndex + centerOffset + n) % n;
          return orderPos - centerOffset;
        }

        /** 环形排列（如 4,5,1,2,3），当前项始终在轨道正中 */
        _applyLogoLayout(activeIndex) {
          if (!this._trackEl || this._slideCount <= 0) return;

          const centerOffset = this._getCenterOffset();
          const showAll = this._slideCount <= this._visibleSlotCount;

          this._logoButtons.forEach((btn) => {
            const index = Number(btn.dataset.index);
            const slot = this._getLogoSlot(index, activeIndex);

            btn.style.setProperty('--logo-slot', String(slot));
            btn.classList.toggle(
              'product-media-endorsement-v2__logo--hidden',
              !showAll && Math.abs(slot) > centerOffset
            );
          });
        }

        _setActiveLogo(index) {
          this._logoButtons.forEach((btn) => {
            const isActive = Number(btn.dataset.index) === index;
            btn.classList.toggle('product-media-endorsement-v2__logo--active', isActive);
            btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
        }

        _handleLogoSlideChange(_prevIndex, newIndex) {
          if (newIndex === this._activeIndex) return;

          this._activeIndex = newIndex;
          this._setActiveLogo(newIndex);
          this._applyLogoLayout(newIndex);
        }

        _goTo(index) {
          const normalized = ((index % this._slideCount) + this._slideCount) % this._slideCount;
          if (normalized === this._activeIndex) return;

          if (this._mainSwiper) {
            this._mainSwiper.slideToLoop(normalized);
          }
        }

        _handleLogoClick(event) {
          const btn = event.target.closest('.product-media-endorsement-v2__logo');
          if (!btn) return;
          const index = Number(btn.dataset.index);
          if (Number.isNaN(index) || index === this._activeIndex) return;
          this._goTo(index);
        }

        _syncQuoteHeight() {
          const mainEl = this.querySelector('.product-media-endorsement-v2__main');
          if (!mainEl || this._slideCount <= 0) return;

          const panels = mainEl.querySelectorAll('.product-media-endorsement-v2__panel');
          if (!panels.length) return;

          const measureWidth = mainEl.clientWidth || mainEl.getBoundingClientRect().width;
          let maxHeight = 0;

          panels.forEach((panel) => {
            const measurer = document.createElement('div');
            measurer.style.cssText = [
              'position:absolute',
              'visibility:hidden',
              'pointer-events:none',
              'width:' + measureWidth + 'px',
              'left:-9999px',
              'top:0',
            ].join(';');
            measurer.appendChild(panel.cloneNode(true));
            mainEl.appendChild(measurer);
            maxHeight = Math.max(maxHeight, measurer.offsetHeight);
            mainEl.removeChild(measurer);
          });

          mainEl.style.minHeight = maxHeight + 'px';
          mainEl.style.setProperty('--quote-min-height', maxHeight + 'px');

          if (this._mainSwiper) {
            this._mainSwiper.update();
          }
        }

        _init() {
          this._destroy();

          const mainEl = this.querySelector('.product-media-endorsement-v2__main');
          const prevEl = this.querySelector('.product-media-endorsement-v2__nav-btn--prev');
          const nextEl = this.querySelector('.product-media-endorsement-v2__nav-btn--next');

          if (!mainEl || this._slideCount <= 0) return;

          const loop = this._slideCount > 1;
          const speed = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 400;
          const autoplayEnabled =
            this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const autoplayDelay = Number(this.dataset.autoplayDelay) || 5000;

          this._mainSwiper = new Swiper(mainEl, {
            initialSlide: 0,
            loop: loop,
            speed: speed,
            allowTouchMove: loop,
            autoplay: autoplayEnabled
              ? {
                  delay: autoplayDelay,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }
              : false,
            navigation:
              loop && prevEl && nextEl
                ? {
                    prevEl: prevEl,
                    nextEl: nextEl,
                  }
                : undefined,
            on: {
              slideChange: (swiper) => {
                this._handleLogoSlideChange(this._activeIndex, swiper.realIndex);
              },
            },
          });

          if (this._logosEl) {
            this._logosEl.removeEventListener('click', this._boundClickHandler);
            this._logosEl.addEventListener('click', this._boundClickHandler);
          }

          this._activeIndex = 0;
          this._setActiveLogo(0);
          this._syncQuoteHeight();
          this._applyLogoLayout(0);
          requestAnimationFrame(() => {
            this._syncQuoteHeight();
            this._applyLogoLayout(this._activeIndex);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-video-v2"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('product-media-video-v2')) {
      customElements.define(
        'product-media-video-v2',
        class ProductMediaVideoV2 extends HTMLElement {
          constructor() {
            super();
            window.litime.ModalControllerState = window.litime.ModalControllerState || new ModalController();
            this.modalManager = window.litime.ModalControllerState;
            this.swiper = null;
            this._initialized = false;
          }

          connectedCallback() {
            this._panel = this.closest('.product-tabs-content-v2__panel');
            this._onPanelChange = () => this._tryInit();

            if (this._panel) {
              this._panelObserver = new MutationObserver(this._onPanelChange);
              this._panelObserver.observe(this._panel, {
                attributes: true,
                attributeFilter: ['class', 'aria-hidden'],
              });
            }

            this._tryInit();
          }

          disconnectedCallback() {
            this._panelObserver?.disconnect();
            if (this.swiper) {
              this.swiper.destroy(true, true);
              this.swiper = null;
            }
            this._initialized = false;
          }

          /** Tab 面板可见后再初始化 Swiper，避免 display:none 时尺寸为 0 */
          _tryInit() {
            if (this._initialized) return;

            if (this._panel) {
              if (this._panel.getAttribute('aria-hidden') === 'true') return;
              if (!this._panel.classList.contains('product-tabs-content-v2__panel--active')) return;
            }

            this.init();
            this._initialized = true;
          }

          init() {
            const $root = $(this);
            const _this = this;
            const $videoItems = $root.find('.video_item');

            $videoItems.off('click.productMediaVideoV2').on('click.productMediaVideoV2', function (event) {
              _this.handlePlayClick(event);
            });

            const $mySwiper = this.querySelector('.product-media-video-v2_swiper');
            if (!$mySwiper) return;

            const $scrollbarDom = this.querySelector('.product-media-video-v2-scrollbar');
            const $prevDom = this.querySelector('.product-media-video-v2_prev');
            const $nextDom = this.querySelector('.product-media-video-v2_next');

            if (this.swiper) {
              this.swiper.destroy(true, true);
              this.swiper = null;
            }

            this.swiper = new Swiper($mySwiper, {
              slidesPerView: 'auto',
              spaceBetween: 0,
              slidesPerGroup: 1,
              navigation: {
                nextEl: $nextDom,
                prevEl: $prevDom,
              },
              scrollbar: {
                el: $scrollbarDom,
                draggable: true,
              },
              breakpoints: {
                1201: {
                  slidesPerGroup: 4,
                },
              },
              on: {
                slideChange: function () {
                  if (!$prevDom || !$nextDom) return;

                  if (this.isBeginning) {
                    $prevDom.classList.add('product-media-video-v2__nav-btn--hidden');
                  } else {
                    $prevDom.classList.remove('product-media-video-v2__nav-btn--hidden');
                  }

                  if (this.isEnd) {
                    $nextDom.classList.add('product-media-video-v2__nav-btn--hidden');
                  } else {
                    $nextDom.classList.remove('product-media-video-v2__nav-btn--hidden');
                  }
                },
              },
            });
          }

          handlePlayClick(event) {
            const $video = $(event.currentTarget);
            const modalId = $video.data('id');
            const _this = this;

            if (!this.modalManager.getModal(modalId)) {
              this.modalManager.register(modalId, {
                onOpen: (container) => {
                  const iframe = $(container).find('iframe');
                  const currentSrc = iframe.attr('src');
                  const newSrc = currentSrc + '&autoplay=1&playsinline=1&mute=1&enablejsapi=1';

                  setTimeout(() => {
                    iframe.attr('src', newSrc);
                    try {
                      const iframeElement = iframe[0];
                      iframeElement.contentWindow.postMessage(
                        JSON.stringify({
                          event: 'command',
                          func: 'playVideo',
                        }),
                        '*'
                      );
                    } catch (error) {
                      console.error('[product-media-video-v2] Failed to post play message:', error);
                    }
                  }, 0);

                  _this.initMobileYouTubeControl(container);
                },
                onClose: (container) => {
                  const iframe = $(container).find('iframe');
                  const currentSrc = iframe.attr('src');
                  iframe.attr('src', currentSrc.replace('&autoplay=1&playsinline=1&mute=1&enablejsapi=1', ''));
                },
              });
            }

            this.modalManager.open(modalId);
          }

          initMobileYouTubeControl(container) {
            const $container = $(container);
            const iframe = $container.find('iframe')[0];
            let isMobile = window.innerWidth <= 768;
            let isPlaying = true;

            const checkMobile = () => {
              isMobile = window.innerWidth <= 768;
            };

            window.addEventListener('resize', checkMobile);

            const togglePlayback = (event) => {
              if (!isMobile) return;

              event.preventDefault();
              event.stopPropagation();

              try {
                if (isPlaying) {
                  iframe.contentWindow.postMessage(
                    JSON.stringify({
                      event: 'command',
                      func: 'pauseVideo',
                    }),
                    '*'
                  );
                  isPlaying = false;
                } else {
                  iframe.contentWindow.postMessage(
                    JSON.stringify({
                      event: 'command',
                      func: 'playVideo',
                    }),
                    '*'
                  );
                  isPlaying = true;
                }
              } catch (error) {
                console.error('[product-media-video-v2] Failed to control YouTube video:', error);
              }
            };

            $container.on('click.productMediaVideoV2 touchend.productMediaVideoV2', togglePlayback);

            window.addEventListener('message', (event) => {
              if (event.origin !== 'https://www.youtube.com') return;

              try {
                const data = JSON.parse(event.data);
                if (data.event === 'video-progress') {
                  if (data.info && data.info.playerState !== undefined) {
                    isPlaying = data.info.playerState === 1;
                  }
                }
              } catch (error) {
                // ignore parse errors
              }
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-sticky-form-bottom"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('product-sticky-form-bottom')) {
      customElements.define(
        'product-sticky-form-bottom',
        class ProductStickyFormBottom extends HTMLElement {
          constructor() {
            super();
            this.$currentQuantity = 1;
            this.$productStickyFormBottom = null;
            this.countdownInterval = null;
          }

          connectedCallback() {
            this.productStickyFormBottom = this.querySelector('.product-sticky-form-bottom');

            // 获取包含变体ID的section元素
            const stickyFormSection = this.querySelector('section.product-sticky-form-bottom');
            if (stickyFormSection) {
              // 获取URL中的variant参数
              const urlParams = new URLSearchParams(window.location.search);
              const urlVariantId = urlParams.get('variant');

              // 如果URL中有variant参数，使用它
              if (urlVariantId) {
                stickyFormSection.setAttribute('data-variant-id', urlVariantId);
              }

              this.$productStickyFormBottom = stickyFormSection;
            }

            this.nowQuantityClick();
            this.handleBuyNowClick();
            this.initCountdown();
          }

          disconnectedCallback() {
            if (this.countdownInterval) {
              clearInterval(this.countdownInterval);
              this.countdownInterval = null;
            }
          }

          // 从 product-coupon 组件获取倒计时时间并初始化
          initCountdown() {
            const couponElement = document.querySelector('product-coupon .time[data-time]');
            if (!couponElement) return;

            const time = couponElement.dataset.time;

            if (!time || time === '') return;

            // 处理时间戳，如果是秒级则转换为毫秒
            let endTime = parseInt(time);
            if (endTime < 10000000000) {
              endTime = endTime * 1000;
            }

            this.updateCountdown(endTime);
            this.countdownInterval = setInterval(() => this.updateCountdown(endTime), 1000);
          }

          // 更新倒计时显示
          updateCountdown(endTime) {
            const countdownEls = this.querySelectorAll('.product-bottom__countdown');
            countdownEls.forEach((el) => {
              el.classList.remove('hidden');
              el.classList.add('flex');
            });
            if (countdownEls.length === 0) return;

            const now = new Date().getTime();
            const timeDifference = endTime - now;

            if (timeDifference <= 0) {
              // 时间过期，停止定时器
              if (this.countdownInterval) {
                clearInterval(this.countdownInterval);
                this.countdownInterval = null;
              }
              // 设置为 00:00:00:00
              countdownEls.forEach((el) => {
                const daysEl = el.querySelector('.days');
                const hoursEl = el.querySelector('.hours');
                const minutesEl = el.querySelector('.minutes');
                const secondsEl = el.querySelector('.seconds');
                if (daysEl) daysEl.textContent = '00';
                if (hoursEl) hoursEl.textContent = '00';
                if (minutesEl) minutesEl.textContent = '00';
                if (secondsEl) secondsEl.textContent = '00';
              });
              return;
            }

            // 计算时间差
            const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

            // 更新所有倒计时元素的各个部分
            countdownEls.forEach((el) => {
              const daysEl = el.querySelector('.days');
              const hoursEl = el.querySelector('.hours');
              const minutesEl = el.querySelector('.minutes');
              const secondsEl = el.querySelector('.seconds');

              if (daysEl) daysEl.textContent = days.toString().padStart(2, '0');
              if (hoursEl) hoursEl.textContent = hours.toString().padStart(2, '0');
              if (minutesEl) minutesEl.textContent = minutes.toString().padStart(2, '0');
              if (secondsEl) secondsEl.textContent = seconds.toString().padStart(2, '0');
            });
          }

          // 处理预售逻辑
          nowQuantityClick() {
            const $active_sku = document.querySelector('choose-products .active-sku');
            const addToCartBtn = this.querySelectorAll('.add-to-cart-btn');
            if ($active_sku) {
              const $active_sku_quantity = $active_sku.getAttribute('data-inventory_quantity');
              const $active_sku_inventory_policy = $active_sku.getAttribute('data-inventory_policy');

              // 处理预售
              if (
                $active_sku_quantity > 0 ||
                ($active_sku_quantity <= 0 && $active_sku_inventory_policy == 'continue')
              ) {
                addToCartBtn.forEach((item) => {
                  item.querySelector('.add-to-cart-text').innerHTML = item.getAttribute('data-success-text');
                  item.classList.add('product-sticky-form-bottom__button--state-primary');
                  item.classList.remove('product-sticky-form-bottom__button--state-default');
                });
              } else {
                this.$currentQuantity = $active_sku_quantity;
                addToCartBtn.forEach((item) => {
                  item.querySelector('.add-to-cart-text').innerHTML = item.getAttribute('data-error-text');
                  item.setAttribute('id', 'stock_notify');
                  item.classList.add('product-sticky-form-bottom__button--state-default');
                  item.classList.remove('product-sticky-form-bottom__button--state-primary');
                });
              }
            }
          }

          //  添加到购物车按钮点击事件
          handleBuyNowClick() {
            if (!this.$productStickyFormBottom) return;

            const variantId = this.$productStickyFormBottom.getAttribute('data-variant-id');
            const buyNowBtn = this.querySelector('.buy-now-btn');

            if (buyNowBtn && !buyNowBtn.hasAttribute('data-event-bound')) {
              buyNowBtn.setAttribute('data-event-bound', 'true');

              buyNowBtn.addEventListener('click', async (event) => {
                event.preventDefault();

                const $icon = $(buyNowBtn).find('.rotate_icon');
                const $text = $(buyNowBtn).find('.loading-button-text');

                $icon.removeClass('hidden').addClass('is-loading');
                $text.addClass('is-loading');

                try {
                  const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      items: [
                        {
                          id: parseInt(variantId),
                          quantity: parseInt(this.$currentQuantity),
                        },
                        ...(window.selectedProducts || []).map((product) => ({
                          id: product.variantId,
                          quantity: parseInt(product.quantity),
                        })),
                      ],
                    }),
                  });

                  if (!response.ok) throw new Error('Failed to add items to cart');

                  if (window.gtag) {
                    gtag('event', 'conversion', { send_to: 'AW-11059876179/3GvVCJvMxIsYENOi4Zkp' });
                  }

                  window.location.href = '/checkout';
                } catch (error) {
                  $icon.removeClass('is-loading').addClass('hidden');
                  $text.removeClass('is-loading');
                }
              });
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-sticky-form-countdown"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('product-sticky-form-countdown')) {
      customElements.define(
        'product-sticky-form-countdown',
        class productStickyFormCountdown extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.countdownInterval = setInterval(() => this.updateCountdown(), 1000);
            this.updateCountdown();
          }
          updateCountdown() {
            const $time = $(this).find('.time');
            if (!$time.length) return;
            let time = $time.data('time');
            // 先统一转换格式
            time = time.trim().replace(/\//g, '-');
            const timeFormat = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;

            if (!timeFormat.test(time)) {
              $(this).css('display', 'none');
              return;
            }

            const endTime = new Date(time).getTime();
            const now = new Date().getTime();
            const timeDifference = endTime - now;
            if (timeDifference > 0) {
              if ($(this).css('display') !== 'block') {
                $(this).css('display', 'block');
              }
            } else {
              $(this).css('display', 'none');
              clearInterval(this.countdownInterval);
              return;
            }
            const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

            $time.find('.days').text(days.toString().padStart(2, '0'));
            $time.find('.hrs').text(hours.toString().padStart(2, '0'));
            $time.find('.min').text(minutes.toString().padStart(2, '0'));
            $time.find('.sec').text(seconds.toString().padStart(2, '0'));
          }
          disconnectedCallback() {
            clearInterval(this.countdownInterval);
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["products-choose"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('choose-products')) {
      customElements.define(
        'choose-products',
        class chooseProducts extends HTMLElement {
          constructor() {
            super();
          }

          connectedCallback() {
            this.$variantContainer = null;
            this.$currentQuantity = 1;
            const value = new CustomEvent('updateResult', { detail: 1 });
            window.dispatchEvent(value);
            this.$current_inventory_quantity = 0;
            this.$priceContainer = this.querySelector('.price-container');
            this.$variantContainer = this.querySelector('.variant-container');

            this.$productsPrchase = document.querySelector('products-purchase .products-purchase');
            this.$productStickyFormPrice = document.querySelector(
              'product-sticky-form-price .product-sticky-form-price'
            );
            this.$productStickyFormBottom = document.querySelector(
              'product-sticky-form-bottom .product-sticky-form-bottom'
            );
            this.$deliverInfoContainer = document.querySelector(
              'product-sticky-form .product-sticky-form__delivery-info-container'
            );
            this.$expiryUpdateTriggered = false;
            this.VariantFunction();
            try {
              const url = new URL(window.location.href);
              const variantId = url.searchParams.get('variant');
              if (variantId) {
                this.triggerDefaultPositionChange();
              }
            } catch (e) {}

            // 默认执行updateEventShow事件
            this.triggerDefaultUpdateEventShow();
            this.updateCountdown();
          }
          updateCountdown() {
            // 确保 this 指向正确的元素
            const self = this;
            // 使用原生 DOM 方法
            const timeElement = document.querySelector('.product-coupon .time');
            let time = timeElement.dataset.time;
            // 如果没有时间戳，隐藏组件并清除定时器
            if (!time || time === '') {
              const timeStampElement = document.querySelector('.product-coupon .product-coupon-time-stamp');
              if (timeStampElement) {
                timeStampElement.classList.add('hidden');
              }
              if (timeElement.countdownInterval) {
                clearInterval(timeElement.countdownInterval);
                timeElement.countdownInterval = null;
              }
              return;
            }

            // 处理时间戳
            let endTime = parseInt(time);
            // 如果时间戳是秒级，转换为毫秒
            if (endTime < 10000000000) {
              endTime = endTime * 1000;
            }

            const now = new Date().getTime();
            const timeDifference = endTime - now;

            if (timeDifference > 0) {
              // 显示倒计时组件
              const timeStampElement = document.querySelector('.product-coupon .product-coupon-time-stamp');
              if (timeStampElement) {
                timeStampElement.classList.remove('hidden');
                timeStampElement.classList.add('flex');
              }

              // 只有在没有定时器时才启动新的定时器
              if (!timeElement.countdownInterval) {
                timeElement.countdownInterval = setInterval(() => this.updateCountdown(), 1000);
              }
            } else {
              // 时间已过期，隐藏组件并清除定时器
              const timeStampElement = document.querySelector('.product-coupon .product-coupon-time-stamp');
              const productCoupon = document.querySelector('.product-coupon .product-coupon');
              if (timeStampElement) {
                timeStampElement.classList.add('hidden');
                timeStampElement.classList.remove('flex');
              }
              if (productCoupon) {
                productCoupon.classList.add('hidden');
                productCoupon.classList.remove('flex');
              }
              if (timeElement.countdownInterval) {
                clearInterval(timeElement.countdownInterval);
                timeElement.countdownInterval = null;
              }

              // 时间过期时触发变体更新
              this.triggerVariantUpdateOnExpiry();
              return;
            }

            const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

            const daysElement = timeElement.querySelector('.days');
            if (daysElement) {
              daysElement.textContent = days.toString().padStart(2, '0');
            }
            const hrsElement = timeElement.querySelector('.hrs');
            if (hrsElement) {
              hrsElement.textContent = hours.toString().padStart(2, '0');
            }
            const minElement = timeElement.querySelector('.min');
            if (minElement) {
              minElement.textContent = minutes.toString().padStart(2, '0');
            }
            const secElement = timeElement.querySelector('.sec');
            if (secElement) {
              secElement.textContent = seconds.toString().padStart(2, '0');
            }
          }
          disconnectedCallback() {
            if (this.countdownInterval) {
              clearInterval(this.countdownInterval);
              this.countdownInterval = null;
            }
          }
          triggerDefaultPositionChange() {
            // 获取默认选中的变体位置
            const activeItem = this.$variantContainer.querySelector('.active-sku');
            if (activeItem) {
              const current_position = activeItem.getAttribute('data-position');
              if (current_position) {
                // 触发 current_positionChange 事件，传递默认位置
                const event = new CustomEvent('current_positionChange', {
                  detail: {
                    current_position: current_position - 1,
                  },
                });
                window.dispatchEvent(event);
              }
            }
          }

          triggerDefaultUpdateEventShow() {
            // 获取当前选中的SKU元素
            const activeSkuElement = this.$variantContainer.querySelector('.active-sku');
            const productStickyFormPrice = this.$productStickyFormPrice;

            if (activeSkuElement && productStickyFormPrice) {
              const updateEventShow = new CustomEvent('updateEventShow', {
                detail: {
                  price: productStickyFormPrice.querySelector('.price-container').getAttribute('data-current-price'),
                  originalComparePrice: productStickyFormPrice
                    .querySelector('.price-container')
                    .getAttribute('data-compare-price'),
                  final_cents: activeSkuElement.getAttribute('data-final_cents'),
                  price_cents: activeSkuElement.getAttribute('data-price_cents'),
                  best_discount_cents: activeSkuElement.getAttribute('data-best_discount_cents'),
                  end_s: activeSkuElement.getAttribute('data-end_s'),
                },
              });

              window.dispatchEvent(updateEventShow);

              // 获取推荐产品的总金额并调用updateAmount
              const productRecommendationsContainer = document.querySelector('.product-recommendations');
              if (productRecommendationsContainer) {
                const selectedTotalAmount =
                  productRecommendationsContainer.getAttribute('data-selected-total-amount') || '0';
                const selectedCompareTotalAmount =
                  productRecommendationsContainer.getAttribute('data-selected-compare-total-amount') || '0';

                // 调用products-recommend的updateAmount方法
                const productsRecommendElement = document.querySelector('products-recommend');
                if (productsRecommendElement && typeof productsRecommendElement.updateAmount === 'function') {
                  productsRecommendElement.updateAmount(selectedTotalAmount, selectedCompareTotalAmount);
                }
              }
            }
          }

          VariantFunction() {
            let progressList = this.$variantContainer.querySelectorAll('.progress');
            progressList.forEach((res) => {
              this.progressFuncion(res);
            });
            this.skuSwatch();
            this.initResult();
          }
          ceilIfDecimal(value) {
            return value % 1 === 0 ? value : Math.floor(value) + 1;
          }
          // 计算折扣后的总价格（包含推荐商品）
          calculateDiscountedTotal(quantity) {
            // 获取推荐商品数据
            const selectedProducts = window.selectedProducts || [];

            // 计算主商品价格
            const subtotal = quantity * parseFloat(this.$current_price);
            let finalPrice = subtotal;
            let discountAmount = 0;
            let discountType = 'none';

            // 获取商品的原始对比价格（划线价）- 无论是否有折扣都使用 compare_at_price
            const activeItem = this.$variantContainer.querySelector('.active-sku');
            const dataComparePrice = activeItem ? activeItem.getAttribute('data-compare_price') : '0';
            let comparePrice = parseFloat(dataComparePrice) * quantity || 0;

            if (parseFloat(this.$current_best_discount_cents) > 0) {
              if (this.$current_best_type === 'percentage') {
                discountAmount = parseFloat(this.$current_best_discount_cents) * quantity;
                finalPrice = subtotal * (1 - parseFloat(this.$quota) / 100);
                discountType = 'percentage';
                finalPrice = this.ceilIfDecimal(finalPrice);

                // comparePrice 保持为 compare_at_price * quantity
              } else if (this.$current_best_type === 'amount') {
                // 总共减去折扣金额
                // 每件减去折扣金额
                discountAmount = parseFloat(this.$current_best_discount_cents) * quantity;
                finalPrice = subtotal - discountAmount;
                discountType = 'amount';
                // comparePrice 保持为 compare_at_price * quantity
              }
            } else {
              discountType = 'none';
              // comparePrice 已经设置为 compare_at_price * quantity
            }

            // 汇总推荐商品价格
            let recommendedTotalPrice = 0;
            let recommendedTotalComparePrice = 0;

            selectedProducts.forEach((product) => {
              recommendedTotalPrice += parseFloat(product.currentPrice) || 0;
              // 只有当划线价格大于0时才计入总价（0表示没有划线价格）
              if (parseFloat(product.comparePrice) > 0) {
                recommendedTotalComparePrice += parseFloat(product.comparePrice);
              }
            });

            // 处理主商品划线价格显示逻辑：如果划线价格小于等于0或者小于现价，则隐藏（设为0）
            if (comparePrice <= 0 || comparePrice <= finalPrice) {
              comparePrice = 0;
            }

            // 合并主商品和推荐商品的价格
            const totalFinalPrice = finalPrice + recommendedTotalPrice;
            const totalComparePrice = comparePrice + recommendedTotalComparePrice;

            // 最终结果 - 只保留需要的三个关键值
            const result = {
              discountType: discountType, // 主商品折扣类型：percentage, amount, none
              finalPrice: totalFinalPrice, // 合计最终价格（主商品 + 推荐商品）
              comparePrice: totalComparePrice, // 合计对比价格（主商品 + 推荐商品）
            };

            // 保存最后的计算结果
            this.$lastCalculationResult = result;

            // 触发价格计算完成事件
            const calculationEvent = new CustomEvent('priceCalculated', {
              detail: result,
            });
            window.dispatchEvent(calculationEvent);

            document
              .querySelector('.credit-promotion-badge-container-product klarna-placement')
              .setAttribute('data-purchase-amount', this.ceilIfDecimal(result.finalPrice));
            const timeElement = document.querySelector('product-coupon .time');
            if (timeElement) {
              timeElement.dataset.time = this.$current_end_s;
            }
            // 手动触发 product-coupon 组件的倒计时更新
            this.updateCountdown();

            // // 处理所有 total_discount 元素
            document.querySelectorAll('.total_discount').forEach((totalDiscountElement) => {
              // 在每个 total_discount 元素下查找 global-discount 组件
              const globalDiscountElement = totalDiscountElement.querySelector('global-discount[data-type]');

              if (globalDiscountElement) {
                const dataType = globalDiscountElement.getAttribute('data-type');

                if (dataType === 'percentage' || dataType === 'quota') {
                  let discountValue = 0;
                  if (result.comparePrice > 0 && result.finalPrice < result.comparePrice) {
                    if (dataType === 'percentage') {
                      // 取整数this.$quota
                      discountValue = Math.floor(
                        ((result.comparePrice * 100 - result.finalPrice * 100) / (result.comparePrice * 100)) * 100
                      );
                    } else if (dataType === 'quota') {
                      // 固定额度类型：计算减少的固定金额并四舍五入
                      discountValue = Math.floor(result.comparePrice - result.finalPrice);
                    }
                  }

                  // 如果折扣小于1%（百分比）或小于1（固定额度），隐藏所有 total_discount
                  if (
                    (dataType === 'percentage' && discountValue < 1) ||
                    (dataType === 'quota' && discountValue <= 0)
                  ) {
                    document.querySelectorAll('.total_discount').forEach((element) => {
                      element.classList.add('hidden');
                    });
                  } else {
                    // 显示折扣并更新内容
                    document.querySelectorAll('.total_discount').forEach((element) => {
                      element.classList.remove('hidden');
                    });

                    // 更新当前 global-discount 元素的内容
                    if (dataType === 'percentage') {
                      globalDiscountElement.textContent = `${discountValue}% OFF`;
                    } else if (dataType === 'quota') {
                      globalDiscountElement.textContent = window.Shopify.formatMoney(
                        discountValue,
                        window.shopMoneyFormat + ' OFF'
                      );
                    }
                  }
                }
              }
            });
            document.querySelectorAll('.product-sticky-form').forEach((res) => {
              res.querySelector('.price').innerHTML = window.Shopify.formatMoney(
                this.ceilIfDecimal(result.finalPrice),
                window.shopMoneyFormat
              );
              const compareAtPriceElement = res.querySelector('.compare_at_price');
              if (result.comparePrice > 0 && result.comparePrice > result.finalPrice) {
                compareAtPriceElement.classList.remove('hidden');
                compareAtPriceElement.innerHTML = window.Shopify.formatMoney(
                  result.comparePrice,
                  window.shopMoneyFormat
                );
              } else {
                compareAtPriceElement.classList.add('hidden');
                compareAtPriceElement.innerHTML = '';
              }
            });
            document.querySelectorAll('.product-sticky-form-bottom').forEach((res) => {
              res.querySelectorAll('.price').forEach((res) => {
                res.innerHTML = window.Shopify.formatMoney(
                  this.ceilIfDecimal(result.finalPrice),
                  window.shopMoneyFormat
                );
              });
              const compareAtPriceElement = res.querySelectorAll('.compare_at_price');
              if (result.comparePrice > 0 && result.comparePrice > result.finalPrice) {
                compareAtPriceElement.forEach((res) => {
                  res.classList.remove('hidden');
                  res.innerHTML = window.Shopify.formatMoney(result.comparePrice, window.shopMoneyFormat);
                });
              } else {
                compareAtPriceElement.forEach((res) => {
                  res.classList.add('hidden');
                  res.innerHTML = '';
                });
              }
            });
            return result;
          }

          initResult() {
            const activeItem = this.$variantContainer.querySelector('.active-sku');

            if (!activeItem) {
              console.error('未找到选中的变体');
              return;
            }

            this.$current_inventory_quantity = activeItem.getAttribute('data-inventory_quantity');
            this.$current_price = activeItem.getAttribute('data-price_cents');
            this.$quota = activeItem.getAttribute('data-quota');
            this.$current_best_discount_cents = activeItem.getAttribute('data-best_discount_cents');
            this.$current_best_title = activeItem.getAttribute('data-best_title');
            this.$current_best_type = activeItem.getAttribute('data-best_type')?.trim();
            this.$current_end_s = activeItem.getAttribute('data-end_s');
            // 4. 设置数量输入框
            const quantityContainer = this.querySelector('.quantity-container');
            const quantityInput = quantityContainer.querySelector('input[type="text"]');
            const discountedTotal = this.calculateDiscountedTotal(this.$currentQuantity);

            if (quantityInput) {
              quantityInput.max = this.$current_inventory_quantity;

              quantityInput.addEventListener('input', (event) => {
                if (event.target.value >= 1) {
                  this.$currentQuantity = event.target.value;
                  const discountedTotal = this.calculateDiscountedTotal(this.$currentQuantity);
                  // 触发数量变化事件时，传递完整的对象结构
                  const value = new CustomEvent('quantityChange06', {
                    detail: {
                      quantity: parseInt(event.target.value),
                      discountedTotal: discountedTotal,
                    },
                  });
                  window.dispatchEvent(value);
                }
              });

              window.addEventListener('quantityChange06', (event) => {
                this.$currentQuantity = event.detail.quantity || event.detail; // 兼容两种数据格式
                document.querySelector('.product-sticky-form').setAttribute('currentQuantity', this.$currentQuantity);
                const discountedTotal = this.calculateDiscountedTotal(this.$currentQuantity);
                const value = new CustomEvent('updateResult', {
                  detail: {
                    quantity: event.detail.quantity,
                    discountedTotal: discountedTotal,
                  },
                });
                window.dispatchEvent(value);
              });
            }
          }

          skuSwatch() {
            const productFormRadios = this.$variantContainer.querySelectorAll('.product-form__radio');
            let skuList = this.$variantContainer.querySelectorAll('.sku');
            skuList.forEach((res) => {
              customEventListener(res, 'click', () => {
                const current_url = res.getAttribute('data-url');
                const current_id = res.getAttribute('data-id');
                const current_product_id = res.getAttribute('data-product_id');
                const current_inventory_quantity = res.getAttribute('data-inventory_quantity');
                const current_position = res.getAttribute('data-position');
                const current_section = res.getAttribute('data-section');
                let current_price = res.getAttribute('data-price');
                current_price = current_price.replace(/[^0-9.-]+/g, '');

                res.querySelector('.product-form__radio').checked = true;
                productFormRadios.forEach((radio) => {
                  radio.checked = false; // 取消选中状态
                });

                if (this.querySelector('.quantity-container')) {
                  const quantityContainer = this.querySelector('.quantity-container');
                  const quantityInput = quantityContainer.querySelector('input[type="text"]'); // 查找输入框
                  if (quantityInput) {
                    // 更新最大值
                    quantityInput.max = current_inventory_quantity;

                    // 检查当前值是否超过新的最大值
                    if (parseInt(quantityInput.value, 10) > current_inventory_quantity) {
                      quantityInput.value = current_inventory_quantity; // 将值限制为新最大值
                      this.$currentQuantity = quantityInput.value;
                    }
                  }
                }
                this.renderProductInfo(
                  current_url,
                  current_id,
                  current_inventory_quantity,
                  current_section,
                  current_product_id,
                  current_position,
                  current_price
                );
              });
            });
          }
          renderProductInfo(
            current_url,
            current_id,
            current_inventory_quantity,
            current_section,
            current_product_id,
            current_position,
            current_price
          ) {
            // 判断是否切换变体ID

            fetch(`${current_url}?variant=${current_id}&section_id=${current_section}`)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');

                this.updateURL(current_url, current_id);

                this.handleUpdateProductInfo(html, current_product_id, current_position, current_price, current_id);
              });
          }
          handleUpdateProductInfo(html, current_product_id, current_position, current_price, current_id) {
            const chooseProducts = html.querySelector('choose-products .variant-container');
            const productsPurchase = html.querySelector('products-purchase .products-purchase');
            const productStickyFormPrice = html.querySelector('product-sticky-form-price .product-sticky-form-price');

            const productStickyFormBottom = html.querySelector(
              'product-sticky-form-bottom .product-sticky-form-bottom'
            );
            const deliverInfoContainer = html.querySelector(
              'product-sticky-form .product-sticky-form__delivery-info-container'
            );

            if (current_position == null) {
              current_position = 1;
            }

            // 将轮播位置值传递到父组件中
            const event = new CustomEvent('current_positionChange', {
              detail: {
                current_position: current_position - 1,
              },
            });

            window.dispatchEvent(event);

            // 保存当前数量
            const currentQuantity = this.$currentQuantity;
            // 替换对比按钮
            this.$compareContainer = this.querySelector('.extension-compare');
            if (this.$compareContainer) {
              const extensionCompare = html.querySelector('choose-products .extension-compare');
              this.$compareContainer.replaceWith(extensionCompare);
            }
            // 更新DOM
            this.$variantContainer.innerHTML = chooseProducts.innerHTML;
            this.$productsPrchase.innerHTML = productsPurchase.innerHTML;
            this.$productStickyFormPrice.innerHTML = productStickyFormPrice.innerHTML;
            this.$productStickyFormBottom.innerHTML = productStickyFormBottom.innerHTML;
            if (!!this.$deliverInfoContainer) {
              this.$deliverInfoContainer.innerHTML = deliverInfoContainer.innerHTML;
            }
            // 获取 custom element 实例并调用方法
            const stickyFormBottom = document.querySelector('product-sticky-form-bottom');
            if (stickyFormBottom) {
              stickyFormBottom.nowQuantityClick();
            }

            document.querySelector('products-purchase .products-purchase').setAttribute('data-variant-id', current_id);
            document
              .querySelector('product-sticky-form-bottom .product-sticky-form-bottom')
              .setAttribute('data-variant-id', current_id);

            const quantityContainer = this.querySelector('.quantity-container');
            const quantityInput = quantityContainer.querySelector('input[type="text"]');

            // 重置数量为1
            this.$currentQuantity = 1;
            quantityInput.value = 1;

            // 创建新的事件，detail值为1
            const value = new CustomEvent('quantityChange06', { detail: 1 });

            window.dispatchEvent(value);

            // 找到所有推荐产品的复选框并更新状态
            const recommendProducts = document.querySelectorAll('.product-recommendations .products-select-menu');
            window.selectedProducts = [];
            recommendProducts.forEach((menu) => {
              // 如果存在选中状态的容器，才移除该类
              if (menu.classList.contains('products-recommend__container--selected')) {
                menu.classList.remove('products-recommend__container--selected');
              }

              // 取消选中复选框
              const checkbox = menu.querySelector('input[type="checkbox"]');
              if (checkbox) {
                checkbox.checked = false;
              }
            });

            // 先更新价格容器的原始价格
            $('.product-sticky-form-price').each((index, res) => {
              const priceElement = res.querySelector('.price');
              const comparePriceElement = res.querySelector('.compare_at_price');

              // 从新的HTML中获取原始价格
              const originalPrice = productStickyFormPrice.querySelector('.current_price').innerHTML;
              const originalComparePrice = productStickyFormPrice.querySelector('.current_compare_at_price')?.innerHTML;

              // 设置原始价格
              if (priceElement) {
                priceElement.setAttribute('data-original-price', originalPrice);
              }
              if (comparePriceElement && originalComparePrice) {
                comparePriceElement.setAttribute('data-original-price', originalComparePrice);
              }
            });

            // 获取当前选中的SKU元素
            const activeSkuElement = this.$variantContainer.querySelector('.active-sku');
            if (Number(activeSkuElement.getAttribute('data-best_discount_cents')) > 0) {
              document.querySelector('.product-coupon').style.display = 'flex';
              document.querySelector('.product-coupon .product-coupon_num').innerHTML =
                activeSkuElement.getAttribute('data-best_title');
            } else {
              document.querySelector('.product-coupon').style.display = 'none';
            }
            const updateEventShow = new CustomEvent('updateEventShow', {
              detail: {
                price: productStickyFormPrice.querySelector('.price-container').getAttribute('data-current-price'),
                originalComparePrice: productStickyFormPrice
                  .querySelector('.price-container')
                  .getAttribute('data-compare-price'),
                final_cents: activeSkuElement.getAttribute('data-final_cents'),
                price_cents: activeSkuElement.getAttribute('data-price_cents'),
                best_discount_cents: activeSkuElement.getAttribute('data-best_discount_cents'),
              },
            });

            window.dispatchEvent(updateEventShow);

            // 每次切换变体时执行 triggerDefaultUpdateEventShow 方法
            this.triggerDefaultUpdateEventShow();

            // 直接使用保存的数量触发更新
            const updateEvent = new CustomEvent('updateResult', { detail: currentQuantity });
            window.dispatchEvent(updateEvent);

            if (chooseProducts) {
              this.skuSwatch();
              this.VariantFunction();
            }

            // 更新 DOM 后重新初始化 products-purchase（延后到下一帧，避免 innerHTML 后布局未提交）
            requestAnimationFrame(() => {
              const productsPurchase2 = document.querySelector('products-purchase');
              if (productsPurchase2) {
                productsPurchase2.handleAddToCartClick();
                productsPurchase2.handleBuyNowClick();
              }
            });
          }

          updateURL(currentUrl, currentId) {
            if (!currentUrl && !currentId) return;

            window.history.replaceState({}, '', `${currentUrl}?variant=${currentId}`);
          }

          // 处理进度条
          progressFuncion(res) {
            let maxStock = parseInt(res.getAttribute('data-max-stock'), 10); // 最大库存数
            let currentStock = parseInt(res.getAttribute('data-stock'), 10); // 当前变体的库存
            let percentage = (currentStock / maxStock) * 100;

            // 确保百分比不会超过 100%
            percentage = Math.min(percentage, 100);

            // 输出计算出的百分比
            // 可以将这个百分比用于设置进度条宽度
            let progressNum = res.querySelector('.progress-num');
            progressNum.style.width = percentage + '%';
          }

          // 添加新方法
          triggerVariantUpdateOnExpiry() {
            // 如果已经触发过，直接返回
            if (this.$expiryUpdateTriggered) {
              return;
            }

            // 设置标志，防止重复执行
            this.$expiryUpdateTriggered = true;

            // 获取当前选中的变体信息
            const activeSku = this.$variantContainer.querySelector('.sku.active-sku');
            if (!activeSku) return;

            // 模拟点击事件来触发 skuSwatch 的逻辑
            const current_url = activeSku.getAttribute('data-url');
            const current_id = activeSku.getAttribute('data-id');
            const current_section = activeSku.getAttribute('data-section');
            const current_product_id = activeSku.getAttribute('data-product_id');
            const current_position = activeSku.getAttribute('data-position');
            const current_price = activeSku.getAttribute('data-price');
            const current_inventory_quantity = activeSku.getAttribute('data-inventory_quantity');

            // 直接触发 fetch 请求
            fetch(`${current_url}?variant=${current_id}&section_id=${current_section}`)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');

                // 更新 URL
                this.updateURL(current_url, current_id);

                // 处理更新后的产品信息
                this.handleUpdateProductInfo(html, current_product_id, current_position, current_price, current_id);

                // 更新倒计时相关逻辑 - 重新获取当前选中的变体
                const timeElement = document.querySelector('.product-coupon .time');
                const currentActiveSku = this.$variantContainer.querySelector('.sku.active-sku');
                if (timeElement && currentActiveSku) {
                  const end_s = currentActiveSku.getAttribute('data-end_s');
                  if (end_s) {
                    timeElement.dataset.time = end_s;
                  }
                }
                // 手动触发倒计时更新
                this.updateCountdown();

                // 重置标志，允许下次倒计时过期时再次触发
                this.$expiryUpdateTriggered = false;
              })
              .catch((error) => {
                console.error('Error updating variant on expiry:', error);
                // 即使出错也要重置标志
                this.$expiryUpdateTriggered = false;
              });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["products-purchase"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('products-purchase')) {
      /** 主购买区矩形是否与当前可视区域相交（含 mobile visualViewport） */
      function productsPurchaseRowIntersectsViewport(rect) {
        if (rect.width <= 0 || rect.height <= 0) return false;
        const vv = window.visualViewport;
        const top = vv ? vv.offsetTop : 0;
        const left = vv ? vv.offsetLeft : 0;
        const vh = vv ? vv.height : window.innerHeight;
        const vw = vv ? vv.width : window.innerWidth;
        return rect.bottom > top && rect.top < top + vh && rect.right > left && rect.left < left + vw;
      }

      customElements.define(
        'products-purchase',
        class productsPurchase extends HTMLElement {
          constructor() {
            super();
            this.$currentQuantity = 1;
            this.$productsPurchase = null;
            /** @type {IntersectionObserver | null} */
            this.$stickyAtcObserver = null;
          }

          connectedCallback() {
            this.$productsPurchase = this.querySelector('.products-purchase');

            this.handleAddToCartClick();
            this.handleBuyNowClick();
          }

          disconnectedCallback() {
            if (this.$stickyAtcObserver) {
              this.$stickyAtcObserver.disconnect();
              this.$stickyAtcObserver = null;
            }
          }

          // 购买按钮点击事件
          handleBuyNowClick() {
            const buyNowBtn = this.querySelector('.buy-now-btn');
            if (buyNowBtn) {
              buyNowBtn.addEventListener('click', async (event) => {
                if (buyNowBtn.getAttribute('data-tax-free-disabled')) return;

                event.preventDefault();
                const variantId = this.$productsPurchase.getAttribute('data-variant-id');
                this.$currentQuantity =
                  document.querySelector('.product-sticky-form').getAttribute('currentQuantity') || 1;
                const quantity = this.$currentQuantity;

                const selectedProducts = window.selectedProducts || [];

                // 构建 cart URL
                const items = [
                  `${parseInt(variantId)}:${parseInt(quantity)}`,
                  ...selectedProducts.map((product) => `${product.variantId}:${parseInt(product.quantity)}`),
                ];
                let cartUrl = `/cart/${items.join(',')}`;

                // 处理税费属性
                let properties = buyNowBtn.getAttribute('data-tax-free-properties');
                if (properties) {
                  const propertiesEncoded = btoa(unescape(encodeURIComponent(properties)))
                    .replace(/\+/g, '-')
                    .replace(/\//g, '_')
                    .replace(/=/g, '');
                  cartUrl += '?properties=' + propertiesEncoded;
                }
                // 显示加载状态
                $(buyNowBtn).find('.loading-icon').removeClass('hidden').addClass('is-loading');
                $(buyNowBtn).find('.loading-button-text').removeClass('is-loading').addClass('hidden');
                // 跳转到购物车
                requestAnimationFrame(() => {
                  window.location.href = cartUrl;
                });

                // Google 转化事件
                if (window.gtag) {
                  gtag('event', 'conversion', { send_to: 'AW-11059876179/3GvVCJvMxIsYENOi4Zkp' });
                }
              });
            }
          }

          // 添加到购物车按钮点击事件
          handleAddToCartClick() {
            if (this.$stickyAtcObserver) {
              this.$stickyAtcObserver.disconnect();
              this.$stickyAtcObserver = null;
            }

            const atcEl = this.querySelector('.pur-add-to-cart-btn');
            if (atcEl) {
              atcEl.addEventListener('click', async (event) => {
                if (atcEl.getAttribute('data-tax-free-disabled')) return;
                event.preventDefault();
              });
            }

            const buttonsRow = this.querySelector('.products-purchase__buttons-container');
            const observeTarget = buttonsRow || atcEl;
            if (!observeTarget) return;

            const stickyBottom = document.querySelector('product-sticky-form-bottom .product-sticky-form-bottom');
            if (!stickyBottom) return;

            const syncStickyBottom = () => {
              if (!observeTarget.isConnected || !stickyBottom.isConnected) return;
              const r = observeTarget.getBoundingClientRect();
              if (r.width <= 0 || r.height <= 0) {
                stickyBottom.classList.remove('hidden');
                return;
              }
              stickyBottom.classList.toggle('hidden', productsPurchaseRowIntersectsViewport(r));
            };

            this.$stickyAtcObserver = new IntersectionObserver(syncStickyBottom, {
              threshold: [0, 1],
            });

            const observerRef = this.$stickyAtcObserver;
            const attach = () => {
              if (this.$stickyAtcObserver !== observerRef) return;
              observerRef.observe(observeTarget);
              syncStickyBottom();
            };
            requestAnimationFrame(() => requestAnimationFrame(attach));
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["products-recommend"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('products-recommend')) {
      customElements.define(
        'products-recommend',
        class ProductsRecommend extends HTMLElement {
          constructor() {
            super();
            this.recommendContainer = null;
          }

          connectedCallback() {
            this.recommendContainer = this.querySelector('.product-recommendations');

            if (!this.recommendContainer) return;

            // 初始化自定义属性
            this.recommendContainer.setAttribute('data-selected-total-amount', '0');
            this.recommendContainer.setAttribute('data-selected-compare-total-amount', '0');

            // 直接执行 fetch 请求
            this.loadRecommendations();
          }

          async loadRecommendations() {
            try {
              const response = await fetch(this.recommendContainer.dataset.url);
              const text = await response.text();
              const parser = new DOMParser();
              const doc = parser.parseFromString(text, 'text/html');
              const recommendations = doc.querySelector('.product-recommendations');
              if (recommendations?.innerHTML.trim()) {
                this.recommendContainer.innerHTML = recommendations.innerHTML;
                // 初始化自定义属性
                this.recommendContainer.setAttribute('data-selected-total-amount', '0');
                this.recommendContainer.setAttribute('data-selected-compare-total-amount', '0');
              }
            } catch (error) {
              console.error('Failed to load recommendations:', error);
            }
          }
        }
      );
    }
    $(function () {
      if (!customElements.get('products-select-menu')) {
        customElements.define(
          'products-select-menu',
          class productsSelectMenu extends HTMLElement {
            constructor() {
              super();
              this.container = null;
              this.header = null;
              this.valueSpan = null;
              this.optionsList = null;
              this.optionsContainer = null;
              this.arrowIcon = null;
              this.$current_inventory_quantity = 0;
              this.$currentPrice = 0;
              this.$currentId = 0;
              this.$currentComparePrice = 0;
              this.$currentRecommendId = 0;
              this.$currentQuantity = 1;
              this.productId = null;
              this._documentClickBound = false;
              this.totalPrice = 0;
              this.totalComparePrice = 0;
              this.totalDiscount = 0;
              this.priceContribution = {
                price: 0,
                comparePrice: 0,
                discount: 0,
              };
              this.shopMoneyFormat = window.shopMoneyFormat;
            }

            connectedCallback() {
              this.container = this.querySelector('div');
              this.header = this.querySelector('.select-header');
              this.valueSpan = this.querySelector('.select-value');
              this.optionsList = this.querySelector('ul');
              this.optionsContainer = this.querySelector('.select-options');
              this.arrowIcon = this.querySelector('.arrow-icon');
              this.productId = this.getAttribute('data-product-id');
              this.$priceContainer = $('.price-container');
              this.$productStickyFormTotal = $('.product-sticky-form-total');

              this.openVariantPopup();
              if (!this.header || !this.optionsList || !this.optionsContainer) {
                console.error('Required elements not found:', {
                  header: !!this.header,
                  optionsList: !!this.optionsList,
                  optionsContainer: !!this.optionsContainer,
                });
                return;
              }

              this.checkboxClick();
              this.bindEvents();
              this.initEveryOption();
              this.openProductDetails();
            }
            checkboxClick() {
              // 获取最外层容器
              this.containerDiv = this.querySelector('.products-select-item');
              // 获取复选框和其他元素
              const checkboxImage = this.querySelector(`.checkbox-image-${this.productId}`);
              const checkboxTitle = this.querySelector(`.checkbox-title-${this.productId}`);
              const checkboxContainer = this.querySelector(`.checkbox-container-${this.productId}`);
              this.checkbox = checkboxContainer.querySelector('input[type="checkbox"]');

              // 为 checkbox 本身添加点击事件处理
              if (this.checkbox) {
                this.checkbox.addEventListener('click', (e) => {
                  // 阻止事件冒泡
                  e.stopPropagation();
                });
              }

              // 为图片和标题添加点击事件
              const handleClick = (e) => {
                // 阻止事件冒泡
                e.stopPropagation();

                if (this.checkbox) {
                  const currentState = this.checkbox.checked;
                  this.checkbox.checked = !currentState;

                  // 手动触发 change 事件
                  this.checkbox.dispatchEvent(new Event('change'));
                }
              };

              if (checkboxImage) {
                checkboxImage.addEventListener('click', handleClick);
              }
              if (checkboxTitle) {
                checkboxTitle.addEventListener('click', handleClick);
              }
              if (checkboxContainer) {
                checkboxContainer.addEventListener('click', handleClick);
              }

              // 初始化全局选中产品数组（如果不存在）
              window.selectedProducts = window.selectedProducts || [];

              // 通知 products-choose 重新计算价格的方法
              this.triggerPriceRecalculation = () => {
                // 查找 products-choose 组件
                const productsChooseElement = document.querySelector('choose-products');
                if (productsChooseElement && typeof productsChooseElement.calculateDiscountedTotal === 'function') {
                  // 直接调用 calculateDiscountedTotal 方法
                  const currentQuantity = productsChooseElement.$currentQuantity || 1;
                  productsChooseElement.calculateDiscountedTotal(currentQuantity);
                } else {
                  console.warn('未找到 products-choose 组件或 calculateDiscountedTotal 方法');
                }
              };

              // 创建产品数据对象的辅助函数
              this.createProductData = (productId, variantId, quantity) => {
                // 计算现价和原价
                let currentPrice, comparePrice;

                if (this.$bestDiscountCents > 0) {
                  // 有折扣时：现价是final_cents，原价是price_cents
                  currentPrice = this.$finalCents * quantity;
                  comparePrice = this.$currentComparePrice * quantity;
                } else {
                  // 无折扣时：现价是currentPrice，原价是currentComparePrice
                  currentPrice = this.$currentPrice * quantity;
                  comparePrice = this.$currentComparePrice * quantity;
                }

                // 处理划线价格显示逻辑：如果划线价格小于等于0或者小于等于现价，则不传递（设为0）
                if (comparePrice <= 0 || comparePrice <= currentPrice) {
                  comparePrice = 0;
                }

                return {
                  productId: productId,
                  variantId: variantId,
                  quantity: quantity,
                  currentPrice: currentPrice, // 最终现价
                  comparePrice: comparePrice, // 划线价格（0表示没有）
                };
              };

              // 绑定复选框change事件
              if (this.checkbox && this.containerDiv) {
                this.checkbox.addEventListener('change', (e) => {
                  if (e.target.checked) {
                    // 使用辅助函数创建产品数据
                    const productData = this.createProductData(this.productId, this.$currentId, this.$currentQuantity);

                    // 检查是否已存在，如果存在则更新
                    const existingIndex = window.selectedProducts.findIndex(
                      (p) => p.variantId === this.$currentId || p.productId === this.productId
                    );

                    if (existingIndex !== -1) {
                      window.selectedProducts[existingIndex] = productData;
                    } else {
                      window.selectedProducts.push(productData);
                    }

                    this.containerDiv.classList.add('products-recommend__container--selected');

                    // 通知 products-choose 重新计算价格
                    this.triggerPriceRecalculation();
                  } else {
                    this.containerDiv.classList.remove('products-recommend__container--selected');
                    // 确保从数组中移除当前变体
                    window.selectedProducts = window.selectedProducts.filter(
                      (p) => p.variantId !== this.$currentId && p.productId !== this.productId
                    );

                    // 通知 products-choose 重新计算价格
                    this.triggerPriceRecalculation();
                  }
                });
              }
            }
            bindEvents() {
              // 点击header展开/收起
              $(this.header).on('click', (e) => {
                e.stopPropagation();
                this.toggle();
              });

              // 点击选项 - 修改事件委托的方式
              $(this.optionsList).on('click', 'li.select-option', (e) => {
                e.stopPropagation();
                const selectOption = e.target.closest('.select-option');
                this.$current_inventory_quantity = selectOption.getAttribute('data-inventory_quantity');
                if (this.$current_inventory_quantity != 0) {
                  this.selectOption(selectOption);
                }
              });

              // 点击外部关闭 - 确保事件只绑定一次
              if (!this._documentClickBound) {
                $(document).on('click', (e) => {
                  if (!this.contains(e.target)) {
                    this.close();
                  }
                });
                this._documentClickBound = true;
              }
            }

            toggle() {
              const $header = $(this.header);
              const $optionsContainer = $(this.optionsContainer);
              const $arrowIcon = $(this.arrowIcon);
              const isActive = $header.hasClass('active-select-menu');

              if (!isActive) {
                // 展开
                $header.addClass('active-select-menu');
                $optionsContainer
                  .css({
                    'max-height': '300px',
                    opacity: '1',
                  })
                  .addClass('!max-h-[300px] !opacity-100');
                $(this.valueSpan).css('color', '#acacac');
                $arrowIcon.css('transform', 'rotate(-180deg)');
              } else {
                // 收起
                this.close();
              }
            }

            close() {
              const $header = $(this.header);
              const $optionsContainer = $(this.optionsContainer);
              const $arrowIcon = $(this.arrowIcon);

              $header.removeClass('active-select-menu');
              $optionsContainer
                .css({
                  'max-height': '0',
                  opacity: '0',
                })
                .removeClass('!max-h-[300px] !opacity-100');
              $(this.valueSpan).css('color', '');
              $arrowIcon.css('transform', '');
            }

            parsePriceString(priceString) {
              return priceString;
            }

            selectOption(option) {
              if (!option) return;

              const $option = $(option);
              const value = $option.find('span').text().trim();
              const inventoryQuantity = option.getAttribute('data-inventory_quantity');
              const price = option.getAttribute('data-price');
              const comparePrice = option.getAttribute('data-compare_at_price');
              const variantId = option.getAttribute('data-id');
              const recommendId = option.getAttribute('data-recommend-id');

              // 获取折扣相关数据
              const bestDiscountCents = Number(option.getAttribute('data-best_discount_cents') || 0);
              const finalCents = Number(option.getAttribute('data-final_cents') || 0);
              const priceCents = Number(option.getAttribute('data-price_cents') || 0);

              // 先更新当前状态，确保使用新的价格
              this.$current_inventory_quantity = inventoryQuantity;
              this.$currentPrice = this.parsePriceString(price);
              this.$currentComparePrice = this.parsePriceString(comparePrice);
              this.$currentId = variantId;
              this.$currentRecommendId = recommendId;

              // 更新折扣相关数据
              this.$bestDiscountCents = bestDiscountCents;
              this.$finalCents = finalCents;
              this.$priceCents = priceCents;

              // 更新数量输入框
              const quantityInput = this.querySelector('.option-container input[type="text"]');
              if (quantityInput) {
                // 更新最大值
                quantityInput.max = inventoryQuantity;
                // 每次切换选项时重置数量为1
                this.$currentQuantity = 1;
                quantityInput.value = 1;
              }
              // 更新价格显示
              const $priceContainer = $(`.select-price-option-${recommendId}`);
              const $comparePriceContainer = $(`.select-compare-price-${recommendId}`);
              const $comparePriceContainerOut = $(`.select-compare-price-container-${recommendId}`);

              if ($comparePriceContainer.length) {
                if (this.$bestDiscountCents > 0) {
                  if ($priceContainer.length) {
                    $priceContainer.html(window.Shopify.formatMoney(this.$finalCents, this.shopMoneyFormat));
                  }
                  // 检查划线价格是否需要显示：必须大于0且大于现价
                  if (this.$currentComparePrice > 0 && this.$currentComparePrice > this.$finalCents) {
                    $comparePriceContainerOut.removeClass('hidden');
                    $comparePriceContainer.html(
                      window.Shopify.formatMoney(this.$currentComparePrice, this.shopMoneyFormat)
                    );
                  } else {
                    $comparePriceContainer.html('');
                    $comparePriceContainerOut.addClass('hidden');
                  }
                } else {
                  if ($priceContainer.length) {
                    $priceContainer.html(window.Shopify.formatMoney(price, this.shopMoneyFormat));
                  }
                  // 检查划线价格是否需要显示：必须大于0且大于现价
                  if (comparePrice > 0 && comparePrice > price) {
                    $comparePriceContainerOut.removeClass('hidden');
                    $comparePriceContainer.html(window.Shopify.formatMoney(comparePrice, this.shopMoneyFormat));
                  } else {
                    $comparePriceContainer.html('');
                    $comparePriceContainerOut.addClass('hidden');
                  }
                }
              } else {
                $comparePriceContainer.html('');
                $comparePriceContainerOut.addClass('hidden');
              }

              // 移除所有选项的高亮效果，并给当前选中项添加高亮
              $(this.optionsList).find('.select-option').removeClass('text-orange-500 selected');
              $option.addClass('text-orange-500 selected');

              // 自动勾选 checkbox
              if (this.checkbox && !this.checkbox.checked) {
                this.checkbox.checked = true;
                this.containerDiv.classList.add('products-recommend__container--selected');

                // 添加到已选商品数组
                const productData = this.createProductData(this.productId, parseInt(variantId), this.$currentQuantity);
                window.selectedProducts.push(productData);

                // 通知 products-choose 重新计算价格
                this.triggerPriceRecalculation();
              }

              // 如果这个商品已经被选中（checkbox已勾选）
              if (this.checkbox && this.checkbox.checked) {
                // 从已选商品数组中移除该商品的旧变体（如果存在）
                window.selectedProducts = window.selectedProducts.filter(
                  (p) => !(p.productId === this.productId || p.variantId === this.$currentId)
                );

                // 添加新选择的变体
                const productData = this.createProductData(this.productId, parseInt(variantId), this.$currentQuantity);
                window.selectedProducts.push(productData);

                // 通知 products-choose 重新计算价格
                this.triggerPriceRecalculation();
              }

              // 更新显示
              this.valueSpan.innerHTML = value;

              // 关闭选项列表
              this.close();
            }

            initEveryOption() {
              // 获取第一个可用变体（已标记为selected的选项）
              let selectedOption = this.querySelector('.select-options-item.selected');

              // 如果没有selected的选项，则根据data-first_variant_id查找
              if (!selectedOption) {
                const firstVariantId = this.getAttribute('data-first_variant_id');
                if (firstVariantId) {
                  selectedOption = this.querySelector(`.select-options-item[data-id="${firstVariantId}"]`);
                }
              }

              // 如果还是没有找到，则使用第一个选项作为后备
              if (!selectedOption) {
                selectedOption = this.querySelector('.select-options-item');
              }

              if (selectedOption) {
                this.$current_inventory_quantity = selectedOption.getAttribute('data-inventory_quantity');
                this.$currentPrice = this.parsePriceString(selectedOption.getAttribute('data-price'));
                this.$currentId = this.parsePriceString(selectedOption.getAttribute('data-id'));
                this.$currentComparePrice = this.parsePriceString(selectedOption.getAttribute('data-compare_at_price'));
                this.$currentRecommendId = this.parsePriceString(selectedOption.getAttribute('data-recommend-id'));

                // 获取折扣相关数据
                this.$bestDiscountCents = Number(selectedOption.getAttribute('data-best_discount_cents') || 0);
                this.$finalCents = Number(selectedOption.getAttribute('data-final_cents') || 0);
                this.$priceCents = Number(selectedOption.getAttribute('data-price_cents') || 0);

                // 更新价格显示
                this.updateOptionPrice();
              }
              // 获取复选框元素

              // 设置数量输入框，限定在当前产品范围内
              const quantityContainer = this.querySelector('.option-container');
              const quantityInput = quantityContainer.querySelector('input[type="text"]');

              if (quantityInput) {
                quantityInput.max = this.$current_inventory_quantity;
                quantityInput.addEventListener('input', (event) => {
                  const oldQuantity = this.$currentQuantity;
                  const newQuantity = event.target.value;
                  // 如果复选框已经选中，先减去旧价格
                  if (this.checkbox && this.checkbox.checked) {
                    // 先减去旧价格
                    const oldTotal = this.$currentPrice * oldQuantity;
                    const oldCompareTotal = this.$currentComparePrice * oldQuantity;
                    this.totalPrice -= oldTotal;
                    this.totalComparePrice -= oldCompareTotal;
                  }
                  if (newQuantity) {
                    this.$currentQuantity = newQuantity;
                  } else {
                    // this.$currentQuantity = 1;
                  }

                  // 如果复选框已经选中，加上新价格
                  if (this.checkbox && this.checkbox.checked) {
                    // 更新 selectedProducts 中的数量
                    const existingIndex = window.selectedProducts.findIndex(
                      (p) => p.variantId === this.$currentId || p.productId === this.productId
                    );
                    if (existingIndex !== -1) {
                      const productData = this.createProductData(
                        this.productId,
                        this.$currentId,
                        parseInt(newQuantity)
                      );
                      window.selectedProducts[existingIndex] = productData;
                    }

                    // 通知 products-choose 重新计算价格
                    this.triggerPriceRecalculation();
                  } else if (newQuantity > 0 && this.$current_inventory_quantity > newQuantity) {
                    // 如果数量大于0且复选框未选中，选中复选框
                    this.checkbox.checked = true;
                    this.containerDiv.classList.add('products-recommend__container--selected');
                    // 当添加选中状态类时，同步更新 selectedProducts
                    const existingProductIndex = window.selectedProducts.findIndex(
                      (p) => p.productId === this.productId || p.variantId === this.$currentId
                    );

                    if (existingProductIndex === -1) {
                      // 如果商品不在列表中，添加它
                      const productData = this.createProductData(
                        this.productId,
                        parseInt(this.$currentId),
                        parseInt(newQuantity)
                      );
                      window.selectedProducts.push(productData);
                    } else {
                      // 如果商品已在列表中，更新数量和价格
                      const productData = this.createProductData(
                        this.productId,
                        parseInt(this.$currentId),
                        parseInt(newQuantity)
                      );
                      window.selectedProducts[existingProductIndex] = productData;
                    }

                    // 通知 products-choose 重新计算价格
                    this.triggerPriceRecalculation();
                  }

                  this.updateOptionPrice();
                });
              }

              // 监听当前组件的数量变化事件
              this.addEventListener('quantityChange06', (event) => {
                const oldQuantity = this.$currentQuantity;
                const newQuantity = parseInt(event.detail);
                // 如果复选框已经选中，先减去旧价格
                if (this.checkbox && this.checkbox.checked) {
                  const oldTotal = this.$currentPrice * oldQuantity;
                  const oldCompareTotal = this.$currentComparePrice * oldQuantity;
                  this.totalPrice -= oldTotal;
                  this.totalComparePrice -= oldCompareTotal;
                }
                if (newQuantity) {
                  this.$currentQuantity = newQuantity;
                }

                // 如果复选框已经选中，加上新价格
                if (this.checkbox && this.checkbox.checked) {
                  // 更新已选商品数组中的数量
                  const existingIndex = window.selectedProducts.findIndex(
                    (p) => p.productId === this.productId || p.variantId === this.$currentId
                  );
                  if (existingIndex !== -1) {
                    const productData = this.createProductData(this.productId, this.$currentId, parseInt(newQuantity));
                    window.selectedProducts[existingIndex] = productData;
                  }

                  // 通知 products-choose 重新计算价格
                  this.triggerPriceRecalculation();
                } else if (newQuantity > 0 && this.$current_inventory_quantity > newQuantity) {
                  // 如果数量大于0且复选框未选中，选中复选框
                  this.checkbox.checked = true;
                  this.containerDiv.classList.add('products-recommend__container--selected');
                  // 添加到已选商品数组
                  const existingProductIndex = window.selectedProducts.findIndex(
                    (p) => p.productId === this.productId || p.variantId === this.$currentId
                  );

                  if (existingProductIndex === -1) {
                    // 如果商品不在列表中，添加它
                    const productData = this.createProductData(
                      this.productId,
                      parseInt(this.$currentId),
                      parseInt(newQuantity)
                    );
                    window.selectedProducts.push(productData);
                  } else {
                    // 如果商品已在列表中，更新数量和价格
                    const productData = this.createProductData(
                      this.productId,
                      parseInt(this.$currentId),
                      parseInt(newQuantity)
                    );
                    window.selectedProducts[existingProductIndex] = productData;
                  }

                  // 通知 products-choose 重新计算价格
                  this.triggerPriceRecalculation();
                }

                this.updateOptionPrice();
              });

              this.updateOptionPrice();
            }
            ceilIfDecimal(value) {
              return value % 1 === 0 ? value : Math.floor(value) + 1;
            }
            updateOptionPrice() {
              const priceSection = this.querySelector('.product-select-form-price');
              if (!priceSection) return;

              // 使用唯一的类名选择器
              const priceElement = priceSection.querySelector(`.select-price-${this.productId}`);
              const comparePriceElement = priceSection.querySelector(`.select-compare-price-${this.productId}`);

              // 获取全局优惠类型设置
              const globalPreferentialType =
                document.querySelector('product-screening')?.getAttribute('data-global-preferential-type') || 'before';

              if (priceElement && this.$currentQuantity) {
                // 根据是否有折扣和全局优惠类型决定显示哪个价格
                let displayPrice, displayComparePrice;

                if (this.$bestDiscountCents > 0) {
                  // 有折扣且是after模式，显示final_cents
                  displayPrice = this.$finalCents * this.$currentQuantity;
                  displayPrice = this.ceilIfDecimal(displayPrice);
                  displayComparePrice = this.$currentComparePrice * this.$currentQuantity;
                } else {
                  // 无折扣或before模式，使用原来的价格
                  displayPrice = this.$currentPrice * this.$currentQuantity;
                  displayComparePrice = this.$currentComparePrice * this.$currentQuantity;
                }

                // 更新价格显示
                priceElement.innerHTML = window.Shopify.formatMoney(displayPrice, this.shopMoneyFormat);

                // 更新比较价格
                if (comparePriceElement) {
                  // 检查划线价格是否需要显示：必须大于0且大于现价
                  if (displayComparePrice && displayComparePrice > 0 && displayComparePrice > displayPrice) {
                    comparePriceElement.innerHTML = window.Shopify.formatMoney(
                      displayComparePrice,
                      this.shopMoneyFormat
                    );
                    comparePriceElement.closest('.select-compare-price-container')?.classList.remove('hidden');
                  } else {
                    comparePriceElement.innerHTML = '';
                    comparePriceElement.closest('.select-compare-price-container')?.classList.add('hidden');
                  }
                }
              }
            }

            parsePriceString(priceString) {
              return priceString;
            }

            openVariantPopup() {
              const $variantContainer = this.querySelector('.products-select-menu__variant-wrapper');
              // 检查元素是否存在
              if (!$variantContainer) {
                console.warn('Variant container not found');
                return;
              }

              customEventListener($variantContainer, 'click', () => {
                const $productDetailModal = this.querySelector('product-detail-data-variant-popup');
                // 检查弹窗元素是否存在
                if (!$productDetailModal) {
                  console.warn('Product detail modal not found');
                  return;
                }

                $productDetailModal.classList.remove('hidden');
                // 添加关闭弹窗的逻辑
                const closeModal = (e) => {
                  if (e.target === $productDetailModal) {
                    $productDetailModal.classList.add('hidden');
                    document.removeEventListener('click', closeModal);
                  }
                };
                document.addEventListener('click', closeModal);
              });
            }
            openProductDetails() {
              const _this = this;
              this.querySelector('.open-product-details').addEventListener('click', (event) => {
                event.stopPropagation();

                const $swiperSlide = $(_this).closest('.products-select-menu');
                _this.openProductDetailModal($swiperSlide);
              });
            }
            openProductDetailModal(element) {
              const _this = this;
              const productHandle = $(element).data('product-handle');

              if (
                window.litime.tryOpenProductModalV2?.(productHandle, undefined, {
                  onBefore: () => window.litime.showLoading(false),
                  onFinally: () => window.litime.hideLoading(false),
                })
              ) {
                return;
              }

              // 禁用浏览器滚动
              window.litime.disableScroll();
              window.litime.showLoading(false);
              // 请求productHandle
              fetch(`/products/${productHandle}?view=modal`)
                .then((response) => {
                  if (response.status === 200) {
                    return response.text();
                  } else {
                    throw new Error('Network response was not ok');
                  }
                })
                .then((responseText) => {
                  const html = responseText;
                  _this.renderProductDetailModal(html);
                })
                .finally(() => {
                  window.litime.hideLoading(false);
                });
            }

            renderProductDetailModal(html, inventoryPolicy, view) {
              const _this = this;
              const quickshopPopup = new DOMParser()
                .parseFromString(html, 'text/html')
                .getElementById('quickshop-popup')?.innerHTML;
              const $productDetailModal = $('#global-product-card-popup');

              $productDetailModal.html(quickshopPopup);
              // let app = document.querySelector('.product-detail-modal_wrapper');
              let modalWrapper = $productDetailModal.find('.product-detail-modal_wrapper');
            }
          }
        );
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["products-service"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('products-service')) {
      customElements.define(
        'products-service',
        class productsService extends HTMLElement {
          constructor() {
            super();
          }

          connectedCallback() {
            this.init();
          }
          init() {
            const $items = $(this).find('.service-item');

            this.$dialog = $(this).find('dialog-simple');
            // 检查每个item的desc属性
            $items.each(function () {
              const $item = $(this);
              if (!$item.attr('data-desc')) {
                $item.css('pointer-events', 'none');
              }
            });
            $items.on('click', (e) => {
              const $item = $(e.currentTarget);
              this.$dialog.attr({
                'data-show': 'true',
                'data-title': $item.attr('data-title'),
                'data-desc': $item.attr('data-desc'),
                'data-button-text': $item.attr('data-button-text'),
                'data-button-link': $item.attr('data-button-link'),
              });
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["referral-integration"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('referral-integration')) {
      customElements.define(
        'referral-integration',
        class referralReward extends HTMLElement {
          constructor() {
            super();
          }
          async connectedCallback() {
            this.querySelector('.referral-integration-modal-close').addEventListener('click', () => {
              this.classList.add('hidden');
              window.litime.enableScroll();
            });
            const referralRewardCodeCopy = this.querySelector('.referral-integration-modal-code-copy');
            if (referralRewardCodeCopy) {
              referralRewardCodeCopy.addEventListener('click', () => {
                const referralRewardCode =
                  this.querySelector('.referral-integration-modal-code span')?.textContent || '';
                this.copy(referralRewardCode);
              });
            }

            const referralRewardModalBtnCopy = this.querySelector('.referral-integration-modal-btn-copy button');
            if (referralRewardModalBtnCopy) {
              referralRewardModalBtnCopy.addEventListener('click', () => {
                const referralRewardCode = this.querySelector('.referral-integration-modal-code span').textContent;
                this.copy(referralRewardCode);
                // 返回首页
                if (window.copyAndShoppingUrl) {
                  window.location.href = window.copyAndShoppingUrl;
                } else {
                  window.location.href = '/';
                }
              });
            }
          }

          copy(text) {
            window.litime.copyToClipboard(text);
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["referral-reword-detail"] && !Shopify.designMode) return;
  try {
    $(document).ready(function () {
    const referralRewardDetailModal = $('.referral-reword-detail-modal');
    referralRewardDetailModal.find('.referral-reword-detail-modal-close').on('click', function () {
      referralRewardDetailModal.addClass('hidden');
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["referral-reword"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('referral-reword')) {
      customElements.define(
        'referral-reword',
        class referralReward extends HTMLElement {
          constructor() {
            super();
          }
          async connectedCallback() {
            this.querySelector('.referral-reword-modal-close').addEventListener('click', () => {
              this.classList.add('hidden');
              window.litime.enableScroll();
            });
            const referralRewardCodeCopy = this.querySelector('.referral-reword-modal-code-copy');
            referralRewardCodeCopy.addEventListener('click', () => {
              const referralRewardCode = this.querySelector('.referral-reword-modal-code span').textContent;
              this.copy(referralRewardCode);
            });
            const referralRewardModalBtnCopy = this.querySelector('.referral-reword-modal-btn-copy button');
            referralRewardModalBtnCopy.addEventListener('click', () => {
              const referralRewardCode = this.querySelector('.referral-reword-modal-code span').textContent;
              this.copy(referralRewardCode);
            });
          }

          copy(text) {
            // 复制优惠码到剪贴板
            window.litime.copyToClipboard(text);
            // 直接跳转到 discount URL（GET 请求，无参数）
            const redirecturl = `/discount/${text}?redirect=${copyAndShoppingUrl}`;
            window.location.href = redirecturl;
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scene-product-popup"] && !Shopify.designMode) return;
  try {
    $(function () {
    // 在这里编写需要在文档加载完成后执行的代码
    if (!customElements.get('scene-product-popup')) {
      customElements.define(
        'scene-product-popup',
        class SceneProductPopup extends HTMLElement {
          productDetailModalBigPictrueSwiper = null;
          productDetailModalSmallPictrueSwiper = null;
          shopMoneyFormat = null;
          productInventoryQuantity = null;
          productDetailModalCopy = null;
          swiper = null;
          constructor() {
            super();
          }

          connectedCallback() {
            const _this = this;
            this.init();
            this.initModalTabSwiper();
            this.shopMoneyFormat = window.shopMoneyFormat;

            const learnMoreIndex = $(this.parentElement).find('[data-learn-index]');
            learnMoreIndex.on('click', function () {
              const index = $(this).data('learn-index');
              const allCollectionModal = $(_this.parentElement).find('.all-collection_modal');
              allCollectionModal.removeClass('hidden');
              const $mySwiper = $(_this.parentElement).find('.modal-tab_swiper');
              const swiperWidth = $($mySwiper).width();
              const swiperWrapperWidth = $mySwiper.parent().width();
              if (swiperWidth >= swiperWrapperWidth - 64) {
                $mySwiper.parent().find('.modal-tab_swiper_next').removeClass('hidden').addClass('flex');
              }
              _this.changeTav(index, allCollectionModal.find(`[data-tab-index="${index}"]`), false);
              // 禁用浏览器滚动
              window.litime.disableScroll();
            });
            // 监听all-collection_modal_wrapper的滚动
            $(_this.parentElement.querySelector('.all-collection_modal_wrapper')).on(
              'scroll',
              _this.modalTabSwiperScroll.bind(_this)
            );
          }

          modalTabSwiperScroll() {
            const stickyTab = $(this.querySelector('.sticky_tab'));
            //stickyTabTop 距离 浏览器视窗顶部
            // 元素距离文档顶部的距离
            const elementOffset = stickyTab.offset().top;
            // 当前滚动位置
            const scrollTop = $(window).scrollTop();
            // 元素距离视窗顶部的距离
            const distanceFromTop = elementOffset - scrollTop;
            if (60 >= distanceFromTop) {
              stickyTab.css('box-shadow', '0 2px 10px rgba(0, 0, 0, 0.1)').css('padding-bottom', '32px');
            } else {
              stickyTab.css('box-shadow', 'none').css('padding-bottom', '42px');
            }
          }

          init() {
            const _this = this;
            const allCollectionModalClose = $(this).find('.all-collection_modal_close');
            allCollectionModalClose.on('click', function () {
              // 恢复浏览器滚动
              window.litime.enableScroll();
              $(_this).find('.all-collection_modal').addClass('hidden');
              $(this.querySelector('.all-collection_modal_wrapper')).off(
                'scroll',
                _this.modalTabSwiperScroll.bind(_this)
              );
            });

            const dataTabIndex = $(this).find('[data-tab-index]');
            dataTabIndex.on('click', function () {
              const index = $(this).data('tab-index');
              _this.changeTav(index, this);
            });
          }

          changeTav(index, element, scoll = true) {
            const allCollectionModal = $(this).find('.all-collection_modal');
            // 获取collection_modal_title
            const collectionModalTitle = $(allCollectionModal).find('.collection_modal_title');
            // 获取collectionModalTitle的paddingTop值 转成数字
            const paddingTop = parseInt(collectionModalTitle.css('padding-top'));
            const scollTop = collectionModalTitle.height() + paddingTop;
            const sticky_tab = $(allCollectionModal).find('.sticky_tab');
            // 获取sticky_tab的paddingBottom值 转成数字
            const paddingBottom = parseInt(sticky_tab.css('padding-bottom'));
            if (scoll) {
              if (paddingBottom === 42) {
                allCollectionModal.find('.all-collection_modal_wrapper').scrollTop(scollTop + 10);
              } else {
                allCollectionModal.find('.all-collection_modal_wrapper').scrollTop(scollTop);
              }
            }
            $(element)
              .css('background-color', 'black')
              .css('color', 'white')
              .siblings()
              .css('background-color', 'white')
              .css('color', 'black');
            const dataPicIndex = $(allCollectionModal).find(`[data-pic-index="${index}"]`);
            dataPicIndex.removeClass('hidden');
            dataPicIndex.siblings().addClass('hidden');
            // 获取data-product-index的元素
            const allProduct = $(allCollectionModal).find('[data-product-index]');
            const dataProductIndex = $(allCollectionModal).find(`[data-product-index="${index}"]`);
            allProduct.addClass('hidden');
            dataProductIndex.removeClass('hidden');
            this.swiper.slideTo(index - 1);
          }

          initModalTabSwiper() {
            const $mySwiper = this.querySelector('.modal-tab_swiper');
            const $swiperPrev = this.querySelector('.modal-tab_swiper_prev');
            const $swiperNext = this.querySelector('.modal-tab_swiper_next');
            this.swiper = new Swiper($mySwiper, {
              slidesPerView: 'auto',
              spaceBetween: 16,
              navigation: {
                prevEl: $swiperPrev,
                nextEl: $swiperNext,
              },
              on: {
                slideChange: function () {
                  if (this.isBeginning) {
                    $($swiperPrev).removeClass('flex').addClass('hidden');
                  } else {
                    $($swiperPrev).removeClass('hidden').addClass('flex');
                  }
                  if (this.isEnd) {
                    $($swiperNext).addClass('hidden').removeClass('flex');
                  } else {
                    $($swiperNext).removeClass('hidden').addClass('flex');
                  }
                },
                progress: function (swiper, progress) {
                  if (progress > 0.9) {
                    // 当滑动超过90%时
                    $($swiperNext).addClass('hidden');
                    // 可以预加载更多内容
                  } else if (progress > 0.1 && progress < 0.9) {
                    $($swiperNext).removeClass('hidden');
                    $($swiperPrev).removeClass('hidden').addClass('flex');
                  } else {
                    $($swiperPrev).addClass('hidden');
                  }
                },
              },
            });
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-to-top"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('scroll-to-top')) {
    customElements.define(
      'scroll-to-top',
      class ScrollToTop extends HTMLElement {
        static SCROLL_THRESHOLD = 300;
        static SCROLL_IDLE_MS = 500;
        static SCROLL_MEDIA = '(max-width: 1200px)';

        connectedCallback() {
          this.sideFab = this.querySelector('#litime-side-fab');
          this.topBtn = this.querySelector('#litime-side-fab-back-to-top');
          this.topBtnSlot = this.querySelector('#litime-side-fab-top-slot');
          this.accessibilityBtn = this.querySelector('#litime-side-fab-accessibility');
          this.chatProvider = this.dataset.chatProvider || '';
          this.lastScrollY = this.getScrollY();
          this.isFabVisible = false;
          this.isTopVisible = false;
          this.pluginOpen = false;
          this.nextopChatOpen = false;
          this.scrollIdleTimer = null;
          this.scrollMedia = window.matchMedia(ScrollToTop.SCROLL_MEDIA);
          this._onMediaChange = () => this.handleViewportChange();

          this.initActions();
          this.initScrollVisibility();
          this.initSeaAccessibilityButton();
          this.initPluginObserver();
          this.initNextopChatEvents();
          this.scrollMedia.addEventListener('change', this._onMediaChange);
          this.handleViewportChange();
        }

        hasSeaAccessibilityWidget() {
          return !!document.querySelector('#Sea-Accessibility__button, .Sea-Accessibility__WidgetButton');
        }

        updateAccessibilityButtonVisibility() {
          if (!this.accessibilityBtn) return;
          this.accessibilityBtn.classList.toggle('is-available', this.hasSeaAccessibilityWidget());
        }

        initSeaAccessibilityButton() {
          if (!this.accessibilityBtn) return;

          this.updateAccessibilityButtonVisibility();

          this.seaObserver = new MutationObserver(() => {
            this.updateAccessibilityButtonVisibility();
          });
          this.seaObserver.observe(document.body, { childList: true, subtree: true });
        }

        initNextopChatEvents() {
          if (this.chatProvider !== 'nextop') return;

          this._onNextopOpen = () => {
            this.nextopChatOpen = true;
            this.pluginOpen = true;
            this.handleViewportChange();
          };

          this._onNextopClose = () => {
            this.nextopChatOpen = false;
            this.pluginOpen = this.isPluginPopupOpen();
            this.handleViewportChange();
          };

          this.addEventListener('litime:nextop-open', this._onNextopOpen);
          this.addEventListener('litime:nextop-close', this._onNextopClose);
        }

        isCompactViewport() {
          return this.scrollMedia.matches;
        }

        handleViewportChange() {
          if (this.isCompactViewport()) {
            this.applyVisibility(this.getScrollY(), 'idle');
          } else {
            this.setDesktopVisible(this.getScrollY());
          }
        }

        shouldShowTopButton(scrollY) {
          return scrollY > ScrollToTop.SCROLL_THRESHOLD;
        }

        setDesktopVisible(scrollY) {
          const y = scrollY ?? this.getScrollY();

          if (this.scrollIdleTimer) {
            clearTimeout(this.scrollIdleTimer);
            this.scrollIdleTimer = null;
          }

          this.setFabVisible(true);
          this.setTopButtonVisible(this.shouldShowTopButton(y));
        }

        getScrollY() {
          return window.pageYOffset || document.documentElement.scrollTop || 0;
        }

        disconnectedCallback() {
          if (this._onScroll) {
            window.removeEventListener('scroll', this._onScroll);
            document.removeEventListener('scroll', this._onScroll);
          }
          if (this.scrollIdleTimer) {
            clearTimeout(this.scrollIdleTimer);
          }
          if (this.pluginObserver) {
            this.pluginObserver.disconnect();
          }
          if (this.seaObserver) {
            this.seaObserver.disconnect();
          }
          if (this.scrollMedia && this._onMediaChange) {
            this.scrollMedia.removeEventListener('change', this._onMediaChange);
          }
          if (this._onNextopOpen) {
            this.removeEventListener('litime:nextop-open', this._onNextopOpen);
          }
          if (this._onNextopClose) {
            this.removeEventListener('litime:nextop-close', this._onNextopClose);
          }
        }

        initActions() {
          this.querySelectorAll('[data-action]').forEach((btn) => {
            btn.addEventListener('click', () => {
              const action = btn.dataset.action;

              if (action === 'top') {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              } else if (action === 'lucas-chat' && this.chatProvider === 'lucas') {
                const launcher = document.querySelector('[data-lucas-chat-floating] .lucas-chat-launcher');
                if (launcher) launcher.click();
              }
            });
          });
        }

        initScrollVisibility() {
          this._onScroll = () => {
            const scrollY = this.getScrollY();

            if (!this.isCompactViewport()) {
              this.setDesktopVisible(scrollY);
              this.lastScrollY = scrollY;
              return;
            }

            const delta = scrollY - this.lastScrollY;

            if (delta > 2) {
              clearTimeout(this.scrollIdleTimer);
              this.scrollIdleTimer = null;
              this.applyVisibility(scrollY, 'down');
            } else if (delta < -2) {
              clearTimeout(this.scrollIdleTimer);
              this.scrollIdleTimer = null;
              this.applyVisibility(scrollY, 'up');
            } else if (this.isFabVisible) {
              this.setTopButtonVisible(this.shouldShowTopButton(scrollY));
            }

            clearTimeout(this.scrollIdleTimer);
            this.scrollIdleTimer = setTimeout(() => {
              this.applyVisibility(scrollY, 'idle');
            }, ScrollToTop.SCROLL_IDLE_MS);

            this.lastScrollY = scrollY;
          };

          window.addEventListener('scroll', this._onScroll, { passive: true });
          document.addEventListener('scroll', this._onScroll, { passive: true });
        }

        initPluginObserver() {
          const checkPlugin = () => {
            const open = this.isPluginPopupOpen();
            if (open === this.pluginOpen) return;
            this.pluginOpen = open;
            this.handleViewportChange();
          };

          this.pluginObserver = new MutationObserver(checkPlugin);
          this.pluginObserver.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'style', 'data-open', 'aria-hidden', 'hidden', 'open'],
          });

          checkPlugin();
        }

        isElementVisible(el) {
          if (!el) return false;
          if (el.getAttribute('aria-hidden') === 'true' || el.hasAttribute('hidden')) return false;
          if (el.closest('[aria-hidden="true"], [hidden]')) return false;

          const style = window.getComputedStyle(el);
          if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) {
            return false;
          }

          const rect = el.getBoundingClientRect();
          return rect.width > 8 && rect.height > 8;
        }

        isLucasPluginOpen() {
          const lucasRoot = document.querySelector('[data-lucas-chat-floating]');
          if (!lucasRoot) return false;

          const panels = lucasRoot.querySelectorAll(
            '.lucas-chat-panel, .lucas-chat-window, [class*="chat-panel"], [class*="ChatPanel"], dialog, [role="dialog"]'
          );

          for (const panel of panels) {
            if (panel.classList.contains('lucas-chat-launcher')) continue;
            if (this.isElementVisible(panel)) return true;
          }

          return false;
        }

        isSeaPluginOpen() {
          const seaSelectors = [
            '.Sea-Accessibility__Popup',
            '.Sea-Accessibility__Modal',
            '#Sea-Accessibility__Widget--open',
          ];

          for (const selector of seaSelectors) {
            const nodes = document.querySelectorAll(selector);
            for (const node of nodes) {
              if (
                node.matches(
                  '#litime-side-fab-back-to-top, #litime-side-fab-accessibility, #litime-side-fab-live-chat, .side-fab__btn'
                )
              ) {
                continue;
              }
              if (this.isElementVisible(node)) return true;
            }
          }

          return false;
        }

        isPluginPopupOpen() {
          if (this.chatProvider === 'nextop' && this.nextopChatOpen) {
            return true;
          }

          if (this.isSeaPluginOpen()) {
            return true;
          }

          if (this.chatProvider === 'lucas' && this.isLucasPluginOpen()) {
            return true;
          }

          return false;
        }

        applyVisibility(scrollY, mode) {
          if (!this.isCompactViewport()) {
            this.setDesktopVisible(scrollY);
            return;
          }

          const allowByScroll = this.pluginOpen || mode !== 'down';
          const fabVisible = allowByScroll;
          const topVisible = allowByScroll && this.shouldShowTopButton(scrollY);

          this.setFabVisible(fabVisible);
          this.setTopButtonVisible(topVisible);
        }

        setFabVisible(visible) {
          if (!this.sideFab || visible === this.isFabVisible) return;
          this.isFabVisible = visible;
          this.sideFab.classList.toggle('is-visible', visible);
        }

        setTopButtonVisible(visible) {
          if (!this.topBtnSlot || visible === this.isTopVisible) return;
          this.isTopVisible = visible;
          this.topBtnSlot.classList.toggle('is-visible', visible);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["select-filter-collection"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('select-href')) {
      customElements.define(
        'select-href',
        class selectHref extends HTMLElement {
          constructor() {
            super();
          }
          connectedCallback() {
            this.init();
          }
          init() {
            let selectDom = this.querySelector('.select_href_main');
            selectDom.addEventListener('click', (event) => {
              this.compareDropdownTrigger(event);
            });
            document.addEventListener('click', (e) => {
              this.cleanAllDropdownSelect(e);
            });
          }
          compareDropdownTrigger(event) {
            event.stopPropagation();
            let selectDom = this.querySelector('.select_href_main');
            let visibleValue = selectDom.getAttribute('data-visible');
            // 如果当前值是 'false'，则修改为 'true'，否则修改为 'false'
            let newVisibleValue = visibleValue === 'false' ? 'true' : 'false';
            selectDom.setAttribute('data-visible', newVisibleValue);
          }
          cleanAllDropdownSelect(e) {
            let className = e.target.className;
            if (className === 'select_href_options') {
              return;
            }
            let selectDom = this.querySelector('.select_href_main');
            if (selectDom.getAttribute('data-visible') === 'true') {
              selectDom.setAttribute('data-visible', 'false');
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shopping-guide-battery-solution"] && !Shopify.designMode) return;
  try {
    window.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('battery-solution')) {
      class BatterySolution extends HTMLElement {
        constructor() {
          super();
        }
        type = '';
        connectedCallback() {
          this.init();
        }
        init() {
          const card = this.querySelectorAll('.starry-extension-battery-solution__card');
          //   选中的增加active，其他去除active
          card.forEach((item) => {
            item.addEventListener('click', () => {
              item.classList.add('active');
              this.setAttribute('data-value', item.getAttribute('data-type'));
              this.setAttribute('data-step-id', item.getAttribute('data-step-id'));
              document
                .querySelector('shopping-guide')
                .generateStepIdsByCategory(window.starryExtension.shippingGuide, item.getAttribute('data-type'));
              card.forEach((item) => {
                if (item.getAttribute('data-type') !== this.getAttribute('data-value')) {
                  item.classList.remove('active');
                }
              });
            });
          });
        }
        reset() {
          const card = this.querySelectorAll('.starry-extension-battery-solution__card');
          this.setAttribute('data-value', '');
          this.setAttribute('data-step-id', '');
          card.forEach((item) => {
            item.classList.remove('active');
          });
        }
      }
      customElements.define('battery-solution', BatterySolution);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tailgate-purchase-buy-btn"] && !Shopify.designMode) return;
  try {
    class MarketingSceneBuyBtn extends HTMLElement {
    constructor() {
      super();
      this._onCartClick = this._handleCartClick.bind(this);
    }

    connectedCallback() {
      this._init();
    }

    disconnectedCallback() {
      this._cleanup();
    }

    _init() {
      const modelDetailsShow = this.getAttribute('data-model-details_show');
      const variantSize = parseInt(this.getAttribute('data-variant-size') || '1', 10);

      if (modelDetailsShow === 'show' && !isNaN(variantSize) && variantSize > 1) {
        const cartDynamicAddToCart = this.querySelector('.btn-cart dynamic-add-to-cart');
        if (cartDynamicAddToCart) {
          cartDynamicAddToCart.style.pointerEvents = 'none';

          const loading = cartDynamicAddToCart.querySelector('.rotate_icon');
          if (loading) {
            loading.classList.add('hidden');
            loading.classList.remove('flex');
          }
        }
      }

      const btnCart = this.querySelector('.btn-cart');
      if (btnCart) {
        btnCart.addEventListener('click', this._onCartClick, true);
      }
    }

    _cleanup() {
      const btnCart = this.querySelector('.btn-cart');
      if (btnCart) {
        btnCart.removeEventListener('click', this._onCartClick, true);
      }
    }

    _handleCartClick(e) {
      const modelDetailsShow = this.getAttribute('data-model-details_show');
      const productHandle = this.getAttribute('data-product-handle');
      const variantSize = parseInt(this.getAttribute('data-variant-size') || '1', 10);

      if (modelDetailsShow === 'show' && !isNaN(variantSize) && variantSize > 1 && productHandle) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this._openProductDetailModal(productHandle, 'cart');
        return false;
      }

      if (variantSize <= 1) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const btnCart = this.querySelector('.btn-cart');
        const dynamicAddToCart = btnCart ? btnCart.querySelector('dynamic-add-to-cart') : null;

        if (dynamicAddToCart && typeof dynamicAddToCart.addToCart === 'function') {
          dynamicAddToCart.addToCart(
            dynamicAddToCart.getVariantId(),
            dynamicAddToCart.getQuantity()
          );
        }
      }
    }

    _openProductDetailModal(productHandle, buttonType = 'cart') {
      const _this = this;
      this._currentButtonType = buttonType;
      window.litime.disableScroll();
      window.litime.showLoading(false);

      const variantSize = parseInt(this.getAttribute('data-variant-size') || '1', 10);

      if (variantSize <= 1) {
        const btnCart = this.querySelector('.btn-cart');
        const loading = btnCart ? btnCart.querySelector('.rotate_icon') : null;
        const textEl = btnCart ? btnCart.querySelector('.loading-button-text') : null;

        if (loading) {
          loading.classList.remove('hidden');
          loading.classList.add('flex');
        }

        if (textEl) {
          textEl.classList.add('hidden');
        }
      }

      if (
        window.litime.tryOpenProductModalV2?.(productHandle, undefined, {
          onBefore: () => {},
          onFinally: () => {
            window.litime.hideLoading(false);
            const variantSize = parseInt(_this.getAttribute('data-variant-size') || '1', 10);
            if (variantSize <= 1) {
              _this._resetLoadingState(_this._currentButtonType);
            }
          },
        })
      ) {
        return;
      }

      fetch(`/products/${productHandle}?view=modal`)
        .then((response) => {
          if (response.status === 200) {
            return response.text();
          } else {
            throw new Error('Network response was not ok');
          }
        })
        .then((responseText) => {
          const html = responseText;

          const inventoryPolicy =
            _this.querySelector('[data-inventory-policy]')?.getAttribute('data-inventory-policy') || 'deny';

          _this._renderProductDetailModal(html, inventoryPolicy, 'buy_now_to_cart');
        })
        .finally(() => {
          window.litime.hideLoading(false);
          const variantSize = parseInt(_this.getAttribute('data-variant-size') || '1', 10);
          if (variantSize <= 1) {
            _this._resetLoadingState(_this._currentButtonType);
          }
        });
    }

    _renderProductDetailModal(html, inventoryPolicy, view) {
      const _this = this;
      const quickshopPopup = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('quickshop-popup')?.innerHTML;
      const $productDetailModal = $('#global-product-card-popup');

      $productDetailModal.html(quickshopPopup);
      try {
        const preferType = _this.getAttribute('data-global-preferential-type');
        const popupEl = $productDetailModal.find('product-detail-data-popup')[0];
        if (popupEl && preferType) {
          popupEl.setAttribute('data-global-preferential-type', preferType);
        }

        if (popupEl && popupEl.applyPreferentialMode) {
          popupEl.applyPreferentialMode();
        }
      } catch (e) {
        console.warn('set data-global-preferential-type failed:', e);
      }
      let modalWrapper = $productDetailModal.find('.product-detail-modal_wrapper');
      if (inventoryPolicy === 'continue' && view === 'buy_now_to_cart') {
        let $preOrderButton = modalWrapper
          .find('.product-detail-popup_button')
          .eq(0)
          .find('.buy-now-btn-card-button-popup');

        $preOrderButton.removeClass('hidden').addClass('flex');
        const $preOrderSubmitButton = modalWrapper
          .find('.product-detail-popup_form_wrapper')
          .eq(0)
          .find('.buy-now-btn-card-submit-button');
        $preOrderSubmitButton.addClass('hidden').removeClass('flex');
      } else {
        let $preOrderButton = modalWrapper
          .find('.product-detail-popup_form_wrapper')
          .eq(0)
          .find('.buy-now-btn-card-button-popup');
        $preOrderButton.addClass('hidden').removeClass('flex');
        const $preOrderSubmitButton = modalWrapper
          .find('.product-detail-popup_form_wrapper')
          .eq(0)
          .find('.buy-now-btn-card-submit-button');
        $preOrderSubmitButton.removeClass('hidden').addClass('flex');
      }
    }

    _resetLoadingState(buttonType = 'cart') {
      const btnCart = this.querySelector('.btn-cart');
      if (!btnCart) return;

      const loading = btnCart.querySelector('.rotate_icon');
      const textEl = btnCart.querySelector('.loading-button-text');

      if (loading) {
        loading.classList.add('hidden');
        loading.classList.remove('flex');
      }

      if (textEl) {
        textEl.classList.remove('hidden');
      }
    }
  }

  if (!customElements.get('tailgate-purchase-buy-btn')) {
    customElements.define('tailgate-purchase-buy-btn', MarketingSceneBuyBtn);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tailgate-purchase-more-btn"] && !Shopify.designMode) return;
  try {
    class MarketingSceneMoreBtn extends HTMLElement {
    constructor() {
      super();
      this._onBtnClick = this._handleBtnClick.bind(this);
    }

    connectedCallback() {
      this._init();
    }

    disconnectedCallback() {
      this._cleanup();
    }

    _init() {
      const btn = this.querySelector('.btn');
      if (btn) {
        btn.addEventListener('click', this._onBtnClick);
      }
    }

    _cleanup() {
      const btn = this.querySelector('.btn');
      if (btn) {
        btn.removeEventListener('click', this._onBtnClick);
      }
    }

    _handleBtnClick(e) {
      // Show loading state
      const loading = this.querySelector('.rotate_icon');
      if (loading) {
        loading.classList.remove('hidden');
        loading.classList.add('flex');
      }

      const textEl = this.querySelector('.loading-button-text');
      if (textEl) {
        textEl.classList.add('hidden');
      }
    }
  }

  // Register custom element
  if (!customElements.get('marketing-scene-more-btn')) {
    customElements.define('marketing-scene-more-btn', MarketingSceneMoreBtn);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tailgate-purchase-product-list"] && !Shopify.designMode) return;
  try {
    $(function () {
    if (!customElements.get('tailgate-purchase-product-list')) {
      customElements.define(
        'tailgate-purchase-product-list',
        class TailgatePurchaseProductList extends HTMLElement {
          constructor() {
            super();
            this._cards = [];
            this._totalEl = null;
            this._compareEl = null;
            this._discountBadge = null;
            this._addBtn = null;
            this._defaultSelected = 0;
            this._discountType = 'amount';
            this._moneyFormat = null;
            this._swiper = null;
          }

          connectedCallback() {
            this._defaultSelected = parseInt(this.getAttribute('data-default-selected')) || 0;
            this._discountType = this.getAttribute('data-discount-type') || 'amount';
            this._moneyFormat = (cents) => {
              if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.formatMoney === 'function') {
                return window.Shopify.formatMoney(cents, window.shopMoneyFormat);
              }
            };
            this._cards = Array.from(this.querySelectorAll('.tailgate-purchase-product-list__card'));
            this._totalEl = this.querySelector('[data-total-display]');
            this._compareEl = this.querySelector('[data-compare-display]');
            this._discountBadge = this.querySelector('[data-discount-badge]');
            this._addBtn = this.querySelector('[data-add-to-cart]');
            this._loadMoreBtn = this.querySelector('[data-load-more]');
            this._initMobileLoadMore();
            this._applyDefaultSelection();
            this._bindCardClick();
            this._bindAddToCart();
            this._updateSummary();
            this._adjustCardWidth();
          }

          // 移动端加载更多功能：768px及以下默认显示5个，点击展开全部
          _initMobileLoadMore() {
            const visibleCount = 5;
            const checkAndSetup = () => {
              const isMobile = window.innerWidth <= 768;
              // 移动端且产品数大于5时，隐藏第6个及以后的产品，显示Load More按钮
              if (isMobile && this._cards.length > visibleCount) {
                this._cards.forEach((card, index) => {
                  card.style.display = index >= visibleCount ? 'none' : '';
                });
                if (this._loadMoreBtn) this._loadMoreBtn.removeAttribute('hidden');
              } else {
                // 非移动端或产品数不足5个，显示全部，隐藏Load More按钮
                this._cards.forEach((card) => (card.style.display = ''));
                if (this._loadMoreBtn) this._loadMoreBtn.setAttribute('hidden', '');
              }
            };
            // 初始化时执行一次
            checkAndSetup();
            // 监听窗口大小变化，切换移动端/桌面端时自动调整
            let resizeTimer;
            window.addEventListener('resize', () => {
              clearTimeout(resizeTimer);
              resizeTimer = setTimeout(checkAndSetup, 150);
            });
            // 点击Load More按钮展开全部产品
            if (this._loadMoreBtn) {
              this._loadMoreBtn.addEventListener('click', () => {
                this._cards.forEach((card) => (card.style.display = ''));
                this._loadMoreBtn.setAttribute('hidden', '');
              });
            }
          }

          _adjustCardWidth() {
            const cardCount = this._cards.length;
            if (cardCount > 0 && cardCount < 5) {
              this.style.setProperty('--card-width', '300px');
              // 通知父组件更新 swiper
              this.dispatchEvent(new CustomEvent('card-width-changed', { bubbles: true }));
            }
          }

          _applyDefaultSelection() {
            let selectedCount = 0;
            this._cards.forEach((card) => {
              if (selectedCount >= this._defaultSelected) return;

              const isSelectable = this._isCardSelectable(card);

              // 库存为0且inventory_policy为deny（不允许缺货购买）时，不勾选但仍然计数
              if (isSelectable) {
                card.classList.add('tailgate-purchase-product-list__card--selected');
              }
              selectedCount++;
            });
          }

          _bindCardClick() {
            this._cards.forEach((card) => {
              card.addEventListener('click', () => {
                const isSelectable = this._isCardSelectable(card);

                // 如果产品不可勾选，则不允许切换选中状态
                if (!isSelectable) {
                  return;
                }

                card.classList.toggle('tailgate-purchase-product-list__card--selected');
                this._updateSummary();
              });
            });
          }

          _bindAddToCart() {
            if (!this._addBtn) return;
            this._addBtn.addEventListener('click', () => this._doAddToCart());
          }

          _getSelectedCards() {
            return this._cards.filter((c) => c.classList.contains('tailgate-purchase-product-list__card--selected'));
          }

          _isCardSelectable(card) {
            const inventoryQuantity = parseInt(card.dataset.inventoryQuantity || '0', 10);
            const inventoryPolicy = card.dataset.inventoryPolicy || 'deny';
            return !(inventoryQuantity <= 0 && inventoryPolicy === 'deny');
          }

          _updateSummary() {
            const selected = this._getSelectedCards();

            // 清理不可选产品的选中状态
            selected.forEach((card) => {
              if (!this._isCardSelectable(card)) {
                card.classList.remove('tailgate-purchase-product-list__card--selected');
              }
            });

            // 重新获取有效选中的产品
            const validSelected = this._getSelectedCards().filter((card) => this._isCardSelectable(card));

            let totalCents = 0;
            let compareCents = 0;
            validSelected.forEach((card) => {
              totalCents += parseInt(card.dataset.priceCents || '0', 10);
              compareCents += parseInt(card.dataset.compareCents || '0', 10);
            });
            const discountCents = Math.max(0, compareCents - totalCents);
            const format = this._moneyFormat;
            if (this._totalEl) this._totalEl.textContent = totalCents > 0 ? format(totalCents) : '';
            if (this._compareEl) {
              if (compareCents > totalCents) {
                this._compareEl.textContent = format(compareCents);
                this._compareEl.removeAttribute('hidden');
              } else {
                this._compareEl.setAttribute('hidden', '');
              }
            }
            if (this._discountBadge) {
              if (discountCents > 0) {
                if (this._discountType === 'amount') {
                  this._discountBadge.textContent = format(discountCents) + ' OFF';
                } else {
                  const pct = compareCents > 0 ? Math.floor((discountCents / compareCents) * 100) : 0;
                  this._discountBadge.textContent = pct + '% OFF';
                }
                this._discountBadge.removeAttribute('hidden');
              } else {
                this._discountBadge.setAttribute('hidden', '');
              }
            }
            if (this._addBtn) {
              this._addBtn.disabled = validSelected.length === 0;
            }
          }

          _doAddToCart() {
            const selected = this._getSelectedCards();
            if (selected.length === 0) return;

            // 显示loading状态
            const btnText = this._addBtn.querySelector('.loading-button-text');
            const btnLoading = this._addBtn.querySelector('.rotate_icon');
            if (btnText) btnText.classList.add('hidden');
            if (btnLoading) {
              btnLoading.classList.remove('hidden');
              btnLoading.classList.add('flex');
            }

            // 过滤掉不可选的产品（库存为0且不允许缺货购买）
            const validItems = selected
              .filter((card) => this._isCardSelectable(card))
              .map((card) => ({
                id: parseInt(card.dataset.variantId || '0', 10),
                quantity: 1,
              }))
              .filter((item) => item.id > 0);

            const resetBtnState = () => {
              if (btnText) btnText.classList.remove('hidden');
              if (btnLoading) {
                btnLoading.classList.add('hidden');
                btnLoading.classList.remove('flex');
              }
              this._addBtn.disabled = validItems.length === 0;
            };

            if (typeof window.litime !== 'undefined' && typeof window.litime.addCart === 'function') {
              this._addBtn.disabled = true;
              window.litime
                .addCart(validItems)
                .then(() => {
                  resetBtnState();
                })
                .catch(() => {
                  resetBtnState();
                });
            } else {
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: validItems }),
              })
                .then((r) => r.json())
                .then((data) => {
                  if (data.status && data.status !== 200) {
                    if (window.litime?.showToast) window.litime.showToast('error', data.description);
                  }
                })
                .finally(() => {
                  resetBtnState();
                });
            }
          }
        }
      );
    }
  });
  } catch(e) { console.error(e); }
})();

})();
